import { templateApi as api } from "./templateApi";
export const addTagTypes = [
  "tenants",
  "recipes",
  "chef_groups",
  "material_limits",
  "steel_grades",
  "steel_grade_plans",
  "baskets",
  "chemistry",
  "crane",
  "materials",
  "fixed_mix_defaults",
  "auto_recipe_defaults",
  "default_parameters",
  "loads",
  "deployments",
  "heat_queue",
  "multiple_price_availability",
  "product_groups",
  "product_group_plans",
  "search",
  "plan",
  "session",
  "result",
  "uploaded_files",
  "publish",
  "messages",
  "inventory",
  "target_baskets",
  "parameter_feasibility",
  "invite",
  "auth",
  "label_reservation_settings",
  "label_review",
  "labelled_events",
  "labelling_coverage",
  "locations_loading",
  "plan_change_tracking",
  "physical_parameters",
  "simulator",
  "summaries",
  "strategy_dashboard",
  "delivery_form",
  "cache_admin",
  "projections",
  "delivery_adjustments",
  "scenario_planning",
  "scrap_eye_metadata",
  "scrap_eyes",
  "scrap_eyes_data",
  "scrap_eyes_devices",
  "video",
  "radio",
  "raw_data",
  "inference",
  "heat_baskets",
  "loading_windows",
  "installation",
  "scrap_eyes_redaction",
  "location_exceptional_status",
  "scrap_eyes_ingest",
  "uploads",
  "segment_status",
  "edge_inference",
  "scrap_loading_layout",
  "railcars",
  "recipe_compliance_report",
  "tenant_emails",
  "mission_control",
  "organisation",
  "scrap_market",
  "rail_routing",
  "health",
  "event_labelling_models",
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getTenantMetadata: build.query<
        GetTenantMetadataApiResponse,
        GetTenantMetadataApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/tenants/${queryArg.tenantName}`,
        }),
        providesTags: ["tenants"],
      }),
      triggerAutoRecipesFromFiles: build.mutation<
        TriggerAutoRecipesFromFilesApiResponse,
        TriggerAutoRecipesFromFilesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/recipes/auto/${queryArg.tenantName}/trigger-from-uploaded-files`,
          method: "POST",
          body: queryArg.triggerAutoRecipesRequest,
          headers: {
            "X-Idempotency-Key": queryArg["X-Idempotency-Key"],
          },
        }),
        invalidatesTags: ["recipes"],
      }),
      triggerAutoRecipesFromTypes: build.mutation<
        TriggerAutoRecipesFromTypesApiResponse,
        TriggerAutoRecipesFromTypesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/recipes/auto/${queryArg.tenantName}/trigger-from-recipe-types`,
          method: "POST",
          body: queryArg.triggerAutoRecipesFromTypesRequest,
          headers: {
            "X-Idempotency-Key": queryArg["X-Idempotency-Key"],
          },
        }),
        invalidatesTags: ["recipes"],
      }),
      listAutoRecipeStrategies: build.query<
        ListAutoRecipeStrategiesApiResponse,
        ListAutoRecipeStrategiesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/recipes/auto/${queryArg.tenantName}/strategies`,
        }),
        providesTags: ["recipes"],
      }),
      listAutoRecipeEstimators: build.query<
        ListAutoRecipeEstimatorsApiResponse,
        ListAutoRecipeEstimatorsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/recipes/auto/${queryArg.tenantName}/estimators`,
        }),
        providesTags: ["recipes"],
      }),
      getDefaultAutoRecipeEstimators: build.query<
        GetDefaultAutoRecipeEstimatorsApiResponse,
        GetDefaultAutoRecipeEstimatorsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/recipes/auto/${queryArg.tenantName}/default_estimators`,
          params: {
            search_type: queryArg.searchType,
          },
        }),
        providesTags: ["recipes"],
      }),
      getDefaultAutoRecipeStrategy: build.query<
        GetDefaultAutoRecipeStrategyApiResponse,
        GetDefaultAutoRecipeStrategyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/recipes/auto/${queryArg.tenantName}/default_strategy`,
          params: {
            search_type: queryArg.searchType,
          },
        }),
        providesTags: ["recipes"],
      }),
      createAutoRecipe: build.mutation<
        CreateAutoRecipeApiResponse,
        CreateAutoRecipeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/recipes/auto/${queryArg.tenantName}/create`,
          method: "POST",
          body: queryArg.autoRecipeCreate,
        }),
        invalidatesTags: ["recipes"],
      }),
      createAndRunAutoRecipe: build.mutation<
        CreateAndRunAutoRecipeApiResponse,
        CreateAndRunAutoRecipeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/recipes/auto/${queryArg.tenantName}/run`,
          method: "POST",
          body: queryArg.autoRecipeCreate,
        }),
        invalidatesTags: ["recipes"],
      }),
      listChefGroups: build.query<
        ListChefGroupsApiResponse,
        ListChefGroupsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/chef_groups/${queryArg.tenantName}`,
        }),
        providesTags: ["chef_groups"],
      }),
      createChefGrouping: build.mutation<
        CreateChefGroupingApiResponse,
        CreateChefGroupingApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/chef_groups/${queryArg.tenantName}`,
          method: "POST",
          body: queryArg.chefGroupingCreate,
        }),
        invalidatesTags: ["chef_groups"],
      }),
      updateDefaultTargetBaskets: build.mutation<
        UpdateDefaultTargetBasketsApiResponse,
        UpdateDefaultTargetBasketsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/chef_groups/${queryArg.tenantName}/default_target_baskets`,
          method: "POST",
          body: queryArg.updateDefaultTargetBasketsRequest,
        }),
        invalidatesTags: ["chef_groups"],
      }),
      getChefGrouping: build.query<
        GetChefGroupingApiResponse,
        GetChefGroupingApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/chef_groups/${queryArg.tenantName}/${queryArg.chefGroupingId}`,
          params: {
            source: queryArg.source,
          },
        }),
        providesTags: ["chef_groups"],
      }),
      updateDefaultMaterialLimits: build.mutation<
        UpdateDefaultMaterialLimitsApiResponse,
        UpdateDefaultMaterialLimitsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/material_limits/${queryArg.tenantName}/default`,
          method: "POST",
          body: queryArg.updateDefaultMaterialLimitsRequest,
        }),
        invalidatesTags: ["material_limits"],
      }),
      getMaterialLimitSet: build.query<
        GetMaterialLimitSetApiResponse,
        GetMaterialLimitSetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/material_limits/${queryArg.tenantName}/${queryArg.materialLimitSetId}`,
          params: {
            source: queryArg.source,
          },
        }),
        providesTags: ["material_limits"],
      }),
      listSteelGrades: build.query<
        ListSteelGradesApiResponse,
        ListSteelGradesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/steel_grades/${queryArg.tenantName}`,
        }),
        providesTags: ["steel_grades"],
      }),
      createSteelGradeSet: build.mutation<
        CreateSteelGradeSetApiResponse,
        CreateSteelGradeSetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/steel_grades/${queryArg.tenantName}`,
          method: "POST",
          body: queryArg.steelGradeSetCreate,
        }),
        invalidatesTags: ["steel_grades"],
      }),
      getSteelGradeSet: build.query<
        GetSteelGradeSetApiResponse,
        GetSteelGradeSetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/steel_grades/${queryArg.tenantName}/${queryArg.steelGradeSetId}`,
        }),
        providesTags: ["steel_grades"],
      }),
      listSteelGradePlans: build.query<
        ListSteelGradePlansApiResponse,
        ListSteelGradePlansApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/steel_grade_plans/${queryArg.tenantName}`,
        }),
        providesTags: ["steel_grade_plans"],
      }),
      createSteelGradePlan: build.mutation<
        CreateSteelGradePlanApiResponse,
        CreateSteelGradePlanApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/steel_grade_plans/${queryArg.tenantName}`,
          method: "POST",
          body: queryArg.steelGradePlanCreate,
        }),
        invalidatesTags: ["steel_grade_plans"],
      }),
      getSteelGradePlan: build.query<
        GetSteelGradePlanApiResponse,
        GetSteelGradePlanApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/steel_grade_plans/${queryArg.tenantName}/${queryArg.steelGradePlanId}`,
        }),
        providesTags: ["steel_grade_plans"],
      }),
      getTypicalSteelGradePlan: build.query<
        GetTypicalSteelGradePlanApiResponse,
        GetTypicalSteelGradePlanApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/steel_grade_plans/typical/production/${queryArg.tenantName}/${queryArg.steelGradeSetId}`,
          params: {
            num_heats: queryArg.numHeats,
          },
        }),
        providesTags: ["steel_grade_plans"],
      }),
      getSteelGradePlanItemsFromProductGroupPlanItems: build.mutation<
        GetSteelGradePlanItemsFromProductGroupPlanItemsApiResponse,
        GetSteelGradePlanItemsFromProductGroupPlanItemsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/steel_grade_plans/from_product_group_plan_items/${queryArg.tenantName}/${queryArg.steelGradeSetId}`,
          method: "POST",
          body: queryArg.productGroupPlanItems,
        }),
        invalidatesTags: ["steel_grade_plans"],
      }),
      getFormattedBasketConstraints: build.query<
        GetFormattedBasketConstraintsApiResponse,
        GetFormattedBasketConstraintsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/formatted_basket_constraints/${queryArg.tenantName}`,
        }),
        providesTags: ["baskets"],
      }),
      listChemicalElements: build.query<
        ListChemicalElementsApiResponse,
        ListChemicalElementsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/chemical_elements/${queryArg.tenantName}`,
        }),
        providesTags: ["chemistry"],
      }),
      getCraneAssignedBasket: build.query<
        GetCraneAssignedBasketApiResponse,
        GetCraneAssignedBasketApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/crane/${queryArg.tenantName}/${queryArg.craneUserUid}`,
        }),
        providesTags: ["crane"],
      }),
      getMaterialMetadataSet: build.query<
        GetMaterialMetadataSetApiResponse,
        GetMaterialMetadataSetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/materials/${queryArg.tenantName}/${queryArg.materialMetadataSetId}`,
        }),
        providesTags: ["materials"],
      }),
      listMaterialConstraintClasses: build.query<
        ListMaterialConstraintClassesApiResponse,
        ListMaterialConstraintClassesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/material_constraint_classes/${queryArg.tenantName}/${queryArg.materialMetadataSetId}/${queryArg.materialPhysicsSetId}`,
        }),
        providesTags: ["materials"],
      }),
      createMaterialChemistrySet: build.mutation<
        CreateMaterialChemistrySetApiResponse,
        CreateMaterialChemistrySetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/material_chemistry/${queryArg.tenantName}`,
          method: "POST",
          body: queryArg.materialChemistrySetCreate,
        }),
        invalidatesTags: ["materials"],
      }),
      listMaterialChemistrySets: build.query<
        ListMaterialChemistrySetsApiResponse,
        ListMaterialChemistrySetsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/material_chemistry/${queryArg.tenantName}`,
        }),
        providesTags: ["materials"],
      }),
      updateDefaultMaterialChemistry: build.mutation<
        UpdateDefaultMaterialChemistryApiResponse,
        UpdateDefaultMaterialChemistryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/material_chemistry/${queryArg.tenantName}/default`,
          method: "POST",
          body: queryArg.updateDefaultMaterialChemistryRequest,
        }),
        invalidatesTags: ["materials"],
      }),
      getMaterialChemistrySet: build.query<
        GetMaterialChemistrySetApiResponse,
        GetMaterialChemistrySetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/material_chemistry/${queryArg.tenantName}/${queryArg.materialChemistrySetId}`,
          params: {
            source: queryArg.source,
          },
        }),
        providesTags: ["materials"],
      }),
      getMaterialPrices: build.query<
        GetMaterialPricesApiResponse,
        GetMaterialPricesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/prices/${queryArg.tenantName}/${queryArg.timestamp}`,
        }),
        providesTags: ["materials"],
      }),
      updateDefaultMaterialPhysics: build.mutation<
        UpdateDefaultMaterialPhysicsApiResponse,
        UpdateDefaultMaterialPhysicsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/material_physics/${queryArg.tenantName}/default`,
          method: "POST",
          body: queryArg.updateDefaultMaterialPhysicsRequest,
        }),
        invalidatesTags: ["materials"],
      }),
      getMaterialPhysicsSet: build.query<
        GetMaterialPhysicsSetApiResponse,
        GetMaterialPhysicsSetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/material_physics/${queryArg.tenantName}/${queryArg.materialPhysicsSetId}`,
          params: {
            source: queryArg.source,
          },
        }),
        providesTags: ["materials"],
      }),
      getFixedMixDefaults: build.query<
        GetFixedMixDefaultsApiResponse,
        GetFixedMixDefaultsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/fixed_mix_defaults/${queryArg.tenantName}`,
        }),
        providesTags: ["fixed_mix_defaults"],
      }),
      updateFixedMixDefaults: build.mutation<
        UpdateFixedMixDefaultsApiResponse,
        UpdateFixedMixDefaultsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/fixed_mix_defaults/${queryArg.tenantName}`,
          method: "PUT",
          body: queryArg.fixedMixDefaultsRequest,
        }),
        invalidatesTags: ["fixed_mix_defaults"],
      }),
      previewFixedMixDefaults: build.mutation<
        PreviewFixedMixDefaultsApiResponse,
        PreviewFixedMixDefaultsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/fixed_mix_defaults/${queryArg.tenantName}/preview`,
          method: "POST",
          body: queryArg.fixedMixDefaultsRequest,
        }),
        invalidatesTags: ["fixed_mix_defaults"],
      }),
      getAutoRecipeDefaults: build.query<
        GetAutoRecipeDefaultsApiResponse,
        GetAutoRecipeDefaultsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/auto_recipe_defaults/${queryArg.tenantName}/${queryArg.searchType}`,
          params: {
            scope: queryArg.scope,
          },
        }),
        providesTags: ["auto_recipe_defaults"],
      }),
      validateAutoRecipeDefaults: build.mutation<
        ValidateAutoRecipeDefaultsApiResponse,
        ValidateAutoRecipeDefaultsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/auto_recipe_defaults/${queryArg.tenantName}/validate`,
          method: "POST",
          body: queryArg.autoRecipeDefaultsRequest,
          params: {
            scope: queryArg.scope,
          },
        }),
        invalidatesTags: ["auto_recipe_defaults"],
      }),
      updateAutoRecipeDefaults: build.mutation<
        UpdateAutoRecipeDefaultsApiResponse,
        UpdateAutoRecipeDefaultsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/auto_recipe_defaults/${queryArg.tenantName}`,
          method: "PUT",
          body: queryArg.autoRecipeDefaultsRequest,
        }),
        invalidatesTags: ["auto_recipe_defaults"],
      }),
      revertAutoRecipeDefaults: build.mutation<
        RevertAutoRecipeDefaultsApiResponse,
        RevertAutoRecipeDefaultsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/auto_recipe_defaults/${queryArg.tenantName}/revert`,
          method: "POST",
          body: queryArg.autoRecipeDefaultsContext,
        }),
        invalidatesTags: ["auto_recipe_defaults"],
      }),
      previewAutoRecipeSupply: build.mutation<
        PreviewAutoRecipeSupplyApiResponse,
        PreviewAutoRecipeSupplyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/auto_recipe_defaults/${queryArg.tenantName}/supply_preview`,
          method: "POST",
          body: queryArg.autoRecipeSupplyPreviewRequest,
          params: {
            scope: queryArg.scope,
          },
        }),
        invalidatesTags: ["auto_recipe_defaults"],
      }),
      notifyDefaultParameterVisit: build.mutation<
        NotifyDefaultParameterVisitApiResponse,
        NotifyDefaultParameterVisitApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/default_parameters/${queryArg.tenantName}/visit`,
          method: "POST",
          body: queryArg.defaultParameterVisit,
        }),
        invalidatesTags: ["default_parameters"],
      }),
      listLoads: build.query<ListLoadsApiResponse, ListLoadsApiArg>({
        query: (queryArg) => ({
          url: `/api/v2/load/${queryArg.tenantName}`,
          params: {
            created_since: queryArg.createdSince,
            created_before: queryArg.createdBefore,
            sort_order: queryArg.sortOrder,
            limit: queryArg.limit,
            status: queryArg.status,
          },
        }),
        providesTags: ["loads"],
      }),
      createLoad: build.mutation<CreateLoadApiResponse, CreateLoadApiArg>({
        query: (queryArg) => ({
          url: `/api/v2/load/${queryArg.tenantName}`,
          method: "POST",
          body: queryArg.loadCreate,
        }),
        invalidatesTags: ["loads"],
      }),
      listCranes: build.query<ListCranesApiResponse, ListCranesApiArg>({
        query: (queryArg) => ({
          url: `/api/v2/load/${queryArg.tenantName}/cranes`,
        }),
        providesTags: ["loads"],
      }),
      getLoad: build.query<GetLoadApiResponse, GetLoadApiArg>({
        query: (queryArg) => ({
          url: `/api/v2/load/${queryArg.tenantName}/${queryArg.loadId}`,
        }),
        providesTags: ["loads"],
      }),
      deleteLoad: build.mutation<DeleteLoadApiResponse, DeleteLoadApiArg>({
        query: (queryArg) => ({
          url: `/api/v2/load/${queryArg.tenantName}/${queryArg.loadId}/delete`,
          method: "PATCH",
        }),
        invalidatesTags: ["loads"],
      }),
      updateLoadBasketAssignment: build.mutation<
        UpdateLoadBasketAssignmentApiResponse,
        UpdateLoadBasketAssignmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/load_basket/${queryArg.tenantName}/${queryArg.loadBasketId}/assignment`,
          method: "POST",
          body: queryArg.loadBasketAssignmentUpdate,
        }),
        invalidatesTags: ["loads"],
      }),
      updateLoadBasketAdditions: build.mutation<
        UpdateLoadBasketAdditionsApiResponse,
        UpdateLoadBasketAdditionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/load_basket/${queryArg.tenantName}/${queryArg.loadBasketId}/additions`,
          method: "POST",
          body: queryArg.loadBasketAdditionUpdate,
        }),
        invalidatesTags: ["loads"],
      }),
      completeLoadBasket: build.mutation<
        CompleteLoadBasketApiResponse,
        CompleteLoadBasketApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/load_basket/${queryArg.tenantName}/${queryArg.loadBasketId}/complete`,
          method: "POST",
          body: queryArg.loadBasketAdditionUpdate,
        }),
        invalidatesTags: ["loads"],
      }),
      getPlanResults: build.query<
        GetPlanResultsApiResponse,
        GetPlanResultsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/deployments/${queryArg.tenantName}/plan_results/${queryArg.planId}`,
          params: {
            period: queryArg.period,
          },
        }),
        providesTags: ["deployments"],
      }),
      getPlanResultsBatch: build.mutation<
        GetPlanResultsBatchApiResponse,
        GetPlanResultsBatchApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/deployments/${queryArg.tenantName}/plan_results/batch`,
          method: "POST",
          body: queryArg.requests,
        }),
        invalidatesTags: ["deployments"],
      }),
      getDeployedPlans: build.query<
        GetDeployedPlansApiResponse,
        GetDeployedPlansApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/deployments/${queryArg.tenantName}/deployed`,
          params: {
            deployment_types: queryArg.deploymentTypes,
          },
        }),
        providesTags: ["deployments"],
      }),
      getDeployedPlanResults: build.query<
        GetDeployedPlanResultsApiResponse,
        GetDeployedPlanResultsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/deployments/${queryArg.tenantName}/plan_results/${queryArg.planId}/deployed`,
          params: {
            period: queryArg.period,
            deployment_types: queryArg.deploymentTypes,
          },
        }),
        providesTags: ["deployments"],
      }),
      getDeployedPlanMetadata: build.query<
        GetDeployedPlanMetadataApiResponse,
        GetDeployedPlanMetadataApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/deployments/${queryArg.tenantName}/deployed_metadata`,
          params: {
            deployment_types: queryArg.deploymentTypes,
          },
        }),
        providesTags: ["deployments"],
      }),
      getPlanResultsExcel: build.query<
        GetPlanResultsExcelApiResponse,
        GetPlanResultsExcelApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/deployments/${queryArg.tenantName}/plan_results/${queryArg.planId}/excel/${queryArg.language}`,
          params: {
            period: queryArg.period,
          },
        }),
        providesTags: ["deployments"],
      }),
      deployPlan: build.mutation<DeployPlanApiResponse, DeployPlanApiArg>({
        query: (queryArg) => ({
          url: `/api/v2/deployments/${queryArg.tenantName}/deploy/${queryArg.planId}`,
          method: "POST",
          body: queryArg.deployParameters,
        }),
        invalidatesTags: ["deployments"],
      }),
      createHeatOverride: build.mutation<
        CreateHeatOverrideApiResponse,
        CreateHeatOverrideApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/deployments/${queryArg.tenantName}/heat_overrides`,
          method: "POST",
          body: queryArg.create,
        }),
        invalidatesTags: ["deployments"],
      }),
      listCompletedHeats: build.query<
        ListCompletedHeatsApiResponse,
        ListCompletedHeatsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/deployments/${queryArg.tenantName}/heat_overrides/completed_heats`,
          params: {
            heat_id: queryArg.heatId,
          },
        }),
        providesTags: ["deployments"],
      }),
      createCompletedHeatsOverride: build.mutation<
        CreateCompletedHeatsOverrideApiResponse,
        CreateCompletedHeatsOverrideApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/deployments/${queryArg.tenantName}/heat_overrides/completed_heats`,
          method: "POST",
          body: queryArg.heatOverrideCatalogCreate,
        }),
        invalidatesTags: ["deployments"],
      }),
      listHeatOverrideHistory: build.query<
        ListHeatOverrideHistoryApiResponse,
        ListHeatOverrideHistoryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/deployments/${queryArg.tenantName}/heat_overrides/history`,
          params: {
            page: queryArg.page,
            page_size: queryArg.pageSize,
            date: queryArg.date,
            start_date: queryArg.startDate,
            end_date: queryArg.endDate,
            cancellation: queryArg.cancellation,
          },
        }),
        providesTags: ["deployments"],
      }),
      editHeatOverrideHistory: build.mutation<
        EditHeatOverrideHistoryApiResponse,
        EditHeatOverrideHistoryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/deployments/${queryArg.tenantName}/heat_overrides/${queryArg.overrideId}/history`,
          method: "POST",
          body: queryArg.historicalHeatOverrideUpdate,
        }),
        invalidatesTags: ["deployments"],
      }),
      listHeatOverrideRecipes: build.query<
        ListHeatOverrideRecipesApiResponse,
        ListHeatOverrideRecipesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/deployments/${queryArg.tenantName}/heat_overrides/recipes`,
        }),
        providesTags: ["deployments"],
      }),
      reviseHeatOverrideRecipe: build.mutation<
        ReviseHeatOverrideRecipeApiResponse,
        ReviseHeatOverrideRecipeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/deployments/${queryArg.tenantName}/heat_overrides/recipes/${queryArg.fixedMixSetId}`,
          method: "POST",
          body: queryArg.heatOverrideRecipeUpdate,
        }),
        invalidatesTags: ["deployments"],
      }),
      listHeatOverrideReasons: build.query<
        ListHeatOverrideReasonsApiResponse,
        ListHeatOverrideReasonsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/deployments/${queryArg.tenantName}/heat_overrides/reasons`,
        }),
        providesTags: ["deployments"],
      }),
      cancelHeatOverride: build.mutation<
        CancelHeatOverrideApiResponse,
        CancelHeatOverrideApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/deployments/${queryArg.tenantName}/heat_overrides/${queryArg.overrideId}/cancel`,
          method: "POST",
        }),
        invalidatesTags: ["deployments"],
      }),
      cancelHistoricalHeatOverride: build.mutation<
        CancelHistoricalHeatOverrideApiResponse,
        CancelHistoricalHeatOverrideApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/deployments/${queryArg.tenantName}/heat_overrides/${queryArg.overrideId}/history/cancel`,
          method: "POST",
        }),
        invalidatesTags: ["deployments"],
      }),
      getLiveRecipe: build.query<GetLiveRecipeApiResponse, GetLiveRecipeApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/v2/deployments/${queryArg.tenantName}/live_recipe`,
          }),
          providesTags: ["deployments"],
        },
      ),
      getHeatQueue: build.query<GetHeatQueueApiResponse, GetHeatQueueApiArg>({
        query: (queryArg) => ({
          url: `/api/v2/heat-queue/${queryArg.tenantName}`,
        }),
        providesTags: ["heat_queue"],
      }),
      getObtainableBundleItemSet: build.query<
        GetObtainableBundleItemSetApiResponse,
        GetObtainableBundleItemSetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/multiple_price_availability/${queryArg.tenantName}/${queryArg.obtainableBundleSetId}`,
          params: {
            material_metadata_set_id: queryArg.materialMetadataSetId,
          },
        }),
        providesTags: ["multiple_price_availability"],
      }),
      createObtainableBundleItemSet: build.mutation<
        CreateObtainableBundleItemSetApiResponse,
        CreateObtainableBundleItemSetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/multiple_price_availability/${queryArg.tenantName}`,
          method: "POST",
          body: queryArg.obtainableBundleItemSetCreate,
        }),
        invalidatesTags: ["multiple_price_availability"],
      }),
      listProductGroupings: build.query<
        ListProductGroupingsApiResponse,
        ListProductGroupingsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/product_groups/${queryArg.tenantName}`,
        }),
        providesTags: ["product_groups"],
      }),
      createProductGrouping: build.mutation<
        CreateProductGroupingApiResponse,
        CreateProductGroupingApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/product_groups/${queryArg.tenantName}`,
          method: "POST",
          body: queryArg.productGroupingCreate,
        }),
        invalidatesTags: ["product_groups"],
      }),
      getProductGrouping: build.query<
        GetProductGroupingApiResponse,
        GetProductGroupingApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/product_groups/${queryArg.tenantName}/${queryArg.productGroupingId}`,
        }),
        providesTags: ["product_groups"],
      }),
      listProductGroupPlans: build.query<
        ListProductGroupPlansApiResponse,
        ListProductGroupPlansApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/product_group_plans/${queryArg.tenantName}`,
        }),
        providesTags: ["product_group_plans"],
      }),
      createProductGroupPlan: build.mutation<
        CreateProductGroupPlanApiResponse,
        CreateProductGroupPlanApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/product_group_plans/${queryArg.tenantName}`,
          method: "POST",
          body: queryArg.productGroupPlanCreate,
        }),
        invalidatesTags: ["product_group_plans"],
      }),
      getProductGroupPlan: build.query<
        GetProductGroupPlanApiResponse,
        GetProductGroupPlanApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/product_group_plans/${queryArg.tenantName}/${queryArg.productGroupPlanId}`,
        }),
        providesTags: ["product_group_plans"],
      }),
      getTypicalProductGroupPlan: build.query<
        GetTypicalProductGroupPlanApiResponse,
        GetTypicalProductGroupPlanApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/product_group_plans/typical_production/${queryArg.tenantName}/${queryArg.productGroupingId}`,
          params: {
            num_heats: queryArg.numHeats,
          },
        }),
        providesTags: ["product_group_plans"],
      }),
      getProductGroupPlanItemsFromSteelGradePlanItems: build.mutation<
        GetProductGroupPlanItemsFromSteelGradePlanItemsApiResponse,
        GetProductGroupPlanItemsFromSteelGradePlanItemsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/product_group_plans/from_steel_grade_plan_items/${queryArg.tenantName}/${queryArg.productGroupingId}`,
          method: "POST",
          body: queryArg.steelGradePlanItems,
        }),
        invalidatesTags: ["product_group_plans"],
      }),
      listSearches: build.query<ListSearchesApiResponse, ListSearchesApiArg>({
        query: (queryArg) => ({
          url: `/api/v2/search/${queryArg.tenantName}`,
          params: {
            ordering: queryArg.ordering,
            session_id: queryArg.sessionId,
            limit: queryArg.limit,
            status: queryArg.status,
          },
        }),
        providesTags: ["search"],
      }),
      sendSearchNotification: build.mutation<
        SendSearchNotificationApiResponse,
        SendSearchNotificationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/search/${queryArg.tenantName}/${queryArg.searchId}/notify`,
          method: "POST",
        }),
        invalidatesTags: ["search"],
      }),
      createSearchFromContext: build.mutation<
        CreateSearchFromContextApiResponse,
        CreateSearchFromContextApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/search/${queryArg.tenantName}/${queryArg.searchId}/context`,
          method: "POST",
          params: {
            chef_grouping_source: queryArg.chefGroupingSource,
          },
        }),
        invalidatesTags: ["search"],
      }),
      runSearch: build.mutation<RunSearchApiResponse, RunSearchApiArg>({
        query: (queryArg) => ({
          url: `/api/v2/search/${queryArg.tenantName}/${queryArg.searchId}/run`,
          method: "POST",
          body: queryArg.runSearchOptions,
        }),
        invalidatesTags: ["search"],
      }),
      getSearch: build.query<GetSearchApiResponse, GetSearchApiArg>({
        query: (queryArg) => ({
          url: `/api/v2/search/${queryArg.tenantName}/search_parameters/${queryArg.searchId}`,
        }),
        providesTags: ["search"],
      }),
      createSearch: build.mutation<CreateSearchApiResponse, CreateSearchApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/v2/search/${queryArg.tenantName}/search_parameters`,
            method: "POST",
            body: queryArg.searchCreate,
          }),
          invalidatesTags: ["search"],
        },
      ),
      getSearchContext: build.query<
        GetSearchContextApiResponse,
        GetSearchContextApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/search/${queryArg.tenantName}/search_context/${queryArg.searchContextId}`,
        }),
        providesTags: ["search"],
      }),
      getNameBasedSearch: build.query<
        GetNameBasedSearchApiResponse,
        GetNameBasedSearchApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/search/${queryArg.tenantName}/name_based_search/${queryArg.searchId}`,
        }),
        providesTags: ["search"],
      }),
      overwriteFromNameBasedSearch: build.mutation<
        OverwriteFromNameBasedSearchApiResponse,
        OverwriteFromNameBasedSearchApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/search/${queryArg.tenantName}/name_based_search/${queryArg.searchId}`,
          method: "POST",
          body: queryArg.nameBasedSearch,
        }),
        invalidatesTags: ["search"],
      }),
      applyNameBasedSearchDiff: build.mutation<
        ApplyNameBasedSearchDiffApiResponse,
        ApplyNameBasedSearchDiffApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/search/${queryArg.tenantName}/name_based_search/${queryArg.searchId}/apply_diff`,
          method: "POST",
          body: queryArg.nameBasedSearchDiff,
        }),
        invalidatesTags: ["search"],
      }),
      getNameBasedSearchDiff: build.query<
        GetNameBasedSearchDiffApiResponse,
        GetNameBasedSearchDiffApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/search/${queryArg.tenantName}/diff/${queryArg.sourceSearchId}/${queryArg.targetSearchId}`,
        }),
        providesTags: ["search"],
      }),
      getNameBasedSearchObjectDiff: build.mutation<
        GetNameBasedSearchObjectDiffApiResponse,
        GetNameBasedSearchObjectDiffApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/search/${queryArg.tenantName}/diff`,
          method: "POST",
          body: queryArg.nameBasedSearchDiffRequest,
        }),
        invalidatesTags: ["search"],
      }),
      listDeployedPlans: build.query<
        ListDeployedPlansApiResponse,
        ListDeployedPlansApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/plan/${queryArg.tenantName}/deployed`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["plan"],
      }),
      listDeployedPlanDays: build.query<
        ListDeployedPlanDaysApiResponse,
        ListDeployedPlanDaysApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/plan/${queryArg.tenantName}/deployed/days`,
          params: {
            timezone: queryArg.timezone,
            limit: queryArg.limit,
            offset: queryArg.offset,
            match_text: queryArg.matchText,
            match_date: queryArg.matchDate,
          },
        }),
        providesTags: ["plan"],
      }),
      sendPlanNotification: build.mutation<
        SendPlanNotificationApiResponse,
        SendPlanNotificationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/plan/${queryArg.tenantName}/${queryArg.planId}/send_notification`,
          method: "POST",
          params: {
            plan_name: queryArg.planName,
          },
        }),
        invalidatesTags: ["plan"],
      }),
      createPlanFromStandingRecipe: build.mutation<
        CreatePlanFromStandingRecipeApiResponse,
        CreatePlanFromStandingRecipeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/plan/${queryArg.tenantName}/from-standing-recipe`,
          method: "POST",
        }),
        invalidatesTags: ["plan"],
      }),
      previewLayering: build.mutation<
        PreviewLayeringApiResponse,
        PreviewLayeringApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/plan/${queryArg.tenantName}/preview-layering`,
          method: "POST",
          body: queryArg.mixCreate,
        }),
        invalidatesTags: ["plan"],
      }),
      updatePlanResults: build.mutation<
        UpdatePlanResultsApiResponse,
        UpdatePlanResultsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/plan/${queryArg.tenantName}/${queryArg.planId}/results`,
          method: "POST",
          body: queryArg.planMixUpdates,
        }),
        invalidatesTags: ["plan"],
      }),
      updateAndDeployPlanResults: build.mutation<
        UpdateAndDeployPlanResultsApiResponse,
        UpdateAndDeployPlanResultsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/plan/${queryArg.tenantName}/${queryArg.planId}/results/deploy`,
          method: "POST",
          body: queryArg.deployedPlanMixUpdates,
        }),
        invalidatesTags: ["plan"],
      }),
      comparePlanPeriods: build.query<
        ComparePlanPeriodsApiResponse,
        ComparePlanPeriodsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/plan/${queryArg.tenantName}/plan-period-comparison`,
          params: {
            plan_id: queryArg.planId,
            period: queryArg.period,
            baseline_plan_id: queryArg.baselinePlanId,
            baseline_period: queryArg.baselinePeriod,
          },
        }),
        providesTags: ["plan"],
      }),
      compareMixes: build.query<CompareMixesApiResponse, CompareMixesApiArg>({
        query: (queryArg) => ({
          url: `/api/v2/plan/${queryArg.tenantName}/mix/compare/${queryArg.materialMetadataSetId}/${queryArg.srcMixId}/${queryArg.tgtMixId}`,
        }),
        providesTags: ["plan"],
      }),
      getPlanAncestors: build.query<
        GetPlanAncestorsApiResponse,
        GetPlanAncestorsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/plan/${queryArg.tenantName}/${queryArg.planId}/ancestors`,
        }),
        providesTags: ["plan"],
      }),
      getBackups: build.query<GetBackupsApiResponse, GetBackupsApiArg>({
        query: (queryArg) => ({
          url: `/api/v2/plan/${queryArg.tenantName}/${queryArg.planId}/backups`,
        }),
        providesTags: ["plan"],
      }),
      getPlan: build.query<GetPlanApiResponse, GetPlanApiArg>({
        query: (queryArg) => ({
          url: `/api/v2/plan/${queryArg.tenantName}/${queryArg.planId}`,
        }),
        providesTags: ["plan"],
      }),
      copyDeployedPlanMixes: build.mutation<
        CopyDeployedPlanMixesApiResponse,
        CopyDeployedPlanMixesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/plan/copy_deployed_mixes/${queryArg.tenantName}/${queryArg.targetPlanId}`,
          method: "POST",
          params: {
            deployment_cutoff: queryArg.deploymentCutoff,
          },
        }),
        invalidatesTags: ["plan"],
      }),
      listSessions: build.query<ListSessionsApiResponse, ListSessionsApiArg>({
        query: (queryArg) => ({
          url: `/api/v2/session/${queryArg.tenantName}`,
        }),
        providesTags: ["session"],
      }),
      createSession: build.mutation<
        CreateSessionApiResponse,
        CreateSessionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/session/${queryArg.tenantName}`,
          method: "POST",
          body: queryArg.sessionCreate,
        }),
        invalidatesTags: ["session"],
      }),
      listSessionVersions: build.query<
        ListSessionVersionsApiResponse,
        ListSessionVersionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/session/${queryArg.tenantName}/versions`,
        }),
        providesTags: ["session"],
      }),
      renameSession: build.mutation<
        RenameSessionApiResponse,
        RenameSessionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/session/${queryArg.tenantName}/${queryArg.sessionId}`,
          method: "PATCH",
          body: queryArg.renameSession,
        }),
        invalidatesTags: ["session"],
      }),
      deleteSession: build.mutation<
        DeleteSessionApiResponse,
        DeleteSessionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/session/${queryArg.tenantName}/${queryArg.sessionId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["session"],
      }),
      copySearch: build.mutation<CopySearchApiResponse, CopySearchApiArg>({
        query: (queryArg) => ({
          url: `/api/v2/session/${queryArg.tenantName}/${queryArg.sessionId}`,
          method: "POST",
          body: queryArg.copySearch,
        }),
        invalidatesTags: ["session"],
      }),
      getResult: build.query<GetResultApiResponse, GetResultApiArg>({
        query: (queryArg) => ({
          url: `/api/v2/result/${queryArg.tenantName}/${queryArg.searchId}`,
        }),
        providesTags: ["result"],
      }),
      getNameBasedResults: build.query<
        GetNameBasedResultsApiResponse,
        GetNameBasedResultsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/result/name_based/${queryArg.tenantName}/${queryArg.searchId}`,
        }),
        providesTags: ["result"],
      }),
      getNameBasedResult: build.query<
        GetNameBasedResultApiResponse,
        GetNameBasedResultApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/result/name_based_single/${queryArg.tenantName}/${queryArg.planId}`,
        }),
        providesTags: ["result"],
      }),
      saveUploadedFile: build.mutation<
        SaveUploadedFileApiResponse,
        SaveUploadedFileApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/uploaded_files/${queryArg.tenantName}/files`,
          method: "POST",
          body: queryArg.uploadedFileCreate,
        }),
        invalidatesTags: ["uploaded_files"],
      }),
      listUploadedFiles: build.query<
        ListUploadedFilesApiResponse,
        ListUploadedFilesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/uploaded_files/${queryArg.tenantName}/files`,
          params: {
            types: queryArg.types,
            deleted: queryArg.deleted,
            since: queryArg.since,
            limit: queryArg.limit,
            order: queryArg.order,
          },
        }),
        providesTags: ["uploaded_files"],
      }),
      saveAndParseFile: build.mutation<
        SaveAndParseFileApiResponse,
        SaveAndParseFileApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/uploaded_files/${queryArg.tenantName}/save_and_parse`,
          method: "POST",
          body: queryArg.uploadedFileCreate,
        }),
        invalidatesTags: ["uploaded_files"],
      }),
      uploadAdhocFile: build.mutation<
        UploadAdhocFileApiResponse,
        UploadAdhocFileApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/uploaded_files/${queryArg.tenantName}/adhoc`,
          method: "POST",
          body: queryArg.file,
        }),
        invalidatesTags: ["uploaded_files"],
      }),
      getUploadedFile: build.query<
        GetUploadedFileApiResponse,
        GetUploadedFileApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/uploaded_files/${queryArg.tenantName}/files/${queryArg.uploadedFileId}`,
        }),
        providesTags: ["uploaded_files"],
      }),
      listUploadedFileTypes: build.query<
        ListUploadedFileTypesApiResponse,
        ListUploadedFileTypesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/uploaded_files/${queryArg.tenantName}/types`,
          method: "POST",
          body: queryArg.uploadedFileOutputTypeList,
        }),
        providesTags: ["uploaded_files"],
      }),
      getParsedSearchParameters: build.query<
        GetParsedSearchParametersApiResponse,
        GetParsedSearchParametersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/uploaded_files/${queryArg.tenantName}/parsed/${queryArg.uploadedFileId}/${queryArg.materialMetadataSetId}/${queryArg.steelGradeSetId}`,
        }),
        providesTags: ["uploaded_files"],
      }),
      getLayering: build.mutation<GetLayeringApiResponse, GetLayeringApiArg>({
        query: (queryArg) => ({
          url: `/api/v2/published_charge_schedules/${queryArg.tenantName}/${queryArg.planId}/${queryArg.period}/${queryArg.groupId}/${queryArg.mixNumber}`,
          method: "POST",
        }),
        invalidatesTags: ["publish"],
      }),
      publishPlanChargeSchedule: build.mutation<
        PublishPlanChargeScheduleApiResponse,
        PublishPlanChargeScheduleApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/published_charge_schedules/${queryArg.tenantName}/new`,
          method: "POST",
          body: queryArg.publishPlans,
        }),
        invalidatesTags: ["publish"],
      }),
      listNewPublishedChargeSchedules: build.query<
        ListNewPublishedChargeSchedulesApiResponse,
        ListNewPublishedChargeSchedulesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/published_charge_schedules/${queryArg.tenantName}/new`,
        }),
        providesTags: ["publish"],
      }),
      listAllPublishedChargeSchedules: build.query<
        ListAllPublishedChargeSchedulesApiResponse,
        ListAllPublishedChargeSchedulesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/published_charge_schedules/${queryArg.tenantName}/all`,
          params: {
            plan_id: queryArg.planId,
          },
        }),
        providesTags: ["publish"],
      }),
      confirmPublishedChargeSchedules: build.mutation<
        ConfirmPublishedChargeSchedulesApiResponse,
        ConfirmPublishedChargeSchedulesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/published_charge_schedules/${queryArg.tenantName}/confirm`,
          method: "POST",
          body: queryArg.confirmChargeSchedules,
        }),
        invalidatesTags: ["publish"],
      }),
      listConfirmedChargeScheduleMeta: build.mutation<
        ListConfirmedChargeScheduleMetaApiResponse,
        ListConfirmedChargeScheduleMetaApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/published_charge_schedules/${queryArg.tenantName}/confirmed`,
          method: "POST",
          body: queryArg.fdmChargeScheduleIds,
        }),
        invalidatesTags: ["publish"],
      }),
      getPublishPreflight: build.query<
        GetPublishPreflightApiResponse,
        GetPublishPreflightApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/published_charge_schedules/${queryArg.tenantName}/publish-preflight`,
          params: {
            plan_id: queryArg.planId,
            period: queryArg.period,
            chef_group_ids: queryArg.chefGroupIds,
          },
        }),
        providesTags: ["publish"],
      }),
      getChargeScheduleMessageTemplate: build.query<
        GetChargeScheduleMessageTemplateApiResponse,
        GetChargeScheduleMessageTemplateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/published_charge_schedules/${queryArg.tenantName}/message-template`,
          params: {
            plan_id: queryArg.planId,
            period: queryArg.period,
            chef_group_ids: queryArg.chefGroupIds,
          },
        }),
        providesTags: ["publish"],
      }),
      sendChargeScheduleMessageList: build.mutation<
        SendChargeScheduleMessageListApiResponse,
        SendChargeScheduleMessageListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/published_charge_schedules/${queryArg.tenantName}/messages`,
          method: "POST",
          body: queryArg.chargeScheduleMessages,
        }),
        invalidatesTags: ["publish"],
      }),
      sendPlanDeployedMessage: build.mutation<
        SendPlanDeployedMessageApiResponse,
        SendPlanDeployedMessageApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/published_charge_schedules/${queryArg.tenantName}/message/${queryArg.planId}`,
          method: "POST",
        }),
        invalidatesTags: ["publish"],
      }),
      getActiveChargeSchedules: build.query<
        GetActiveChargeSchedulesApiResponse,
        GetActiveChargeSchedulesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/published_charge_schedules/${queryArg.tenantName}/active`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
          },
        }),
        providesTags: ["publish"],
      }),
      listMessages: build.query<ListMessagesApiResponse, ListMessagesApiArg>({
        query: (queryArg) => ({
          url: `/api/v2/messages/${queryArg.tenantName}`,
          params: {
            user_uid: queryArg.userUid,
            start: queryArg.start,
            end: queryArg.end,
            message_type_filter: queryArg.messageTypeFilter,
          },
        }),
        providesTags: ["messages"],
      }),
      addSentMessage: build.mutation<
        AddSentMessageApiResponse,
        AddSentMessageApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/messages/${queryArg.tenantName}`,
          method: "POST",
          body: queryArg.addSentMessageRequest,
        }),
        invalidatesTags: ["messages"],
      }),
      confirmMessageSent: build.mutation<
        ConfirmMessageSentApiResponse,
        ConfirmMessageSentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/messages/${queryArg.tenantName}/${queryArg.messageId}`,
          method: "POST",
        }),
        invalidatesTags: ["messages"],
      }),
      createInventoryMeasurementSet: build.mutation<
        CreateInventoryMeasurementSetApiResponse,
        CreateInventoryMeasurementSetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/inventory/${queryArg.tenantName}/measurement`,
          method: "POST",
          body: queryArg.inventoryMeasurementSetCreate,
        }),
        invalidatesTags: ["inventory"],
      }),
      getInventoryEstimateAtTimestamp: build.query<
        GetInventoryEstimateAtTimestampApiResponse,
        GetInventoryEstimateAtTimestampApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/inventory_estimate/${queryArg.tenantName}`,
          params: {
            material_metadata_set_id: queryArg.materialMetadataSetId,
            material_physics_set_id: queryArg.materialPhysicsSetId,
            timestamp: queryArg.timestamp,
          },
        }),
        providesTags: ["inventory"],
      }),
      getInventoryEstimateAtTimestampForMeasurement: build.query<
        GetInventoryEstimateAtTimestampForMeasurementApiResponse,
        GetInventoryEstimateAtTimestampForMeasurementApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/inventory_estimate_for_measurement/${queryArg.tenantName}`,
          params: {
            material_metadata_set_id: queryArg.materialMetadataSetId,
            material_physics_set_id: queryArg.materialPhysicsSetId,
            timestamp: queryArg.timestamp,
          },
        }),
        providesTags: ["inventory"],
      }),
      getInventoryBreakdownAtTimestamp: build.query<
        GetInventoryBreakdownAtTimestampApiResponse,
        GetInventoryBreakdownAtTimestampApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/inventory_breakdown/${queryArg.tenantName}`,
          params: {
            timestamp: queryArg.timestamp,
          },
        }),
        providesTags: ["inventory"],
      }),
      getLatestInventoryMeasurementCreatedAt: build.query<
        GetLatestInventoryMeasurementCreatedAtApiResponse,
        GetLatestInventoryMeasurementCreatedAtApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/inventory/${queryArg.tenantName}/measurement/latest/created_at`,
        }),
        providesTags: ["inventory"],
      }),
      getInventoryMeasurementCompliance: build.query<
        GetInventoryMeasurementComplianceApiResponse,
        GetInventoryMeasurementComplianceApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/inventory/${queryArg.tenantName}/measurement/${queryArg.measurementSetId}/compliance`,
        }),
        providesTags: ["inventory"],
      }),
      getRecipesImpuritiesStats: build.query<
        GetRecipesImpuritiesStatsApiResponse,
        GetRecipesImpuritiesStatsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/recipes/impurities/${queryArg.tenantName}/${queryArg.planId}`,
          params: {
            mix_id: queryArg.mixId,
            period: queryArg.period,
            steel_grade_ids: queryArg.steelGradeIds,
          },
        }),
        providesTags: ["inventory"],
      }),
      createTargetBasketSet: build.mutation<
        CreateTargetBasketSetApiResponse,
        CreateTargetBasketSetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/target_baskets/${queryArg.tenantName}`,
          method: "POST",
          body: queryArg.targetBasketSetCreate,
        }),
        invalidatesTags: ["target_baskets"],
      }),
      updateDefaultTargetBasketsSet: build.mutation<
        UpdateDefaultTargetBasketsSetApiResponse,
        UpdateDefaultTargetBasketsSetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/target_baskets/${queryArg.tenantName}/default`,
          method: "POST",
          body: queryArg.updateDefaultTargetBasketSetRequest,
        }),
        invalidatesTags: ["target_baskets"],
      }),
      getTargetBasketSet: build.query<
        GetTargetBasketSetApiResponse,
        GetTargetBasketSetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/target_baskets/${queryArg.tenantName}/${queryArg.targetBasketSetId}`,
          params: {
            source: queryArg.source,
          },
        }),
        providesTags: ["target_baskets"],
      }),
      checkParameterFeasibility: build.mutation<
        CheckParameterFeasibilityApiResponse,
        CheckParameterFeasibilityApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/parameter_feasibility/${queryArg.tenantName}/check`,
          method: "POST",
          body: queryArg.checkParameterFeasibilityRequest,
        }),
        invalidatesTags: ["parameter_feasibility"],
      }),
      addUsers: build.mutation<AddUsersApiResponse, AddUsersApiArg>({
        query: (queryArg) => ({
          url: `/api/v2/auth/${queryArg.tenantName}/add-users`,
          method: "POST",
          body: queryArg.addUsersRequest,
        }),
        invalidatesTags: ["invite", "auth"],
      }),
      generateSignInLink: build.mutation<
        GenerateSignInLinkApiResponse,
        GenerateSignInLinkApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/auth/${queryArg.tenantName}/generate-sign-in-link`,
          method: "POST",
          body: queryArg.generateSignInLinkRequest,
        }),
        invalidatesTags: ["invite", "auth"],
      }),
      sendInviteEmail: build.mutation<
        SendInviteEmailApiResponse,
        SendInviteEmailApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/auth/${queryArg.tenantName}/send-invite-email`,
          method: "POST",
          body: queryArg.sendInviteEmailRequest,
        }),
        invalidatesTags: ["invite", "auth"],
      }),
      getPendingInvites: build.query<
        GetPendingInvitesApiResponse,
        GetPendingInvitesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/auth/${queryArg.tenantName}/invite`,
        }),
        providesTags: ["invite", "auth"],
      }),
      deleteUserInvite: build.mutation<
        DeleteUserInviteApiResponse,
        DeleteUserInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/auth/${queryArg.tenantName}/invite`,
          method: "DELETE",
          params: {
            email: queryArg.email,
          },
        }),
        invalidatesTags: ["invite", "auth"],
      }),
      listLabelReservationSettings: build.query<
        ListLabelReservationSettingsApiResponse,
        ListLabelReservationSettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/label_reservation_settings/${queryArg.tenantName}/settings`,
        }),
        providesTags: ["label_reservation_settings"],
      }),
      createLabelReservationSettings: build.mutation<
        CreateLabelReservationSettingsApiResponse,
        CreateLabelReservationSettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/label_reservation_settings/${queryArg.tenantName}/settings`,
          method: "POST",
          body: queryArg.labelReservationSettingsCreate,
        }),
        invalidatesTags: ["label_reservation_settings"],
      }),
      updateLabelReservationSettings: build.mutation<
        UpdateLabelReservationSettingsApiResponse,
        UpdateLabelReservationSettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/label_reservation_settings/${queryArg.tenantName}/settings/${queryArg.settingsId}`,
          method: "PUT",
          body: queryArg.labelReservationSettingsUpdate,
        }),
        invalidatesTags: ["label_reservation_settings"],
      }),
      deleteLabelReservationSettings: build.mutation<
        DeleteLabelReservationSettingsApiResponse,
        DeleteLabelReservationSettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/label_reservation_settings/${queryArg.tenantName}/settings/${queryArg.settingsId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["label_reservation_settings"],
      }),
      setDefaultLabelReservationSettings: build.mutation<
        SetDefaultLabelReservationSettingsApiResponse,
        SetDefaultLabelReservationSettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/label_reservation_settings/${queryArg.tenantName}/settings/${queryArg.settingsId}/default`,
          method: "POST",
        }),
        invalidatesTags: ["label_reservation_settings"],
      }),
      listLabelReservationSettingsAssignments: build.query<
        ListLabelReservationSettingsAssignmentsApiResponse,
        ListLabelReservationSettingsAssignmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/label_reservation_settings/${queryArg.tenantName}/assignments`,
        }),
        providesTags: ["label_reservation_settings"],
      }),
      assignUserLabelReservationSettings: build.mutation<
        AssignUserLabelReservationSettingsApiResponse,
        AssignUserLabelReservationSettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/label_reservation_settings/${queryArg.tenantName}/assignments`,
          method: "POST",
          body: queryArg.userSettingsAssignment,
        }),
        invalidatesTags: ["label_reservation_settings"],
      }),
      unassignUserLabelReservationSettings: build.mutation<
        UnassignUserLabelReservationSettingsApiResponse,
        UnassignUserLabelReservationSettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/label_reservation_settings/${queryArg.tenantName}/assignments/${queryArg.userId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["label_reservation_settings"],
      }),
      getResolvedLabelReservationSettings: build.query<
        GetResolvedLabelReservationSettingsApiResponse,
        GetResolvedLabelReservationSettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/label_reservation_settings/${queryArg.tenantName}/resolved`,
        }),
        providesTags: ["label_reservation_settings"],
      }),
      getReviewDayOverview: build.query<
        GetReviewDayOverviewApiResponse,
        GetReviewDayOverviewApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/label_review/${queryArg.tenantName}/review_day_overview`,
          params: {
            date: queryArg.date,
            location: queryArg.location,
            review_reasons: queryArg.reviewReasons,
            cache_compression: queryArg.cacheCompression,
          },
        }),
        providesTags: ["label_review"],
      }),
      getSiteReviewPeriods: build.query<
        GetSiteReviewPeriodsApiResponse,
        GetSiteReviewPeriodsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/label_review/${queryArg.tenantName}/site_review_periods`,
          params: {
            date: queryArg.date,
            cache_compression: queryArg.cacheCompression,
          },
        }),
        providesTags: ["label_review"],
      }),
      getReviewMonthSummary: build.query<
        GetReviewMonthSummaryApiResponse,
        GetReviewMonthSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/label_review/${queryArg.tenantName}/review_month_summary`,
          method: "POST",
          body: queryArg.materialAreaFilterList,
          params: {
            location: queryArg.location,
            month_start: queryArg.monthStart,
            month_end: queryArg.monthEnd,
            include_flags: queryArg.includeFlags,
            include_count_categories: queryArg.includeCountCategories,
            consumption_limit_to: queryArg.consumptionLimitTo,
            review_reasons: queryArg.reviewReasons,
            projection: queryArg.projection,
            cache_compression: queryArg.cacheCompression,
          },
        }),
        providesTags: ["label_review"],
      }),
      getCommentedEvents: build.query<
        GetCommentedEventsApiResponse,
        GetCommentedEventsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/label_review/${queryArg.tenantName}/commented_events`,
          params: {
            location: queryArg.location,
            start: queryArg.start,
            end: queryArg.end,
            cache_compression: queryArg.cacheCompression,
          },
        }),
        providesTags: ["label_review"],
      }),
      getEventsForReview: build.query<
        GetEventsForReviewApiResponse,
        GetEventsForReviewApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/label_review/${queryArg.tenantName}/events_for_review`,
          params: {
            window_start: queryArg.windowStart,
            window_end: queryArg.windowEnd,
            location: queryArg.location,
            target_number_of_labellers: queryArg.targetNumberOfLabellers,
            minimum_intersection_over_union:
              queryArg.minimumIntersectionOverUnion,
            merge_events_separated_by_gap_seconds:
              queryArg.mergeEventsSeparatedByGapSeconds,
            excluded_period_ids: queryArg.excludedPeriodIds,
            exclude_material_period_ids: queryArg.excludeMaterialPeriodIds,
            exclude_timing_period_ids: queryArg.excludeTimingPeriodIds,
            include_verified: queryArg.includeVerified,
            exclusion_mode: queryArg.exclusionMode,
            omitted_model_statuses: queryArg.omittedModelStatuses,
            cache_compression: queryArg.cacheCompression,
          },
        }),
        providesTags: ["label_review"],
      }),
      unverifyPeriod: build.mutation<
        UnverifyPeriodApiResponse,
        UnverifyPeriodApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/label_review/${queryArg.tenantName}/periods/${queryArg.periodId}/verify`,
          method: "DELETE",
          params: {
            cache_compression: queryArg.cacheCompression,
          },
        }),
        invalidatesTags: ["label_review"],
      }),
      uploadCorrectedEventsAndVerify: build.mutation<
        UploadCorrectedEventsAndVerifyApiResponse,
        UploadCorrectedEventsAndVerifyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/label_review/${queryArg.tenantName}/periods/corrected_events`,
          method: "POST",
          body: queryArg.correctedEventsForPeriods,
          params: {
            cache_compression: queryArg.cacheCompression,
          },
        }),
        invalidatesTags: ["label_review"],
      }),
      markCommentEventReviewed: build.mutation<
        MarkCommentEventReviewedApiResponse,
        MarkCommentEventReviewedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/label_review/${queryArg.tenantName}/events/${queryArg.eventId}/reviewed`,
          method: "POST",
        }),
        invalidatesTags: ["label_review"],
      }),
      assignPeriods: build.mutation<
        AssignPeriodsApiResponse,
        AssignPeriodsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/label_review/${queryArg.tenantName}/periods/assign`,
          method: "POST",
          params: {
            period_ids: queryArg.periodIds,
            assigned_to_id: queryArg.assignedToId,
            cache_compression: queryArg.cacheCompression,
          },
        }),
        invalidatesTags: ["label_review"],
      }),
      unassignPeriods: build.mutation<
        UnassignPeriodsApiResponse,
        UnassignPeriodsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/label_review/${queryArg.tenantName}/periods/unassign`,
          method: "POST",
          params: {
            period_ids: queryArg.periodIds,
            cache_compression: queryArg.cacheCompression,
          },
        }),
        invalidatesTags: ["label_review"],
      }),
      getUnverifiedPeriods: build.query<
        GetUnverifiedPeriodsApiResponse,
        GetUnverifiedPeriodsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/label_review/${queryArg.tenantName}/unverified_periods`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
            location: queryArg.location,
            cache_compression: queryArg.cacheCompression,
          },
        }),
        providesTags: ["label_review"],
      }),
      getUnverifiedDates: build.query<
        GetUnverifiedDatesApiResponse,
        GetUnverifiedDatesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/label_review/${queryArg.tenantName}/unverified_dates`,
          params: {
            location: queryArg.location,
            cache_compression: queryArg.cacheCompression,
          },
        }),
        providesTags: ["label_review"],
      }),
      getAssignedReviewPeriods: build.query<
        GetAssignedReviewPeriodsApiResponse,
        GetAssignedReviewPeriodsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/label_review/${queryArg.tenantName}/assigned_review_periods`,
          params: {
            location: queryArg.location,
            cache_compression: queryArg.cacheCompression,
          },
        }),
        providesTags: ["label_review"],
      }),
      getLabellerTimelinesReport: build.query<
        GetLabellerTimelinesReportApiResponse,
        GetLabellerTimelinesReportApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/label_review/${queryArg.tenantName}/labeller_timelines`,
          params: {
            window_start: queryArg.windowStart,
            window_end: queryArg.windowEnd,
            location: queryArg.location,
            model: queryArg.model,
            cache_compression: queryArg.cacheCompression,
          },
        }),
        providesTags: ["label_review"],
      }),
      createEvent: build.mutation<CreateEventApiResponse, CreateEventApiArg>({
        query: (queryArg) => ({
          url: `/api/v2/labelled_events/${queryArg.tenantName}/event`,
          method: "POST",
          body: queryArg.eventCreate,
        }),
        invalidatesTags: ["labelled_events"],
      }),
      createEventsForReservations: build.mutation<
        CreateEventsForReservationsApiResponse,
        CreateEventsForReservationsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/labelled_events/${queryArg.tenantName}/events`,
          method: "POST",
          body: queryArg.eventsCreate,
        }),
        invalidatesTags: ["labelled_events"],
      }),
      listEvents: build.query<ListEventsApiResponse, ListEventsApiArg>({
        query: (queryArg) => ({
          url: `/api/v2/labelled_events/${queryArg.tenantName}/events`,
          params: {
            event_types: queryArg.eventTypes,
            start: queryArg.start,
            end: queryArg.end,
          },
        }),
        providesTags: ["labelled_events"],
      }),
      getReservedPeriods: build.query<
        GetReservedPeriodsApiResponse,
        GetReservedPeriodsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/labelled_events/${queryArg.tenantName}/periods/reserve`,
          params: {
            location: queryArg.location,
          },
        }),
        providesTags: ["labelled_events"],
      }),
      reserveLabellingPeriods: build.mutation<
        ReserveLabellingPeriodsApiResponse,
        ReserveLabellingPeriodsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/labelled_events/${queryArg.tenantName}/periods/reserve`,
          method: "POST",
          params: {
            max_duration_seconds: queryArg.maxDurationSeconds,
            location: queryArg.location,
            reserve_from: queryArg.reserveFrom,
            reserve_until: queryArg.reserveUntil,
            allowed_coverage_gap_seconds: queryArg.allowedCoverageGapSeconds,
            required_angles: queryArg.requiredAngles,
            reservation_seconds: queryArg.reservationSeconds,
            maximum_number_of_labellers: queryArg.maximumNumberOfLabellers,
            target_number_of_labellers: queryArg.targetNumberOfLabellers,
            label_coverage_priority: queryArg.labelCoveragePriority,
            ignore_coverage: queryArg.ignoreCoverage,
          },
        }),
        invalidatesTags: ["labelled_events"],
      }),
      reserveLabellingPeriodsForModel: build.mutation<
        ReserveLabellingPeriodsForModelApiResponse,
        ReserveLabellingPeriodsForModelApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/labelled_events/${queryArg.tenantName}/periods/reserve/model/${queryArg.modelId}`,
          method: "POST",
          params: {
            location: queryArg.location,
            reserve_from: queryArg.reserveFrom,
            reserve_until: queryArg.reserveUntil,
            reservation_lifetime_seconds: queryArg.reservationLifetimeSeconds,
            allowed_coverage_gap_seconds: queryArg.allowedCoverageGapSeconds,
            required_angles: queryArg.requiredAngles,
            ignore_coverage: queryArg.ignoreCoverage,
          },
        }),
        invalidatesTags: ["labelled_events"],
      }),
      deletePeriodReservation: build.mutation<
        DeletePeriodReservationApiResponse,
        DeletePeriodReservationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/labelled_events/${queryArg.tenantName}/periods/${queryArg.labellingPeriodId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["labelled_events"],
      }),
      invalidatePeriods: build.mutation<
        InvalidatePeriodsApiResponse,
        InvalidatePeriodsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/labelled_events/${queryArg.tenantName}/periods/invalidate`,
          method: "POST",
          body: queryArg.periodIds,
        }),
        invalidatesTags: ["labelled_events"],
      }),
      getLatestEventExamples: build.query<
        GetLatestEventExamplesApiResponse,
        GetLatestEventExamplesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/labelled_events/${queryArg.tenantName}/guide/latest-events`,
          params: {
            location: queryArg.location,
            event_type: queryArg.eventType,
            limit: queryArg.limit,
          },
        }),
        providesTags: ["labelled_events"],
      }),
      getMaterialExamples: build.query<
        GetMaterialExamplesApiResponse,
        GetMaterialExamplesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/labelled_events/${queryArg.tenantName}/guide/material-examples/${queryArg.materialName}`,
          params: {
            location: queryArg.location,
            limit: queryArg.limit,
          },
        }),
        providesTags: ["labelled_events"],
      }),
      getLabellerVerifiedEventsComparison: build.query<
        GetLabellerVerifiedEventsComparisonApiResponse,
        GetLabellerVerifiedEventsComparisonApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/labelled_events/${queryArg.tenantName}/labeller_verified_events_comparison`,
          params: {
            window_start: queryArg.windowStart,
            window_end: queryArg.windowEnd,
            location: queryArg.location,
            labeller_id: queryArg.labellerId,
            labeller_type: queryArg.labellerType,
            include_unused_model_events: queryArg.includeUnusedModelEvents,
            minimum_intersection_over_union:
              queryArg.minimumIntersectionOverUnion,
            merge_events_separated_by_gap_seconds:
              queryArg.mergeEventsSeparatedByGapSeconds,
            cache_compression: queryArg.cacheCompression,
          },
        }),
        providesTags: ["labelled_events"],
      }),
      getLabellers: build.query<GetLabellersApiResponse, GetLabellersApiArg>({
        query: (queryArg) => ({
          url: `/api/v2/labelled_events/${queryArg.tenantName}/labellers`,
        }),
        providesTags: ["labelled_events"],
      }),
      getCostLabellers: build.query<
        GetCostLabellersApiResponse,
        GetCostLabellersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/labelled_events/${queryArg.tenantName}/cost_labellers`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
            filter_mode: queryArg.filterMode,
            location: queryArg.location,
          },
        }),
        providesTags: ["labelled_events"],
      }),
      getDailyLabellerStats: build.query<
        GetDailyLabellerStatsApiResponse,
        GetDailyLabellerStatsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/labelled_events/${queryArg.tenantName}/labeller_stats/${queryArg.labellerId}/daily`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
            filter_mode: queryArg.filterMode,
            location: queryArg.location,
            session_types: queryArg.sessionTypes,
          },
        }),
        providesTags: ["labelled_events"],
      }),
      getLabellerCostStats: build.query<
        GetLabellerCostStatsApiResponse,
        GetLabellerCostStatsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/labelled_events/${queryArg.tenantName}/labeller_cost_stats`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
            filter_mode: queryArg.filterMode,
            location: queryArg.location,
          },
        }),
        providesTags: ["labelled_events"],
      }),
      getLabellerAccuracyStats: build.query<
        GetLabellerAccuracyStatsApiResponse,
        GetLabellerAccuracyStatsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/labelled_events/${queryArg.tenantName}/labellers/${queryArg.labellerId}/accuracy_stats`,
          params: {
            location: queryArg.location,
            start: queryArg.start,
            end: queryArg.end,
          },
        }),
        providesTags: ["labelled_events"],
      }),
      getLabellerMatchedEvents: build.query<
        GetLabellerMatchedEventsApiResponse,
        GetLabellerMatchedEventsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/labelled_events/${queryArg.tenantName}/labellers/${queryArg.labellerId}/matched_events`,
          params: {
            location: queryArg.location,
            metric: queryArg.metric,
            start: queryArg.start,
            end: queryArg.end,
            predicted: queryArg.predicted,
            actual: queryArg.actual,
            page: queryArg.page,
            page_size: queryArg.pageSize,
          },
        }),
        providesTags: ["labelled_events"],
      }),
      getTenantLabellingCoverage: build.query<
        GetTenantLabellingCoverageApiResponse,
        GetTenantLabellingCoverageApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/labelling_coverage/${queryArg.tenantName}`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
            granularity: queryArg.granularity,
            gap_tolerance_seconds: queryArg.gapToleranceSeconds,
          },
        }),
        providesTags: ["labelling_coverage"],
      }),
      getLocationsLoadingTimeline: build.query<
        GetLocationsLoadingTimelineApiResponse,
        GetLocationsLoadingTimelineApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/locations_loading/${queryArg.tenantName}/timeline`,
          params: {
            date: queryArg.date,
            cache_compression: queryArg.cacheCompression,
          },
        }),
        providesTags: ["locations_loading"],
      }),
      listPendingPlanChanges: build.query<
        ListPendingPlanChangesApiResponse,
        ListPendingPlanChangesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/plan_changes/${queryArg.tenantName}/pending`,
          params: {
            acknowledged_by_uid: queryArg.acknowledgedByUid,
            since_hours: queryArg.sinceHours,
          },
        }),
        providesTags: ["plan_change_tracking"],
      }),
      listPlanChanges: build.query<
        ListPlanChangesApiResponse,
        ListPlanChangesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/plan_changes/${queryArg.tenantName}/all`,
          params: {
            since_hours: queryArg.sinceHours,
          },
        }),
        providesTags: ["plan_change_tracking"],
      }),
      getPlanChangeDetails: build.query<
        GetPlanChangeDetailsApiResponse,
        GetPlanChangeDetailsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/plan_changes/${queryArg.tenantName}/${queryArg.planId}/details`,
        }),
        providesTags: ["plan_change_tracking"],
      }),
      getPhysicalParametersSet: build.query<
        GetPhysicalParametersSetApiResponse,
        GetPhysicalParametersSetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/physical_parameters/${queryArg.tenantName}/${queryArg.physicalParametersSetId}`,
        }),
        providesTags: ["physical_parameters"],
      }),
      listSimulatorDataLoaders: build.query<
        ListSimulatorDataLoadersApiResponse,
        ListSimulatorDataLoadersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/simulator/${queryArg.tenantName}/simulator_data_loaders`,
        }),
        providesTags: ["simulator"],
      }),
      listSimulatorRuns: build.query<
        ListSimulatorRunsApiResponse,
        ListSimulatorRunsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/simulator/${queryArg.tenantName}/simulation`,
        }),
        providesTags: ["simulator"],
      }),
      getSimulatorRun: build.query<
        GetSimulatorRunApiResponse,
        GetSimulatorRunApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/simulator/${queryArg.tenantName}/simulation/${queryArg.simulatorRunId}`,
        }),
        providesTags: ["simulator"],
      }),
      summarisePlanResults: build.mutation<
        SummarisePlanResultsApiResponse,
        SummarisePlanResultsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/summaries/${queryArg.tenantName}/plan_results`,
          method: "POST",
          body: queryArg.unsummarisedPlanResults,
        }),
        invalidatesTags: ["summaries"],
      }),
      sendStrategyDashboardNotification: build.mutation<
        SendStrategyDashboardNotificationApiResponse,
        SendStrategyDashboardNotificationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/strategy_dashboard/${queryArg.tenantName}/notify`,
          method: "POST",
          body: queryArg.strategyDashboardNotification,
        }),
        invalidatesTags: ["strategy_dashboard", "strategy_dashboard"],
      }),
      getStrategyDashboardEditing: build.query<
        GetStrategyDashboardEditingApiResponse,
        GetStrategyDashboardEditingApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/strategy_dashboard/${queryArg.tenantName}/editing`,
          headers: {
            "Cache-Control": queryArg["Cache-Control"],
          },
          params: {
            start: queryArg.start,
            end: queryArg.end,
          },
        }),
        providesTags: ["strategy_dashboard", "strategy_dashboard"],
      }),
      getStrategyDashboardEditingRecipesByDate: build.query<
        GetStrategyDashboardEditingRecipesByDateApiResponse,
        GetStrategyDashboardEditingRecipesByDateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/strategy_dashboard/${queryArg.tenantName}/editing/recipes_by_date`,
          headers: {
            "Cache-Control": queryArg["Cache-Control"],
          },
          params: {
            heat_date: queryArg.heatDate,
            product_group_name: queryArg.productGroupName,
          },
        }),
        providesTags: ["strategy_dashboard", "strategy_dashboard"],
      }),
      getRecipeEditsVisualization: build.query<
        GetRecipeEditsVisualizationApiResponse,
        GetRecipeEditsVisualizationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/strategy_dashboard/${queryArg.tenantName}/editing/recipe_edits_visualization`,
          headers: {
            "Cache-Control": queryArg["Cache-Control"],
          },
          params: {
            recipe_code: queryArg.recipeCode,
          },
        }),
        providesTags: ["strategy_dashboard", "strategy_dashboard"],
      }),
      getStrategyDashboardInventory: build.query<
        GetStrategyDashboardInventoryApiResponse,
        GetStrategyDashboardInventoryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/strategy_dashboard/${queryArg.tenantName}/inventory`,
          headers: {
            "Cache-Control": queryArg["Cache-Control"],
          },
          params: {
            start: queryArg.start,
            end: queryArg.end,
          },
        }),
        providesTags: ["strategy_dashboard", "strategy_dashboard"],
      }),
      getStrategyDashboardConsumption: build.query<
        GetStrategyDashboardConsumptionApiResponse,
        GetStrategyDashboardConsumptionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/strategy_dashboard/${queryArg.tenantName}/consumption`,
          headers: {
            "Cache-Control": queryArg["Cache-Control"],
          },
          params: {
            start: queryArg.start,
            end: queryArg.end,
            time_aggregation: queryArg.timeAggregation,
            product_grouping: queryArg.productGrouping,
          },
        }),
        providesTags: ["strategy_dashboard", "strategy_dashboard"],
      }),
      getStrategyDashboardConsumptionProjection: build.query<
        GetStrategyDashboardConsumptionProjectionApiResponse,
        GetStrategyDashboardConsumptionProjectionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/strategy_dashboard/${queryArg.tenantName}/consumption_projection`,
          headers: {
            "Cache-Control": queryArg["Cache-Control"],
          },
          params: {
            on: queryArg.on,
          },
        }),
        providesTags: ["strategy_dashboard", "strategy_dashboard"],
      }),
      getStrategyDashboardProduction: build.query<
        GetStrategyDashboardProductionApiResponse,
        GetStrategyDashboardProductionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/strategy_dashboard/${queryArg.tenantName}/production`,
          headers: {
            "Cache-Control": queryArg["Cache-Control"],
          },
          params: {
            start: queryArg.start,
            end: queryArg.end,
          },
        }),
        providesTags: ["strategy_dashboard", "strategy_dashboard"],
      }),
      getStrategyDashboardProductionPace: build.query<
        GetStrategyDashboardProductionPaceApiResponse,
        GetStrategyDashboardProductionPaceApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/strategy_dashboard/${queryArg.tenantName}/production_pace`,
          headers: {
            "Cache-Control": queryArg["Cache-Control"],
          },
          params: {
            on: queryArg.on,
          },
        }),
        providesTags: ["strategy_dashboard", "strategy_dashboard"],
      }),
      getStrategyDashboardFailureRate: build.query<
        GetStrategyDashboardFailureRateApiResponse,
        GetStrategyDashboardFailureRateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/strategy_dashboard/${queryArg.tenantName}/failure_rate`,
          headers: {
            "Cache-Control": queryArg["Cache-Control"],
          },
          params: {
            start: queryArg.start,
            end: queryArg.end,
          },
        }),
        providesTags: ["strategy_dashboard", "strategy_dashboard"],
      }),
      getStrategyDashboardPrices: build.query<
        GetStrategyDashboardPricesApiResponse,
        GetStrategyDashboardPricesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/strategy_dashboard/${queryArg.tenantName}/prices`,
          headers: {
            "Cache-Control": queryArg["Cache-Control"],
          },
          params: {
            start: queryArg.start,
            end: queryArg.end,
          },
        }),
        providesTags: ["strategy_dashboard", "strategy_dashboard"],
      }),
      getStrategyDashboardScrapChefUsage: build.query<
        GetStrategyDashboardScrapChefUsageApiResponse,
        GetStrategyDashboardScrapChefUsageApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/strategy_dashboard/${queryArg.tenantName}/scrap_chef_usage`,
          headers: {
            "Cache-Control": queryArg["Cache-Control"],
          },
        }),
        providesTags: ["strategy_dashboard", "strategy_dashboard"],
      }),
      getStrategyDashboardScrapChefUsageDetailed: build.query<
        GetStrategyDashboardScrapChefUsageDetailedApiResponse,
        GetStrategyDashboardScrapChefUsageDetailedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/strategy_dashboard/${queryArg.tenantName}/scrap-chef-usage-detailed`,
          headers: {
            "Cache-Control": queryArg["Cache-Control"],
          },
        }),
        providesTags: ["strategy_dashboard", "strategy_dashboard"],
      }),
      getStrategyDashboardCost: build.query<
        GetStrategyDashboardCostApiResponse,
        GetStrategyDashboardCostApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/strategy_dashboard/${queryArg.tenantName}/cost`,
          headers: {
            "Cache-Control": queryArg["Cache-Control"],
          },
          params: {
            start: queryArg.start,
            end: queryArg.end,
            time_aggregation: queryArg.timeAggregation,
          },
        }),
        providesTags: ["strategy_dashboard", "strategy_dashboard"],
      }),
      getStrategyDashboardHeats: build.query<
        GetStrategyDashboardHeatsApiResponse,
        GetStrategyDashboardHeatsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/strategy_dashboard/${queryArg.tenantName}/heats`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
            filter_mode: queryArg.filterMode,
            page: queryArg.page,
            results_per_page: queryArg.resultsPerPage,
          },
        }),
        providesTags: ["strategy_dashboard", "strategy_dashboard"],
      }),
      getStrategyDashboardHeatsByIds: build.mutation<
        GetStrategyDashboardHeatsByIdsApiResponse,
        GetStrategyDashboardHeatsByIdsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/strategy_dashboard/${queryArg.tenantName}/heats_by_ids`,
          method: "POST",
          body: queryArg.heatIds,
        }),
        invalidatesTags: ["strategy_dashboard", "strategy_dashboard"],
      }),
      getStrategyDashboardShifts: build.query<
        GetStrategyDashboardShiftsApiResponse,
        GetStrategyDashboardShiftsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/strategy_dashboard/${queryArg.tenantName}/shifts`,
          params: {
            reference_timestamp: queryArg.referenceTimestamp,
            before: queryArg.before,
            after: queryArg.after,
          },
        }),
        providesTags: ["strategy_dashboard", "strategy_dashboard"],
      }),
      getStrategyDashboardDeliveriesAndPurchases: build.query<
        GetStrategyDashboardDeliveriesAndPurchasesApiResponse,
        GetStrategyDashboardDeliveriesAndPurchasesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/strategy_dashboard/${queryArg.tenantName}/delivery`,
          headers: {
            "Cache-Control": queryArg["Cache-Control"],
          },
          params: {
            start: queryArg.start,
            end: queryArg.end,
          },
        }),
        providesTags: ["strategy_dashboard", "strategy_dashboard"],
      }),
      getStrategyDashboardDeliveriesOverview: build.query<
        GetStrategyDashboardDeliveriesOverviewApiResponse,
        GetStrategyDashboardDeliveriesOverviewApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/strategy_dashboard/${queryArg.tenantName}/delivery_overview`,
          headers: {
            "Cache-Control": queryArg["Cache-Control"],
          },
          params: {
            on: queryArg.on,
          },
        }),
        providesTags: ["strategy_dashboard", "strategy_dashboard"],
      }),
      getStrategyDashboardCompliance: build.query<
        GetStrategyDashboardComplianceApiResponse,
        GetStrategyDashboardComplianceApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/strategy_dashboard/${queryArg.tenantName}/compliance`,
          headers: {
            "Cache-Control": queryArg["Cache-Control"],
          },
          params: {
            start: queryArg.start,
            end: queryArg.end,
          },
        }),
        providesTags: ["strategy_dashboard", "strategy_dashboard"],
      }),
      getCrewAggregatedCompliance: build.query<
        GetCrewAggregatedComplianceApiResponse,
        GetCrewAggregatedComplianceApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/strategy_dashboard/${queryArg.tenantName}/compliance/crew_aggregate`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
            exclude_materials: queryArg.excludeMaterials,
          },
        }),
        providesTags: ["strategy_dashboard", "strategy_dashboard"],
      }),
      getStrategyDashboardCrewComparison: build.query<
        GetStrategyDashboardCrewComparisonApiResponse,
        GetStrategyDashboardCrewComparisonApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/strategy_dashboard/${queryArg.tenantName}/crew_comparison`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
          },
        }),
        providesTags: ["strategy_dashboard", "strategy_dashboard"],
      }),
      getTenantSavings: build.query<
        GetTenantSavingsApiResponse,
        GetTenantSavingsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/strategy_dashboard/${queryArg.tenantName}/savings`,
        }),
        providesTags: ["strategy_dashboard", "strategy_dashboard"],
      }),
      getStrategyDashboardSavingsTimeseries: build.query<
        GetStrategyDashboardSavingsTimeseriesApiResponse,
        GetStrategyDashboardSavingsTimeseriesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/strategy_dashboard/${queryArg.tenantName}/savings-timeseries`,
        }),
        providesTags: ["strategy_dashboard", "strategy_dashboard"],
      }),
      getTenantSiopSchedule: build.query<
        GetTenantSiopScheduleApiResponse,
        GetTenantSiopScheduleApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/strategy_dashboard/${queryArg.tenantName}/siop-schedule`,
          headers: {
            "Cache-Control": queryArg["Cache-Control"],
          },
          params: {
            include_daily: queryArg.includeDaily,
            from_date: queryArg.fromDate,
          },
        }),
        providesTags: ["strategy_dashboard", "strategy_dashboard"],
      }),
      getTenantPlannedShred: build.query<
        GetTenantPlannedShredApiResponse,
        GetTenantPlannedShredApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/strategy_dashboard/${queryArg.tenantName}/planned-shred`,
        }),
        providesTags: ["strategy_dashboard", "strategy_dashboard"],
      }),
      uploadDeliveryFormPhoto: build.mutation<
        UploadDeliveryFormPhotoApiResponse,
        UploadDeliveryFormPhotoApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/delivery_form/${queryArg.tenantName}/${queryArg.formId}/upload_photo`,
          method: "POST",
          body: queryArg.file,
        }),
        invalidatesTags: ["delivery_form"],
      }),
      saveDeliveryForm: build.mutation<
        SaveDeliveryFormApiResponse,
        SaveDeliveryFormApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/delivery_form/${queryArg.tenantName}/save`,
          method: "POST",
          body: queryArg.deliveryFormSave,
        }),
        invalidatesTags: ["delivery_form"],
      }),
      listDeliveryForms: build.query<
        ListDeliveryFormsApiResponse,
        ListDeliveryFormsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/delivery_form/${queryArg.tenantName}/list`,
          params: {
            limit: queryArg.limit,
          },
        }),
        providesTags: ["delivery_form"],
      }),
      getDeliveryForm: build.query<
        GetDeliveryFormApiResponse,
        GetDeliveryFormApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/delivery_form/${queryArg.tenantName}/${queryArg.formId}`,
        }),
        providesTags: ["delivery_form"],
      }),
      getUploadedPhoto: build.query<
        GetUploadedPhotoApiResponse,
        GetUploadedPhotoApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/delivery_form/${queryArg.tenantName}/${queryArg.formId}/get_uploaded_photo`,
        }),
        providesTags: ["delivery_form"],
      }),
      processAudioWithGemini: build.mutation<
        ProcessAudioWithGeminiApiResponse,
        ProcessAudioWithGeminiApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/delivery_form/${queryArg.tenantName}/process_audio`,
          method: "POST",
          body: queryArg.processAudioWithGeminiRequest,
        }),
        invalidatesTags: ["delivery_form"],
      }),
      generateDeliveryFormName: build.mutation<
        GenerateDeliveryFormNameApiResponse,
        GenerateDeliveryFormNameApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/delivery_form/${queryArg.tenantName}/generate_name`,
          method: "POST",
          body: queryArg.deliveryFormSave,
        }),
        invalidatesTags: ["delivery_form"],
      }),
      getCacheLines: build.query<GetCacheLinesApiResponse, GetCacheLinesApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/v2/admin/cache/${queryArg.tenantName}/lines`,
          }),
          providesTags: ["cache_admin", "cache_admin"],
        },
      ),
      invalidateCacheLines: build.mutation<
        InvalidateCacheLinesApiResponse,
        InvalidateCacheLinesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/admin/cache/${queryArg.tenantName}/lines`,
          method: "DELETE",
          body: queryArg.cacheLineKeys,
        }),
        invalidatesTags: ["cache_admin", "cache_admin"],
      }),
      getLatestConsumptionProjection: build.query<
        GetLatestConsumptionProjectionApiResponse,
        GetLatestConsumptionProjectionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/consumption_projections/${queryArg.tenantName}/latest`,
          params: {
            month: queryArg.month,
          },
        }),
        providesTags: ["projections"],
      }),
      listConsumptionProjections: build.query<
        ListConsumptionProjectionsApiResponse,
        ListConsumptionProjectionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/consumption_projections/${queryArg.tenantName}`,
          params: {
            month: queryArg.month,
          },
        }),
        providesTags: ["projections"],
      }),
      createConsumptionProjection: build.mutation<
        CreateConsumptionProjectionApiResponse,
        CreateConsumptionProjectionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/consumption_projections/${queryArg.tenantName}`,
          method: "POST",
          body: queryArg.consumptionProjectionCreate,
        }),
        invalidatesTags: ["projections"],
      }),
      getLatestDeliveryAdjustment: build.query<
        GetLatestDeliveryAdjustmentApiResponse,
        GetLatestDeliveryAdjustmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/delivery_adjustments/${queryArg.tenantName}/latest`,
          params: {
            month: queryArg.month,
          },
        }),
        providesTags: ["delivery_adjustments"],
      }),
      listDeliveryAdjustments: build.query<
        ListDeliveryAdjustmentsApiResponse,
        ListDeliveryAdjustmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/delivery_adjustments/${queryArg.tenantName}`,
          params: {
            month: queryArg.month,
          },
        }),
        providesTags: ["delivery_adjustments"],
      }),
      createDeliveryAdjustment: build.mutation<
        CreateDeliveryAdjustmentApiResponse,
        CreateDeliveryAdjustmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/delivery_adjustments/${queryArg.tenantName}`,
          method: "POST",
          body: queryArg.deliveryAdjustmentCreate,
        }),
        invalidatesTags: ["delivery_adjustments"],
      }),
      runPeakShavingScenarios: build.mutation<
        RunPeakShavingScenariosApiResponse,
        RunPeakShavingScenariosApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scenarios/${queryArg.tenantName}/peak_shaving`,
          method: "POST",
          body: queryArg.peakShavingInputs,
        }),
        invalidatesTags: ["scenario_planning"],
      }),
      getScrapEyeMetadata: build.query<
        GetScrapEyeMetadataApiResponse,
        GetScrapEyeMetadataApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eye_metadata/${queryArg.tenantName}`,
        }),
        providesTags: ["scrap_eye_metadata"],
      }),
      listScrapEyeSegmentsByDevices: build.query<
        ListScrapEyeSegmentsByDevicesApiResponse,
        ListScrapEyeSegmentsByDevicesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/data/segments`,
          params: {
            device_ids: queryArg.deviceIds,
            start: queryArg.start,
            end: queryArg.end,
            kind: queryArg.kind,
          },
        }),
        providesTags: ["scrap_eyes", "scrap_eyes_data"],
      }),
      listAvailableCameraAngles: build.query<
        ListAvailableCameraAnglesApiResponse,
        ListAvailableCameraAnglesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/data/camera_angles`,
          params: {
            device_ids: queryArg.deviceIds,
            at_time: queryArg.atTime,
          },
        }),
        providesTags: ["scrap_eyes", "scrap_eyes_data"],
      }),
      renameScrapEyeDevice: build.mutation<
        RenameScrapEyeDeviceApiResponse,
        RenameScrapEyeDeviceApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/data/${queryArg.deviceId}/rename-device`,
          method: "PUT",
          body: queryArg.renameScrapEyeDeviceRequest,
        }),
        invalidatesTags: ["scrap_eyes", "scrap_eyes_data"],
      }),
      getTrainableConfig: build.query<
        GetTrainableConfigApiResponse,
        GetTrainableConfigApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/data/trainable_config`,
        }),
        providesTags: ["scrap_eyes", "scrap_eyes_data"],
      }),
      getTrainablePeriods: build.query<
        GetTrainablePeriodsApiResponse,
        GetTrainablePeriodsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/data/trainable_periods`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
            target_location: queryArg.targetLocation,
            period_duration_seconds: queryArg.periodDurationSeconds,
            angles_json: queryArg.anglesJson,
            embedding_json: queryArg.embeddingJson,
          },
        }),
        providesTags: ["scrap_eyes", "scrap_eyes_data"],
      }),
      getModelCoverageConfig: build.query<
        GetModelCoverageConfigApiResponse,
        GetModelCoverageConfigApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/data/model_coverage_config`,
        }),
        providesTags: ["scrap_eyes", "scrap_eyes_data"],
      }),
      getModelCoverage: build.query<
        GetModelCoverageApiResponse,
        GetModelCoverageApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/data/model_coverage`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
            target_location: queryArg.targetLocation,
            labelling_name: queryArg.labellingName,
            period_duration_seconds: queryArg.periodDurationSeconds,
          },
        }),
        providesTags: ["scrap_eyes", "scrap_eyes_data"],
      }),
      getJobFailures: build.query<
        GetJobFailuresApiResponse,
        GetJobFailuresApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/data/job_failures`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
            target_location: queryArg.targetLocation,
            angles_json: queryArg.anglesJson,
            labelling_name: queryArg.labellingName,
          },
        }),
        providesTags: ["scrap_eyes", "scrap_eyes_data"],
      }),
      previewTerminalFailures: build.query<
        PreviewTerminalFailuresApiResponse,
        PreviewTerminalFailuresApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/data/terminal_failures_preview`,
          params: {
            target_location: queryArg.targetLocation,
            start: queryArg.start,
            end: queryArg.end,
            angles_json: queryArg.anglesJson,
            labelling_name: queryArg.labellingName,
          },
        }),
        providesTags: ["scrap_eyes", "scrap_eyes_data"],
      }),
      resetTerminalFailures: build.mutation<
        ResetTerminalFailuresApiResponse,
        ResetTerminalFailuresApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/data/reset_terminal_failures`,
          method: "POST",
          params: {
            target_location: queryArg.targetLocation,
            start: queryArg.start,
            end: queryArg.end,
            angles_json: queryArg.anglesJson,
            labelling_name: queryArg.labellingName,
          },
        }),
        invalidatesTags: ["scrap_eyes", "scrap_eyes_data"],
      }),
      getPerformanceTimeseries: build.query<
        GetPerformanceTimeseriesApiResponse,
        GetPerformanceTimeseriesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/data/performance_timeseries`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
            target_location: queryArg.targetLocation,
            labelling_name: queryArg.labellingName,
            bucket_size_seconds: queryArg.bucketSizeSeconds,
            merge_events_separated_by_gap_seconds:
              queryArg.mergeEventsSeparatedByGapSeconds,
            area: queryArg.area,
          },
        }),
        providesTags: ["scrap_eyes", "scrap_eyes_data"],
      }),
      getDatasetSize: build.query<
        GetDatasetSizeApiResponse,
        GetDatasetSizeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/data/dataset_size`,
          params: {
            target_location: queryArg.targetLocation,
            angles_json: queryArg.anglesJson,
          },
        }),
        providesTags: ["scrap_eyes", "scrap_eyes_data"],
      }),
      getLabellingCostDaily: build.query<
        GetLabellingCostDailyApiResponse,
        GetLabellingCostDailyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/data/labelling_cost_daily`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
            group_by: queryArg.groupBy,
            cost_scope: queryArg.costScope,
          },
        }),
        providesTags: ["scrap_eyes", "scrap_eyes_data"],
      }),
      getLabellingCostDailyByLocation: build.query<
        GetLabellingCostDailyByLocationApiResponse,
        GetLabellingCostDailyByLocationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/data/labelling_cost_daily_by_location`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
            group_by: queryArg.groupBy,
            cost_scope: queryArg.costScope,
          },
        }),
        providesTags: ["scrap_eyes", "scrap_eyes_data"],
      }),
      getLabellingCostByLabeller: build.query<
        GetLabellingCostByLabellerApiResponse,
        GetLabellingCostByLabellerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/data/labelling_cost_by_labeller`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
            group_by: queryArg.groupBy,
            cost_scope: queryArg.costScope,
          },
        }),
        providesTags: ["scrap_eyes", "scrap_eyes_data"],
      }),
      getLabellingRedundancyDaily: build.query<
        GetLabellingRedundancyDailyApiResponse,
        GetLabellingRedundancyDailyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/data/labelling_redundancy_daily`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
          },
        }),
        providesTags: ["scrap_eyes", "scrap_eyes_data"],
      }),
      getReviewerTrackingDaily: build.query<
        GetReviewerTrackingDailyApiResponse,
        GetReviewerTrackingDailyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/data/reviewer_tracking_daily`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
          },
        }),
        providesTags: ["scrap_eyes", "scrap_eyes_data"],
      }),
      provisionNewManualDevice: build.mutation<
        ProvisionNewManualDeviceApiResponse,
        ProvisionNewManualDeviceApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/devices/${queryArg.name}/provision_new_manual_device`,
          method: "POST",
        }),
        invalidatesTags: ["scrap_eyes", "scrap_eyes_devices"],
      }),
      getLiveCameraVideoPlaylist: build.query<
        GetLiveCameraVideoPlaylistApiResponse,
        GetLiveCameraVideoPlaylistApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/video/device/${queryArg.deviceId}/camera/${queryArg.physicalId}/live.m3u8`,
          params: {
            segment_count: queryArg.segmentCount,
          },
        }),
        providesTags: ["scrap_eyes", "video"],
      }),
      getCameraVideoPlaylist: build.query<
        GetCameraVideoPlaylistApiResponse,
        GetCameraVideoPlaylistApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/video/device/${queryArg.deviceId}/camera/${queryArg.physicalId}/playlist.m3u8`,
          params: {
            start_time: queryArg.startTime,
            end_time: queryArg.endTime,
            variant: queryArg.variant,
          },
        }),
        providesTags: ["scrap_eyes", "video"],
      }),
      getLiveAngleVideoPlaylist: build.query<
        GetLiveAngleVideoPlaylistApiResponse,
        GetLiveAngleVideoPlaylistApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/video/${queryArg.location}/${queryArg.angle}/live.m3u8`,
          params: {
            segment_count: queryArg.segmentCount,
            device_id: queryArg.deviceId,
          },
        }),
        providesTags: ["scrap_eyes", "video"],
      }),
      getAngleVideoPlaylist: build.query<
        GetAngleVideoPlaylistApiResponse,
        GetAngleVideoPlaylistApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/video/${queryArg.location}/${queryArg.angle}/playlist.m3u8`,
          params: {
            start_time: queryArg.startTime,
            end_time: queryArg.endTime,
            device_id: queryArg.deviceId,
            variant: queryArg.variant,
          },
        }),
        providesTags: ["scrap_eyes", "video"],
      }),
      getGcsReadToken: build.query<
        GetGcsReadTokenApiResponse,
        GetGcsReadTokenApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/video/gcs-read-token`,
        }),
        providesTags: ["scrap_eyes", "video"],
      }),
      getLiveRadioPlaylist: build.query<
        GetLiveRadioPlaylistApiResponse,
        GetLiveRadioPlaylistApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/radio/device/${queryArg.deviceId}/live.m3u8`,
          params: {
            segment_count: queryArg.segmentCount,
            receiver_id: queryArg.receiverId,
          },
        }),
        providesTags: ["scrap_eyes", "radio"],
      }),
      getRadioPlaylist: build.query<
        GetRadioPlaylistApiResponse,
        GetRadioPlaylistApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/radio/device/${queryArg.deviceId}/playlist.m3u8`,
          params: {
            start_time: queryArg.startTime,
            end_time: queryArg.endTime,
            receiver_id: queryArg.receiverId,
          },
        }),
        providesTags: ["scrap_eyes", "radio"],
      }),
      getRadioTranscript: build.query<
        GetRadioTranscriptApiResponse,
        GetRadioTranscriptApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/radio/device/${queryArg.deviceId}/transcript.json`,
          params: {
            start_time: queryArg.startTime,
            end_time: queryArg.endTime,
            receiver_id: queryArg.receiverId,
            all_receivers: queryArg.allReceivers,
          },
        }),
        providesTags: ["scrap_eyes", "radio"],
      }),
      getRadioSegmentInfo: build.query<
        GetRadioSegmentInfoApiResponse,
        GetRadioSegmentInfoApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/radio/device/${queryArg.deviceId}/segment-info`,
          params: {
            receiver_id: queryArg.receiverId,
          },
        }),
        providesTags: ["scrap_eyes", "radio"],
      }),
      listRadioReceivers: build.query<
        ListRadioReceiversApiResponse,
        ListRadioReceiversApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/radio/device/${queryArg.deviceId}/receivers`,
        }),
        providesTags: ["scrap_eyes", "radio"],
      }),
      getRadioGcsReadToken: build.query<
        GetRadioGcsReadTokenApiResponse,
        GetRadioGcsReadTokenApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/radio/gcs-read-token`,
        }),
        providesTags: ["scrap_eyes", "radio"],
      }),
      getMassCandidateEvents: build.query<
        GetMassCandidateEventsApiResponse,
        GetMassCandidateEventsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/raw_data/mass_candidate_events`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
            location: queryArg.location,
          },
        }),
        providesTags: ["scrap_eyes", "raw_data"],
      }),
      getMassTimeseries: build.query<
        GetMassTimeseriesApiResponse,
        GetMassTimeseriesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/raw_data/mass_timeseries`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
            location: queryArg.location,
            downsample: queryArg.downsample,
            include: queryArg.include,
          },
        }),
        providesTags: ["scrap_eyes", "raw_data"],
      }),
      getModelPredictionTimeseries: build.query<
        GetModelPredictionTimeseriesApiResponse,
        GetModelPredictionTimeseriesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/inference/model_predictions`,
          params: {
            labelling_name: queryArg.labellingName,
            start: queryArg.start,
            end: queryArg.end,
          },
        }),
        providesTags: ["scrap_eyes", "inference"],
      }),
      getInferenceInputTimeseries: build.query<
        GetInferenceInputTimeseriesApiResponse,
        GetInferenceInputTimeseriesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/inference/inference_input`,
          params: {
            labelling_name: queryArg.labellingName,
            start: queryArg.start,
            end: queryArg.end,
          },
        }),
        providesTags: ["scrap_eyes", "inference"],
      }),
      getHeatQualityIssues: build.query<
        GetHeatQualityIssuesApiResponse,
        GetHeatQualityIssuesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/heat_baskets/heat_quality_issues`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
          },
        }),
        providesTags: ["scrap_eyes", "heat_baskets"],
      }),
      getLoadingWindowPlannedConsumption: build.query<
        GetLoadingWindowPlannedConsumptionApiResponse,
        GetLoadingWindowPlannedConsumptionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/heat_baskets/planned_consumption`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
          },
        }),
        providesTags: ["scrap_eyes", "heat_baskets"],
      }),
      getLoadingWindowDrops: build.query<
        GetLoadingWindowDropsApiResponse,
        GetLoadingWindowDropsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/heat_baskets/loading_window_drops`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
          },
        }),
        providesTags: ["scrap_eyes", "heat_baskets"],
      }),
      getLoadingWindowHeatMetadata: build.query<
        GetLoadingWindowHeatMetadataApiResponse,
        GetLoadingWindowHeatMetadataApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/heat_baskets/heat_metadata`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
          },
        }),
        providesTags: ["scrap_eyes", "heat_baskets"],
      }),
      getLoadingWindowChargeEvents: build.query<
        GetLoadingWindowChargeEventsApiResponse,
        GetLoadingWindowChargeEventsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/heat_baskets/loading_window_charge_events`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
          },
        }),
        providesTags: ["scrap_eyes", "heat_baskets"],
      }),
      submitAndApplyLoadingEdits: build.mutation<
        SubmitAndApplyLoadingEditsApiResponse,
        SubmitAndApplyLoadingEditsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/loading_windows/edits/apply`,
          method: "POST",
          body: queryArg.submitLoadingEditsRequest,
        }),
        invalidatesTags: ["scrap_eyes", "loading_windows"],
      }),
      submitLoadingReviews: build.mutation<
        SubmitLoadingReviewsApiResponse,
        SubmitLoadingReviewsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/loading_windows/edits/reviews`,
          method: "POST",
          body: queryArg.submitLoadingReviewsRequest,
        }),
        invalidatesTags: ["scrap_eyes", "loading_windows"],
      }),
      reviseAndApplyLoadingEdits: build.mutation<
        ReviseAndApplyLoadingEditsApiResponse,
        ReviseAndApplyLoadingEditsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/loading_windows/edits/revise/apply`,
          method: "POST",
          body: queryArg.reviseAndApplyLoadingEditsRequest,
        }),
        invalidatesTags: ["scrap_eyes", "loading_windows"],
      }),
      getLoadingWindows: build.query<
        GetLoadingWindowsApiResponse,
        GetLoadingWindowsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/loading_windows/windows`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
            area_name: queryArg.areaName,
          },
        }),
        providesTags: ["scrap_eyes", "loading_windows"],
      }),
      listConsumptionAreas: build.query<
        ListConsumptionAreasApiResponse,
        ListConsumptionAreasApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/loading_windows/areas`,
        }),
        providesTags: ["scrap_eyes", "loading_windows"],
      }),
      listLoadingEdits: build.query<
        ListLoadingEditsApiResponse,
        ListLoadingEditsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/loading_windows/edits`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
            pending_only: queryArg.pendingOnly,
            area_name: queryArg.areaName,
          },
        }),
        providesTags: ["scrap_eyes", "loading_windows"],
      }),
      submitLoadingEditsForReview: build.mutation<
        SubmitLoadingEditsForReviewApiResponse,
        SubmitLoadingEditsForReviewApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/loading_windows/edits`,
          method: "POST",
          body: queryArg.submitLoadingEditsRequest,
        }),
        invalidatesTags: ["scrap_eyes", "loading_windows"],
      }),
      reseedLoadingWindows: build.mutation<
        ReseedLoadingWindowsApiResponse,
        ReseedLoadingWindowsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/loading_windows/seed`,
          method: "POST",
          body: queryArg.reseedLoadingWindowsRequest,
        }),
        invalidatesTags: ["scrap_eyes", "loading_windows"],
      }),
      createInstallationLocation: build.mutation<
        CreateInstallationLocationApiResponse,
        CreateInstallationLocationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/installation/locations`,
          method: "POST",
          body: queryArg.scrapEyeInstallationLocationCreate,
        }),
        invalidatesTags: ["scrap_eyes", "installation"],
      }),
      listInstallationLocations: build.query<
        ListInstallationLocationsApiResponse,
        ListInstallationLocationsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/installation/locations`,
          params: {
            location_types: queryArg.locationTypes,
          },
        }),
        providesTags: ["scrap_eyes", "installation"],
      }),
      listInstallationLocationsWithBacklog: build.query<
        ListInstallationLocationsWithBacklogApiResponse,
        ListInstallationLocationsWithBacklogApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/installation/locations/with-backlog`,
          params: {
            target_number_of_labellers: queryArg.targetNumberOfLabellers,
            allowed_coverage_gap_seconds: queryArg.allowedCoverageGapSeconds,
            required_angles: queryArg.requiredAngles,
          },
        }),
        providesTags: ["scrap_eyes", "installation"],
      }),
      createRecordingPosition: build.mutation<
        CreateRecordingPositionApiResponse,
        CreateRecordingPositionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/installation/recording_positions`,
          method: "POST",
          body: queryArg.scrapEyeRecordingPositionCreate,
        }),
        invalidatesTags: ["scrap_eyes", "installation"],
      }),
      listRecordingPositions: build.query<
        ListRecordingPositionsApiResponse,
        ListRecordingPositionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/installation/recording_positions`,
          params: {
            device_ids: queryArg.deviceIds,
            at_time: queryArg.atTime,
            active_at_start: queryArg.activeAtStart,
            active_at_end: queryArg.activeAtEnd,
          },
        }),
        providesTags: ["scrap_eyes", "installation"],
      }),
      listAvailableRecordingPositionsForLocation: build.query<
        ListAvailableRecordingPositionsForLocationApiResponse,
        ListAvailableRecordingPositionsForLocationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/installation/recording_positions/${queryArg.locationName}`,
        }),
        providesTags: ["scrap_eyes", "installation"],
      }),
      createCameraAngle: build.mutation<
        CreateCameraAngleApiResponse,
        CreateCameraAngleApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/installation/camera_angles`,
          method: "POST",
          body: queryArg.scrapEyeRecordingPositionCreate,
        }),
        invalidatesTags: ["scrap_eyes", "installation"],
      }),
      listCameraAngles: build.query<
        ListCameraAnglesApiResponse,
        ListCameraAnglesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/installation/camera_angles`,
          params: {
            device_ids: queryArg.deviceIds,
            at_time: queryArg.atTime,
            active_at_start: queryArg.activeAtStart,
            active_at_end: queryArg.activeAtEnd,
          },
        }),
        providesTags: ["scrap_eyes", "installation"],
      }),
      listAvailableCameraAnglesForLocation: build.query<
        ListAvailableCameraAnglesForLocationApiResponse,
        ListAvailableCameraAnglesForLocationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/installation/camera_angles/${queryArg.locationName}`,
        }),
        providesTags: ["scrap_eyes", "installation"],
      }),
      installCamera: build.mutation<
        InstallCameraApiResponse,
        InstallCameraApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/installation/install`,
          method: "POST",
          body: queryArg.scrapEyeInstallationEventCreate,
        }),
        invalidatesTags: ["scrap_eyes", "installation"],
      }),
      uninstallCamera: build.mutation<
        UninstallCameraApiResponse,
        UninstallCameraApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/installation/uninstall`,
          method: "POST",
          body: queryArg.scrapEyeUninstallation,
        }),
        invalidatesTags: ["scrap_eyes", "installation"],
      }),
      listInstallations: build.query<
        ListInstallationsApiResponse,
        ListInstallationsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/installation/installations`,
          params: {
            kind: queryArg.kind,
          },
        }),
        providesTags: ["scrap_eyes", "installation"],
      }),
      createVideoPlayerGroup: build.mutation<
        CreateVideoPlayerGroupApiResponse,
        CreateVideoPlayerGroupApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/installation/video_player_groups`,
          method: "POST",
          body: queryArg.scrapEyeInstallationVideoPlayerGroupCreate,
        }),
        invalidatesTags: ["scrap_eyes", "installation"],
      }),
      listVideoPlayerGroups: build.query<
        ListVideoPlayerGroupsApiResponse,
        ListVideoPlayerGroupsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/installation/video_player_groups`,
          params: {
            location_name: queryArg.locationName,
            include_location_types: queryArg.includeLocationTypes,
          },
        }),
        providesTags: ["scrap_eyes", "installation"],
      }),
      getVideoPlayerGroup: build.query<
        GetVideoPlayerGroupApiResponse,
        GetVideoPlayerGroupApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/installation/video_player_groups/${queryArg.groupId}`,
        }),
        providesTags: ["scrap_eyes", "installation"],
      }),
      updateVideoPlayerGroup: build.mutation<
        UpdateVideoPlayerGroupApiResponse,
        UpdateVideoPlayerGroupApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/installation/video_player_groups/${queryArg.groupId}`,
          method: "PUT",
          body: queryArg.scrapEyeInstallationVideoPlayerGroupUpdate,
        }),
        invalidatesTags: ["scrap_eyes", "installation"],
      }),
      deleteVideoPlayerGroup: build.mutation<
        DeleteVideoPlayerGroupApiResponse,
        DeleteVideoPlayerGroupApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/installation/video_player_groups/${queryArg.groupId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["scrap_eyes", "installation"],
      }),
      addAngleToGroup: build.mutation<
        AddAngleToGroupApiResponse,
        AddAngleToGroupApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/installation/video_player_groups/${queryArg.groupId}/angles`,
          method: "POST",
          body: queryArg.scrapEyeInstallationVideoPlayerGroupMembershipCreate,
        }),
        invalidatesTags: ["scrap_eyes", "installation"],
      }),
      updateAnglePriority: build.mutation<
        UpdateAnglePriorityApiResponse,
        UpdateAnglePriorityApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/installation/video_player_groups/${queryArg.groupId}/angles/${queryArg.angleId}`,
          method: "PUT",
          body: queryArg.priority,
        }),
        invalidatesTags: ["scrap_eyes", "installation"],
      }),
      removeAngleFromGroup: build.mutation<
        RemoveAngleFromGroupApiResponse,
        RemoveAngleFromGroupApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/installation/video_player_groups/${queryArg.groupId}/angles/${queryArg.angleId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["scrap_eyes", "installation"],
      }),
      createLocationSupportAssociation: build.mutation<
        CreateLocationSupportAssociationApiResponse,
        CreateLocationSupportAssociationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/installation/location_support_associations`,
          method: "POST",
          body: queryArg.scrapEyeLocationSupportAssociationCreate,
        }),
        invalidatesTags: ["scrap_eyes", "installation"],
      }),
      listLocationSupportAssociations: build.query<
        ListLocationSupportAssociationsApiResponse,
        ListLocationSupportAssociationsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/installation/location_support_associations`,
          params: {
            labelling_location_name: queryArg.labellingLocationName,
          },
        }),
        providesTags: ["scrap_eyes", "installation"],
      }),
      deleteLocationSupportAssociation: build.mutation<
        DeleteLocationSupportAssociationApiResponse,
        DeleteLocationSupportAssociationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/installation/location_support_associations/${queryArg.associationId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["scrap_eyes", "installation"],
      }),
      installSensor: build.mutation<
        InstallSensorApiResponse,
        InstallSensorApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/sensors/installations`,
          method: "POST",
          body: queryArg.scrapEyeSensorPlacementCreate,
        }),
        invalidatesTags: ["scrap_eyes", "installation"],
      }),
      listSensorInstallations: build.query<
        ListSensorInstallationsApiResponse,
        ListSensorInstallationsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/sensors/installations`,
          params: {
            kind: queryArg.kind,
          },
        }),
        providesTags: ["scrap_eyes", "installation"],
      }),
      correctSensorInstallation: build.mutation<
        CorrectSensorInstallationApiResponse,
        CorrectSensorInstallationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/sensors/installations/${queryArg.versionId}/corrections`,
          method: "POST",
          body: queryArg.scrapEyeSensorPlacementCreate,
        }),
        invalidatesTags: ["scrap_eyes", "installation"],
      }),
      connectSensor: build.mutation<
        ConnectSensorApiResponse,
        ConnectSensorApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/sensors/connections`,
          method: "POST",
          body: queryArg.scrapEyeSensorConnectionCreate,
        }),
        invalidatesTags: ["scrap_eyes", "installation"],
      }),
      listSensorConnections: build.query<
        ListSensorConnectionsApiResponse,
        ListSensorConnectionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/sensors/connections`,
          params: {
            device_id: queryArg.deviceId,
            kind: queryArg.kind,
          },
        }),
        providesTags: ["scrap_eyes", "installation"],
      }),
      correctSensorConnection: build.mutation<
        CorrectSensorConnectionApiResponse,
        CorrectSensorConnectionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/sensors/connections/${queryArg.versionId}/corrections`,
          method: "POST",
          body: queryArg.scrapEyeSensorConnectionCorrection,
        }),
        invalidatesTags: ["scrap_eyes", "installation"],
      }),
      listSensorCameraRecordings: build.query<
        ListSensorCameraRecordingsApiResponse,
        ListSensorCameraRecordingsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/sensors/camera-recordings`,
          params: {
            device_id: queryArg.deviceId,
          },
        }),
        providesTags: ["scrap_eyes", "installation"],
      }),
      reconcileSensorMetrics: build.mutation<
        ReconcileSensorMetricsApiResponse,
        ReconcileSensorMetricsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/sensors/metrics/reconcile`,
          method: "POST",
        }),
        invalidatesTags: ["scrap_eyes", "installation"],
      }),
      createSensor: build.mutation<CreateSensorApiResponse, CreateSensorApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/v2/scrap_eyes/${queryArg.tenantName}/sensors`,
            method: "POST",
            body: queryArg.scrapEyeSensorCreate,
          }),
          invalidatesTags: ["scrap_eyes", "installation"],
        },
      ),
      listSensors: build.query<ListSensorsApiResponse, ListSensorsApiArg>({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/sensors`,
          params: {
            sensor_types: queryArg.sensorTypes,
          },
        }),
        providesTags: ["scrap_eyes", "installation"],
      }),
      updateSensorMetadata: build.mutation<
        UpdateSensorMetadataApiResponse,
        UpdateSensorMetadataApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/sensors/${queryArg.sensorId}`,
          method: "PATCH",
          body: queryArg.scrapEyeSensorMetadataUpdate,
        }),
        invalidatesTags: ["scrap_eyes", "installation"],
      }),
      redactFootagePreview: build.mutation<
        RedactFootagePreviewApiResponse,
        RedactFootagePreviewApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/data/redact/preview`,
          method: "POST",
          body: queryArg.redactFootageRequest,
        }),
        invalidatesTags: ["scrap_eyes", "scrap_eyes_redaction"],
      }),
      redactFootage: build.mutation<
        RedactFootageApiResponse,
        RedactFootageApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/data/redact`,
          method: "POST",
          body: queryArg.redactFootageRequest,
        }),
        invalidatesTags: ["scrap_eyes", "scrap_eyes_redaction"],
      }),
      getRedactionStatus: build.query<
        GetRedactionStatusApiResponse,
        GetRedactionStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/data/redact/${queryArg.jobId}`,
        }),
        providesTags: ["scrap_eyes", "scrap_eyes_redaction"],
      }),
      createLocationExceptionalStatus: build.mutation<
        CreateLocationExceptionalStatusApiResponse,
        CreateLocationExceptionalStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/location_exceptional_status`,
          method: "POST",
          body: queryArg.locationExceptionalStatusCreate,
        }),
        invalidatesTags: ["scrap_eyes", "location_exceptional_status"],
      }),
      listLocationExceptionalStatuses: build.query<
        ListLocationExceptionalStatusesApiResponse,
        ListLocationExceptionalStatusesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/location_exceptional_status`,
          params: {
            location_name: queryArg.locationName,
            area: queryArg.area,
            status: queryArg.status,
          },
        }),
        providesTags: ["scrap_eyes", "location_exceptional_status"],
      }),
      updateLocationExceptionalStatus: build.mutation<
        UpdateLocationExceptionalStatusApiResponse,
        UpdateLocationExceptionalStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/location_exceptional_status/${queryArg.statusId}`,
          method: "PUT",
          body: queryArg.locationExceptionalStatusUpdate,
        }),
        invalidatesTags: ["scrap_eyes", "location_exceptional_status"],
      }),
      deleteLocationExceptionalStatus: build.mutation<
        DeleteLocationExceptionalStatusApiResponse,
        DeleteLocationExceptionalStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/location_exceptional_status/${queryArg.statusId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["scrap_eyes", "location_exceptional_status"],
      }),
      listScrapEyeDevices: build.query<
        ListScrapEyeDevicesApiResponse,
        ListScrapEyeDevicesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/devices`,
          params: {
            include_additional_info: queryArg.includeAdditionalInfo,
          },
        }),
        providesTags: ["scrap_eyes"],
      }),
      listScrapEyeCameras: build.query<
        ListScrapEyeCamerasApiResponse,
        ListScrapEyeCamerasApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/cameras/${queryArg.deviceId}`,
        }),
        providesTags: ["scrap_eyes"],
      }),
      getSensorTopology: build.query<
        GetSensorTopologyApiResponse,
        GetSensorTopologyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/sensor-topology`,
          params: {
            at: queryArg.at,
          },
        }),
        providesTags: ["scrap_eyes", "installation"],
      }),
      applySensorTopologyChanges: build.mutation<
        ApplySensorTopologyChangesApiResponse,
        ApplySensorTopologyChangesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_eyes/${queryArg.tenantName}/sensor-topology/changes`,
          method: "POST",
          body: queryArg.sensorTopologyChanges,
        }),
        invalidatesTags: ["scrap_eyes", "installation"],
      }),
      registerCapabilities: build.mutation<
        RegisterCapabilitiesApiResponse,
        RegisterCapabilitiesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrapeyes/${queryArg.tenantName}/devices/${queryArg.deviceName}/register_capabilities`,
          method: "POST",
          body: queryArg.registerCapabilitiesRequest,
        }),
        invalidatesTags: ["scrap_eyes_ingest"],
      }),
      announceCameras: build.mutation<
        AnnounceCamerasApiResponse,
        AnnounceCamerasApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrapeyes/${queryArg.tenantName}/devices/${queryArg.deviceName}/cameras/announce`,
          method: "POST",
          body: queryArg.announceCamerasRequest,
        }),
        invalidatesTags: ["scrap_eyes_ingest"],
      }),
      uploadVideoFromUri: build.mutation<
        UploadVideoFromUriApiResponse,
        UploadVideoFromUriApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrapeyes/${queryArg.tenantName}/devices/${queryArg.deviceName}/upload/video-from-uri`,
          method: "POST",
          body: queryArg.videoCreate,
        }),
        invalidatesTags: ["scrap_eyes_ingest", "uploads"],
      }),
      uploadRadioFromUri: build.mutation<
        UploadRadioFromUriApiResponse,
        UploadRadioFromUriApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrapeyes/${queryArg.tenantName}/devices/${queryArg.deviceName}/upload/radio-from-uri`,
          method: "POST",
          body: queryArg.radioCreate,
        }),
        invalidatesTags: ["scrap_eyes_ingest", "uploads"],
      }),
      getGcsUploadToken: build.query<
        GetGcsUploadTokenApiResponse,
        GetGcsUploadTokenApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrapeyes/${queryArg.tenantName}/devices/${queryArg.deviceName}/upload/gcs-upload-token`,
        }),
        providesTags: ["scrap_eyes_ingest", "uploads"],
      }),
      getSegmentStatusList: build.query<
        GetSegmentStatusListApiResponse,
        GetSegmentStatusListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrapeyes/${queryArg.tenantName}/devices/${queryArg.deviceName}/segment_status_list`,
          params: {
            segment_type: queryArg.segmentType,
            start: queryArg.start,
            count: queryArg.count,
            segment_length_sec: queryArg.segmentLengthSec,
            camera_physical_ids: queryArg.cameraPhysicalIds,
            camera_angle_ids: queryArg.cameraAngleIds,
            radio_receiver_id: queryArg.radioReceiverId,
          },
        }),
        providesTags: ["scrap_eyes_ingest", "segment_status"],
      }),
      uploadEdgePredictionsFromUri: build.mutation<
        UploadEdgePredictionsFromUriApiResponse,
        UploadEdgePredictionsFromUriApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrapeyes/${queryArg.tenantName}/devices/${queryArg.deviceName}/upload/edge-predictions-from-uri`,
          method: "POST",
          body: queryArg.edgePredictionWindowCreate,
        }),
        invalidatesTags: ["scrap_eyes_ingest", "edge_inference"],
      }),
      uploadEdgeEmbeddingFromUri: build.mutation<
        UploadEdgeEmbeddingFromUriApiResponse,
        UploadEdgeEmbeddingFromUriApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrapeyes/${queryArg.tenantName}/devices/${queryArg.deviceName}/upload/edge-embedding-from-uri`,
          method: "POST",
          body: queryArg.edgeEmbeddingCreate,
        }),
        invalidatesTags: ["scrap_eyes_ingest", "edge_inference"],
      }),
      getScrapLoadingLayout: build.query<
        GetScrapLoadingLayoutApiResponse,
        GetScrapLoadingLayoutApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap_loading_layout/${queryArg.tenantName}/${queryArg.location}`,
          params: {
            timestamp: queryArg.timestamp,
          },
        }),
        providesTags: ["scrap_loading_layout"],
      }),
      getRailcarMovements: build.query<
        GetRailcarMovementsApiResponse,
        GetRailcarMovementsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/railcars/${queryArg.tenantName}/movements`,
          params: {
            start_time: queryArg.startTime,
            end_time: queryArg.endTime,
          },
        }),
        providesTags: ["railcars"],
      }),
      getReportedRailcarSlots: build.query<
        GetReportedRailcarSlotsApiResponse,
        GetReportedRailcarSlotsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/railcars/${queryArg.tenantName}/reported-slots`,
          params: {
            location: queryArg.location,
            start_time: queryArg.startTime,
            end_time: queryArg.endTime,
            numbering: queryArg.numbering,
          },
        }),
        providesTags: ["railcars"],
      }),
      createRailcarOrderRequest: build.mutation<
        CreateRailcarOrderRequestApiResponse,
        CreateRailcarOrderRequestApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/railcars/${queryArg.tenantName}/order-requests`,
          method: "POST",
          body: queryArg.railcarOrderRequestCreate,
        }),
        invalidatesTags: ["railcars"],
      }),
      proposeRailcarOrder: build.mutation<
        ProposeRailcarOrderApiResponse,
        ProposeRailcarOrderApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/railcars/${queryArg.tenantName}/order-proposals`,
          method: "POST",
          body: queryArg.railcarOrderProposalCreate,
        }),
        invalidatesTags: ["railcars"],
      }),
      getRecipeComplianceReportDaily: build.query<
        GetRecipeComplianceReportDailyApiResponse,
        GetRecipeComplianceReportDailyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/recipe-compliance-reports/${queryArg.tenantName}/daily`,
          params: {
            anchor_date: queryArg.anchorDate,
            shift_anchor: queryArg.shiftAnchor,
            diff_mode: queryArg.diffMode,
            report_label: queryArg.reportLabel,
          },
        }),
        providesTags: ["recipe_compliance_report", "recipe_compliance_report"],
      }),
      getRecipeComplianceReportMonthly: build.query<
        GetRecipeComplianceReportMonthlyApiResponse,
        GetRecipeComplianceReportMonthlyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/recipe-compliance-reports/${queryArg.tenantName}/monthly`,
          params: {
            anchor_date: queryArg.anchorDate,
            diff_mode: queryArg.diffMode,
          },
        }),
        providesTags: ["recipe_compliance_report", "recipe_compliance_report"],
      }),
      getRecipeComplianceReportDailyHtml: build.query<
        GetRecipeComplianceReportDailyHtmlApiResponse,
        GetRecipeComplianceReportDailyHtmlApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/recipe-compliance-reports/${queryArg.tenantName}/daily/html`,
          params: {
            anchor_date: queryArg.anchorDate,
            shift_anchor: queryArg.shiftAnchor,
            diff_mode: queryArg.diffMode,
            report_label: queryArg.reportLabel,
          },
        }),
        providesTags: ["recipe_compliance_report", "recipe_compliance_report"],
      }),
      getRecipeComplianceReportMonthlyHtml: build.query<
        GetRecipeComplianceReportMonthlyHtmlApiResponse,
        GetRecipeComplianceReportMonthlyHtmlApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/recipe-compliance-reports/${queryArg.tenantName}/monthly/html`,
          params: {
            anchor_date: queryArg.anchorDate,
            diff_mode: queryArg.diffMode,
          },
        }),
        providesTags: ["recipe_compliance_report", "recipe_compliance_report"],
      }),
      listTenantEmails: build.query<
        ListTenantEmailsApiResponse,
        ListTenantEmailsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/tenant-emails/${queryArg.tenantName}`,
        }),
        providesTags: ["tenant_emails"],
      }),
      listTenantNames: build.query<
        ListTenantNamesApiResponse,
        ListTenantNamesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/tenant_names`,
          params: {
            tenant_group_name: queryArg.tenantGroupName,
            visibility: queryArg.visibility,
          },
        }),
        providesTags: ["tenants"],
      }),
      listTenantGroups: build.query<
        ListTenantGroupsApiResponse,
        ListTenantGroupsApiArg
      >({
        query: () => ({ url: `/api/v2/tenant_groups` }),
        providesTags: ["tenants"],
      }),
      getMe: build.query<GetMeApiResponse, GetMeApiArg>({
        query: (queryArg) => ({
          url: `/api/v2/auth/${queryArg.tenantName}/me`,
        }),
        providesTags: ["auth"],
      }),
      getAuthCustomToken: build.mutation<
        GetAuthCustomTokenApiResponse,
        GetAuthCustomTokenApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/auth/${queryArg.tenantName}/token`,
          method: "POST",
          params: {
            on_behalf_of: queryArg.onBehalfOf,
          },
        }),
        invalidatesTags: ["auth"],
      }),
      getUsers: build.query<GetUsersApiResponse, GetUsersApiArg>({
        query: (queryArg) => ({
          url: `/api/v2/auth/${queryArg.tenantName}/users`,
          params: {
            account_types: queryArg.accountTypes,
          },
        }),
        providesTags: ["auth"],
      }),
      getUserByEmail: build.query<
        GetUserByEmailApiResponse,
        GetUserByEmailApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/auth/${queryArg.tenantName}/user`,
          params: {
            email: queryArg.email,
          },
        }),
        providesTags: ["auth"],
      }),
      updateUser: build.mutation<UpdateUserApiResponse, UpdateUserApiArg>({
        query: (queryArg) => ({
          url: `/api/v2/auth/${queryArg.tenantName}/user`,
          method: "PATCH",
          body: queryArg.userUpdate,
        }),
        invalidatesTags: ["auth"],
      }),
      syncWithFirebase: build.mutation<
        SyncWithFirebaseApiResponse,
        SyncWithFirebaseApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/auth/users/${queryArg.tenantName}/sync`,
          method: "POST",
        }),
        invalidatesTags: ["auth"],
      }),
      logout: build.mutation<LogoutApiResponse, LogoutApiArg>({
        query: () => ({ url: `/api/v2/auth/logout`, method: "POST" }),
        invalidatesTags: ["auth"],
      }),
      setAdminMode: build.mutation<SetAdminModeApiResponse, SetAdminModeApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/v2/auth/admin-mode`,
            method: "POST",
            body: queryArg.adminModeUpdate,
          }),
          invalidatesTags: ["auth"],
        },
      ),
      requestSignInLink: build.mutation<
        RequestSignInLinkApiResponse,
        RequestSignInLinkApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/auth/${queryArg.tenantName}/request-sign-in-link`,
          method: "POST",
          body: queryArg.requestSignInLinkRequest,
        }),
        invalidatesTags: ["auth"],
      }),
      getClarkProfile: build.query<
        GetClarkProfileApiResponse,
        GetClarkProfileApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/auth/${queryArg.tenantName}/clark-profile`,
          params: {
            email: queryArg.email,
          },
        }),
        providesTags: ["auth"],
      }),
      updateClarkProfile: build.mutation<
        UpdateClarkProfileApiResponse,
        UpdateClarkProfileApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/auth/${queryArg.tenantName}/clark-profile`,
          method: "PUT",
          body: queryArg.clarkProfileUpdate,
        }),
        invalidatesTags: ["auth"],
      }),
      sendMissionControlNotification: build.mutation<
        SendMissionControlNotificationApiResponse,
        SendMissionControlNotificationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/mission-control/notify`,
          method: "POST",
          params: {
            tenant_group_name: queryArg.tenantGroupName,
          },
        }),
        invalidatesTags: ["mission_control"],
      }),
      listMissionControlTenants: build.query<
        ListMissionControlTenantsApiResponse,
        ListMissionControlTenantsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/mission-control/tenants`,
          params: {
            tenant_group_name: queryArg.tenantGroupName,
            visibility: queryArg.visibility,
          },
        }),
        providesTags: ["mission_control"],
      }),
      uploadMissionControlFiles: build.mutation<
        UploadMissionControlFilesApiResponse,
        UploadMissionControlFilesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/mission-control/upload`,
          method: "POST",
          body: queryArg.missionControlUploadRequest,
          params: {
            tenant_group_name: queryArg.tenantGroupName,
          },
        }),
        invalidatesTags: ["mission_control"],
      }),
      getMissionControlTenantSavings: build.query<
        GetMissionControlTenantSavingsApiResponse,
        GetMissionControlTenantSavingsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/mission-control/tenants/${queryArg.tenantName}/savings`,
        }),
        providesTags: ["mission_control"],
      }),
      getMissionControlTenantTotalInventory: build.query<
        GetMissionControlTenantTotalInventoryApiResponse,
        GetMissionControlTenantTotalInventoryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/mission-control/tenants/${queryArg.tenantName}/total-inventory`,
        }),
        providesTags: ["mission_control"],
      }),
      getMissionControlTenantSiopSchedule: build.query<
        GetMissionControlTenantSiopScheduleApiResponse,
        GetMissionControlTenantSiopScheduleApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/mission-control/tenants/${queryArg.tenantName}/siop-schedule`,
        }),
        providesTags: ["mission_control"],
      }),
      getMissionControlTenantProductMix: build.query<
        GetMissionControlTenantProductMixApiResponse,
        GetMissionControlTenantProductMixApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/mission-control/tenants/${queryArg.tenantName}/product-mix`,
        }),
        providesTags: ["mission_control"],
      }),
      getMissionControlTenantShredUsage: build.query<
        GetMissionControlTenantShredUsageApiResponse,
        GetMissionControlTenantShredUsageApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/mission-control/tenants/${queryArg.tenantName}/shred-usage`,
        }),
        providesTags: ["mission_control"],
      }),
      getMissionControlScrapReport: build.query<
        GetMissionControlScrapReportApiResponse,
        GetMissionControlScrapReportApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/mission-control/tenants/${queryArg.tenantName}/scrap-report`,
        }),
        providesTags: ["mission_control"],
      }),
      listOrganisationUsers: build.query<
        ListOrganisationUsersApiResponse,
        ListOrganisationUsersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/organisation/${queryArg.groupName}/users`,
        }),
        providesTags: ["organisation"],
      }),
      addOrganisationUser: build.mutation<
        AddOrganisationUserApiResponse,
        AddOrganisationUserApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/organisation/${queryArg.groupName}/users`,
          method: "POST",
          body: queryArg.addOrganisationUserRequest,
        }),
        invalidatesTags: ["organisation"],
      }),
      updateOrganisationUserPermissions: build.mutation<
        UpdateOrganisationUserPermissionsApiResponse,
        UpdateOrganisationUserPermissionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/organisation/${queryArg.groupName}/users/${queryArg.uid}`,
          method: "PATCH",
          body: queryArg.updateOrganisationUserRequest,
        }),
        invalidatesTags: ["organisation"],
      }),
      removeOrganisationUser: build.mutation<
        RemoveOrganisationUserApiResponse,
        RemoveOrganisationUserApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/organisation/${queryArg.groupName}/users/${queryArg.uid}`,
          method: "DELETE",
        }),
        invalidatesTags: ["organisation"],
      }),
      getClarkDirectory: build.query<
        GetClarkDirectoryApiResponse,
        GetClarkDirectoryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/organisation/${queryArg.groupName}/clark-directory`,
        }),
        providesTags: ["organisation"],
      }),
      addNodeObservation: build.mutation<
        AddNodeObservationApiResponse,
        AddNodeObservationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap-market/node-observations`,
          method: "POST",
          body: queryArg.nodeObservationCreate,
        }),
        invalidatesTags: ["scrap_market"],
      }),
      addNodeAttributeObservation: build.mutation<
        AddNodeAttributeObservationApiResponse,
        AddNodeAttributeObservationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap-market/node-attribute-observations`,
          method: "POST",
          body: queryArg.nodeAttributeObservationCreate,
        }),
        invalidatesTags: ["scrap_market"],
      }),
      addRouteAttributeObservation: build.mutation<
        AddRouteAttributeObservationApiResponse,
        AddRouteAttributeObservationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/scrap-market/route-attribute-observations`,
          method: "POST",
          body: queryArg.routeAttributeObservationCreate,
        }),
        invalidatesTags: ["scrap_market"],
      }),
      listNodes: build.query<ListNodesApiResponse, ListNodesApiArg>({
        query: () => ({ url: `/api/v2/scrap-market/nodes` }),
        providesTags: ["scrap_market"],
      }),
      listMaterials: build.query<ListMaterialsApiResponse, ListMaterialsApiArg>(
        {
          query: () => ({ url: `/api/v2/scrap-market/materials` }),
          providesTags: ["scrap_market"],
        },
      ),
      listDataSources: build.query<
        ListDataSourcesApiResponse,
        ListDataSourcesApiArg
      >({
        query: () => ({ url: `/api/v2/scrap-market/data-sources` }),
        providesTags: ["scrap_market"],
      }),
      sendLogisticsRoutingNotification: build.mutation<
        SendLogisticsRoutingNotificationApiResponse,
        SendLogisticsRoutingNotificationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/rail-routing/notify`,
          method: "POST",
          params: {
            tenant_group_name: queryArg.tenantGroupName,
          },
        }),
        invalidatesTags: ["rail_routing"],
      }),
      getRailStations: build.query<
        GetRailStationsApiResponse,
        GetRailStationsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/rail-routing/stations`,
          params: {
            tenant_group_name: queryArg.tenantGroupName,
          },
        }),
        providesTags: ["rail_routing"],
      }),
      getRatesToMills: build.query<
        GetRatesToMillsApiResponse,
        GetRatesToMillsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/rail-routing/rates-to-mills`,
          params: {
            station_name: queryArg.stationName,
            station_state: queryArg.stationState,
            tenant_group_name: queryArg.tenantGroupName,
          },
        }),
        providesTags: ["rail_routing"],
      }),
      findTruckRoute: build.query<
        FindTruckRouteApiResponse,
        FindTruckRouteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/rail-routing/find-truck-route`,
          params: {
            station_name: queryArg.stationName,
            station_state: queryArg.stationState,
            destination_latitude: queryArg.destinationLatitude,
            destination_longitude: queryArg.destinationLongitude,
          },
        }),
        providesTags: ["rail_routing"],
      }),
      getTruckCostFormula: build.query<
        GetTruckCostFormulaApiResponse,
        GetTruckCostFormulaApiArg
      >({
        query: () => ({ url: `/api/v2/rail-routing/truck-cost-formula` }),
        providesTags: ["rail_routing"],
      }),
      findRailRoute: build.query<FindRailRouteApiResponse, FindRailRouteApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/v2/rail-routing/find-route`,
            params: {
              from_latitude: queryArg.fromLatitude,
              from_longitude: queryArg.fromLongitude,
              to_latitude: queryArg.toLatitude,
              to_longitude: queryArg.toLongitude,
              railroad: queryArg.railroad,
            },
          }),
          providesTags: ["rail_routing"],
        },
      ),
      geocodeStation: build.query<
        GeocodeStationApiResponse,
        GeocodeStationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/rail-routing/geocode-station`,
          params: {
            station_name: queryArg.stationName,
            station_state: queryArg.stationState,
          },
        }),
        providesTags: ["rail_routing"],
      }),
      healthCheck: build.query<HealthCheckApiResponse, HealthCheckApiArg>({
        query: () => ({ url: `/health` }),
        providesTags: ["health"],
      }),
      registerEventLabellingModel: build.mutation<
        RegisterEventLabellingModelApiResponse,
        RegisterEventLabellingModelApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/event_labelling_models/${queryArg.tenantName}`,
          method: "POST",
          body: queryArg.eventLabellingModelCreate,
        }),
        invalidatesTags: ["event_labelling_models"],
      }),
      listEventLabellingModels: build.query<
        ListEventLabellingModelsApiResponse,
        ListEventLabellingModelsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/event_labelling_models/${queryArg.tenantName}`,
        }),
        providesTags: ["event_labelling_models"],
      }),
      getEventLabellingModel: build.query<
        GetEventLabellingModelApiResponse,
        GetEventLabellingModelApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/event_labelling_models/${queryArg.tenantName}/lookup`,
          params: {
            labelling_name: queryArg.labellingName,
          },
        }),
        providesTags: ["event_labelling_models"],
      }),
      getTargetedReviewReasonsInUse: build.query<
        GetTargetedReviewReasonsInUseApiResponse,
        GetTargetedReviewReasonsInUseApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/event_labelling_models/${queryArg.tenantName}/targeted_review_reasons_in_use`,
          params: {
            labelling_name: queryArg.labellingName,
          },
        }),
        providesTags: ["event_labelling_models"],
      }),
      getEventLabellingModelStateHistories: build.query<
        GetEventLabellingModelStateHistoriesApiResponse,
        GetEventLabellingModelStateHistoriesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/event_labelling_models/${queryArg.tenantName}/model_state_history`,
          params: {
            model_id: queryArg.modelId,
          },
        }),
        providesTags: ["event_labelling_models"],
      }),
      updateEventLabellingModel: build.mutation<
        UpdateEventLabellingModelApiResponse,
        UpdateEventLabellingModelApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/event_labelling_models/${queryArg.tenantName}/${queryArg.modelId}`,
          method: "PATCH",
          body: queryArg.eventLabellingModelUpdate,
        }),
        invalidatesTags: ["event_labelling_models"],
      }),
      getEventLabellingModelConfidenceRecallAtThresholds: build.query<
        GetEventLabellingModelConfidenceRecallAtThresholdsApiResponse,
        GetEventLabellingModelConfidenceRecallAtThresholdsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/event_labelling_models/${queryArg.tenantName}/${queryArg.labellingName}/confidence_recall_at_thresholds`,
          params: {
            material_threshold: queryArg.materialThreshold,
            event_threshold: queryArg.eventThreshold,
            area_threshold: queryArg.areaThreshold,
          },
        }),
        providesTags: ["event_labelling_models"],
      }),
      getEventLabellingModelExpectedPerformanceAtThresholds: build.query<
        GetEventLabellingModelExpectedPerformanceAtThresholdsApiResponse,
        GetEventLabellingModelExpectedPerformanceAtThresholdsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/event_labelling_models/${queryArg.tenantName}/${queryArg.labellingName}/expected_performance_at_thresholds`,
          params: {
            material_threshold: queryArg.materialThreshold,
            event_threshold: queryArg.eventThreshold,
            area_threshold: queryArg.areaThreshold,
          },
        }),
        providesTags: ["event_labelling_models"],
      }),
      getEventLabellingModelWindowedConfidenceRecallAtThresholds: build.query<
        GetEventLabellingModelWindowedConfidenceRecallAtThresholdsApiResponse,
        GetEventLabellingModelWindowedConfidenceRecallAtThresholdsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/event_labelling_models/${queryArg.tenantName}/${queryArg.labellingName}/windowed_confidence_recall_at_thresholds`,
          params: {
            window_days: queryArg.windowDays,
            material_threshold: queryArg.materialThreshold,
            event_threshold: queryArg.eventThreshold,
            area_threshold: queryArg.areaThreshold,
          },
        }),
        providesTags: ["event_labelling_models"],
      }),
      getEventLabellingModelAlwaysOnFlags: build.query<
        GetEventLabellingModelAlwaysOnFlagsApiResponse,
        GetEventLabellingModelAlwaysOnFlagsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/event_labelling_models/${queryArg.tenantName}/${queryArg.labellingName}/targeted_review_always_on`,
        }),
        providesTags: ["event_labelling_models"],
      }),
      getEventLabellingModelWindowedAlwaysOnFlags: build.query<
        GetEventLabellingModelWindowedAlwaysOnFlagsApiResponse,
        GetEventLabellingModelWindowedAlwaysOnFlagsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/event_labelling_models/${queryArg.tenantName}/${queryArg.labellingName}/windowed_targeted_review_always_on`,
          params: {
            window_days: queryArg.windowDays,
          },
        }),
        providesTags: ["event_labelling_models"],
      }),
      getEventLabellingModelRecallAtThresholds: build.query<
        GetEventLabellingModelRecallAtThresholdsApiResponse,
        GetEventLabellingModelRecallAtThresholdsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/event_labelling_models/${queryArg.tenantName}/${queryArg.labellingName}/recall_at_thresholds`,
          params: {
            material_threshold: queryArg.materialThreshold,
            event_threshold: queryArg.eventThreshold,
            area_threshold: queryArg.areaThreshold,
          },
        }),
        providesTags: ["event_labelling_models"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as generatedApi };
export type GetTenantMetadataApiResponse =
  /** status 200 Successful Response */ Tenant;
export type GetTenantMetadataApiArg = {
  tenantName: string;
};
export type TriggerAutoRecipesFromFilesApiResponse =
  | /** status 200 No auto recipes needed or trigger suppressed */ TriggerAutoRecipesResponse
  | /** status 202 Auto recipes triggered - processing in background */ TriggerAutoRecipesResponse;
export type TriggerAutoRecipesFromFilesApiArg = {
  tenantName: string;
  "X-Idempotency-Key"?: string;
  triggerAutoRecipesRequest: TriggerAutoRecipesRequest;
};
export type TriggerAutoRecipesFromTypesApiResponse =
  | /** status 200 No auto recipes needed - empty recipe types list */ TriggerAutoRecipesResponse
  | /** status 202 Auto recipes triggered - processing in background */ TriggerAutoRecipesResponse;
export type TriggerAutoRecipesFromTypesApiArg = {
  tenantName: string;
  "X-Idempotency-Key"?: string;
  triggerAutoRecipesFromTypesRequest: TriggerAutoRecipesFromTypesRequest;
};
export type ListAutoRecipeStrategiesApiResponse =
  /** status 200 Successful Response */ AutoRecipeStrategySpecs;
export type ListAutoRecipeStrategiesApiArg = {
  tenantName: string;
};
export type ListAutoRecipeEstimatorsApiResponse =
  /** status 200 Successful Response */ AutoRecipeEstimatorsSpecs;
export type ListAutoRecipeEstimatorsApiArg = {
  tenantName: string;
};
export type GetDefaultAutoRecipeEstimatorsApiResponse =
  /** status 200 Successful Response */ AutoRecipeEstimatorsSpec;
export type GetDefaultAutoRecipeEstimatorsApiArg = {
  tenantName: string;
  searchType: SearchType;
};
export type GetDefaultAutoRecipeStrategyApiResponse =
  /** status 200 Successful Response */ AutoRecipeStrategySpec;
export type GetDefaultAutoRecipeStrategyApiArg = {
  tenantName: string;
  searchType: SearchType;
};
export type CreateAutoRecipeApiResponse =
  /** status 200 Successful Response */ AutoRecipeRead;
export type CreateAutoRecipeApiArg = {
  tenantName: string;
  autoRecipeCreate: AutoRecipeCreate;
};
export type CreateAndRunAutoRecipeApiResponse =
  /** status 200 Successful Response */ AutoRecipeRead;
export type CreateAndRunAutoRecipeApiArg = {
  tenantName: string;
  autoRecipeCreate: AutoRecipeCreate;
};
export type ListChefGroupsApiResponse =
  /** status 200 Successful Response */ Metadata[];
export type ListChefGroupsApiArg = {
  tenantName: string;
};
export type CreateChefGroupingApiResponse =
  /** status 200 Successful Response */ ChefGroupingRead;
export type CreateChefGroupingApiArg = {
  tenantName: string;
  chefGroupingCreate: ChefGroupingCreate;
};
export type UpdateDefaultTargetBasketsApiResponse =
  /** status 200 Successful Response */ ChefGroupingRead;
export type UpdateDefaultTargetBasketsApiArg = {
  tenantName: string;
  updateDefaultTargetBasketsRequest: UpdateDefaultTargetBasketsRequest;
};
export type GetChefGroupingApiResponse =
  /** status 200 Successful Response */ ChefGroupingRead;
export type GetChefGroupingApiArg = {
  tenantName: string;
  chefGroupingId: number | Default;
  source?: EntitySource | null;
};
export type UpdateDefaultMaterialLimitsApiResponse =
  /** status 200 Successful Response */ MaterialLimitSet;
export type UpdateDefaultMaterialLimitsApiArg = {
  tenantName: string;
  updateDefaultMaterialLimitsRequest: UpdateDefaultMaterialLimitsRequest;
};
export type GetMaterialLimitSetApiResponse =
  /** status 200 Successful Response */ MaterialLimitSet;
export type GetMaterialLimitSetApiArg = {
  tenantName: string;
  materialLimitSetId: number | Default;
  source?: EntitySource | null;
};
export type ListSteelGradesApiResponse =
  /** status 200 Successful Response */ Metadata[];
export type ListSteelGradesApiArg = {
  tenantName: string;
};
export type CreateSteelGradeSetApiResponse =
  /** status 200 Successful Response */ SteelGradeSetRead;
export type CreateSteelGradeSetApiArg = {
  tenantName: string;
  steelGradeSetCreate: SteelGradeSetCreate;
};
export type GetSteelGradeSetApiResponse =
  /** status 200 Successful Response */ SteelGradeSetRead;
export type GetSteelGradeSetApiArg = {
  tenantName: string;
  steelGradeSetId: number | Default;
};
export type ListSteelGradePlansApiResponse =
  /** status 200 Successful Response */ Metadata[];
export type ListSteelGradePlansApiArg = {
  tenantName: string;
};
export type CreateSteelGradePlanApiResponse =
  /** status 200 Successful Response */ SteelGradePlanRead;
export type CreateSteelGradePlanApiArg = {
  tenantName: string;
  steelGradePlanCreate: SteelGradePlanCreate;
};
export type GetSteelGradePlanApiResponse =
  /** status 200 Successful Response */ SteelGradePlanRead;
export type GetSteelGradePlanApiArg = {
  tenantName: string;
  steelGradePlanId: number;
};
export type GetTypicalSteelGradePlanApiResponse =
  /** status 200 Successful Response */ SteelGradePlanRead;
export type GetTypicalSteelGradePlanApiArg = {
  tenantName: string;
  steelGradeSetId: number;
  numHeats: number;
};
export type GetSteelGradePlanItemsFromProductGroupPlanItemsApiResponse =
  /** status 200 Successful Response */ SteelGradePlanItem[];
export type GetSteelGradePlanItemsFromProductGroupPlanItemsApiArg = {
  tenantName: string;
  steelGradeSetId: number;
  productGroupPlanItems: ProductGroupPlanItem[];
};
export type GetFormattedBasketConstraintsApiResponse =
  /** status 200 Successful Response */ FormattedBasketConstraint[];
export type GetFormattedBasketConstraintsApiArg = {
  tenantName: string;
};
export type ListChemicalElementsApiResponse =
  /** status 200 Successful Response */ ChemicalElement[];
export type ListChemicalElementsApiArg = {
  tenantName: string;
};
export type GetCraneAssignedBasketApiResponse =
  /** status 200 Successful Response */ LoadBasketReadList;
export type GetCraneAssignedBasketApiArg = {
  tenantName: string;
  craneUserUid: string;
};
export type GetMaterialMetadataSetApiResponse =
  /** status 200 Successful Response */ MaterialMetadataSetRead;
export type GetMaterialMetadataSetApiArg = {
  tenantName: string;
  materialMetadataSetId: number | Default;
};
export type ListMaterialConstraintClassesApiResponse =
  /** status 200 Successful Response */ MaterialConstraintClass[];
export type ListMaterialConstraintClassesApiArg = {
  tenantName: string;
  materialMetadataSetId: number;
  materialPhysicsSetId: number;
};
export type CreateMaterialChemistrySetApiResponse =
  /** status 200 Successful Response */ MaterialChemistrySetRead;
export type CreateMaterialChemistrySetApiArg = {
  tenantName: string;
  materialChemistrySetCreate: MaterialChemistrySetCreate;
};
export type ListMaterialChemistrySetsApiResponse =
  /** status 200 Successful Response */ Metadata[];
export type ListMaterialChemistrySetsApiArg = {
  tenantName: string;
};
export type UpdateDefaultMaterialChemistryApiResponse =
  /** status 200 Successful Response */ MaterialChemistrySetRead;
export type UpdateDefaultMaterialChemistryApiArg = {
  tenantName: string;
  updateDefaultMaterialChemistryRequest: UpdateDefaultMaterialChemistryRequest;
};
export type GetMaterialChemistrySetApiResponse =
  /** status 200 Successful Response */ MaterialChemistrySetRead;
export type GetMaterialChemistrySetApiArg = {
  tenantName: string;
  materialChemistrySetId: number | Default;
  source?: EntitySource | null;
};
export type GetMaterialPricesApiResponse =
  /** status 200 Successful Response */ {
    [key: string]: number;
  };
export type GetMaterialPricesApiArg = {
  tenantName: string;
  timestamp: string;
};
export type UpdateDefaultMaterialPhysicsApiResponse =
  /** status 200 Successful Response */ MaterialPhysicsSetRead;
export type UpdateDefaultMaterialPhysicsApiArg = {
  tenantName: string;
  updateDefaultMaterialPhysicsRequest: UpdateDefaultMaterialPhysicsRequest;
};
export type GetMaterialPhysicsSetApiResponse =
  /** status 200 Successful Response */ MaterialPhysicsSetRead;
export type GetMaterialPhysicsSetApiArg = {
  tenantName: string;
  materialPhysicsSetId: number | Default;
  source?: EntitySource | null;
};
export type GetFixedMixDefaultsApiResponse =
  /** status 200 Successful Response */ FixedMixDefaultsRead;
export type GetFixedMixDefaultsApiArg = {
  tenantName: string;
};
export type UpdateFixedMixDefaultsApiResponse =
  /** status 200 Successful Response */ FixedMixDefaultsRead;
export type UpdateFixedMixDefaultsApiArg = {
  tenantName: string;
  fixedMixDefaultsRequest: FixedMixDefaultsRequest;
};
export type PreviewFixedMixDefaultsApiResponse =
  /** status 200 Successful Response */ FixedMixDefaultsPreview;
export type PreviewFixedMixDefaultsApiArg = {
  tenantName: string;
  fixedMixDefaultsRequest: FixedMixDefaultsRequest;
};
export type GetAutoRecipeDefaultsApiResponse =
  /** status 200 Successful Response */ AutoRecipeDefaultsRead;
export type GetAutoRecipeDefaultsApiArg = {
  tenantName: string;
  searchType: SearchType;
  scope?: AutoRecipeParameterScope;
};
export type ValidateAutoRecipeDefaultsApiResponse =
  /** status 200 Successful Response */ AutoRecipeParameters;
export type ValidateAutoRecipeDefaultsApiArg = {
  tenantName: string;
  scope?: AutoRecipeParameterScope;
  autoRecipeDefaultsRequest: AutoRecipeDefaultsRequest;
};
export type UpdateAutoRecipeDefaultsApiResponse =
  /** status 200 Successful Response */ AutoRecipeDefaultsRead;
export type UpdateAutoRecipeDefaultsApiArg = {
  tenantName: string;
  autoRecipeDefaultsRequest: AutoRecipeDefaultsRequest;
};
export type RevertAutoRecipeDefaultsApiResponse =
  /** status 200 Successful Response */ AutoRecipeDefaultsRead;
export type RevertAutoRecipeDefaultsApiArg = {
  tenantName: string;
  autoRecipeDefaultsContext: AutoRecipeDefaultsContext;
};
export type PreviewAutoRecipeSupplyApiResponse =
  /** status 200 Successful Response */ AutoRecipeSupplyPreview;
export type PreviewAutoRecipeSupplyApiArg = {
  tenantName: string;
  scope?: AutoRecipeParameterScope;
  autoRecipeSupplyPreviewRequest: AutoRecipeSupplyPreviewRequest;
};
export type NotifyDefaultParameterVisitApiResponse = unknown;
export type NotifyDefaultParameterVisitApiArg = {
  tenantName: string;
  defaultParameterVisit: DefaultParameterVisit;
};
export type ListLoadsApiResponse =
  /** status 200 Successful Response */ LoadRead[];
export type ListLoadsApiArg = {
  tenantName: string;
  createdSince?: string | null;
  createdBefore?: string | null;
  sortOrder?: LoadSortOrder | null;
  limit?: number | null;
  status?: LoadStatus | null;
};
export type CreateLoadApiResponse =
  /** status 200 Successful Response */ LoadRead;
export type CreateLoadApiArg = {
  tenantName: string;
  loadCreate: LoadCreate;
};
export type ListCranesApiResponse =
  /** status 200 Successful Response */ CraneList;
export type ListCranesApiArg = {
  tenantName: string;
};
export type GetLoadApiResponse = /** status 200 Successful Response */ LoadRead;
export type GetLoadApiArg = {
  tenantName: string;
  loadId: number;
};
export type DeleteLoadApiResponse = unknown;
export type DeleteLoadApiArg = {
  tenantName: string;
  loadId: number;
};
export type UpdateLoadBasketAssignmentApiResponse =
  /** status 200 Successful Response */ LoadBasketRead;
export type UpdateLoadBasketAssignmentApiArg = {
  tenantName: string;
  loadBasketId: number;
  loadBasketAssignmentUpdate: LoadBasketAssignmentUpdate;
};
export type UpdateLoadBasketAdditionsApiResponse =
  /** status 200 Successful Response */ LoadBasketRead;
export type UpdateLoadBasketAdditionsApiArg = {
  tenantName: string;
  loadBasketId: number;
  loadBasketAdditionUpdate: LoadBasketAdditionUpdate;
};
export type CompleteLoadBasketApiResponse =
  /** status 200 Successful Response */ LoadBasketRead;
export type CompleteLoadBasketApiArg = {
  tenantName: string;
  loadBasketId: number;
  loadBasketAdditionUpdate: LoadBasketAdditionUpdate;
};
export type GetPlanResultsApiResponse =
  /** status 200 Successful Response */ PlannedResultsRead;
export type GetPlanResultsApiArg = {
  tenantName: string;
  planId: number;
  period: number;
};
export type GetPlanResultsBatchApiResponse =
  /** status 200 Successful Response */ BatchPlanResultsResponse;
export type GetPlanResultsBatchApiArg = {
  tenantName: string;
  requests: PlanMixRequest[];
};
export type GetDeployedPlansApiResponse =
  /** status 200 Successful Response */ DeployedPlans;
export type GetDeployedPlansApiArg = {
  tenantName: string;
  deploymentTypes?: DeploymentType[] | null;
};
export type GetDeployedPlanResultsApiResponse =
  /** status 200 Successful Response */ DeployedPlannedResultsRead;
export type GetDeployedPlanResultsApiArg = {
  tenantName: string;
  planId: number | Latest | Next;
  period: number;
  deploymentTypes?: DeploymentType[] | null;
};
export type GetDeployedPlanMetadataApiResponse =
  /** status 200 Successful Response */ Deployment;
export type GetDeployedPlanMetadataApiArg = {
  tenantName: string;
  deploymentTypes?: DeploymentType[] | null;
};
export type GetPlanResultsExcelApiResponse =
  /** status 200 Successful Response */ Blob;
export type GetPlanResultsExcelApiArg = {
  tenantName: string;
  planId: number;
  language: SupportedLanguage;
  period?: number | null;
};
export type DeployPlanApiResponse = unknown;
export type DeployPlanApiArg = {
  tenantName: string;
  planId: number;
  deployParameters: DeployParameters;
};
export type CreateHeatOverrideApiResponse =
  /** status 200 Successful Response */ HeatOverrideCreated;
export type CreateHeatOverrideApiArg = {
  tenantName: string;
  create: HeatOverrideDeltaCreate | HeatOverrideCatalogCreate;
};
export type ListCompletedHeatsApiResponse =
  /** status 200 Successful Response */ CompletedHeats;
export type ListCompletedHeatsApiArg = {
  tenantName: string;
  heatId: number;
};
export type CreateCompletedHeatsOverrideApiResponse =
  /** status 200 Successful Response */ HeatOverrideCreated;
export type CreateCompletedHeatsOverrideApiArg = {
  tenantName: string;
  heatOverrideCatalogCreate: HeatOverrideCatalogCreate;
};
export type ListHeatOverrideHistoryApiResponse =
  /** status 200 Successful Response */ HeatOverrideHistory;
export type ListHeatOverrideHistoryApiArg = {
  tenantName: string;
  page: number;
  pageSize: number;
  date?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  cancellation?: HeatOverrideCancellationFilter;
};
export type EditHeatOverrideHistoryApiResponse =
  /** status 200 Successful Response */ HistoricalHeatOverride;
export type EditHeatOverrideHistoryApiArg = {
  tenantName: string;
  overrideId: number;
  historicalHeatOverrideUpdate: HistoricalHeatOverrideUpdate;
};
export type ListHeatOverrideRecipesApiResponse =
  /** status 200 Successful Response */ HeatOverrideRecipes;
export type ListHeatOverrideRecipesApiArg = {
  tenantName: string;
};
export type ReviseHeatOverrideRecipeApiResponse =
  /** status 201 Successful Response */ HeatOverrideCatalogSelection;
export type ReviseHeatOverrideRecipeApiArg = {
  tenantName: string;
  fixedMixSetId: number;
  heatOverrideRecipeUpdate: HeatOverrideRecipeUpdate;
};
export type ListHeatOverrideReasonsApiResponse =
  /** status 200 Successful Response */ HeatOverrideReasons;
export type ListHeatOverrideReasonsApiArg = {
  tenantName: string;
};
export type CancelHeatOverrideApiResponse = unknown;
export type CancelHeatOverrideApiArg = {
  tenantName: string;
  overrideId: number;
};
export type CancelHistoricalHeatOverrideApiResponse = unknown;
export type CancelHistoricalHeatOverrideApiArg = {
  tenantName: string;
  overrideId: number;
};
export type GetLiveRecipeApiResponse =
  /** status 200 Successful Response */ LiveRecipeResponse | null;
export type GetLiveRecipeApiArg = {
  tenantName: string;
};
export type GetHeatQueueApiResponse =
  /** status 200 Successful Response */ HeatQueueRead;
export type GetHeatQueueApiArg = {
  tenantName: string;
};
export type GetObtainableBundleItemSetApiResponse =
  /** status 200 Successful Response */ ObtainableBundleItemSet;
export type GetObtainableBundleItemSetApiArg = {
  tenantName: string;
  obtainableBundleSetId: number;
  materialMetadataSetId?: number | null;
};
export type CreateObtainableBundleItemSetApiResponse =
  /** status 200 Successful Response */ ObtainableBundleItemSet;
export type CreateObtainableBundleItemSetApiArg = {
  tenantName: string;
  obtainableBundleItemSetCreate: ObtainableBundleItemSetCreate;
};
export type ListProductGroupingsApiResponse =
  /** status 200 Successful Response */ Metadata[];
export type ListProductGroupingsApiArg = {
  tenantName: string;
};
export type CreateProductGroupingApiResponse =
  /** status 200 Successful Response */ ProductGroupingRead;
export type CreateProductGroupingApiArg = {
  tenantName: string;
  productGroupingCreate: ProductGroupingCreate;
};
export type GetProductGroupingApiResponse =
  /** status 200 Successful Response */ ProductGroupingRead;
export type GetProductGroupingApiArg = {
  tenantName: string;
  productGroupingId: number | Default;
};
export type ListProductGroupPlansApiResponse =
  /** status 200 Successful Response */ Metadata[];
export type ListProductGroupPlansApiArg = {
  tenantName: string;
};
export type CreateProductGroupPlanApiResponse =
  /** status 200 Successful Response */ ProductGroupPlanRead;
export type CreateProductGroupPlanApiArg = {
  tenantName: string;
  productGroupPlanCreate: ProductGroupPlanCreate;
};
export type GetProductGroupPlanApiResponse =
  /** status 200 Successful Response */ ProductGroupPlanRead;
export type GetProductGroupPlanApiArg = {
  tenantName: string;
  productGroupPlanId: number;
};
export type GetTypicalProductGroupPlanApiResponse =
  /** status 200 Successful Response */ ProductGroupPlanRead;
export type GetTypicalProductGroupPlanApiArg = {
  tenantName: string;
  productGroupingId: number;
  numHeats: number;
};
export type GetProductGroupPlanItemsFromSteelGradePlanItemsApiResponse =
  /** status 200 Successful Response */ ProductGroupPlanItem[];
export type GetProductGroupPlanItemsFromSteelGradePlanItemsApiArg = {
  tenantName: string;
  productGroupingId: number;
  steelGradePlanItems: SteelGradePlanItem[];
};
export type ListSearchesApiResponse =
  /** status 200 Successful Response */ SearchSummary[];
export type ListSearchesApiArg = {
  tenantName: string;
  ordering: Ordering;
  sessionId?: number | null;
  limit?: number | null;
  status?: SearchStatus | null;
};
export type SendSearchNotificationApiResponse = unknown;
export type SendSearchNotificationApiArg = {
  tenantName: string;
  searchId: number;
};
export type CreateSearchFromContextApiResponse =
  /** status 200 Successful Response */ SearchRead;
export type CreateSearchFromContextApiArg = {
  tenantName: string;
  searchId: number;
  chefGroupingSource?: EntitySource | null;
};
export type RunSearchApiResponse =
  /** status 200 Successful Response */ SearchResult;
export type RunSearchApiArg = {
  tenantName: string;
  searchId: number;
  runSearchOptions: RunSearchOptions;
};
export type GetSearchApiResponse =
  /** status 200 Successful Response */ SearchRead;
export type GetSearchApiArg = {
  tenantName: string;
  searchId: number;
};
export type CreateSearchApiResponse =
  /** status 200 Successful Response */ SearchRead;
export type CreateSearchApiArg = {
  tenantName: string;
  searchCreate: SearchCreate;
};
export type GetSearchContextApiResponse =
  /** status 200 Successful Response */ SearchContextData;
export type GetSearchContextApiArg = {
  tenantName: string;
  searchContextId: number;
};
export type GetNameBasedSearchApiResponse =
  /** status 200 Successful Response */ NameBasedSearch;
export type GetNameBasedSearchApiArg = {
  tenantName: string;
  searchId: number;
};
export type OverwriteFromNameBasedSearchApiResponse =
  /** status 200 Successful Response */ SearchRead;
export type OverwriteFromNameBasedSearchApiArg = {
  tenantName: string;
  searchId: number;
  nameBasedSearch: NameBasedSearch;
};
export type ApplyNameBasedSearchDiffApiResponse =
  /** status 200 Successful Response */ ApplyNameBasedSearchDiffResult;
export type ApplyNameBasedSearchDiffApiArg = {
  tenantName: string;
  searchId: number;
  nameBasedSearchDiff: NameBasedSearchDiff;
};
export type GetNameBasedSearchDiffApiResponse =
  /** status 200 Successful Response */ NameBasedSearchDiff;
export type GetNameBasedSearchDiffApiArg = {
  tenantName: string;
  targetSearchId: number;
  sourceSearchId: number;
};
export type GetNameBasedSearchObjectDiffApiResponse =
  /** status 200 Successful Response */ NameBasedSearchDiff;
export type GetNameBasedSearchObjectDiffApiArg = {
  tenantName: string;
  nameBasedSearchDiffRequest: NameBasedSearchDiffRequest;
};
export type ListDeployedPlansApiResponse =
  /** status 200 Successful Response */ DeployedPlansRead;
export type ListDeployedPlansApiArg = {
  tenantName: string;
  limit: number;
  offset: number;
};
export type ListDeployedPlanDaysApiResponse =
  /** status 200 Successful Response */ DeployedPlanDaysRead;
export type ListDeployedPlanDaysApiArg = {
  tenantName: string;
  /** IANA name of the timezone that sets the days. */
  timezone: string;
  /** Number of days. */
  limit: number;
  /** Number of days to skip. */
  offset: number;
  /** Text to find in the session name, the deployer or a recipe code. */
  matchText?: string | null;
  /** Date to find in the deployment, plan start or plan end. */
  matchDate?: string | null;
};
export type SendPlanNotificationApiResponse = unknown;
export type SendPlanNotificationApiArg = {
  tenantName: string;
  planId: number;
  planName: string;
};
export type CreatePlanFromStandingRecipeApiResponse =
  /** status 200 Successful Response */ number;
export type CreatePlanFromStandingRecipeApiArg = {
  tenantName: string;
};
export type PreviewLayeringApiResponse =
  /** status 200 Successful Response */ MixCreate;
export type PreviewLayeringApiArg = {
  tenantName: string;
  mixCreate: MixCreate;
};
export type UpdatePlanResultsApiResponse =
  /** status 200 Successful Response */ PlannedResultsRead;
export type UpdatePlanResultsApiArg = {
  tenantName: string;
  planId: number;
  planMixUpdates: PlanMixUpdates;
};
export type UpdateAndDeployPlanResultsApiResponse =
  /** status 200 Successful Response */ DeployedPlannedResultsRead;
export type UpdateAndDeployPlanResultsApiArg = {
  tenantName: string;
  planId: number;
  deployedPlanMixUpdates: DeployedPlanMixUpdates;
};
export type ComparePlanPeriodsApiResponse =
  /** status 200 Successful Response */ PlanPeriodComparison;
export type ComparePlanPeriodsApiArg = {
  tenantName: string;
  planId: number;
  period: number;
  baselinePlanId: number;
  baselinePeriod: number;
};
export type CompareMixesApiResponse =
  /** status 200 Differences between two mixes including material mass changes. */ MixDifferencesRead;
export type CompareMixesApiArg = {
  tenantName: string;
  materialMetadataSetId: number;
  /** ID of first mix to compare */
  srcMixId: number;
  /** ID of second mix to compare */
  tgtMixId: number;
};
export type GetPlanAncestorsApiResponse =
  /** status 200 A list of plan differences between the ancestor plans. */ PlanAncestorDiffsRead;
export type GetPlanAncestorsApiArg = {
  tenantName: string;
  planId: number;
};
export type GetBackupsApiResponse =
  /** status 200 Successful Response */ PlanBackupSummaries;
export type GetBackupsApiArg = {
  tenantName: string;
  planId: number;
};
export type GetPlanApiResponse = /** status 200 Successful Response */ Plan;
export type GetPlanApiArg = {
  tenantName: string;
  planId: number;
};
export type CopyDeployedPlanMixesApiResponse =
  /** status 200 Successful Response */ CopiedPlanSteelGrades;
export type CopyDeployedPlanMixesApiArg = {
  tenantName: string;
  targetPlanId: number;
  deploymentCutoff: string;
};
export type ListSessionsApiResponse =
  /** status 200 Successful Response */ SessionSummary[];
export type ListSessionsApiArg = {
  tenantName: string;
};
export type CreateSessionApiResponse =
  /** status 200 Successful Response */ SearchRead;
export type CreateSessionApiArg = {
  tenantName: string;
  sessionCreate: SessionCreate;
};
export type ListSessionVersionsApiResponse =
  /** status 200 Successful Response */ SessionMajorVersions[];
export type ListSessionVersionsApiArg = {
  tenantName: string;
};
export type RenameSessionApiResponse = unknown;
export type RenameSessionApiArg = {
  tenantName: string;
  sessionId: number;
  renameSession: RenameSession;
};
export type DeleteSessionApiResponse = unknown;
export type DeleteSessionApiArg = {
  tenantName: string;
  sessionId: number;
};
export type CopySearchApiResponse =
  /** status 200 Successful Response */ SearchRead;
export type CopySearchApiArg = {
  tenantName: string;
  sessionId: number;
  copySearch: CopySearch;
};
export type GetResultApiResponse =
  /** status 200 Successful Response */ SearchResult;
export type GetResultApiArg = {
  tenantName: string;
  searchId: number;
};
export type GetNameBasedResultsApiResponse =
  /** status 200 Successful Response */ ResultsRead[];
export type GetNameBasedResultsApiArg = {
  tenantName: string;
  searchId: number;
};
export type GetNameBasedResultApiResponse =
  /** status 200 Successful Response */ ResultsRead;
export type GetNameBasedResultApiArg = {
  tenantName: string;
  planId: number;
};
export type SaveUploadedFileApiResponse =
  /** status 200 Successful Response */ UploadedFileMeta;
export type SaveUploadedFileApiArg = {
  tenantName: string;
  uploadedFileCreate: UploadedFileCreate;
};
export type ListUploadedFilesApiResponse =
  /** status 200 Successful Response */ UploadedFileMeta[];
export type ListUploadedFilesApiArg = {
  tenantName: string;
  types: string[];
  deleted?: boolean | null;
  since?: string | null;
  limit?: number | null;
  order?: Ordering;
};
export type SaveAndParseFileApiResponse =
  /** status 200 Successful Response */ UploadedFileMeta;
export type SaveAndParseFileApiArg = {
  tenantName: string;
  uploadedFileCreate: UploadedFileCreate;
};
export type UploadAdhocFileApiResponse =
  /** status 200 Successful Response */ UploadedFileMeta;
export type UploadAdhocFileApiArg = {
  tenantName: string;
  file: File;
};
export type GetUploadedFileApiResponse =
  /** status 200 Successful Response */ UploadedFileRead;
export type GetUploadedFileApiArg = {
  tenantName: string;
  uploadedFileId: number;
};
export type ListUploadedFileTypesApiResponse =
  /** status 200 Successful Response */ UploadedFileTypeList;
export type ListUploadedFileTypesApiArg = {
  tenantName: string;
  uploadedFileOutputTypeList: UploadedFileOutputTypeList;
};
export type GetParsedSearchParametersApiResponse =
  /** status 200 Successful Response */ UploadedSearchParameters;
export type GetParsedSearchParametersApiArg = {
  tenantName: string;
  uploadedFileId: number;
  materialMetadataSetId: number;
  steelGradeSetId: number;
};
export type GetLayeringApiResponse =
  /** status 200 Successful Response */ PublishedChargeScheduleLayering;
export type GetLayeringApiArg = {
  tenantName: string;
  planId: number;
  period: number;
  groupId: number;
  mixNumber: number;
};
export type PublishPlanChargeScheduleApiResponse =
  /** status 200 Successful Response */ PlanPublishedChargeScheduleRead[];
export type PublishPlanChargeScheduleApiArg = {
  tenantName: string;
  publishPlans: PublishPlans;
};
export type ListNewPublishedChargeSchedulesApiResponse =
  /** status 200 Successful Response */ PublishedChargeScheduleRead[];
export type ListNewPublishedChargeSchedulesApiArg = {
  tenantName: string;
};
export type ListAllPublishedChargeSchedulesApiResponse =
  /** status 200 Successful Response */ PublishedChargeScheduleRead[];
export type ListAllPublishedChargeSchedulesApiArg = {
  tenantName: string;
  planId: number;
};
export type ConfirmPublishedChargeSchedulesApiResponse =
  /** status 200 Successful Response */ string;
export type ConfirmPublishedChargeSchedulesApiArg = {
  tenantName: string;
  confirmChargeSchedules: ChargeScheduleConfirm[];
};
export type ListConfirmedChargeScheduleMetaApiResponse =
  /** status 200 Successful Response */ ConfirmedChargeScheduleMeta[];
export type ListConfirmedChargeScheduleMetaApiArg = {
  tenantName: string;
  fdmChargeScheduleIds: number[];
};
export type GetPublishPreflightApiResponse =
  /** status 200 Successful Response */ PublishPreflight;
export type GetPublishPreflightApiArg = {
  tenantName: string;
  planId: number;
  period: number;
  /** Chef groups the publish would send. Omit to select every chef group in the period. */
  chefGroupIds?: number[] | null;
};
export type GetChargeScheduleMessageTemplateApiResponse =
  /** status 200 Successful Response */ ChargeScheduleMessage;
export type GetChargeScheduleMessageTemplateApiArg = {
  tenantName: string;
  planId: number;
  period: number;
  /** Chef groups to describe. Omit to describe every chef group published for the period. A query string carries no empty list, so an empty selection arrives here as an omission and describes the whole period. */
  chefGroupIds?: number[] | null;
};
export type SendChargeScheduleMessageListApiResponse = unknown;
export type SendChargeScheduleMessageListApiArg = {
  tenantName: string;
  chargeScheduleMessages: ChargeScheduleMessages;
};
export type SendPlanDeployedMessageApiResponse = unknown;
export type SendPlanDeployedMessageApiArg = {
  tenantName: string;
  planId: number;
};
export type GetActiveChargeSchedulesApiResponse =
  /** status 200 Successful Response */ ActiveChargeSchedules;
export type GetActiveChargeSchedulesApiArg = {
  tenantName: string;
  start: string;
  end: string;
};
export type ListMessagesApiResponse =
  /** status 200 Successful Response */ Message[];
export type ListMessagesApiArg = {
  tenantName: string;
  userUid?: string | null;
  start?: string | null;
  end?: string | null;
  messageTypeFilter?: MessageFilter;
};
export type AddSentMessageApiResponse =
  /** status 200 Successful Response */ Message;
export type AddSentMessageApiArg = {
  tenantName: string;
  addSentMessageRequest: AddSentMessageRequest;
};
export type ConfirmMessageSentApiResponse =
  /** status 200 Successful Response */ string;
export type ConfirmMessageSentApiArg = {
  tenantName: string;
  messageId: number;
};
export type CreateInventoryMeasurementSetApiResponse =
  /** status 200 Successful Response */ number;
export type CreateInventoryMeasurementSetApiArg = {
  tenantName: string;
  inventoryMeasurementSetCreate: InventoryMeasurementSetCreate;
};
export type GetInventoryEstimateAtTimestampApiResponse =
  /** status 200 Successful Response */ InventoryEstimate;
export type GetInventoryEstimateAtTimestampApiArg = {
  tenantName: string;
  materialMetadataSetId: number | Default;
  materialPhysicsSetId: number | Default;
  timestamp: string;
};
export type GetInventoryEstimateAtTimestampForMeasurementApiResponse =
  /** status 200 Successful Response */ InventoryEstimate;
export type GetInventoryEstimateAtTimestampForMeasurementApiArg = {
  tenantName: string;
  materialMetadataSetId: number | Default;
  materialPhysicsSetId: number | Default;
  timestamp: string;
};
export type GetInventoryBreakdownAtTimestampApiResponse =
  /** status 200 Successful Response */ InventoryBreakdown;
export type GetInventoryBreakdownAtTimestampApiArg = {
  tenantName: string;
  timestamp: string;
};
export type GetLatestInventoryMeasurementCreatedAtApiResponse =
  /** status 200 Successful Response */ LatestInventoryMeasurementTimestamp;
export type GetLatestInventoryMeasurementCreatedAtApiArg = {
  tenantName: string;
};
export type GetInventoryMeasurementComplianceApiResponse =
  /** status 200 Successful Response */ InventoryMeasurementCompliance;
export type GetInventoryMeasurementComplianceApiArg = {
  tenantName: string;
  measurementSetId: number;
};
export type GetRecipesImpuritiesStatsApiResponse =
  /** status 200 Successful Response */ RecipeImpurityStats[];
export type GetRecipesImpuritiesStatsApiArg = {
  tenantName: string;
  planId: number;
  mixId: number;
  period: number;
  steelGradeIds?: number[] | null;
};
export type CreateTargetBasketSetApiResponse =
  /** status 200 Successful Response */ TargetBasketSetRead;
export type CreateTargetBasketSetApiArg = {
  tenantName: string;
  targetBasketSetCreate: TargetBasketSetCreate;
};
export type UpdateDefaultTargetBasketsSetApiResponse =
  /** status 200 Successful Response */ TargetBasketSetRead;
export type UpdateDefaultTargetBasketsSetApiArg = {
  tenantName: string;
  updateDefaultTargetBasketSetRequest: UpdateDefaultTargetBasketSetRequest;
};
export type GetTargetBasketSetApiResponse =
  /** status 200 Successful Response */ TargetBasketSetRead;
export type GetTargetBasketSetApiArg = {
  tenantName: string;
  targetBasketSetId: number | Default;
  source?: EntitySource | null;
};
export type CheckParameterFeasibilityApiResponse =
  /** status 200 Successful Response */ ParameterFeasibilityReport;
export type CheckParameterFeasibilityApiArg = {
  tenantName: string;
  checkParameterFeasibilityRequest: CheckParameterFeasibilityRequest;
};
export type AddUsersApiResponse = unknown;
export type AddUsersApiArg = {
  tenantName: string;
  addUsersRequest: AddUsersRequest;
};
export type GenerateSignInLinkApiResponse =
  /** status 200 Successful Response */ GenerateSignInLinkResponse;
export type GenerateSignInLinkApiArg = {
  tenantName: string;
  generateSignInLinkRequest: GenerateSignInLinkRequest;
};
export type SendInviteEmailApiResponse = unknown;
export type SendInviteEmailApiArg = {
  tenantName: string;
  sendInviteEmailRequest: SendInviteEmailRequest;
};
export type GetPendingInvitesApiResponse =
  /** status 200 Successful Response */ InvitedUser[];
export type GetPendingInvitesApiArg = {
  tenantName: string;
};
export type DeleteUserInviteApiResponse = unknown;
export type DeleteUserInviteApiArg = {
  tenantName: string;
  email: string;
};
export type ListLabelReservationSettingsApiResponse =
  /** status 200 Successful Response */ LabelReservationSettingsList;
export type ListLabelReservationSettingsApiArg = {
  tenantName: string;
};
export type CreateLabelReservationSettingsApiResponse =
  /** status 201 Successful Response */ LabelReservationSettingsRead;
export type CreateLabelReservationSettingsApiArg = {
  tenantName: string;
  labelReservationSettingsCreate: LabelReservationSettingsCreate;
};
export type UpdateLabelReservationSettingsApiResponse =
  /** status 200 Successful Response */ LabelReservationSettingsRead;
export type UpdateLabelReservationSettingsApiArg = {
  tenantName: string;
  settingsId: number;
  labelReservationSettingsUpdate: LabelReservationSettingsUpdate;
};
export type DeleteLabelReservationSettingsApiResponse = unknown;
export type DeleteLabelReservationSettingsApiArg = {
  tenantName: string;
  settingsId: number;
};
export type SetDefaultLabelReservationSettingsApiResponse =
  /** status 200 Successful Response */ LabelReservationSettingsRead;
export type SetDefaultLabelReservationSettingsApiArg = {
  tenantName: string;
  settingsId: number;
};
export type ListLabelReservationSettingsAssignmentsApiResponse =
  /** status 200 Successful Response */ UserSettingsAssignmentList;
export type ListLabelReservationSettingsAssignmentsApiArg = {
  tenantName: string;
};
export type AssignUserLabelReservationSettingsApiResponse =
  /** status 201 Successful Response */ UserSettingsAssignmentRead;
export type AssignUserLabelReservationSettingsApiArg = {
  tenantName: string;
  userSettingsAssignment: UserSettingsAssignment;
};
export type UnassignUserLabelReservationSettingsApiResponse = unknown;
export type UnassignUserLabelReservationSettingsApiArg = {
  tenantName: string;
  userId: string;
};
export type GetResolvedLabelReservationSettingsApiResponse =
  /** status 200 Successful Response */ LabelReservationSettingsRead | null;
export type GetResolvedLabelReservationSettingsApiArg = {
  tenantName: string;
};
export type GetReviewDayOverviewApiResponse =
  /** status 200 Successful Response */ ReviewDayOverview;
export type GetReviewDayOverviewApiArg = {
  tenantName: string;
  date: string;
  location: string;
  reviewReasons?: ReviewReason[] | null;
  cacheCompression?: "zlib" | null;
};
export type GetSiteReviewPeriodsApiResponse =
  /** status 200 Successful Response */ SiteReviewPeriods;
export type GetSiteReviewPeriodsApiArg = {
  tenantName: string;
  date: string;
  cacheCompression?: "zlib" | null;
};
export type GetReviewMonthSummaryApiResponse =
  /** status 200 Successful Response */ ReviewMonthSummary;
export type GetReviewMonthSummaryApiArg = {
  tenantName: string;
  location: string;
  monthStart: string;
  monthEnd: string;
  includeFlags?: ReviewTimelineTickFlag[] | null;
  includeCountCategories?: ReviewCountCategory[] | null;
  consumptionLimitTo?: ReviewEventLimit | null;
  reviewReasons?: ReviewReason[] | null;
  projection?: ReviewMonthProjection;
  cacheCompression?: "zlib" | null;
  materialAreaFilterList: MaterialAreaFilterList;
};
export type GetCommentedEventsApiResponse =
  /** status 200 Successful Response */ CommentedEventsList;
export type GetCommentedEventsApiArg = {
  tenantName: string;
  location: string;
  start: string;
  end: string;
  cacheCompression?: "zlib" | null;
};
export type GetEventsForReviewApiResponse =
  /** status 200 Successful Response */ EventsForReview;
export type GetEventsForReviewApiArg = {
  tenantName: string;
  windowStart: string;
  windowEnd: string;
  location: string;
  targetNumberOfLabellers?: number | null;
  minimumIntersectionOverUnion?: number;
  mergeEventsSeparatedByGapSeconds?: number;
  excludedPeriodIds?: number[] | null;
  excludeMaterialPeriodIds?: number[] | null;
  excludeTimingPeriodIds?: number[] | null;
  includeVerified?: boolean;
  exclusionMode?: TimelineExclusionMode;
  /** Statuses of the models to leave out of the labeller timelines and the merged events. */
  omittedModelStatuses?: EventLabellingModelStatus[] | null;
  cacheCompression?: "zlib" | null;
};
export type UnverifyPeriodApiResponse = unknown;
export type UnverifyPeriodApiArg = {
  tenantName: string;
  periodId: number;
  cacheCompression?: "zlib" | null;
};
export type UploadCorrectedEventsAndVerifyApiResponse = unknown;
export type UploadCorrectedEventsAndVerifyApiArg = {
  tenantName: string;
  cacheCompression?: "zlib" | null;
  correctedEventsForPeriods: CorrectedEventsForPeriods;
};
export type MarkCommentEventReviewedApiResponse = unknown;
export type MarkCommentEventReviewedApiArg = {
  tenantName: string;
  eventId: number;
};
export type AssignPeriodsApiResponse = unknown;
export type AssignPeriodsApiArg = {
  tenantName: string;
  periodIds: number[];
  assignedToId: string;
  cacheCompression?: "zlib" | null;
};
export type UnassignPeriodsApiResponse = unknown;
export type UnassignPeriodsApiArg = {
  tenantName: string;
  periodIds: number[];
  cacheCompression?: "zlib" | null;
};
export type GetUnverifiedPeriodsApiResponse =
  /** status 200 Successful Response */ UnverifiedReviewPeriodData;
export type GetUnverifiedPeriodsApiArg = {
  tenantName: string;
  start: string;
  end: string;
  location?: string | null;
  cacheCompression?: "zlib" | null;
};
export type GetUnverifiedDatesApiResponse =
  /** status 200 Successful Response */ string[];
export type GetUnverifiedDatesApiArg = {
  tenantName: string;
  location: string;
  cacheCompression?: "zlib" | null;
};
export type GetAssignedReviewPeriodsApiResponse =
  /** status 200 Successful Response */ AssignedReviewPeriodsResponse;
export type GetAssignedReviewPeriodsApiArg = {
  tenantName: string;
  location: string;
  cacheCompression?: "zlib" | null;
};
export type GetLabellerTimelinesReportApiResponse =
  /** status 200 Successful Response */ LabellerTimelinesReport;
export type GetLabellerTimelinesReportApiArg = {
  tenantName: string;
  windowStart: string;
  windowEnd: string;
  location: string;
  model?: string | null;
  cacheCompression?: "zlib" | null;
};
export type CreateEventApiResponse =
  /** status 200 Successful Response */ Event;
export type CreateEventApiArg = {
  tenantName: string;
  eventCreate: EventCreate;
};
export type CreateEventsForReservationsApiResponse =
  /** status 200 Successful Response */ EventsList;
export type CreateEventsForReservationsApiArg = {
  tenantName: string;
  eventsCreate: EventsCreate;
};
export type ListEventsApiResponse =
  /** status 200 Successful Response */ EventsList;
export type ListEventsApiArg = {
  tenantName: string;
  eventTypes: EventType[];
  start: string;
  end: string;
};
export type GetReservedPeriodsApiResponse =
  /** status 200 Successful Response */ LabellingReservations;
export type GetReservedPeriodsApiArg = {
  tenantName: string;
  location: string | "auto";
};
export type ReserveLabellingPeriodsApiResponse =
  /** status 200 Successful Response */ LabellingReservations;
export type ReserveLabellingPeriodsApiArg = {
  tenantName: string;
  maxDurationSeconds?: number | null;
  location?: string | "auto" | null;
  reserveFrom?: string | null;
  reserveUntil?: string | null;
  allowedCoverageGapSeconds?: number | null;
  requiredAngles?: string[] | "all" | null;
  reservationSeconds?: number | null;
  maximumNumberOfLabellers?: number | null;
  targetNumberOfLabellers?: number | null;
  labelCoveragePriority?: LabelCoveragePriority | null;
  ignoreCoverage?: boolean | null;
};
export type ReserveLabellingPeriodsForModelApiResponse =
  /** status 200 Successful Response */ LabellingReservations;
export type ReserveLabellingPeriodsForModelApiArg = {
  tenantName: string;
  modelId: number;
  location: string;
  reserveFrom: string;
  reserveUntil: string;
  reservationLifetimeSeconds?: number;
  allowedCoverageGapSeconds?: number;
  requiredAngles?: string[] | "all";
  ignoreCoverage?: boolean;
};
export type DeletePeriodReservationApiResponse = unknown;
export type DeletePeriodReservationApiArg = {
  tenantName: string;
  labellingPeriodId: number;
};
export type InvalidatePeriodsApiResponse = unknown;
export type InvalidatePeriodsApiArg = {
  tenantName: string;
  periodIds: number[];
};
export type GetLatestEventExamplesApiResponse =
  /** status 200 Successful Response */ EventsList;
export type GetLatestEventExamplesApiArg = {
  tenantName: string;
  location: string;
  eventType: EventType;
  limit?: number;
};
export type GetMaterialExamplesApiResponse =
  /** status 200 Successful Response */ MaterialExamplesList;
export type GetMaterialExamplesApiArg = {
  tenantName: string;
  materialName: string;
  location: string;
  limit?: number;
};
export type GetLabellerVerifiedEventsComparisonApiResponse =
  /** status 200 Successful Response */ LabellerVerifiedEventsComparison;
export type GetLabellerVerifiedEventsComparisonApiArg = {
  tenantName: string;
  windowStart: string;
  windowEnd: string;
  location: string;
  labellerId: string;
  labellerType: LabellerType;
  includeUnusedModelEvents?: boolean;
  minimumIntersectionOverUnion?: number;
  mergeEventsSeparatedByGapSeconds?: number;
  cacheCompression?: "zlib" | null;
};
export type GetLabellersApiResponse =
  /** status 200 Successful Response */ LabellerDetails[];
export type GetLabellersApiArg = {
  tenantName: string;
};
export type GetCostLabellersApiResponse =
  /** status 200 Successful Response */ LabellerDetails[];
export type GetCostLabellersApiArg = {
  tenantName: string;
  start?: string | null;
  end?: string | null;
  filterMode?: TimeRangeFilterMode;
  location?: string | null;
};
export type GetDailyLabellerStatsApiResponse =
  /** status 200 Successful Response */ DailyLabellerStatsResponse;
export type GetDailyLabellerStatsApiArg = {
  tenantName: string;
  labellerId: string;
  start?: string | null;
  end?: string | null;
  filterMode?: TimeRangeFilterMode;
  location?: string | null;
  sessionTypes?: ToolSessionType[] | null;
};
export type GetLabellerCostStatsApiResponse =
  /** status 200 Successful Response */ LabellerCostStatsResponse;
export type GetLabellerCostStatsApiArg = {
  tenantName: string;
  start?: string | null;
  end?: string | null;
  filterMode?: TimeRangeFilterMode;
  location?: string | null;
};
export type GetLabellerAccuracyStatsApiResponse =
  /** status 200 Successful Response */ LabellerAccuracyStats;
export type GetLabellerAccuracyStatsApiArg = {
  tenantName: string;
  labellerId: string;
  location: string;
  start?: string | null;
  end?: string | null;
};
export type GetLabellerMatchedEventsApiResponse =
  /** status 200 Successful Response */ MatchedEventsResponse;
export type GetLabellerMatchedEventsApiArg = {
  tenantName: string;
  labellerId: string;
  location: string;
  metric: AccuracyMetric;
  start?: string | null;
  end?: string | null;
  predicted?: string | null;
  actual?: string | null;
  page?: number;
  pageSize?: number;
};
export type GetTenantLabellingCoverageApiResponse =
  /** status 200 Successful Response */ TenantLabellingCoverage;
export type GetTenantLabellingCoverageApiArg = {
  tenantName: string;
  start?: string | null;
  end?: string | null;
  granularity?: LabellingCoverageGranularity;
  /** Gap tolerance for video uptime in seconds */
  gapToleranceSeconds?: number;
};
export type GetLocationsLoadingTimelineApiResponse =
  /** status 200 Successful Response */ LocationsLoadingTimeline;
export type GetLocationsLoadingTimelineApiArg = {
  tenantName: string;
  date: string;
  cacheCompression?: "zlib" | null;
};
export type ListPendingPlanChangesApiResponse =
  /** status 200 Successful Response */ PlanChangesResponseRead;
export type ListPendingPlanChangesApiArg = {
  tenantName: string;
  acknowledgedByUid: string;
  sinceHours?: number;
};
export type ListPlanChangesApiResponse =
  /** status 200 Successful Response */ PlanChangesResponseRead;
export type ListPlanChangesApiArg = {
  tenantName: string;
  sinceHours?: number;
};
export type GetPlanChangeDetailsApiResponse =
  /** status 200 Successful Response */ PlanChangeDetailsResponseRead;
export type GetPlanChangeDetailsApiArg = {
  tenantName: string;
  planId: number;
};
export type GetPhysicalParametersSetApiResponse =
  /** status 200 Successful Response */ PhysicalParametersSetRead;
export type GetPhysicalParametersSetApiArg = {
  tenantName: string;
  physicalParametersSetId: number | Default;
};
export type ListSimulatorDataLoadersApiResponse =
  /** status 200 Successful Response */ SimulatorDataLoadersSpecs;
export type ListSimulatorDataLoadersApiArg = {
  tenantName: string;
};
export type ListSimulatorRunsApiResponse =
  /** status 200 Successful Response */ SimulatorRunList;
export type ListSimulatorRunsApiArg = {
  tenantName: string;
};
export type GetSimulatorRunApiResponse =
  /** status 200 Successful Response */ SimulatorRunRead;
export type GetSimulatorRunApiArg = {
  tenantName: string;
  simulatorRunId: number;
};
export type SummarisePlanResultsApiResponse =
  /** status 200 Successful Response */ SummarisedPlanResults;
export type SummarisePlanResultsApiArg = {
  tenantName: string;
  unsummarisedPlanResults: UnsummarisedPlanResults;
};
export type SendStrategyDashboardNotificationApiResponse = unknown;
export type SendStrategyDashboardNotificationApiArg = {
  tenantName: string;
  strategyDashboardNotification: StrategyDashboardNotification;
};
export type GetStrategyDashboardEditingApiResponse =
  /** status 200 Successful Response */ StrategyDashboardEditingData;
export type GetStrategyDashboardEditingApiArg = {
  tenantName: string;
  start?: string | null;
  end?: string | null;
  "Cache-Control"?: string;
};
export type GetStrategyDashboardEditingRecipesByDateApiResponse =
  /** status 200 Successful Response */ StrategyDashboardEditingRecipesByDate;
export type GetStrategyDashboardEditingRecipesByDateApiArg = {
  tenantName: string;
  heatDate: string;
  productGroupName: string;
  "Cache-Control"?: string;
};
export type GetRecipeEditsVisualizationApiResponse =
  /** status 200 Successful Response */ StrategyDashboardRecipeEditsVisualizationData;
export type GetRecipeEditsVisualizationApiArg = {
  tenantName: string;
  recipeCode: string;
  "Cache-Control"?: string;
};
export type GetStrategyDashboardInventoryApiResponse =
  /** status 200 Successful Response */ StrategyDashboardInventoryData;
export type GetStrategyDashboardInventoryApiArg = {
  tenantName: string;
  start?: string | null;
  end?: string | null;
  "Cache-Control"?: string;
};
export type GetStrategyDashboardConsumptionApiResponse =
  /** status 200 Successful Response */ StrategyDashboardConsumptionData;
export type GetStrategyDashboardConsumptionApiArg = {
  tenantName: string;
  start?: string | null;
  end?: string | null;
  timeAggregation?: TimeAggregation | null;
  productGrouping?: string | null;
  "Cache-Control"?: string;
};
export type GetStrategyDashboardConsumptionProjectionApiResponse =
  /** status 200 Successful Response */ StrategyDashboardConsumptionProjectionsData;
export type GetStrategyDashboardConsumptionProjectionApiArg = {
  tenantName: string;
  on?: string | null;
  "Cache-Control"?: string;
};
export type GetStrategyDashboardProductionApiResponse =
  /** status 200 Successful Response */ StrategyDashboardProductionData;
export type GetStrategyDashboardProductionApiArg = {
  tenantName: string;
  start?: string | null;
  end?: string | null;
  "Cache-Control"?: string;
};
export type GetStrategyDashboardProductionPaceApiResponse =
  /** status 200 Successful Response */ StrategyDashboardProductionPaceData;
export type GetStrategyDashboardProductionPaceApiArg = {
  tenantName: string;
  on: string;
  "Cache-Control"?: string;
};
export type GetStrategyDashboardFailureRateApiResponse =
  /** status 200 Successful Response */ StrategyDashboardFailureRateData;
export type GetStrategyDashboardFailureRateApiArg = {
  tenantName: string;
  start?: string | null;
  end?: string | null;
  "Cache-Control"?: string;
};
export type GetStrategyDashboardPricesApiResponse =
  /** status 200 Successful Response */ StrategyDashboardPriceData;
export type GetStrategyDashboardPricesApiArg = {
  tenantName: string;
  start?: string | null;
  end?: string | null;
  "Cache-Control"?: string;
};
export type GetStrategyDashboardScrapChefUsageApiResponse =
  /** status 200 Successful Response */ StrategyDashboardScrapChefUsageData;
export type GetStrategyDashboardScrapChefUsageApiArg = {
  tenantName: string;
  "Cache-Control"?: string;
};
export type GetStrategyDashboardScrapChefUsageDetailedApiResponse =
  /** status 200 Successful Response */ ScrapChefUsageDetailedData;
export type GetStrategyDashboardScrapChefUsageDetailedApiArg = {
  tenantName: string;
  "Cache-Control"?: string;
};
export type GetStrategyDashboardCostApiResponse =
  /** status 200 Successful Response */ StrategyDashboardCostData;
export type GetStrategyDashboardCostApiArg = {
  tenantName: string;
  start?: string | null;
  end?: string | null;
  timeAggregation?: TimeAggregation | null;
  "Cache-Control"?: string;
};
export type GetStrategyDashboardHeatsApiResponse =
  /** status 200 Successful Response */ StrategyDashboardHeatData;
export type GetStrategyDashboardHeatsApiArg = {
  tenantName: string;
  start: string | Latest;
  end?: string | null;
  filterMode?: "overlap" | "fully_contained";
  page?: number;
  resultsPerPage?: number | null;
};
export type GetStrategyDashboardHeatsByIdsApiResponse =
  /** status 200 Successful Response */ StrategyDashboardHeatData;
export type GetStrategyDashboardHeatsByIdsApiArg = {
  tenantName: string;
  heatIds: string[];
};
export type GetStrategyDashboardShiftsApiResponse =
  /** status 200 Successful Response */ StrategyDashboardShiftsData;
export type GetStrategyDashboardShiftsApiArg = {
  tenantName: string;
  referenceTimestamp: string;
  before?: number;
  after?: number;
};
export type GetStrategyDashboardDeliveriesAndPurchasesApiResponse =
  /** status 200 Successful Response */ StrategyDashboardDeliveryData;
export type GetStrategyDashboardDeliveriesAndPurchasesApiArg = {
  tenantName: string;
  start?: string | null;
  end?: string | null;
  "Cache-Control"?: string;
};
export type GetStrategyDashboardDeliveriesOverviewApiResponse =
  /** status 200 Successful Response */ StrategyDashboardDeliveryData;
export type GetStrategyDashboardDeliveriesOverviewApiArg = {
  tenantName: string;
  on: string;
  "Cache-Control"?: string;
};
export type GetStrategyDashboardComplianceApiResponse =
  /** status 200 Successful Response */ StrategyDashboardComplianceData;
export type GetStrategyDashboardComplianceApiArg = {
  tenantName: string;
  start: string;
  end: string;
  "Cache-Control"?: string;
};
export type GetCrewAggregatedComplianceApiResponse =
  /** status 200 Successful Response */ CrewAggregatedComplianceData;
export type GetCrewAggregatedComplianceApiArg = {
  tenantName: string;
  start: string;
  end: string;
  excludeMaterials?: string[] | null;
};
export type GetStrategyDashboardCrewComparisonApiResponse =
  /** status 200 Successful Response */ CrewComparisonResponse;
export type GetStrategyDashboardCrewComparisonApiArg = {
  tenantName: string;
  start: string;
  end: string;
};
export type GetTenantSavingsApiResponse =
  /** status 200 Successful Response */ TenantSavingsData;
export type GetTenantSavingsApiArg = {
  tenantName: string;
};
export type GetStrategyDashboardSavingsTimeseriesApiResponse =
  /** status 200 Successful Response */ SavingsTimeseriesData;
export type GetStrategyDashboardSavingsTimeseriesApiArg = {
  tenantName: string;
};
export type GetTenantSiopScheduleApiResponse =
  /** status 200 Successful Response */ TenantSiopScheduleData;
export type GetTenantSiopScheduleApiArg = {
  tenantName: string;
  includeDaily?: boolean;
  fromDate?: string | null;
  "Cache-Control"?: string;
};
export type GetTenantPlannedShredApiResponse =
  /** status 200 Successful Response */ TenantPlannedShredData;
export type GetTenantPlannedShredApiArg = {
  tenantName: string;
};
export type UploadDeliveryFormPhotoApiResponse =
  /** status 200 Successful Response */ UploadedFileMeta;
export type UploadDeliveryFormPhotoApiArg = {
  tenantName: string;
  formId: number;
  file: File;
};
export type SaveDeliveryFormApiResponse =
  /** status 200 Successful Response */ DeliveryFormRead;
export type SaveDeliveryFormApiArg = {
  tenantName: string;
  deliveryFormSave: DeliveryFormSave;
};
export type ListDeliveryFormsApiResponse =
  /** status 200 Successful Response */ DeliveryFormRead[];
export type ListDeliveryFormsApiArg = {
  tenantName: string;
  limit?: number | null;
};
export type GetDeliveryFormApiResponse =
  /** status 200 Successful Response */ DeliveryFormRead | null;
export type GetDeliveryFormApiArg = {
  tenantName: string;
  formId: number;
};
export type GetUploadedPhotoApiResponse =
  /** status 200 Successful Response */ UploadedFileRead | null;
export type GetUploadedPhotoApiArg = {
  tenantName: string;
  formId: number;
};
export type ProcessAudioWithGeminiApiResponse =
  /** status 200 Successful Response */ {
    [key: string]: any;
  };
export type ProcessAudioWithGeminiApiArg = {
  tenantName: string;
  processAudioWithGeminiRequest: ProcessAudioWithGeminiRequest;
};
export type GenerateDeliveryFormNameApiResponse =
  /** status 200 Successful Response */ {
    [key: string]: any;
  };
export type GenerateDeliveryFormNameApiArg = {
  tenantName: string;
  deliveryFormSave: DeliveryFormSave;
};
export type GetCacheLinesApiResponse =
  /** status 200 Successful Response */ CacheLines;
export type GetCacheLinesApiArg = {
  tenantName: string;
};
export type InvalidateCacheLinesApiResponse = unknown;
export type InvalidateCacheLinesApiArg = {
  tenantName: string;
  cacheLineKeys: CacheLineKeys;
};
export type GetLatestConsumptionProjectionApiResponse =
  /** status 200 Successful Response */ ConsumptionProjectionRead | null;
export type GetLatestConsumptionProjectionApiArg = {
  tenantName: string;
  /** Any date within the month */
  month: string;
};
export type ListConsumptionProjectionsApiResponse =
  /** status 200 Successful Response */ ConsumptionProjectionRead[];
export type ListConsumptionProjectionsApiArg = {
  tenantName: string;
  /** Any date within the month */
  month: string;
};
export type CreateConsumptionProjectionApiResponse =
  /** status 200 Successful Response */ ConsumptionProjectionRead;
export type CreateConsumptionProjectionApiArg = {
  tenantName: string;
  consumptionProjectionCreate: ConsumptionProjectionCreate;
};
export type GetLatestDeliveryAdjustmentApiResponse =
  /** status 200 Successful Response */ DeliveryAdjustmentRead | null;
export type GetLatestDeliveryAdjustmentApiArg = {
  tenantName: string;
  /** Any date within the month */
  month: string;
};
export type ListDeliveryAdjustmentsApiResponse =
  /** status 200 Successful Response */ DeliveryAdjustmentRead[];
export type ListDeliveryAdjustmentsApiArg = {
  tenantName: string;
  /** Any date within the month */
  month: string;
};
export type CreateDeliveryAdjustmentApiResponse =
  /** status 200 Successful Response */ DeliveryAdjustmentRead;
export type CreateDeliveryAdjustmentApiArg = {
  tenantName: string;
  deliveryAdjustmentCreate: DeliveryAdjustmentCreate;
};
export type RunPeakShavingScenariosApiResponse =
  /** status 200 Successful Response */ PeakShavingOutputs;
export type RunPeakShavingScenariosApiArg = {
  tenantName: string;
  peakShavingInputs: PeakShavingInputs;
};
export type GetScrapEyeMetadataApiResponse =
  /** status 200 Successful Response */ ScrapEyeMetadata | null;
export type GetScrapEyeMetadataApiArg = {
  tenantName: string;
};
export type ListScrapEyeSegmentsByDevicesApiResponse =
  /** status 200 Successful Response */ ListSegmentsByDevicesResponse;
export type ListScrapEyeSegmentsByDevicesApiArg = {
  tenantName: string;
  deviceIds?: number[] | "all";
  start?: string | null;
  end?: string | null;
  kind?: SegmentKind | null;
};
export type ListAvailableCameraAnglesApiResponse =
  /** status 200 Successful Response */ ListCameraAnglesResponse;
export type ListAvailableCameraAnglesApiArg = {
  tenantName: string;
  deviceIds?: number[] | null;
  /** Return angles that were installed at this specific time */
  atTime?: string | null;
};
export type RenameScrapEyeDeviceApiResponse =
  /** status 200 Successful Response */ any;
export type RenameScrapEyeDeviceApiArg = {
  tenantName: string;
  deviceId: number;
  renameScrapEyeDeviceRequest: RenameScrapEyeDeviceRequest;
};
export type GetTrainableConfigApiResponse =
  /** status 200 Successful Response */ TrainablePeriodsConfig;
export type GetTrainableConfigApiArg = {
  tenantName: string;
};
export type GetTrainablePeriodsApiResponse =
  /** status 200 Successful Response */ TrainablePeriodsResponse;
export type GetTrainablePeriodsApiArg = {
  tenantName: string;
  start: string;
  end: string;
  targetLocation: string;
  periodDurationSeconds?: number;
  anglesJson?: string | null;
  embeddingJson?: string | null;
};
export type GetModelCoverageConfigApiResponse =
  /** status 200 Successful Response */ ModelCoverageConfig;
export type GetModelCoverageConfigApiArg = {
  tenantName: string;
};
export type GetModelCoverageApiResponse =
  /** status 200 Successful Response */ ModelCoverageResponse;
export type GetModelCoverageApiArg = {
  tenantName: string;
  start: string;
  end: string;
  targetLocation: string;
  labellingName: string;
  periodDurationSeconds?: number;
};
export type GetJobFailuresApiResponse =
  /** status 200 Successful Response */ JobFailuresResponse;
export type GetJobFailuresApiArg = {
  tenantName: string;
  start: string;
  end: string;
  targetLocation: string;
  anglesJson?: string | null;
  labellingName?: string | null;
};
export type PreviewTerminalFailuresApiResponse =
  /** status 200 Successful Response */ TerminalFailuresPreview;
export type PreviewTerminalFailuresApiArg = {
  tenantName: string;
  targetLocation: string;
  start?: string | null;
  end?: string | null;
  anglesJson?: string | null;
  labellingName?: string | null;
};
export type ResetTerminalFailuresApiResponse =
  /** status 200 Successful Response */ ResetTerminalFailuresResponse;
export type ResetTerminalFailuresApiArg = {
  tenantName: string;
  targetLocation: string;
  start?: string | null;
  end?: string | null;
  anglesJson?: string | null;
  labellingName?: string | null;
};
export type GetPerformanceTimeseriesApiResponse =
  /** status 200 Successful Response */ PerformanceTimeseriesResponse;
export type GetPerformanceTimeseriesApiArg = {
  tenantName: string;
  start: string;
  end: string;
  targetLocation: string[];
  labellingName: string[];
  bucketSizeSeconds?: number;
  mergeEventsSeparatedByGapSeconds?: number;
  area?: string[] | null;
};
export type GetDatasetSizeApiResponse =
  /** status 200 Successful Response */ DatasetSizeResponse;
export type GetDatasetSizeApiArg = {
  tenantName: string;
  targetLocation: string;
  anglesJson?: string | null;
};
export type GetLabellingCostDailyApiResponse =
  /** status 200 Successful Response */ LabellingCostDailyResponse;
export type GetLabellingCostDailyApiArg = {
  tenantName: string;
  start: string;
  end: string;
  groupBy?: "session_date" | "footage_date";
  costScope?: LabellingCostScope;
};
export type GetLabellingCostDailyByLocationApiResponse =
  /** status 200 Successful Response */ LabellingCostDailyByLocationResponse;
export type GetLabellingCostDailyByLocationApiArg = {
  tenantName: string;
  start: string;
  end: string;
  groupBy?: "session_date" | "footage_date";
  costScope?: LabellingCostScope;
};
export type GetLabellingCostByLabellerApiResponse =
  /** status 200 Successful Response */ LabellingCostByLabellerResponse;
export type GetLabellingCostByLabellerApiArg = {
  tenantName: string;
  start?: string | null;
  end?: string | null;
  groupBy?: "session_date" | "footage_date";
  costScope?: LabellingCostScope;
};
export type GetLabellingRedundancyDailyApiResponse =
  /** status 200 Successful Response */ LabellingRedundancyDailyResponse;
export type GetLabellingRedundancyDailyApiArg = {
  tenantName: string;
  start: string;
  end: string;
};
export type GetReviewerTrackingDailyApiResponse =
  /** status 200 Successful Response */ ReviewerTrackingDailyResponse;
export type GetReviewerTrackingDailyApiArg = {
  tenantName: string;
  start: string;
  end: string;
};
export type ProvisionNewManualDeviceApiResponse =
  /** status 200 Successful Response */ ProvisionNewManualDeviceResponse;
export type ProvisionNewManualDeviceApiArg = {
  tenantName: string;
  name: string;
};
export type GetLiveCameraVideoPlaylistApiResponse =
  /** status 200 Successful Response */ any;
export type GetLiveCameraVideoPlaylistApiArg = {
  tenantName: string;
  deviceId: number;
  physicalId: string;
  /** Count of segments in the window */
  segmentCount?: number;
};
export type GetCameraVideoPlaylistApiResponse =
  /** status 200 Successful Response */ any;
export type GetCameraVideoPlaylistApiArg = {
  tenantName: string;
  deviceId: number;
  physicalId: string;
  /** Start time (ISO8601) */
  startTime: string;
  /** End time (ISO8601) */
  endTime: string;
  /** Return this rendition's media playlist. When omitted, a master playlist listing every rendition is returned instead. */
  variant?: VideoVariant | null;
};
export type GetLiveAngleVideoPlaylistApiResponse =
  /** status 200 Successful Response */ any;
export type GetLiveAngleVideoPlaylistApiArg = {
  tenantName: string;
  location: string;
  angle: string;
  /** Count of segments in the window */
  segmentCount?: number;
  /** Restrict the angle feed to this device's cameras. When omitted, the globally highest-priority camera at the angle is used. */
  deviceId?: number | null;
};
export type GetAngleVideoPlaylistApiResponse =
  /** status 200 Successful Response */ any;
export type GetAngleVideoPlaylistApiArg = {
  tenantName: string;
  location: string;
  angle: string;
  /** Start time (ISO8601) */
  startTime: string;
  /** End time (ISO8601) */
  endTime: string;
  /** Restrict the angle feed to this device's cameras. When omitted, the globally highest-priority camera at the angle is used. */
  deviceId?: number | null;
  /** Return this rendition's media playlist. When omitted, a master playlist listing every rendition is returned instead. */
  variant?: VideoVariant | null;
};
export type GetGcsReadTokenApiResponse =
  /** status 200 Successful Response */ GcsTokenResponse;
export type GetGcsReadTokenApiArg = {
  tenantName: string;
};
export type GetLiveRadioPlaylistApiResponse =
  /** status 200 Successful Response */ any;
export type GetLiveRadioPlaylistApiArg = {
  tenantName: string;
  deviceId: number;
  /** Count of segments in the window */
  segmentCount?: number;
  /** Radio receiver to serve; defaults to the most recently active */
  receiverId?: number | null;
};
export type GetRadioPlaylistApiResponse =
  /** status 200 Successful Response */ any;
export type GetRadioPlaylistApiArg = {
  tenantName: string;
  deviceId: number;
  /** Start time (ISO8601) */
  startTime: string;
  /** End time (ISO8601) */
  endTime: string;
  /** Radio receiver to serve; defaults to the most recently active */
  receiverId?: number | null;
};
export type GetRadioTranscriptApiResponse =
  /** status 200 Successful Response */ RadioTranscriptResponse;
export type GetRadioTranscriptApiArg = {
  tenantName: string;
  deviceId: number;
  /** Start time (ISO8601) */
  startTime: string;
  /** End time (ISO8601) */
  endTime: string;
  /** Radio receiver to serve; defaults to the most recently active */
  receiverId?: number | null;
  /** Include every recorded channel; overrides receiver_id. */
  allReceivers?: boolean;
};
export type GetRadioSegmentInfoApiResponse =
  /** status 200 Successful Response */ RadioSegmentInfo;
export type GetRadioSegmentInfoApiArg = {
  tenantName: string;
  deviceId: number;
  /** Radio receiver to serve; defaults to the most recently active */
  receiverId?: number | null;
};
export type ListRadioReceiversApiResponse =
  /** status 200 Successful Response */ ListRadioReceiversResponse;
export type ListRadioReceiversApiArg = {
  tenantName: string;
  deviceId: number;
};
export type GetRadioGcsReadTokenApiResponse =
  /** status 200 Successful Response */ GcsTokenResponse;
export type GetRadioGcsReadTokenApiArg = {
  tenantName: string;
};
export type GetMassCandidateEventsApiResponse =
  /** status 200 Successful Response */ MassCandidateEvents;
export type GetMassCandidateEventsApiArg = {
  tenantName: string;
  start: string;
  end: string;
  location?: string | null;
};
export type GetMassTimeseriesApiResponse =
  /** status 200 Successful Response */ MassTimeSeries;
export type GetMassTimeseriesApiArg = {
  tenantName: string;
  start: string;
  end: string;
  location?: string | null;
  downsample?: number;
  /** Extra data to compute and return alongside the trace, e.g. the model's detected mass-drop candidate events for overlay. */
  include?: MassTimeSeriesExtra[] | null;
};
export type GetModelPredictionTimeseriesApiResponse =
  /** status 200 Successful Response */ ModelPredictionTimeSeries;
export type GetModelPredictionTimeseriesApiArg = {
  tenantName: string;
  labellingName: string;
  start: string;
  end: string;
};
export type GetInferenceInputTimeseriesApiResponse =
  /** status 200 Successful Response */ InferenceInputTimeSeries;
export type GetInferenceInputTimeseriesApiArg = {
  tenantName: string;
  labellingName: string;
  start: string;
  end: string;
};
export type GetHeatQualityIssuesApiResponse =
  /** status 200 Successful Response */ HeatQualityIssues;
export type GetHeatQualityIssuesApiArg = {
  tenantName: string;
  start?: string | null;
  end?: string | null;
};
export type GetLoadingWindowPlannedConsumptionApiResponse =
  /** status 200 Successful Response */ LoadingWindowPlannedConsumptionResponse;
export type GetLoadingWindowPlannedConsumptionApiArg = {
  tenantName: string;
  start: string;
  end: string;
};
export type GetLoadingWindowDropsApiResponse =
  /** status 200 Successful Response */ LoadingWindowDropsResponse;
export type GetLoadingWindowDropsApiArg = {
  tenantName: string;
  start: string;
  end: string;
};
export type GetLoadingWindowHeatMetadataApiResponse =
  /** status 200 Successful Response */ LoadingWindowHeatMetadataResponse;
export type GetLoadingWindowHeatMetadataApiArg = {
  tenantName: string;
  start: string;
  end: string;
};
export type GetLoadingWindowChargeEventsApiResponse =
  /** status 200 Successful Response */ LoadingWindowChargeEventsResponse;
export type GetLoadingWindowChargeEventsApiArg = {
  tenantName: string;
  start: string;
  end: string;
};
export type SubmitAndApplyLoadingEditsApiResponse =
  /** status 200 Successful Response */ ListLoadingEditsResponse;
export type SubmitAndApplyLoadingEditsApiArg = {
  tenantName: string;
  submitLoadingEditsRequest: SubmitLoadingEditsRequest;
};
export type SubmitLoadingReviewsApiResponse =
  /** status 200 Successful Response */ ListReviewResultsResponse;
export type SubmitLoadingReviewsApiArg = {
  tenantName: string;
  submitLoadingReviewsRequest: SubmitLoadingReviewsRequest;
};
export type ReviseAndApplyLoadingEditsApiResponse =
  /** status 200 Successful Response */ ListLoadingEditsResponse;
export type ReviseAndApplyLoadingEditsApiArg = {
  tenantName: string;
  reviseAndApplyLoadingEditsRequest: ReviseAndApplyLoadingEditsRequest;
};
export type GetLoadingWindowsApiResponse =
  /** status 200 Successful Response */ ListLoadingWindowsResponse;
export type GetLoadingWindowsApiArg = {
  tenantName: string;
  start: string;
  end: string;
  areaName?: string | null;
};
export type ListConsumptionAreasApiResponse =
  /** status 200 Successful Response */ ListConsumptionAreasResponse;
export type ListConsumptionAreasApiArg = {
  tenantName: string;
};
export type ListLoadingEditsApiResponse =
  /** status 200 Successful Response */ ListLoadingEditsResponse;
export type ListLoadingEditsApiArg = {
  tenantName: string;
  start: string;
  end: string;
  pendingOnly?: boolean;
  areaName?: string | null;
};
export type SubmitLoadingEditsForReviewApiResponse =
  /** status 200 Successful Response */ ListLoadingEditsResponse;
export type SubmitLoadingEditsForReviewApiArg = {
  tenantName: string;
  submitLoadingEditsRequest: SubmitLoadingEditsRequest;
};
export type ReseedLoadingWindowsApiResponse =
  /** status 200 Successful Response */ ReseedResult;
export type ReseedLoadingWindowsApiArg = {
  tenantName: string;
  reseedLoadingWindowsRequest: ReseedLoadingWindowsRequest;
};
export type CreateInstallationLocationApiResponse =
  /** status 201 Successful Response */ any;
export type CreateInstallationLocationApiArg = {
  tenantName: string;
  scrapEyeInstallationLocationCreate: ScrapEyeInstallationLocationCreate;
};
export type ListInstallationLocationsApiResponse =
  /** status 200 Successful Response */ ScrapEyeInstallationLocation[];
export type ListInstallationLocationsApiArg = {
  tenantName: string;
  locationTypes?: LocationType[] | null;
};
export type ListInstallationLocationsWithBacklogApiResponse =
  /** status 200 Successful Response */ ScrapEyeInstallationLocationWithBacklog[];
export type ListInstallationLocationsWithBacklogApiArg = {
  tenantName: string;
  targetNumberOfLabellers?: number | null;
  allowedCoverageGapSeconds?: number;
  requiredAngles?: string[] | "all";
};
export type CreateRecordingPositionApiResponse =
  /** status 201 Successful Response */ any;
export type CreateRecordingPositionApiArg = {
  tenantName: string;
  scrapEyeRecordingPositionCreate: ScrapEyeRecordingPositionCreate;
};
export type ListRecordingPositionsApiResponse =
  /** status 200 Successful Response */ ListRecordingPositionsResponse;
export type ListRecordingPositionsApiArg = {
  tenantName: string;
  deviceIds?: number[] | null;
  /** Return positions whose camera was installed at this specific time */
  atTime?: string | null;
  activeAtStart?: string | null;
  activeAtEnd?: string | null;
};
export type ListAvailableRecordingPositionsForLocationApiResponse =
  /** status 200 Successful Response */ ListRecordingPositionsResponse;
export type ListAvailableRecordingPositionsForLocationApiArg = {
  tenantName: string;
  locationName: string;
};
export type CreateCameraAngleApiResponse =
  /** status 201 Successful Response */ any;
export type CreateCameraAngleApiArg = {
  tenantName: string;
  scrapEyeRecordingPositionCreate: ScrapEyeRecordingPositionCreate;
};
export type ListCameraAnglesApiResponse =
  /** status 200 Successful Response */ ScrapEyeRecordingPosition[];
export type ListCameraAnglesApiArg = {
  tenantName: string;
  deviceIds?: number[] | null;
  /** Return angles that were installed at this specific time */
  atTime?: string | null;
  activeAtStart?: string | null;
  activeAtEnd?: string | null;
};
export type ListAvailableCameraAnglesForLocationApiResponse =
  /** status 200 Successful Response */ ScrapEyeRecordingPosition[];
export type ListAvailableCameraAnglesForLocationApiArg = {
  tenantName: string;
  locationName: string;
};
export type InstallCameraApiResponse =
  /** status 201 Successful Response */ any;
export type InstallCameraApiArg = {
  tenantName: string;
  scrapEyeInstallationEventCreate: ScrapEyeInstallationEventCreate;
};
export type UninstallCameraApiResponse =
  /** status 201 Successful Response */ any;
export type UninstallCameraApiArg = {
  tenantName: string;
  scrapEyeUninstallation: ScrapEyeUninstallation;
};
export type ListInstallationsApiResponse =
  /** status 200 Successful Response */ ScrapEyeInstallationEventRead[];
export type ListInstallationsApiArg = {
  tenantName: string;
  kind?: ScrapEyeInstallationListOption;
};
export type CreateVideoPlayerGroupApiResponse =
  /** status 201 Successful Response */ ScrapEyeInstallationVideoPlayerGroupRead;
export type CreateVideoPlayerGroupApiArg = {
  tenantName: string;
  scrapEyeInstallationVideoPlayerGroupCreate: ScrapEyeInstallationVideoPlayerGroupCreate;
};
export type ListVideoPlayerGroupsApiResponse =
  /** status 200 Successful Response */ ScrapEyeInstallationVideoPlayerGroupWithAngles[];
export type ListVideoPlayerGroupsApiArg = {
  tenantName: string;
  locationName?: string | null;
  includeLocationTypes?: LocationType[] | null;
};
export type GetVideoPlayerGroupApiResponse =
  /** status 200 Successful Response */ ScrapEyeInstallationVideoPlayerGroupWithAngles;
export type GetVideoPlayerGroupApiArg = {
  tenantName: string;
  groupId: number;
};
export type UpdateVideoPlayerGroupApiResponse =
  /** status 200 Successful Response */ any;
export type UpdateVideoPlayerGroupApiArg = {
  tenantName: string;
  groupId: number;
  scrapEyeInstallationVideoPlayerGroupUpdate: ScrapEyeInstallationVideoPlayerGroupUpdate;
};
export type DeleteVideoPlayerGroupApiResponse = unknown;
export type DeleteVideoPlayerGroupApiArg = {
  tenantName: string;
  groupId: number;
};
export type AddAngleToGroupApiResponse =
  /** status 201 Successful Response */ any;
export type AddAngleToGroupApiArg = {
  tenantName: string;
  groupId: number;
  scrapEyeInstallationVideoPlayerGroupMembershipCreate: ScrapEyeInstallationVideoPlayerGroupMembershipCreate;
};
export type UpdateAnglePriorityApiResponse =
  /** status 200 Successful Response */ any;
export type UpdateAnglePriorityApiArg = {
  tenantName: string;
  groupId: number;
  angleId: number;
  priority: number;
};
export type RemoveAngleFromGroupApiResponse = unknown;
export type RemoveAngleFromGroupApiArg = {
  tenantName: string;
  groupId: number;
  angleId: number;
};
export type CreateLocationSupportAssociationApiResponse =
  /** status 201 Successful Response */ ScrapEyeLocationSupportAssociationRead;
export type CreateLocationSupportAssociationApiArg = {
  tenantName: string;
  scrapEyeLocationSupportAssociationCreate: ScrapEyeLocationSupportAssociationCreate;
};
export type ListLocationSupportAssociationsApiResponse =
  /** status 200 Successful Response */ ScrapEyeLocationSupportAssociationRead[];
export type ListLocationSupportAssociationsApiArg = {
  tenantName: string;
  labellingLocationName?: string | null;
};
export type DeleteLocationSupportAssociationApiResponse = unknown;
export type DeleteLocationSupportAssociationApiArg = {
  tenantName: string;
  associationId: number;
};
export type InstallSensorApiResponse =
  /** status 201 Successful Response */ any;
export type InstallSensorApiArg = {
  tenantName: string;
  scrapEyeSensorPlacementCreate: ScrapEyeSensorPlacementCreate;
};
export type ListSensorInstallationsApiResponse =
  /** status 200 Successful Response */ ListScrapEyeSensorPlacementsResponse;
export type ListSensorInstallationsApiArg = {
  tenantName: string;
  kind?: ScrapEyeInstallationListOption;
};
export type CorrectSensorInstallationApiResponse =
  /** status 201 Successful Response */ any;
export type CorrectSensorInstallationApiArg = {
  tenantName: string;
  versionId: number;
  scrapEyeSensorPlacementCreate: ScrapEyeSensorPlacementCreate;
};
export type ConnectSensorApiResponse =
  /** status 201 Successful Response */ any;
export type ConnectSensorApiArg = {
  tenantName: string;
  scrapEyeSensorConnectionCreate: ScrapEyeSensorConnectionCreate;
};
export type ListSensorConnectionsApiResponse =
  /** status 200 Successful Response */ ListScrapEyeSensorConnectionsResponse;
export type ListSensorConnectionsApiArg = {
  tenantName: string;
  deviceId?: number | null;
  kind?: ScrapEyeInstallationListOption;
};
export type CorrectSensorConnectionApiResponse =
  /** status 201 Successful Response */ any;
export type CorrectSensorConnectionApiArg = {
  tenantName: string;
  versionId: number;
  scrapEyeSensorConnectionCorrection: ScrapEyeSensorConnectionCorrection;
};
export type ListSensorCameraRecordingsApiResponse =
  /** status 200 Successful Response */ ListScrapEyeCameraRecordingsResponse;
export type ListSensorCameraRecordingsApiArg = {
  tenantName: string;
  deviceId: number;
};
export type ReconcileSensorMetricsApiResponse =
  /** status 200 Successful Response */ any;
export type ReconcileSensorMetricsApiArg = {
  tenantName: string;
};
export type CreateSensorApiResponse =
  /** status 201 Successful Response */ ScrapEyeSensorRead;
export type CreateSensorApiArg = {
  tenantName: string;
  scrapEyeSensorCreate: ScrapEyeSensorCreate;
};
export type ListSensorsApiResponse =
  /** status 200 Successful Response */ ListScrapEyeSensorsResponse;
export type ListSensorsApiArg = {
  tenantName: string;
  sensorTypes?: SensorType[] | null;
};
export type UpdateSensorMetadataApiResponse =
  /** status 200 Successful Response */ any;
export type UpdateSensorMetadataApiArg = {
  tenantName: string;
  sensorId: number;
  scrapEyeSensorMetadataUpdate: ScrapEyeSensorMetadataUpdate;
};
export type RedactFootagePreviewApiResponse =
  /** status 200 Successful Response */ RedactFootagePreviewResponse;
export type RedactFootagePreviewApiArg = {
  tenantName: string;
  redactFootageRequest: RedactFootageRequest;
};
export type RedactFootageApiResponse =
  /** status 200 Successful Response */ RedactFootageJobResponse;
export type RedactFootageApiArg = {
  tenantName: string;
  redactFootageRequest: RedactFootageRequest;
};
export type GetRedactionStatusApiResponse =
  /** status 200 Successful Response */ RedactFootageStatusResponse;
export type GetRedactionStatusApiArg = {
  tenantName: string;
  jobId: string;
};
export type CreateLocationExceptionalStatusApiResponse =
  /** status 201 Successful Response */ LocationExceptionalStatusRead;
export type CreateLocationExceptionalStatusApiArg = {
  tenantName: string;
  locationExceptionalStatusCreate: LocationExceptionalStatusCreate;
};
export type ListLocationExceptionalStatusesApiResponse =
  /** status 200 Successful Response */ ListLocationExceptionalStatusResponse;
export type ListLocationExceptionalStatusesApiArg = {
  tenantName: string;
  locationName?: string | null;
  area?: string | null;
  status?: LocationExceptionalStatusType | null;
};
export type UpdateLocationExceptionalStatusApiResponse =
  /** status 200 Successful Response */ LocationExceptionalStatusRead;
export type UpdateLocationExceptionalStatusApiArg = {
  tenantName: string;
  statusId: number;
  locationExceptionalStatusUpdate: LocationExceptionalStatusUpdate;
};
export type DeleteLocationExceptionalStatusApiResponse = unknown;
export type DeleteLocationExceptionalStatusApiArg = {
  tenantName: string;
  statusId: number;
};
export type ListScrapEyeDevicesApiResponse =
  /** status 200 Successful Response */ ListScrapEyeDevicesResponse;
export type ListScrapEyeDevicesApiArg = {
  tenantName: string;
  includeAdditionalInfo?: boolean;
};
export type ListScrapEyeCamerasApiResponse =
  /** status 200 Successful Response */ ListScrapEyeCamerasResponse;
export type ListScrapEyeCamerasApiArg = {
  tenantName: string;
  deviceId: number;
};
export type GetSensorTopologyApiResponse =
  /** status 200 Successful Response */ SensorTopology;
export type GetSensorTopologyApiArg = {
  tenantName: string;
  at: string;
};
export type ApplySensorTopologyChangesApiResponse =
  /** status 200 Successful Response */ any;
export type ApplySensorTopologyChangesApiArg = {
  tenantName: string;
  sensorTopologyChanges: SensorTopologyChanges;
};
export type RegisterCapabilitiesApiResponse = unknown;
export type RegisterCapabilitiesApiArg = {
  tenantName: string;
  deviceName: string;
  registerCapabilitiesRequest: RegisterCapabilitiesRequest;
};
export type AnnounceCamerasApiResponse =
  /** status 200 Successful Response */ AnnounceCamerasResponse;
export type AnnounceCamerasApiArg = {
  tenantName: string;
  deviceName: string;
  announceCamerasRequest: AnnounceCamerasRequest;
};
export type UploadVideoFromUriApiResponse = unknown;
export type UploadVideoFromUriApiArg = {
  tenantName: string;
  deviceName: string;
  videoCreate: VideoCreate;
};
export type UploadRadioFromUriApiResponse = unknown;
export type UploadRadioFromUriApiArg = {
  tenantName: string;
  deviceName: string;
  radioCreate: RadioCreate;
};
export type GetGcsUploadTokenApiResponse =
  /** status 200 Successful Response */ GcsTokenResponse;
export type GetGcsUploadTokenApiArg = {
  tenantName: string;
  deviceName: string;
};
export type GetSegmentStatusListApiResponse =
  /** status 200 Successful Response */ SegmentStatusListResponse;
export type GetSegmentStatusListApiArg = {
  tenantName: string;
  deviceName: string;
  segmentType: SegmentKind;
  start: string;
  count: number;
  segmentLengthSec: number;
  cameraPhysicalIds?: string[] | null;
  cameraAngleIds?: number[] | null;
  /** Scope radio coverage to one channel (receiver) */
  radioReceiverId?: number | null;
};
export type UploadEdgePredictionsFromUriApiResponse = unknown;
export type UploadEdgePredictionsFromUriApiArg = {
  tenantName: string;
  deviceName: string;
  edgePredictionWindowCreate: EdgePredictionWindowCreate;
};
export type UploadEdgeEmbeddingFromUriApiResponse = unknown;
export type UploadEdgeEmbeddingFromUriApiArg = {
  tenantName: string;
  deviceName: string;
  edgeEmbeddingCreate: EdgeEmbeddingCreate;
};
export type GetScrapLoadingLayoutApiResponse =
  /** status 200 Successful Response */ ScrapLoadingLayoutResponse;
export type GetScrapLoadingLayoutApiArg = {
  tenantName: string;
  location: string;
  timestamp: string;
};
export type GetRailcarMovementsApiResponse =
  /** status 200 Successful Response */ RailcarMovements;
export type GetRailcarMovementsApiArg = {
  tenantName: string;
  startTime: string;
  endTime: string;
};
export type GetReportedRailcarSlotsApiResponse =
  /** status 200 Successful Response */ ReportedRailcarSlots;
export type GetReportedRailcarSlotsApiArg = {
  tenantName: string;
  location: string;
  startTime: string;
  endTime: string;
  numbering: LayoutNumbering;
};
export type CreateRailcarOrderRequestApiResponse =
  | /** status 200 A request for this depot list already exists. */ RailcarOrderRequestRead
  | /** status 201 Successful Response */ RailcarOrderRequestRead;
export type CreateRailcarOrderRequestApiArg = {
  tenantName: string;
  railcarOrderRequestCreate: RailcarOrderRequestCreate;
};
export type ProposeRailcarOrderApiResponse =
  /** status 200 Successful Response */ RailcarOrderProposalResult;
export type ProposeRailcarOrderApiArg = {
  tenantName: string;
  railcarOrderProposalCreate: RailcarOrderProposalCreate;
};
export type GetRecipeComplianceReportDailyApiResponse =
  /** status 200 Successful Response */ RecipeComplianceReport;
export type GetRecipeComplianceReportDailyApiArg = {
  tenantName: string;
  anchorDate: string;
  shiftAnchor: RecipeComplianceReportShiftAnchor;
  diffMode?: DiffMode | null;
  reportLabel?: RecipeComplianceReportLabel | null;
};
export type GetRecipeComplianceReportMonthlyApiResponse =
  /** status 200 Successful Response */ RecipeComplianceReport;
export type GetRecipeComplianceReportMonthlyApiArg = {
  tenantName: string;
  anchorDate: string;
  diffMode?: DiffMode | null;
};
export type GetRecipeComplianceReportDailyHtmlApiResponse =
  /** status 200 Successful Response */ RecipeComplianceReport;
export type GetRecipeComplianceReportDailyHtmlApiArg = {
  tenantName: string;
  anchorDate: string;
  shiftAnchor: RecipeComplianceReportShiftAnchor;
  diffMode?: DiffMode | null;
  reportLabel?: RecipeComplianceReportLabel | null;
};
export type GetRecipeComplianceReportMonthlyHtmlApiResponse =
  /** status 200 Successful Response */ RecipeComplianceReport;
export type GetRecipeComplianceReportMonthlyHtmlApiArg = {
  tenantName: string;
  anchorDate: string;
  diffMode?: DiffMode | null;
};
export type ListTenantEmailsApiResponse =
  /** status 200 Successful Response */ TenantEmails;
export type ListTenantEmailsApiArg = {
  tenantName: string;
};
export type ListTenantNamesApiResponse =
  /** status 200 Successful Response */ TenantNames;
export type ListTenantNamesApiArg = {
  tenantGroupName?: string | null;
  visibility?: "user" | "all";
};
export type ListTenantGroupsApiResponse =
  /** status 200 Successful Response */ TenantGroupNames;
export type ListTenantGroupsApiArg = void;
export type GetMeApiResponse =
  /** status 200 Successful Response */ UserReadAll;
export type GetMeApiArg = {
  tenantName: string;
};
export type GetAuthCustomTokenApiResponse =
  /** status 200 Successful Response */ CustomTokenResponse;
export type GetAuthCustomTokenApiArg = {
  tenantName: string;
  onBehalfOf?: string | null;
};
export type GetUsersApiResponse =
  /** status 200 Successful Response */ UserReadAll[];
export type GetUsersApiArg = {
  tenantName: string;
  accountTypes?: AccountType[] | null;
};
export type GetUserByEmailApiResponse =
  /** status 200 Successful Response */ UserReadAll;
export type GetUserByEmailApiArg = {
  tenantName: string;
  email: string;
};
export type UpdateUserApiResponse =
  /** status 200 Successful Response */ UserReadAll;
export type UpdateUserApiArg = {
  tenantName: string;
  userUpdate: UserUpdate;
};
export type SyncWithFirebaseApiResponse = unknown;
export type SyncWithFirebaseApiArg = {
  tenantName: string;
};
export type LogoutApiResponse = unknown;
export type LogoutApiArg = void;
export type SetAdminModeApiResponse = unknown;
export type SetAdminModeApiArg = {
  adminModeUpdate: AdminModeUpdate;
};
export type RequestSignInLinkApiResponse = unknown;
export type RequestSignInLinkApiArg = {
  tenantName: string;
  requestSignInLinkRequest: RequestSignInLinkRequest;
};
export type GetClarkProfileApiResponse =
  /** status 200 Successful Response */ ClarkProfileRead;
export type GetClarkProfileApiArg = {
  tenantName: string;
  email: string;
};
export type UpdateClarkProfileApiResponse =
  /** status 200 Successful Response */ ClarkProfileRead;
export type UpdateClarkProfileApiArg = {
  tenantName: string;
  clarkProfileUpdate: ClarkProfileUpdate;
};
export type SendMissionControlNotificationApiResponse = unknown;
export type SendMissionControlNotificationApiArg = {
  tenantGroupName?: string | null;
};
export type ListMissionControlTenantsApiResponse =
  /** status 200 Successful Response */ MissionControlTenantsResponse;
export type ListMissionControlTenantsApiArg = {
  tenantGroupName?: string | null;
  visibility?: "user" | "all";
};
export type UploadMissionControlFilesApiResponse =
  /** status 200 Successful Response */ MissionControlUploadResponse;
export type UploadMissionControlFilesApiArg = {
  tenantGroupName?: string | null;
  missionControlUploadRequest: MissionControlUploadRequest;
};
export type GetMissionControlTenantSavingsApiResponse =
  /** status 200 Successful Response */ TenantSavingsData;
export type GetMissionControlTenantSavingsApiArg = {
  tenantName: string;
};
export type GetMissionControlTenantTotalInventoryApiResponse =
  /** status 200 Successful Response */ TenantTotalInventoryData;
export type GetMissionControlTenantTotalInventoryApiArg = {
  tenantName: string;
};
export type GetMissionControlTenantSiopScheduleApiResponse =
  /** status 200 Successful Response */ TenantSiopScheduleData;
export type GetMissionControlTenantSiopScheduleApiArg = {
  tenantName: string;
};
export type GetMissionControlTenantProductMixApiResponse =
  /** status 200 Successful Response */ TenantProductMixData;
export type GetMissionControlTenantProductMixApiArg = {
  tenantName: string;
};
export type GetMissionControlTenantShredUsageApiResponse =
  /** status 200 Successful Response */ TenantShredUsageData;
export type GetMissionControlTenantShredUsageApiArg = {
  tenantName: string;
};
export type GetMissionControlScrapReportApiResponse =
  /** status 200 Successful Response */ ScrapReportResponse;
export type GetMissionControlScrapReportApiArg = {
  tenantName: string;
};
export type ListOrganisationUsersApiResponse =
  /** status 200 Successful Response */ OrganisationUsersResponse;
export type ListOrganisationUsersApiArg = {
  groupName: string;
};
export type AddOrganisationUserApiResponse = unknown;
export type AddOrganisationUserApiArg = {
  groupName: string;
  addOrganisationUserRequest: AddOrganisationUserRequest;
};
export type UpdateOrganisationUserPermissionsApiResponse = unknown;
export type UpdateOrganisationUserPermissionsApiArg = {
  uid: string;
  groupName: string;
  updateOrganisationUserRequest: UpdateOrganisationUserRequest;
};
export type RemoveOrganisationUserApiResponse = unknown;
export type RemoveOrganisationUserApiArg = {
  uid: string;
  groupName: string;
};
export type GetClarkDirectoryApiResponse =
  /** status 200 Successful Response */ ClarkDirectory;
export type GetClarkDirectoryApiArg = {
  groupName: string;
};
export type AddNodeObservationApiResponse =
  /** status 200 Successful Response */ NodeObservationRead;
export type AddNodeObservationApiArg = {
  nodeObservationCreate: NodeObservationCreate;
};
export type AddNodeAttributeObservationApiResponse =
  /** status 200 Successful Response */ NodeAttributeObservationRead;
export type AddNodeAttributeObservationApiArg = {
  nodeAttributeObservationCreate: NodeAttributeObservationCreate;
};
export type AddRouteAttributeObservationApiResponse =
  /** status 200 Successful Response */ RouteAttributeObservationRead;
export type AddRouteAttributeObservationApiArg = {
  routeAttributeObservationCreate: RouteAttributeObservationCreate;
};
export type ListNodesApiResponse =
  /** status 200 Successful Response */ NodeStateRead[];
export type ListNodesApiArg = void;
export type ListMaterialsApiResponse =
  /** status 200 Successful Response */ PurchasingMaterialRead[];
export type ListMaterialsApiArg = void;
export type ListDataSourcesApiResponse =
  /** status 200 Successful Response */ DataSourceRead[];
export type ListDataSourcesApiArg = void;
export type SendLogisticsRoutingNotificationApiResponse = unknown;
export type SendLogisticsRoutingNotificationApiArg = {
  tenantGroupName?: string | null;
};
export type GetRailStationsApiResponse =
  /** status 200 Successful Response */ StationsListResponse;
export type GetRailStationsApiArg = {
  tenantGroupName?: string | null;
};
export type GetRatesToMillsApiResponse =
  /** status 200 Successful Response */ RatesToMillsResponse;
export type GetRatesToMillsApiArg = {
  /** Origin station name */
  stationName: string;
  /** Origin station state */
  stationState: UsState;
  tenantGroupName?: string | null;
};
export type FindTruckRouteApiResponse =
  /** status 200 Successful Response */ TruckRoute;
export type FindTruckRouteApiArg = {
  /** Origin station name */
  stationName: string;
  /** Origin station state (2-letter code) */
  stationState: string;
  /** Destination latitude */
  destinationLatitude: number;
  /** Destination longitude */
  destinationLongitude: number;
};
export type GetTruckCostFormulaApiResponse =
  /** status 200 Successful Response */ TruckCostFormula;
export type GetTruckCostFormulaApiArg = void;
export type FindRailRouteApiResponse =
  /** status 200 Successful Response */ RailRouteResponse;
export type FindRailRouteApiArg = {
  /** Origin latitude */
  fromLatitude: number;
  /** Origin longitude */
  fromLongitude: number;
  /** Destination latitude */
  toLatitude: number;
  /** Destination longitude */
  toLongitude: number;
  /** Restrict route to specific railroad */
  railroad?: string | null;
};
export type GeocodeStationApiResponse =
  /** status 200 Successful Response */ GeocodedLocation;
export type GeocodeStationApiArg = {
  /** Station name */
  stationName: string;
  /** Station state (2-letter code) */
  stationState: string;
};
export type HealthCheckApiResponse = unknown;
export type HealthCheckApiArg = void;
export type RegisterEventLabellingModelApiResponse =
  /** status 201 Successful Response */ EventLabellingModelRead;
export type RegisterEventLabellingModelApiArg = {
  tenantName: string;
  eventLabellingModelCreate: EventLabellingModelCreate;
};
export type ListEventLabellingModelsApiResponse =
  /** status 200 Successful Response */ EventLabellingModels;
export type ListEventLabellingModelsApiArg = {
  tenantName: string;
};
export type GetEventLabellingModelApiResponse =
  /** status 200 Successful Response */ EventLabellingModelRead;
export type GetEventLabellingModelApiArg = {
  tenantName: string;
  labellingName: string;
};
export type GetTargetedReviewReasonsInUseApiResponse =
  /** status 200 Successful Response */ TargetedReviewReasonsInUse;
export type GetTargetedReviewReasonsInUseApiArg = {
  tenantName: string;
  labellingName: string;
};
export type GetEventLabellingModelStateHistoriesApiResponse =
  /** status 200 Successful Response */ ModelStateHistories;
export type GetEventLabellingModelStateHistoriesApiArg = {
  tenantName: string;
  modelId: number[];
};
export type UpdateEventLabellingModelApiResponse =
  /** status 200 Successful Response */ EventLabellingModelRead;
export type UpdateEventLabellingModelApiArg = {
  tenantName: string;
  modelId: number;
  eventLabellingModelUpdate: EventLabellingModelUpdate;
};
export type GetEventLabellingModelConfidenceRecallAtThresholdsApiResponse =
  /** status 200 Successful Response */ ConfidenceRecallAtThresholds;
export type GetEventLabellingModelConfidenceRecallAtThresholdsApiArg = {
  tenantName: string;
  labellingName: string;
  materialThreshold?: number | null;
  eventThreshold?: number | null;
  areaThreshold?: number | null;
};
export type GetEventLabellingModelExpectedPerformanceAtThresholdsApiResponse =
  /** status 200 Successful Response */ ExpectedPerformanceAtThresholds;
export type GetEventLabellingModelExpectedPerformanceAtThresholdsApiArg = {
  tenantName: string;
  labellingName: string;
  materialThreshold?: number | null;
  eventThreshold?: number | null;
  areaThreshold?: number | null;
};
export type GetEventLabellingModelWindowedConfidenceRecallAtThresholdsApiResponse =
  /** status 200 Successful Response */ WindowedConfidenceRecallAtThresholds;
export type GetEventLabellingModelWindowedConfidenceRecallAtThresholdsApiArg = {
  tenantName: string;
  labellingName: string;
  windowDays: number;
  materialThreshold?: number | null;
  eventThreshold?: number | null;
  areaThreshold?: number | null;
};
export type GetEventLabellingModelAlwaysOnFlagsApiResponse =
  /** status 200 Successful Response */ AlwaysOnReviewFlags;
export type GetEventLabellingModelAlwaysOnFlagsApiArg = {
  tenantName: string;
  labellingName: string;
};
export type GetEventLabellingModelWindowedAlwaysOnFlagsApiResponse =
  /** status 200 Successful Response */ WindowedAlwaysOnReviewFlags;
export type GetEventLabellingModelWindowedAlwaysOnFlagsApiArg = {
  tenantName: string;
  labellingName: string;
  windowDays: number;
};
export type GetEventLabellingModelRecallAtThresholdsApiResponse =
  /** status 200 Successful Response */ RecallAtThresholds;
export type GetEventLabellingModelRecallAtThresholdsApiArg = {
  tenantName: string;
  labellingName: string;
  materialThreshold?: number | null;
  eventThreshold?: number | null;
  areaThreshold?: number | null;
};
export type HeatDayGroupingField = "start_time" | "tap_time";
export type ImpurityUnit = "mass_fraction" | "small_mass_fraction";
export type MixBreakdown = "percentage" | "mass" | "small_mass";
export type ProductionPlanSource = "product_groups" | "steel_grades";
export type SearchType =
  | "charging"
  | "charging_two_charge"
  | "charging_three_charge"
  | "charging_fresh_anode"
  | "charging_wet"
  | "charging_two_charge_wet"
  | "medium_term_charging"
  | "purchasing"
  | "purchasing_unrestricted"
  | "simulator";
export type FeatureFlag =
  | "fixed_mix_defaults"
  | "material_availability_import"
  | "search_context_groups"
  | "electrical_energy_price"
  | "plan_excel_download"
  | "inventory_estimate_at_timestamp"
  | "auto_backups"
  | "show_all_edited_plans"
  | "inventory_measurement"
  | "inventory_measurement_with_locations"
  | "inventory_upload_gateway"
  | "inventory_measurement_with_estimate"
  | "strategy_dashboard_inventory"
  | "strategy_dashboard_consumption"
  | "strategy_dashboard_production"
  | "strategy_dashboard_production_pace"
  | "strategy_dashboard_quality"
  | "strategy_dashboard_cost"
  | "strategy_dashboard_prices"
  | "strategy_dashboard_heats"
  | "strategy_dashboard_scrap_chef_usage"
  | "scrap_chef_usage_detailed"
  | "strategy_dashboard_deliveries"
  | "strategy_dashboard_compliance"
  | "strategy_dashboard_consumption_projection"
  | "strategy_dashboard_editing"
  | "strategy_dashboard_crew_comparison"
  | "strategy_dashboard_schedule"
  | "strategy_dashboard_savings"
  | "scrap_eyes"
  | "scrap_eyes_icon"
  | "purchasing_plan_deploy"
  | "heats_view_per_shift"
  | "peak_shaving_scenarios"
  | "cleanup_override"
  | "mix_inventory_depletion"
  | "mobile_ui"
  | "live_recipe_card"
  | "show_in_mission_control"
  | "rail_car_movements"
  | "per_basket_comparison"
  | "show_charged_cost"
  | "ranking_compliance_tab"
  | "compliance_cost"
  | "external_recipe_comparison"
  | "compliance_per_heat"
  | "strategy_dashboard_delivery_pace_percent"
  | "material_overrides"
  | "external_deployment_sync"
  | "first_basket_material_cap"
  | "layering_production_group_name"
  | "bucket_layering_compliance"
  | "likely_error_flagging"
  | "targeted_review"
  | "overview_current_recipe"
  | "overview_deployed_plan"
  | "overview_recent_searches"
  | "overview_compliance"
  | "operations"
  | "optimiser"
  | "operator_error_rate"
  | "railcar_area_materials"
  | "heat_video_crane_lanes"
  | "mass_adjustment_wide_view";
export type DeployProcess =
  "edit_sync_and_sms" | "sync_and_sms" | "edit_and_send" | "message" | "none";
export type BasketTabType = "basket_plot" | "layering_table";
export type MixGrouping = "copper_group" | "grouping_name";
export type ImpurityPlotType = "box" | "bar";
export type MessageType = "email" | "sms";
export type MixQuantity = "mass" | "grabs";
export type RecipeType = "bucket" | "ratio";
export type RecipeFloorSource = "optimisation_result_set" | "planned_mix_set";
export type AuthProvider = "google" | "microsoft";
export type LayerEditMode = "none" | "manual_only" | "full";
export type BasketLayerDisplayOrder = "top_first" | "bottom_first";
export type HeatOverrideMode = "disabled" | "catalog" | "delta";
export type CraneDriverView = "none" | "load_entry" | "heat_recipes";
export type ComplianceReportOverridesSection =
  "none" | "reason_counts_by_crew" | "override_list_by_crew";
export type HeatOverrideOption =
  | "stable_heat_id_column"
  | "product_group_column"
  | "loading_status"
  | "comment_required"
  | "edit_history";
export type CompliancePageVersion = "legacy" | "modern";
export type UnitType =
  | "mass"
  | "small_mass"
  | "cost"
  | "specific_cost"
  | "electrical_energy_consumption"
  | "mass_fraction"
  | "yield"
  | "volume"
  | "density"
  | "energy"
  | "specific_energy_cost"
  | "time"
  | "small_mass_fraction";
export type UnitSpec = {
  unit_type: UnitType;
  units: string;
};
export type Tenant = {
  tenant_name: string;
  long_name: string;
  typical_heats_per_day: number;
  small_mass_per_mass: number;
  rounding_units: number;
  local_timezone: string;
  max_crane_assignments: number;
  created_at: string;
  latitude: number;
  longitude: number;
  heat_day_start_hour: number;
  heat_day_grouping_field: HeatDayGroupingField;
  small_mass_fraction_per_mass_fraction: number;
  impurity_units: ImpurityUnit;
  default_mix_breakdown: MixBreakdown;
  default_production_plan_source: ProductionPlanSource;
  default_language: string;
  auto_search_types: SearchType[];
  inventory_form_recipe_fanout: SearchType[];
  feature_flags: FeatureFlag[];
  deploy_process: DeployProcess;
  basket_tab_type: BasketTabType;
  mix_grouping: MixGrouping;
  impurity_plot_type: ImpurityPlotType;
  message_type: MessageType;
  mix_quantity: MixQuantity;
  recipe_type: RecipeType;
  recipe_floor_source: RecipeFloorSource;
  auth_provider: AuthProvider;
  layer_edit_mode: LayerEditMode;
  basket_layer_display_order: BasketLayerDisplayOrder;
  heat_override_mode: HeatOverrideMode;
  crane_driver_view: CraneDriverView;
  compliance_report_overrides_section: ComplianceReportOverridesSection;
  heat_override_options: HeatOverrideOption[];
  heat_override_max_heats: number | null;
  compliance_page_version: CompliancePageVersion;
  units: UnitSpec[];
  translation_overrides: {
    [key: string]: string;
  };
  manual_heat_overrides: string[];
};
export type ValidationError = {
  loc: (string | number)[];
  msg: string;
  type: string;
  input?: any;
  ctx?: object;
};
export type HttpValidationError = {
  detail?: ValidationError[];
};
export type TriggerAutoRecipesOutcome =
  "enqueued" | "suppressed" | "no_recipe_types";
export type TriggerAutoRecipesResponse = {
  recipe_types: SearchType[];
  /** Whether the trigger enqueued work, was suppressed, or found no recipe types */
  outcome: TriggerAutoRecipesOutcome;
};
export type TriggerAutoRecipesRequest = {
  /** List of uploaded file IDs to process */
  uploaded_file_ids: number[];
};
export type TriggerAutoRecipesFromTypesRequest = {
  /** Recipe types to orchestrate */
  recipe_types: SearchType[];
};
export type JsonValue = any;
export type ParameterisedStrategySpec = {
  name: string;
  params: {
    [key: string]: JsonValue;
  };
};
export type AutoRecipeStrategySpecs = {
  period_splitting_strategies: ParameterisedStrategySpec[];
  period_weighting_strategies: ParameterisedStrategySpec[];
  period_constraint_suppression_strategies: ParameterisedStrategySpec[];
  target_inventory_strategies: ParameterisedStrategySpec[];
  material_exclusivity_strategies: ParameterisedStrategySpec[];
  material_limits_strategies: ParameterisedStrategySpec[];
  period_electricity_price_strategies: ParameterisedStrategySpec[];
  target_baskets_strategies: ParameterisedStrategySpec[] | null;
};
export type AutoRecipeEstimatorsSpecs = {
  initial_inventory_estimators: ParameterisedStrategySpec[];
  production_estimators: ParameterisedStrategySpec[];
  deliveries_estimators: ParameterisedStrategySpec[];
  purchases_estimators: ParameterisedStrategySpec[];
  electricity_price_estimators: ParameterisedStrategySpec[];
  extra_state_estimators: ParameterisedStrategySpec[];
};
export type AutoRecipeEstimatorsSpec = {
  initial_inventory_estimator: ParameterisedStrategySpec;
  production_estimator: ParameterisedStrategySpec;
  deliveries_estimator: ParameterisedStrategySpec;
  purchases_estimator: ParameterisedStrategySpec;
  electricity_price_estimator: ParameterisedStrategySpec;
  extra_state_estimator: ParameterisedStrategySpec;
};
export type AutoRecipeSolutionRounding = "rounded" | "continuous";
export type AutoRecipeStrategySpec = {
  solution_rounding?: AutoRecipeSolutionRounding | null;
  period_splitting_strategy: ParameterisedStrategySpec;
  period_weighting_strategy: ParameterisedStrategySpec;
  period_constraint_suppression_strategy: ParameterisedStrategySpec;
  target_inventory_strategy: ParameterisedStrategySpec;
  material_exclusivity_strategy: ParameterisedStrategySpec;
  delivery_aggregation_strategy: ParameterisedStrategySpec;
  purchase_aggregation_strategy: ParameterisedStrategySpec;
  material_limit_strategy: ParameterisedStrategySpec;
  period_electricity_price_strategy: ParameterisedStrategySpec;
  target_baskets_strategy?: ParameterisedStrategySpec | null;
};
export type MassDisplaySummaryType = "tapped" | "billet";
export type MassConstraintMode =
  "yielded_mass_only" | "charged_mass_only" | "yielded_and_charged_mass";
export type MiscParams = {
  /** Whether to allow obtainable scrap to be used during the 'planned' production. If `False`, obtainable scrap will only be used during the 'forecast' production. */
  allow_obtainable_during_plan: boolean;
  recipe_decimal_places: number;
  /** What type of summary to show in the UI for steel mass, yield, price per tonne, etc. */
  mass_display_summary_type: MassDisplaySummaryType;
  rounded_solution: boolean;
  uniform_deployable_mixes: boolean;
  optimisation_time_limit: number | null;
  /** The mass constraints to use in the optimisation. Charged, yielded or both. */
  mass_constraint_mode?: MassConstraintMode;
};
export type PhysicalParameters = {
  target_tapped_mass_lower: number;
  target_tapped_mass_upper: number;
  tapped_to_billet_yield: number;
  max_distinct_materials_per_mix: number | null;
  typical_hot_heel_mass: number;
  target_charged_mass_lower: number | null;
  target_charged_mass_upper: number | null;
};
export type InventoryItem = {
  material_id: number;
  quantity: number | null;
  specific_price: number | null;
  previous_quantity: number | null;
  deliveries_since_previous: number | null;
  consumption_since_previous: number | null;
  projected_deliveries_since_previous: number | null;
  projected_consumption_since_previous: number | null;
};
export type MaterialChemistry = {
  chemical_element_id: number;
  material_id: number;
  loc: number;
  scale: number;
};
export type MaterialQuantityUnit = "mass" | "ratio" | "grab";
export type MaterialQuantity = {
  value: number;
  unit: MaterialQuantityUnit;
};
export type MixBasketLayer = {
  material_name: string;
  quantity: MaterialQuantity;
  layer_number: number;
  /** Physical deposit this layer belongs to, 1 = bottom of the basket. Layers of one dual-material drop share a group. */
  layer_group_id?: number | null;
};
export type MixBasket = {
  basket_number: number;
  layers: MixBasketLayer[];
};
export type MixMaterial = {
  material_name: string;
  quantity: MaterialQuantity;
};
export type MixThresholdUnit =
  "grabs" | "mass" | "fraction" | "ratio_tolerance";
export type MixMaterialThreshold = {
  material_name: string;
  upper: number | null;
  lower: number | null;
  unit: MixThresholdUnit;
};
export type MixCreate = {
  baskets: MixBasket[];
  furnace?: MixMaterial[];
  thresholds?: MixMaterialThreshold[] | null;
};
export type UnobtainiumReporting = "suppress" | "report";
export type FixedMixOverride = {
  steel_grade_name: string;
  mix: MixCreate | null;
  unobtainium_reporting?: UnobtainiumReporting;
};
export type ProductGroupPlanItem = {
  product_group_id: number;
  num_heats: number;
};
export type SteelGradePlanItem = {
  steel_grade_id: number;
  num_heats: number;
};
export type SearchPeriodProductionPlan = {
  product_group_items: ProductGroupPlanItem[] | null;
  steel_grade_items: SteelGradePlanItem[] | null;
};
export type ObtainableBundleItem = {
  uuid: string;
  material_id: number;
  created_at: string;
  label: string;
  min_obtainable: number | null;
  max_obtainable: number | null;
  specific_price: number | null;
  arrival_probability: number | null;
};
export type TargetInventoryItem = {
  material_id: number;
  min_quantity: number | null;
  max_quantity: number | null;
};
export type TargetBasketItem = {
  chef_group_id: number;
  target_num_baskets: number;
};
export type PeriodMaterialExclusivityConstraintCreate = {
  material_ids: number[];
};
export type SearchPeriod = {
  name: string | null;
  start_timestamp: string | null;
  end_timestamp: string | null;
  is_deployable: boolean;
  production_plan: SearchPeriodProductionPlan;
  obtainable_bundles: ObtainableBundleItem[];
  target_inventory: TargetInventoryItem[];
  target_baskets: TargetBasketItem[];
  /** Steel grades held at the given recipe for this period only. A shortfall against a pinned recipe stays in the slack report, and fails the solve in a deployable period. Each entry needs a mix, and a steel grade cannot appear both here and in the search-level fixed_mix_overrides. */
  pinned_mixes?: FixedMixOverride[];
  material_exclusivity: PeriodMaterialExclusivityConstraintCreate[];
  suppress_mix_material_exclusivity_constraints: boolean;
  suppress_min_feasible_mass_constraints: boolean;
  /** The weighting for the period in the optimiser's objective function. A higher weighting means that the optimiser will prioritise this period over others. */
  optimisation_objective_weighting: number;
  electrical_energy_price: number;
};
export type MaterialLimitCoefficientCreate = {
  material_constraint_class_id: number;
  coefficient: number;
};
export type MaterialLimitBounds = {
  basket_id: number | null;
  min_mass: number | null;
  max_mass: number | null;
  soft_min_mass: number | null;
  soft_max_mass: number | null;
};
export type MaterialLimit = {
  chef_group_id: number;
  coefficients: MaterialLimitCoefficientCreate[];
  name?: string | null;
  hardness: number;
  bounds: MaterialLimitBounds[];
  /** The physical principle or constraint that defines this limit. */
  reason?: string | null;
};
export type UserRead = {
  uid: string;
  name: string;
  email: string;
};
export type SteelGradeSubstitutionReason =
  "requested" | "standing_map" | "billet_size_or_finish_good_code";
export type SteelGradeSubstitution = {
  melt_plan_steel_grade: string;
  planned_as_steel_grade: string;
  num_heats: number;
  reason: SteelGradeSubstitutionReason;
};
export type AutoRecipeRead = {
  session_id: number;
  session_name: string;
  session_created_at: string;
  session_created_by_email: string;
  parent_id: number | null;
  search_type: SearchType;
  context_id: number;
  misc_params: MiscParams;
  physical_parameters: PhysicalParameters;
  inventory: InventoryItem[];
  material_chemistry_overrides: MaterialChemistry[];
  fixed_mix_overrides: FixedMixOverride[];
  periods: SearchPeriod[];
  material_limit_overrides: MaterialLimit[];
  id: number;
  session_created_by: UserRead;
  steel_grade_substitutions: SteelGradeSubstitution[];
};
export type AutoRecipeDefaultsContext = {
  search_type: SearchType;
  effective_set_id: number | null;
  scrapchef_configuration_hash: string;
};
export type AutoRecipeParameters = {
  [key: string]: JsonValue;
};
export type AutoRecipeCreate = {
  default_context?: AutoRecipeDefaultsContext | null;
  parameters?: AutoRecipeParameters | null;
  auto_recipe_type: SearchType;
  on_timestamp?: string;
  /** Immediately mark the search session as deleted */
  deleted?: boolean;
  /** Most deployable periods the recipe keeps. Later deployable periods become forecast periods with the same start and end, so the build needs production data only for the kept periods. */
  deployable_period_limit?: number | null;
  estimators_spec?: AutoRecipeEstimatorsSpec | null;
  strategy_spec?: AutoRecipeStrategySpec | null;
  /** Raw steel grade in the melt plan to the raw steel grade its heats are planned as, e.g. {'1010OPT': '1008OPT'}. Applied ahead of every other match, including an exact catalog name and the plant's standing substitutions, so one entry re-plans every melt plan name carrying that raw grade; only tenants whose production estimator supports substitutions accept it. Keys are raw grades as the melt plan spells them: a key naming no grade on the melt plan for the days being built is refused, so a swap never silently applies to nothing. */
  steel_grade_substitutions?: {
    [key: string]: string;
  };
};
export type Metadata = {
  id: number;
  name: string;
  created_at: string;
  created_by_id: string;
  default: boolean | null;
};
export type ElementStatus = "modelled" | "visible" | "unused";
export type ChemicalElement = {
  id: number;
  name: string;
  symbol: string;
  status: ElementStatus;
  ordering: number;
};
export type ChemicalConstraintCoefficient = {
  chemical_element: ChemicalElement;
  coefficient: number;
};
export type ChemicalConstraint = {
  weight_percent_min?: number | null;
  weight_percent_max: number;
  adjusted_weight_percent_max: number;
  max_failure_rate: number;
  coefficients: ChemicalConstraintCoefficient[];
  name?: string | null;
};
export type SteelGradeSummary = {
  id: number;
  name: string;
};
export type ExclusiveMaterialSet = {
  material_ids: number[];
  violation_cost?: number | null;
};
export type ChefGroup = {
  id?: number | null;
  product_group_id: number;
  name: string;
  fraction_of_heats: number;
  default_target_num_baskets: number;
  max_failure_rate: number;
  chemical_constraints: ChemicalConstraint[];
  steel_grades: SteelGradeSummary[];
  exclusivity_constraints: ExclusiveMaterialSet[];
};
export type EntitySource = "scrapchef" | "customer";
export type ChefGroupingRead = {
  name: string;
  chef_groups: ChefGroup[];
  steel_grade_set_id: number;
  product_grouping_id: number;
  id: number;
  created_at: string;
  created_by_id: string;
  source: EntitySource;
};
export type ChefGroupingCreate = {
  name?: string;
  chef_groups: ChefGroup[];
  steel_grade_set_id: number;
  product_grouping_id: number;
};
export type UpdateDefaultTargetBasketsRequest = {
  source_chef_grouping_id: number;
  overrides: TargetBasketItem[];
};
export type Default = "default";
export type MaterialLimitRead = {
  chef_group_id: number;
  coefficients: MaterialLimitCoefficientCreate[];
  name: string | null;
  hardness: number;
  bounds: MaterialLimitBounds[];
  /** The physical principle or constraint that defines this limit. */
  reason: string | null;
  coefficients_signature: string;
};
export type MaterialLimitSet = {
  id: number;
  default: boolean;
  source: EntitySource;
  created_at: string;
  material_limits: MaterialLimitRead[];
};
export type MaterialLimitCreate = {
  chef_group_id: number;
  coefficients: MaterialLimitCoefficientCreate[];
  name?: string | null;
  hardness: number;
  bounds: MaterialLimitBounds[];
  /** The physical principle or constraint that defines this limit. */
  reason?: string | null;
};
export type UpdateDefaultMaterialLimitsRequest = {
  source_material_limit_set_id: number;
  material_limits: MaterialLimitCreate[];
};
export type SteelGrade = {
  id: number;
  name: string;
  chemical_constraints: ChemicalConstraint[];
  fraction_of_heats: number;
};
export type SteelGradeSetRead = {
  id: number;
  name: string;
  created_at: string;
  created_by_id: string;
  steel_grades: SteelGrade[];
};
export type SteelGradeCreate = {
  name: string;
  chemical_constraints: ChemicalConstraint[];
  fraction_of_heats: number;
};
export type SteelGradeSetCreate = {
  name?: string;
  steel_grades: SteelGradeCreate[];
};
export type SteelGradePlanRead = {
  name: string;
  steel_grade_set_id: number;
  items: SteelGradePlanItem[];
  from_product_group_plan_id: number | null;
  id: number;
  created_at: string;
  created_by_id: string;
};
export type SteelGradePlanCreate = {
  name?: string;
  steel_grade_set_id: number;
  items: SteelGradePlanItem[];
  from_product_group_plan_id?: number | null;
};
export type FormattedBasketRange = {
  minimum: number | null;
  maximum: number | null;
};
export type FormattedBasketConstraint = {
  basket_number: number;
  basket_id: number | null;
  fill_level: FormattedBasketRange;
  mass: FormattedBasketRange;
};
export type LoadBasketLayerRead = {
  material_name: string;
  material_id: number;
  quantity: MaterialQuantity;
  layer_number: number;
};
export type LoadBasketStatus = "new" | "partially_filled" | "filled";
export type LoadBasketRead = {
  load_basket_id: number;
  basket_number: number;
  materials: LoadBasketLayerRead[];
  additions: LoadBasketLayerRead[];
  status: LoadBasketStatus;
  assigned_to_name: string | null;
  assigned_to_uid: string | null;
  customer_heat_id: string | null;
  steel_grade_name: string;
  steel_grade_id: number;
};
export type LoadBasketReadList = {
  loads: LoadBasketRead[];
};
export type MaterialVisibility = "visible" | "hidden";
export type AdditionLocation = "basket" | "hopper";
export type MaterialType = "scrap" | "iron" | "flux";
export type MaterialRead = {
  id: number;
  name: string;
  visibility: MaterialVisibility;
  addition_location: AdditionLocation;
  material_type: MaterialType;
  internal: boolean;
  highlight_safety_stock: boolean;
  highlight_stock_to_drain: boolean;
  level2_id: string;
  level2_name: string;
  erp_id: string;
  erp_name: string;
  short_name: string;
  labelling_name: string | null;
  ordering: number;
  deployment_ordering: number;
  colour: string;
};
export type MaterialMetadataSetRead = {
  id: number;
  created_by_id: string;
  created_at: string;
  materials: MaterialRead[];
};
export type MaterialConstraintClass = {
  id: number;
  name: string;
};
export type MaterialChemistrySetRead = {
  name: string;
  items: MaterialChemistry[];
  source_uris: string[];
  source: EntitySource;
  id: number;
  created_at: string;
  created_by_id: string;
};
export type MaterialChemistrySetCreate = {
  name: string;
  items: MaterialChemistry[];
  source_uris: string[];
  source: EntitySource;
};
export type UpdateDefaultMaterialChemistryRequest = {
  /** ID of the effective default chemistry set used to prepare these edits. */
  source_material_chemistry_set_id: number;
  /** Measurements to replace or add by material and element. Omitted measurements retain their default values. */
  material_chemistry_overrides: MaterialChemistry[];
};
export type IntercalationRole = "ignored" | "big" | "small";
export type MaterialPhysics = {
  material_id: number;
  density: number;
  yield_percent: number;
  min_feasible_mass: number;
  typical_lift_mass: number;
  material_constraint_classes: MaterialConstraintClass[];
  intercalation_role: IntercalationRole;
  empty_space_fraction: number;
  default_substitute_material_id: number;
  electrical_energy_consumption: number;
};
export type MaterialPhysicsSetRead = {
  source: EntitySource;
  items: MaterialPhysics[];
  id: number;
  created_at: string;
  created_by_id: string;
};
export type MaterialPhysicsOverride = {
  material_id: number;
  density: number;
  yield_percent: number;
  min_feasible_mass: number;
  electrical_energy_consumption: number;
};
export type UpdateDefaultMaterialPhysicsRequest = {
  source_material_physics_set_id: number;
  material_physics_overrides: MaterialPhysicsOverride[];
};
export type FixedMixDefaultsContext = {
  fixed_mix_set_id: number;
  scrapchef_fixed_mix_set_id: number;
  material_chemistry_set_id: number | null;
  material_physics_set_id: number;
  material_metadata_set_id: number;
  physical_parameters_set_id: number;
};
export type FixedMixSetTypeLowMo = {
  kind?: "low_mo";
  scale: number;
};
export type FixedMixSetTypeOnShiftOverride = {
  kind?: "on_shift_override";
  name: string;
};
export type FixedMixSetTypeStandard = {
  kind?: "standard";
};
export type RootModelAnnotatedUnionFixedMixSetTypeStandardFixedMixSetTypeLowMoFixedMixSetTypeOnShiftOverrideFieldInfoAnnotationNoneTypeRequiredTrueDiscriminatorKind =
  | ({
      kind: "low_mo";
    } & FixedMixSetTypeLowMo)
  | ({
      kind: "on_shift_override";
    } & FixedMixSetTypeOnShiftOverride)
  | ({
      kind: "standard";
    } & FixedMixSetTypeStandard);
export type MixMassTotal = {
  material_name: string;
  mass: number;
};
export type PhysicsSummary = {
  recipe_mass: number;
  scrap_mass: number;
  dri_mass: number;
  tapped_mass: number;
  target_tapped_mass_lower: number;
  billet_mass: number;
  yield_percent: number;
  yield_percent_billets: number;
  /** The total mass to display in the frontend. This is either the `tapped_mass` or the `billet_mass` depending on the tenant  */
  display_produced_mass: number;
  /** The yield percentage to display in the frontend. This is either the `yield_percent` or the `yield_percent_billets` depending on the tenant */
  display_yield_percent: number;
};
export type SteelGradeRisk = {
  steel_grade_id: number;
  weight_percent_min_tolerance: number | null;
  weight_percent_max_tolerance: number;
  expected_over_tolerance_rate_percent: number;
  expected_under_tolerance_rate_percent: number;
  warning_level_failure_rate_percent: number;
  error_level_failure_rate_percent: number;
};
export type WeightPercentQuantile = {
  quantile: number;
  weight_percent: number;
};
export type ConstraintChemistry = {
  constraint_name: string;
  ordering: number;
  weight_percent_loc: number;
  weight_percent_scale: number;
  steel_grade_risks: SteelGradeRisk[];
  quantiles: WeightPercentQuantile[];
};
export type CostSummary = {
  cost_per_heat_materials: number;
  cost_per_heat_electrical_energy: number;
  cost_per_tonne_tapped_materials: number;
  cost_per_tonne_tapped_electrical_energy: number;
  cost_per_tonne_billets_materials: number;
  cost_per_tonne_billets_electrical_energy: number;
  cost_per_heat: number;
  cost_per_tonne_tapped: number;
  cost_per_tonne_billets: number;
  /** The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant */
  display_cost_per_tonne_materials: number;
  /** The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant */
  display_cost_per_tonne_electrical_energy: number;
  /** The total cost per tonne to display in the frontend.  */
  display_cost_per_tonne: number;
  cost_per_tonne_charged_materials: number;
  cost_per_tonne_charged_electrical_energy: number;
  cost_per_tonne_charged: number;
};
export type SingleMixBasketSummary = {
  chef_group_name: string;
  basket_number: number;
  recipe_mass: number;
  volume: number;
  fullness: number;
  min_fill_level: number;
  max_fill_level: number;
  min_mass: number;
  max_mass: number;
  basket_volume: number;
};
export type SingleMixSummary = {
  physics: PhysicsSummary;
  chemistry: ConstraintChemistry[];
  cost: CostSummary;
  cost_per_target_mass: CostSummary;
  basket_summaries: SingleMixBasketSummary[];
};
export type MixRead = {
  baskets: MixBasket[];
  furnace: MixMaterial[];
  thresholds: MixMaterialThreshold[] | null;
  id: number;
  basket_totals: MixMassTotal[];
  summary: SingleMixSummary | null;
};
export type FixedMixRead = {
  steel_grade_name: string;
  mix: MixRead;
  unobtainium_reporting: UnobtainiumReporting;
};
export type FixedMixSetRead = {
  source: EntitySource;
  id: number;
  type: RootModelAnnotatedUnionFixedMixSetTypeStandardFixedMixSetTypeLowMoFixedMixSetTypeOnShiftOverrideFieldInfoAnnotationNoneTypeRequiredTrueDiscriminatorKind;
  steel_grade_set_id: number;
  created_at: string;
  created_by_id: string;
  mixes: FixedMixRead[];
};
export type FixedMixCreate = {
  steel_grade_name: string;
  mix: MixCreate;
  unobtainium_reporting?: UnobtainiumReporting;
};
export type ConflictKind =
  | "per_basket_minimum_exceeds_capacity"
  | "heat_minimum_exceeds_capacity"
  | "heat_minimum_exceeds_tapped_capacity"
  | "total_maximum_below_basket_minimums"
  | "total_minimum_above_basket_maximums"
  | "coalesced_limits_inconsistent"
  | "chemistry_ceiling_unreachable"
  | "limit_forces_chemistry_breach"
  | "fixed_mix_chemistry_breach"
  | "limit_forces_volume_breach"
  | "fixed_mix_exceeds_volume"
  | "fixed_mix_exceeds_tapped_capacity"
  | "fixed_mix_below_tapped_minimum"
  | "fixed_mix_exceeds_charged_capacity"
  | "fixed_mix_below_charged_minimum"
  | "material_limit_excludes_material"
  | "fixed_mix_below_minimum_usable_mass"
  | "minimum_usable_mass_exceeds_capacity";
export type MaterialPhysicsProperty =
  | "density"
  | "yield_percent"
  | "min_feasible_mass"
  | "electrical_energy_consumption";
export type MaterialPhysicsReference = {
  material_id: number;
  property: MaterialPhysicsProperty;
};
export type ChemistryMeasurementReference = {
  material_id: number;
  chemical_element_id: number;
};
export type ParameterConflict = {
  chef_group_id: number;
  kind: ConflictKind;
  material_physics: MaterialPhysicsReference[];
  required_volume: number | null;
  available_volume: number | null;
  /** Material chemistry measurements contributing to the conflict. */
  chemistry_measurements: ChemistryMeasurementReference[];
  /** Material limit expression for conflicts caused by a material limit. */
  coefficients_signature: string | null;
  /** Basket number for conflicts limited to one basket. */
  basket_number: number | null;
  /** Chemical constraint for chemistry conflicts. */
  chemical_constraint_name: string | null;
  /** Steel grades affected by the conflict. */
  steel_grade_names: string[];
  /** Material affected by a mass warning or with the lowest contribution when no material can meet a chemistry ceiling. */
  material_name: string | null;
  /** Required mass in tonnes. Cross-scope conflicts use weighted material-limit mass. */
  required_mass: number | null;
  /** Available capacity or fixed-mix mass in tonnes. */
  available_mass: number | null;
  /** Lowest achievable weight percentage at max_failure_rate. */
  achievable_weight_percent: number | null;
  /** Adjusted chemistry ceiling at max_failure_rate. */
  tolerance_weight_percent: number | null;
  /** Accepted failure rate as a percentage. */
  max_failure_rate: number | null;
};
export type ParameterFeasibilityReport = {
  conflicts: ParameterConflict[];
};
export type RecipeImpurityStats = {
  chemical_constraint_name: string;
  chemical_element_ordering: number;
  /** The mean value of the recipe in the 'direction' of the constraint, in units of weight percent */
  mean: number;
  /** The standard deviation of the recipe in the 'direction' of the constraint, in units of weight percent */
  std: number;
  quantiles: {
    [key: string]: number;
  };
  weight_percent_min: number | null;
  weight_percent_max: number;
  expected_over_tolerance_rate: number;
  expected_under_tolerance_rate: number;
};
export type FixedMixImpurities = {
  steel_grade_name: string;
  impurities: RecipeImpurityStats[] | null;
};
export type FixedMixDefaultsPreview = {
  mixes: FixedMixCreate[];
  feasibility: ParameterFeasibilityReport;
  chemistry: FixedMixImpurities[];
};
export type FixedMixDefaultsRead = {
  context: FixedMixDefaultsContext;
  effective: FixedMixSetRead;
  scrapchef: FixedMixSetRead;
  mix_groups: string[][];
  effective_preview: FixedMixDefaultsPreview | null;
  scrapchef_preview: FixedMixDefaultsPreview | null;
};
export type FixedMixDefaultsRequest = {
  context: FixedMixDefaultsContext;
  mixes: FixedMixCreate[];
  mix_groups: string[][];
};
export type AutoRecipeParameterSetRead = {
  search_type: SearchType;
  id: number | null;
  source: EntitySource;
  parameters: AutoRecipeParameters;
};
export type AutoRecipeParameterScope = "defaults" | "search";
export type AutoRecipeParameterWidget =
  | "scalar"
  | "month"
  | "time_intervals"
  | "monthly_targets"
  | "inventory_targets"
  | "conditional_inventory_targets"
  | "material_exclusivity"
  | "material_limit_overrides"
  | "steel_grades";
export type AutoRecipeMonthlyValueMode = "independent" | "carry_forward";
export type AutoRecipeParameterField = {
  name: string;
  label: string;
  translation_key: string | null;
  unit: UnitType | null;
  scopes: AutoRecipeParameterScope[];
  widget: AutoRecipeParameterWidget;
  monthly_value_mode: AutoRecipeMonthlyValueMode | null;
  initial_value_from: string | null;
  price_material: string | null;
  help_text: string | null;
  help_translation_key: string | null;
};
export type AutoRecipeParameterSection = {
  name: string;
  label: string;
  translation_key: string | null;
  fields: AutoRecipeParameterField[];
};
export type AutoRecipePeriodLayout =
  | "single_period"
  | "deployable_sequence"
  | "first_deployable_sequence"
  | "schedule_forecast"
  | "calendar_forecast"
  | "weekly_forecast";
export type AutoRecipeParameterDefinition = {
  /** JSON Schema for editable values. Cross-field rules are checked by the server. */
  json_schema: {
    [key: string]: JsonValue;
  };
  sections: AutoRecipeParameterSection[];
  period_layout: AutoRecipePeriodLayout;
};
export type AutoRecipeDefaultsRead = {
  context: AutoRecipeDefaultsContext;
  effective: AutoRecipeParameterSetRead;
  scrapchef: AutoRecipeParameterSetRead;
  definition: AutoRecipeParameterDefinition;
};
export type AutoRecipeDefaultsRequest = {
  context: AutoRecipeDefaultsContext;
  parameters: AutoRecipeParameters;
};
export type UtcTimestamp = string;
export type AutoRecipeSupplyPreviewPoint = {
  timestamp: UtcTimestamp;
  mass: number;
};
export type AutoRecipeSupplyPreview = {
  points: AutoRecipeSupplyPreviewPoint[];
  total_mass: number;
};
export type AutoRecipeSupplyPreviewRequest = {
  context: AutoRecipeDefaultsContext;
  parameters: AutoRecipeParameters;
  start_timestamp: UtcTimestamp;
  end_timestamp: UtcTimestamp;
};
export type DefaultParameterPage =
  | "chemistry"
  | "physics"
  | "predefined_mixes"
  | "target_baskets"
  | "search_parameters";
export type DefaultParameterVisit = {
  page: DefaultParameterPage;
  replay_id: string | null;
};
export type LoadRead = {
  plan_id: number;
  customer_heat_id: string | null;
  steel_grade_id: number;
  steel_grade_name: string;
  copper_group_weight_percent_max: number;
  mix_id: number;
  load_id: number;
  baskets: {
    [key: string]: LoadBasketRead;
  };
  created_at: string;
  created_by_id: string;
  start_time: string | null;
  end_time: string | null;
};
export type LoadSortOrder = "asc" | "desc";
export type LoadStatus = "completed" | "assigned" | "unassigned";
export type LoadCreate = {
  plan_id: number;
  mix_id: number;
  steel_grade_id: number;
  customer_heat_id?: string | null;
  start_time?: string | null;
  end_time?: string | null;
};
export type Crane = {
  user_uid: string;
  name: string;
};
export type CraneList = {
  cranes: Crane[];
};
export type LoadBasketAssignmentUpdate = {
  assigned_to_uid: string | null;
};
export type LoadBasketLayerAdditionUpdate = {
  material_id: number;
  quantity: MaterialQuantity;
  layer_number: number;
};
export type LoadBasketAdditionUpdate = {
  materials: LoadBasketLayerAdditionUpdate[];
};
export type OptimisationStatus =
  | "not_started"
  | "failed"
  | "failed_suboptimal"
  | "succeeded_suboptimal"
  | "succeeded"
  | "edited";
export type NameBasedSteelGradePlanItem = {
  steel_grade_name: string;
  num_heats: number;
};
export type ProductionMixResultRead = {
  name: string;
  description: string | null;
  production: NameBasedSteelGradePlanItem[];
  num_heats: number;
  mix: MixRead;
};
export type MaterialResult = {
  material: string;
  label: string;
  quantity: number;
  min_quantity: number;
  max_quantity: number | null;
  specific_price: number;
};
export type ResultsPeriodRead = {
  period_index: number;
  mixes: ProductionMixResultRead[];
  materials: MaterialResult[];
  product_group_results: ProductionMixResultRead[];
};
export type SlackVariableEnum =
  | "unobtainium_purchased"
  | "unobtainium_consumed"
  | "material_period_exclusivity_constraint_violated"
  | "target_inventory_increases"
  | "target_inventory_decreases"
  | "soft_material_max_increases"
  | "soft_material_min_decreases"
  | "soft_material_exclusivity_constraint_violated"
  | "mix_use_count_increases"
  | "impurity_weight_percent_max_increase"
  | "impurity_weight_percent_min_decrease";
export type OptimisationSlackVariableUsage = {
  details: {
    [key: string]: string | number;
  };
  slack_variable: SlackVariableEnum;
  usage: number;
  period: number;
  cost: number;
};
export type NullableDatetime = string | null;
export type PeriodSummary = {
  cost_per_heat_materials: number;
  cost_per_heat_electrical_energy: number;
  cost_per_tonne_tapped_materials: number;
  cost_per_tonne_tapped_electrical_energy: number;
  cost_per_tonne_billets_materials: number;
  cost_per_tonne_billets_electrical_energy: number;
  cost_per_heat: number;
  cost_per_tonne_tapped: number;
  cost_per_tonne_billets: number;
  /** The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant */
  display_cost_per_tonne_materials: number;
  /** The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant */
  display_cost_per_tonne_electrical_energy: number;
  /** The total cost per tonne to display in the frontend.  */
  display_cost_per_tonne: number;
  cost_per_tonne_charged_materials: number;
  cost_per_tonne_charged_electrical_energy: number;
  cost_per_tonne_charged: number;
  recipe_mass: number;
  scrap_mass: number;
  dri_mass: number;
  tapped_mass: number;
  target_tapped_mass_lower: number;
  billet_mass: number;
  yield_percent: number;
  yield_percent_billets: number;
  /** The total mass to display in the frontend. This is either the `tapped_mass` or the `billet_mass` depending on the tenant  */
  display_produced_mass: number;
  /** The yield percentage to display in the frontend. This is either the `yield_percent` or the `yield_percent_billets` depending on the tenant */
  display_yield_percent: number;
  period: number;
  name: string | null;
  is_deployable: boolean;
  start_timestamp: NullableDatetime;
  end_timestamp: NullableDatetime;
  num_heats: number;
  total_cost_materials: number;
  total_cost_electrical_energy: number;
  total_cost: number;
};
export type NullableNonNegativeFloat = number | null;
export type NameBasedPeriodMaterialSummary = {
  period: number;
  material: string;
  /** The initial inventory at the start of the period, not counting any obtainable acquired during the period. (Can be negative due to unobtainium.) */
  initial_inventory: number;
  /** The inventory at the end of the period, after the obtainable has been added and consumption subtracted. (Can be negative due to unobtainium). */
  final_inventory: number;
  /** The mass consumed of the material in the period */
  mass_consumed: number;
  /** The mass of material obtained during the period */
  obtainable_obtained: number;
  /** The mass of material that could have been obtained in the period but was not. (Can be negative due to unobtainium.) */
  obtainable_remaining: number;
  /** The price per unit mass of the material obtained during the period. Null if no material was obtained */
  obtained_price_per_tonne: NullableNonNegativeFloat;
  /** The material cost per unit mass of the material consumed in the period */
  cost_per_tonne_material: number;
  /** The electrical energy cost per unit mass of the material consumed in the period. (Can be negative due to negative energy prices). */
  cost_per_tonne_electrical_energy: number;
  /** The total material cost in the period (not including electrical energy) */
  cost_consumed: number;
};
export type NameBasedSummary = {
  period_summary: PeriodSummary[];
  period_material_summary: NameBasedPeriodMaterialSummary[];
};
export type PlanType = "base" | "edited" | "fallback";
export type PlanMetadata = {
  base_plan_id: number;
  parent_plan_id: number | null;
  created_by_name: string;
  created_at: string;
  plan_type: PlanType;
};
export type PlannedResultsRead = {
  plan_id: number;
  optimisation_status: OptimisationStatus;
  periods: {
    [key: string]: ResultsPeriodRead;
  };
  slack_variable_usage: OptimisationSlackVariableUsage[];
  summary: NameBasedSummary;
  metadata: PlanMetadata;
  start_at: string | null;
  end_at: string | null;
  steel_grade_set: SteelGradeSetRead;
};
export type PlanResultsResponse = {
  plan_id: number;
  period: number;
  response: PlannedResultsRead | null;
};
export type BatchPlanResultsResponse = {
  results: PlanResultsResponse[];
};
export type PlanMixRequest = {
  plan_id: number;
  period: number;
};
export type DeployedPlans = {
  latest: number | null;
  next: number | null;
};
export type DeploymentType =
  | "standard"
  | "edited_standard"
  | "backup"
  | "edited_backup"
  | "purchasing_plan";
export type DeployedPlannedResultsRead = {
  plan_id: number;
  optimisation_status: OptimisationStatus;
  periods: {
    [key: string]: ResultsPeriodRead;
  };
  slack_variable_usage: OptimisationSlackVariableUsage[];
  summary: NameBasedSummary;
  metadata: PlanMetadata;
  start_at: string;
  end_at: string;
  steel_grade_set: SteelGradeSetRead;
  /** Mapping from mix IDs in the current plan to their equivalents in the plan originally deployed to the scrapyard */
  originally_deployed_mix_ids: {
    [key: string]: number;
  };
  deployed_at: string;
  deployment_type: DeploymentType;
};
export type Latest = "latest";
export type Next = "next";
export type Deployment = {
  id: number;
  plan_id: number;
  deployed_at: string;
  start_at: string;
  end_at: string;
  user_id: string;
  deployment_type: DeploymentType;
  deployed_by_name: string;
};
export type SupportedLanguage = "DE" | "EN" | "ES" | "FR" | "PL";
export type DeployParameters = {
  process: DeployProcess;
  start_at: string;
  end_at: string;
  language: SupportedLanguage;
  deployment_type: DeploymentType;
};
export type HeatOverrideCreated = {
  override_id: number;
};
export type HeatOverrideMaterialDelta = {
  material_name: string;
  /** Signed change to the material's mass in the charge of each heat, in tenant mass units */
  mass_delta_per_heat: number;
};
export type HeatOverrideChargeDelta = {
  basket_number: number;
  material_deltas: HeatOverrideMaterialDelta[];
};
export type HeatOverrideDeltaCreate = {
  /** Stable IDs of the heats the override claims */
  stable_heat_ids: string[];
  reason: string;
  subreason: string | null;
  comment: string | null;
  /** The floor mix the client showed the user; the server rejects the create when the floor has moved since */
  baseline_mix_id: number;
  mode: "delta";
  charge_deltas: HeatOverrideChargeDelta[];
};
export type HeatOverrideCatalogSelection = {
  fixed_mix_set_id: number;
  mix_id: number;
};
export type HeatOverrideCatalogCreate = {
  /** Stable IDs of the heats the override claims */
  stable_heat_ids: string[];
  reason: string;
  subreason: string | null;
  comment: string | null;
  /** The floor mix the client showed the user; the server rejects the create when the floor has moved since */
  baseline_mix_id: number;
  mode: "catalog";
  catalog: HeatOverrideCatalogSelection;
};
export type HeatRecipe = {
  name: string;
  mix: MixRead;
};
export type HeatOverrideNote = {
  reason: string | null;
  subreason: string | null;
  /** Free-text note recorded when the override was deployed */
  comment: string | null;
};
export type HeatQueueStatus = "loading" | "melting" | "queued" | "completed";
export type HeatQueueEntry = {
  heat_id: number;
  stable_heat_id: string;
  steel_grade: string;
  product_group: string | null;
  recipe_name: string | null;
  recipe: HeatRecipe | null;
  floor_recipe: HeatRecipe | null;
  override_id: number | null;
  override: HeatOverrideNote | null;
  heat_start_time: string | null;
  status: HeatQueueStatus;
};
export type CompletedHeats = {
  /** Completed heats from the searched heat onwards, oldest first; empty when no completed heat has the searched ID */
  heats: HeatQueueEntry[];
};
export type HistoricalOverrideHeatStatus =
  "started" | "not_started" | "unrecognised";
export type HistoricalHeatOverrideScope = {
  stable_heat_id: string;
  expected_grade: string;
};
export type HistoricalOverrideEditability =
  "available" | "unfinished" | "cancelled" | "unsupported";
export type HistoricalHeatOverrideVersion = {
  revision_id: number | null;
  edited_at: string;
  edited_by: string;
  override_mix: MixRead;
  recipe_name: string | null;
  reason: string | null;
  subreason: string | null;
  comment: string | null;
};
export type HistoricalHeatOverride = {
  override_id: number;
  created_at: string;
  /** When the earliest of the override's heats started; null until one starts */
  first_heat_start_time: string | null;
  /** Unrecognised when none of the override's heats is in the melt plan */
  heat_status: HistoricalOverrideHeatStatus;
  created_by: string;
  cancelled_at: string | null;
  cancelled_by: string | null;
  reason: string | null;
  subreason: string | null;
  comment: string | null;
  recipe_name: string | null;
  scopes: HistoricalHeatOverrideScope[];
  editability: HistoricalOverrideEditability;
  versions: HistoricalHeatOverrideVersion[];
  replaced_mix: MixRead;
  override_mix: MixRead;
  /** Material changes from the replaced mix, per charge; null unless the tenant enters overrides as deltas */
  charge_deltas: HeatOverrideChargeDelta[] | null;
};
export type HeatOverrideHistory = {
  items: HistoricalHeatOverride[];
  total: number;
};
export type HeatOverrideCancellationFilter = "exclude" | "include";
export type HistoricalHeatOverrideUpdate = {
  expected_revision_id: number | null;
  catalog: HeatOverrideCatalogSelection | null;
  reason: string | null;
  subreason: string | null;
  comment: string | null;
};
export type HeatOverrideRecipe = {
  fixed_mix_set_id: number;
  /** Operator-facing name of the pre-approved override recipe */
  name: string;
  mix_id: number;
  /** The basket recipe the override deploys */
  mix: MixRead;
  /** The steel grades this recipe can be deployed for */
  steel_grades: string[] | null;
};
export type HeatOverrideRecipes = {
  items: HeatOverrideRecipe[];
};
export type HeatOverrideRecipeUpdate = {
  mix_id: number;
  baskets: MixBasket[];
};
export type HeatOverrideReason = {
  reason: string;
  subreasons: string[];
};
export type HeatOverrideReasons = {
  reasons: HeatOverrideReason[];
};
export type LiveRecipeMaterial = {
  material_name: string;
  material_id: number;
  /** Mass of this material per heat in tonnes */
  recipe_mass: number;
  /** Percentage of total recipe mass */
  percentage: number;
  /** Number of heats until this material is depleted from inventory. Null if inventory data is not available. */
  heats_until_depletion: number | null;
};
export type LiveRecipeResponse = {
  /** Name of the mix/recipe */
  mix_name: string;
  /** Database ID of the optimisation result set */
  plan_id: number;
  /** Database ID of the mix */
  mix_id: number;
  /** Heat ID of the next upcoming heat */
  next_heat_id: number;
  /** Number of upcoming heats using this recipe */
  upcoming_heat_count: number;
  /** Plant charge schedule ID assigned to the heats */
  charge_schedule_id: string;
  /** List of materials in the recipe with depletion info */
  materials: LiveRecipeMaterial[];
  /** Total mass of the recipe per heat in tonnes */
  total_recipe_mass: number;
};
export type ActiveHeatOverride = {
  override_id: number;
  created_at: string;
  created_by: string;
  override_mix: MixRead;
  reason: string | null;
  subreason: string | null;
  comment: string | null;
  recipe_name: string | null;
  /** The mix the override pins */
  override_mix_id: number;
  /** The floor mix the override displaced: the baseline captured at creation */
  replaced_mix: MixRead;
  /** Material changes from the replaced mix, per charge; null unless the tenant enters overrides as deltas */
  charge_deltas: HeatOverrideChargeDelta[] | null;
};
export type HeatQueueRead = {
  heats: HeatQueueEntry[];
  current_heat_id: number | null;
  /** Upload time of the newest melt plan that lists future heats */
  plan_updated_at: string | null;
  active_overrides: ActiveHeatOverride[];
};
export type ObtainableBundleItemSet = {
  items: ObtainableBundleItem[];
  obtainable_bundle_set_id: number;
};
export type ObtainableBundleItemSetCreate = {
  items: ObtainableBundleItem[];
};
export type ProductGroup = {
  id?: number | null;
  name: string;
  steel_grades: SteelGradeSummary[];
  /** Fraction of historical production. Stored data can contain values above one. */
  fraction_of_heats: number;
};
export type ProductGroupingRead = {
  name: string;
  product_groups: ProductGroup[];
  steel_grade_set_id: number;
  id: number;
  created_at: string;
  created_by_id: string;
};
export type ProductGroupingCreate = {
  name: string;
  product_groups: ProductGroup[];
  steel_grade_set_id: number;
};
export type ProductGroupPlanRead = {
  name: string;
  product_grouping_id: number;
  items: ProductGroupPlanItem[];
  id: number;
  created_at: string;
  created_by_id: string;
};
export type ProductGroupPlanCreate = {
  name?: string;
  product_grouping_id: number;
  items: ProductGroupPlanItem[];
};
export type SearchStatus = "not_started" | "running" | "success" | "failure";
export type SearchSummary = {
  search_id: number;
  parent_search_id: number | null;
  context_id: number;
  status: SearchStatus;
  created_by_current_user: boolean;
  user_email: string;
  user: UserRead;
  created_at: string;
};
export type Ordering = "asc" | "desc";
export type SearchRead = {
  session_id: number;
  session_name: string;
  session_created_at: string;
  session_created_by_email: string;
  parent_id: number | null;
  search_type: SearchType;
  context_id: number;
  misc_params: MiscParams;
  physical_parameters: PhysicalParameters;
  inventory: InventoryItem[];
  material_chemistry_overrides: MaterialChemistry[];
  fixed_mix_overrides: FixedMixOverride[];
  periods: SearchPeriod[];
  material_limit_overrides: MaterialLimit[];
  id: number;
  session_created_by: UserRead;
};
export type MixMetadata = {
  period: number;
  mix_id: number;
  chef_group_id: number;
  chef_group_name: string;
  customer_mix_id: string | null;
};
export type SummaryTagEnum =
  | "not_enough_available_scrap"
  | "challenging_for_scrapyard"
  | "uses_non_default_baskets";
export type TagSentiment = "positive" | "neutral" | "negative" | "terrible";
export type SummaryTag = {
  period: number;
  tag: SummaryTagEnum;
  details: string[];
  sentiment: TagSentiment;
};
export type MixSummary = {
  cost_per_heat_materials: number;
  cost_per_heat_electrical_energy: number;
  cost_per_tonne_tapped_materials: number;
  cost_per_tonne_tapped_electrical_energy: number;
  cost_per_tonne_billets_materials: number;
  cost_per_tonne_billets_electrical_energy: number;
  cost_per_heat: number;
  cost_per_tonne_tapped: number;
  cost_per_tonne_billets: number;
  /** The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant */
  display_cost_per_tonne_materials: number;
  /** The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant */
  display_cost_per_tonne_electrical_energy: number;
  /** The total cost per tonne to display in the frontend.  */
  display_cost_per_tonne: number;
  cost_per_tonne_charged_materials: number;
  cost_per_tonne_charged_electrical_energy: number;
  cost_per_tonne_charged: number;
  recipe_mass: number;
  scrap_mass: number;
  dri_mass: number;
  tapped_mass: number;
  target_tapped_mass_lower: number;
  billet_mass: number;
  yield_percent: number;
  yield_percent_billets: number;
  /** The total mass to display in the frontend. This is either the `tapped_mass` or the `billet_mass` depending on the tenant  */
  display_produced_mass: number;
  /** The yield percentage to display in the frontend. This is either the `yield_percent` or the `yield_percent_billets` depending on the tenant */
  display_yield_percent: number;
  period: number;
  num_heats: number;
  num_baskets: number;
  /** How many heats of this mix can be produced before initial inventory of the limiting material runs out. */
  heats_of_material_in_initial_inventory: number;
  /** Name of the material that will run out first from initial inventory. None if no materials are used from inventory. */
  limiting_material_in_initial_inventory: string | null;
  mix_id: number;
  chef_group_name: string;
  chef_group_id: number;
  mix_number: number;
};
export type MixMaterialSummary = {
  period: number;
  material: string;
  recipe_mass: number;
  mix_id: number;
  chef_group_name: string;
  mix_number: number;
  /** Number of heats of this mix that can be produced before the initial inventory of this material runs out. None if material has infinite inventory or zero consumption. */
  heats_until_depletion: number | null;
};
export type MixBasketSummary = {
  chef_group_name: string;
  basket_number: number;
  recipe_mass: number;
  volume: number;
  fullness: number;
  period: number;
  mix_id: number;
  mix_number: number;
};
export type MixMaterialBasketSummary = {
  period: number;
  material: string;
  recipe_mass: number;
  mix_id: number;
  chef_group_name: string;
  mix_number: number;
  /** Number of heats of this mix that can be produced before the initial inventory of this material runs out. None if material has infinite inventory or zero consumption. */
  heats_until_depletion: number | null;
  basket_number: number;
  basket_layer: string;
  basket_layer_number: number;
};
export type ProductGroupMixSummary = {
  product_group_name: string;
  cost_per_heat_materials: number;
  cost_per_heat_electrical_energy: number;
  cost_per_tonne_tapped_materials: number;
  cost_per_tonne_tapped_electrical_energy: number;
  cost_per_tonne_billets_materials: number;
  cost_per_tonne_billets_electrical_energy: number;
  cost_per_heat: number;
  cost_per_tonne_tapped: number;
  cost_per_tonne_billets: number;
  /** The cost per tonne of materials to display in the frontend. This is either the `cost_per_tonne_billets_materials` or the `cost_per_tonne_tapped_materials` depending on the tenant */
  display_cost_per_tonne_materials: number;
  /** The cost per tonne of electrical energy to display in the frontend. This is either the `cost_per_tonne_billets_electrical_energy` or the `cost_per_tonne_tapped_electrical_energy` depending on the tenant */
  display_cost_per_tonne_electrical_energy: number;
  /** The total cost per tonne to display in the frontend.  */
  display_cost_per_tonne: number;
  cost_per_tonne_charged_materials: number;
  cost_per_tonne_charged_electrical_energy: number;
  cost_per_tonne_charged: number;
  recipe_mass: number;
  scrap_mass: number;
  dri_mass: number;
  tapped_mass: number;
  target_tapped_mass_lower: number;
  billet_mass: number;
  yield_percent: number;
  yield_percent_billets: number;
  /** The total mass to display in the frontend. This is either the `tapped_mass` or the `billet_mass` depending on the tenant  */
  display_produced_mass: number;
  /** The yield percentage to display in the frontend. This is either the `yield_percent` or the `yield_percent_billets` depending on the tenant */
  display_yield_percent: number;
  period: number;
  num_heats: number;
  num_baskets: number;
  /** How many heats of this mix can be produced before initial inventory of the limiting material runs out. */
  heats_of_material_in_initial_inventory: number;
  /** Name of the material that will run out first from initial inventory. None if no materials are used from inventory. */
  limiting_material_in_initial_inventory: string | null;
};
export type ProductGroupMixMaterialSummary = {
  product_group_name: string;
  period: number;
  material: string;
  recipe_mass: number;
};
export type ObtainableResultItem = {
  period: number;
  material_id: number;
  material_name: string;
  bundle_name: string;
  bundle_id: number;
  bundle_index: number;
  required_obtainable: number;
  max_obtainable: number;
  specific_price: number;
};
export type PeriodMaterialSummary = {
  period: number;
  material: string;
  /** The initial inventory at the start of the period, not counting any obtainable acquired during the period. (Can be negative due to unobtainium.) */
  initial_inventory: number;
  /** The inventory at the end of the period, after the obtainable has been added and consumption subtracted. (Can be negative due to unobtainium). */
  final_inventory: number;
  /** The mass consumed of the material in the period */
  mass_consumed: number;
  /** The mass of material obtained during the period */
  obtainable_obtained: number;
  /** The mass of material that could have been obtained in the period but was not. (Can be negative due to unobtainium.) */
  obtainable_remaining: number;
  /** The price per unit mass of the material obtained during the period. Null if no material was obtained */
  obtained_price_per_tonne: NullableNonNegativeFloat;
  /** The material cost per unit mass of the material consumed in the period */
  cost_per_tonne_material: number;
  /** The electrical energy cost per unit mass of the material consumed in the period. (Can be negative due to negative energy prices). */
  cost_per_tonne_electrical_energy: number;
  /** The total material cost in the period (not including electrical energy) */
  cost_consumed: number;
  material_id: number;
  local_month_to_date_consumed: number;
};
export type OptimisationResultSetSummary = {
  tags: SummaryTag[];
  period_summary: PeriodSummary[];
  mix_summary: MixSummary[];
  mix_material_summary: MixMaterialSummary[];
  mix_basket_summary: MixBasketSummary[];
  mix_material_basket_summary: MixMaterialBasketSummary[];
  product_group_mix_summary: ProductGroupMixSummary[] | null;
  product_group_mix_material_summary: ProductGroupMixMaterialSummary[] | null;
  obtainable_summary: ObtainableResultItem[];
  period_material_summary: PeriodMaterialSummary[];
  first_period_summary: PeriodSummary;
};
export type ExternalRecipeSummary = {
  recipe_mass: number;
  tapped_mass: number;
  yield_percent: number;
  cost_per_tonne_charged: number;
  cost_per_tonne_tapped: number;
};
export type ExternalRecipeWithSummary = {
  baskets: MixBasket[];
  furnace: MixMaterial[];
  thresholds: MixMaterialThreshold[] | null;
  source: string;
  product_group_name: string;
  summary: ExternalRecipeSummary;
};
export type Plan = {
  id: number;
  metadata: PlanMetadata;
  plan_index: number;
  session_id: number;
  search_id: number;
  deployments: Deployment[];
  mix_metadata: MixMetadata[];
  optimisation_status: OptimisationStatus;
  summary: OptimisationResultSetSummary;
  optimisation_slack_variable_usage: OptimisationSlackVariableUsage[];
  time_limit: number;
  comment: string | null;
  external_recipes: {
    [key: string]: ExternalRecipeWithSummary;
  } | null;
};
export type OptimisationFailureReason =
  | "Infeasible Optimisation"
  | "Optimisation Timed Out"
  | "Optimisation Error"
  | "unacceptable_slack_variable_usage";
export type SearchResultStatus = "not_started" | "incomplete" | "complete";
export type SearchResult = {
  search_id: number;
  session_id: number;
  plans: Plan[];
  failure_reason: OptimisationFailureReason | null;
  status: SearchResultStatus;
  failed_optimisation_reasons: OptimisationFailureReason[];
};
export type OptimisationMethod = "classic";
export type RunSearchOptions = {
  /** The optimisation method to use for the auto recipe */
  optimisation_method?: OptimisationMethod | null;
  /** The time limit for the optimisation in seconds. Note that this is the time limit passed to the solver, so does not include time spent loading and saving data. */
  optimisation_time_limit?: number;
  /** If true, then override the parameters in the search and do not use integer solution */
  force_non_rounded_solution?: boolean;
  /** Maximum number of tasks to generate. Defaults to None (no limit). */
  task_limit?: number | null;
  /** If true, then create auto backups for the search. */
  create_auto_backups?: boolean;
  /** If true, then send notification email on completion. */
  notify_on_completion?: boolean;
};
export type SearchCreate = {
  session_id: number;
  session_name: string;
  session_created_at: string;
  session_created_by_email: string;
  parent_id: number | null;
  search_type: SearchType;
  context_id: number;
  misc_params: MiscParams;
  physical_parameters: PhysicalParameters;
  inventory: InventoryItem[];
  material_chemistry_overrides: MaterialChemistry[];
  fixed_mix_overrides: FixedMixOverride[];
  periods: SearchPeriod[];
  material_limit_overrides: MaterialLimit[];
};
export type BasketRead = {
  basket_number: number;
  basket_volume: number;
  id: number;
};
export type SearchContextData = {
  materials_id: number;
  product_groups_id: number | null;
  steel_grades_id: number;
  material_physics_id: number;
  material_limit_set_id: number;
  fixed_mix_set_id: number;
  has_default_sets: boolean;
  product_groups: ProductGroup[];
  chef_groups: ChefGroup[];
  steel_grades: SteelGrade[];
  materials: MaterialRead[];
  material_physics: MaterialPhysics[];
  material_chemistry: MaterialChemistry[];
  material_limits: MaterialLimitRead[];
  /** Base fixed mixes from the context's fixed_mix_set */
  fixed_mixes: FixedMixOverride[];
  baskets: BasketRead[];
  chemical_elements: ChemicalElement[];
};
export type NameBasedInventoryItem = {
  material_name: string;
  quantity: number | null;
  specific_price: number | null;
  previous_quantity?: number | null;
  deliveries_since_previous?: number | null;
  consumption_since_previous?: number | null;
  projected_deliveries_since_previous?: number | null;
  projected_consumption_since_previous?: number | null;
};
export type NameBasedMaterialChemistry = {
  material_name: string;
  chemical_element_name: string;
  loc: number;
  scale: number;
};
export type NameBasedMaterialLimitCoefficient = {
  material_constraint_class_name: string;
  coefficient: number;
};
export type NameBasedMaterialLimitBounds = {
  basket_number: number | null;
  min_mass: number | null;
  max_mass: number | null;
  soft_min_mass: number | null;
  soft_max_mass: number | null;
};
export type NameBasedMaterialLimit = {
  chef_group_name: string;
  coefficients: NameBasedMaterialLimitCoefficient[];
  name?: string | null;
  hardness: number;
  bounds: NameBasedMaterialLimitBounds[];
};
export type NameBasedProductGroupPlanItem = {
  product_group_name: string;
  num_heats: number;
};
export type NameBasedProductionPlan = {
  product_group_items: NameBasedProductGroupPlanItem[] | null;
  steel_grade_items: NameBasedSteelGradePlanItem[] | null;
};
export type NameBasedObtainableBundleItem = {
  material_name: string;
  label: string;
  min_obtainable: number | null;
  max_obtainable: number | null;
  specific_price: number | null;
  arrival_probability: number | null;
};
export type NameBasedTargetInventoryItem = {
  material_name: string;
  min_quantity: number | null;
  max_quantity: number | null;
};
export type NameBasedTargetBasketItem = {
  chef_group_name: string;
  target_num_baskets: number;
};
export type NameBasedExclusiveMaterials = {
  material_names: string[];
};
export type NameBasedSearchPeriod = {
  name: string | null;
  start_timestamp: string | null;
  end_timestamp: string | null;
  production_plan: NameBasedProductionPlan;
  obtainable_bundles: NameBasedObtainableBundleItem[];
  target_inventory: NameBasedTargetInventoryItem[];
  target_baskets: NameBasedTargetBasketItem[];
  /** Steel grades held at the given recipe for this period only. A shortfall against a pinned recipe stays in the slack report, and fails the solve in a deployable period. Each entry needs a mix, and a steel grade cannot appear both here and in the search-level fixed_mix_overrides. */
  pinned_mixes?: FixedMixOverride[];
  material_exclusivity: NameBasedExclusiveMaterials[];
  is_deployable: boolean;
  suppress_mix_material_exclusivity_constraints: boolean;
  suppress_min_feasible_mass_constraints: boolean;
  optimisation_objective_weighting: number;
  electrical_energy_price: number;
};
export type NameBasedSearch = {
  search_type: SearchType;
  misc_params: MiscParams;
  physical_parameters: PhysicalParameters;
  inventory: NameBasedInventoryItem[];
  material_chemistry_overrides: NameBasedMaterialChemistry[];
  fixed_mix_overrides: FixedMixOverride[];
  material_limit_overrides: NameBasedMaterialLimit[];
  periods: NameBasedSearchPeriod[];
};
export type NamesMissingFromContext = {
  materials: string[];
  chef_groups: string[];
  product_groups: string[];
  steel_grades: string[];
  chemical_elements: string[];
  constraint_classes: string[];
};
export type NamesAvailableInContext = {
  materials: string[];
  chef_groups: string[];
  product_groups: string[];
  steel_grades: string[];
  chemical_elements: string[];
  constraint_classes: string[];
};
export type ApplyNameBasedSearchDiffResult = {
  search_id: number;
  parent_id: number;
  /** The created search as persisted, after any items with unresolved names were dropped. */
  name_based_search: NameBasedSearch;
  /** Names in the diff that were not found in the search context. Items referencing them were dropped from the created search. */
  names_missing_from_context: NamesMissingFromContext;
  /** For each category with missing names, the valid names the search context offers. None when nothing was missing. */
  names_available_in_context: NamesAvailableInContext | null;
};
export type DiffNameBasedInventoryItem = {
  /** Locally unique identifier for the changed property.In a list of diffs, this should be unique. */
  key: string;
  previous?: NameBasedInventoryItem | null;
  updated: NameBasedInventoryItem | null;
};
export type DiffBool = {
  /** Locally unique identifier for the changed property.In a list of diffs, this should be unique. */
  key: string;
  previous?: boolean | null;
  updated: boolean | null;
};
export type DiffNameBasedObtainableBundleItem = {
  /** Locally unique identifier for the changed property.In a list of diffs, this should be unique. */
  key: string;
  previous?: NameBasedObtainableBundleItem | null;
  updated: NameBasedObtainableBundleItem | null;
};
export type DiffNameBasedTargetInventoryItem = {
  /** Locally unique identifier for the changed property.In a list of diffs, this should be unique. */
  key: string;
  previous?: NameBasedTargetInventoryItem | null;
  updated: NameBasedTargetInventoryItem | null;
};
export type DiffNameBasedTargetBasketItem = {
  /** Locally unique identifier for the changed property.In a list of diffs, this should be unique. */
  key: string;
  previous?: NameBasedTargetBasketItem | null;
  updated: NameBasedTargetBasketItem | null;
};
export type DiffFixedMixOverride = {
  /** Locally unique identifier for the changed property.In a list of diffs, this should be unique. */
  key: string;
  previous?: FixedMixOverride | null;
  updated: FixedMixOverride | null;
};
export type DiffNameBasedProductGroupPlanItem = {
  /** Locally unique identifier for the changed property.In a list of diffs, this should be unique. */
  key: string;
  previous?: NameBasedProductGroupPlanItem | null;
  updated: NameBasedProductGroupPlanItem | null;
};
export type DiffNameBasedSteelGradePlanItem = {
  /** Locally unique identifier for the changed property.In a list of diffs, this should be unique. */
  key: string;
  previous?: NameBasedSteelGradePlanItem | null;
  updated: NameBasedSteelGradePlanItem | null;
};
export type NameBasedSearchPeriodParams = {
  start_timestamp: string | null;
  end_timestamp: string | null;
  optimisation_objective_weighting: number;
  suppress_mix_material_exclusivity_constraints: boolean;
  suppress_min_feasible_mass_constraints: boolean;
  electrical_energy_price: number;
  is_deployable: boolean;
};
export type DiffNameBasedSearchPeriodParams = {
  /** Locally unique identifier for the changed property.In a list of diffs, this should be unique. */
  key: string;
  previous?: NameBasedSearchPeriodParams | null;
  updated: NameBasedSearchPeriodParams | null;
};
export type NameBasedSearchPeriodDiff = {
  name: string | null;
  /** Existence change: true to false removes the period; false to true adds it. */
  is_present?: DiffBool | null;
  /** Diff in available scrap. Entries match by "material_name-label", or material_name alone when the label is empty. */
  available_scrap?: DiffNameBasedObtainableBundleItem[] | null;
  /** Diff in target inventory. Entries match by material_name. */
  target_inventory?: DiffNameBasedTargetInventoryItem[] | null;
  /** Diff in target baskets. Entries match by chef_group_name. */
  target_baskets?: DiffNameBasedTargetBasketItem[] | null;
  /** Diff in pinned mixes. Entries match by steel_grade_name. */
  pinned_mixes?: DiffFixedMixOverride[] | null;
  /** Diff in production groups. Entries match by product_group_name. */
  production_groups?: DiffNameBasedProductGroupPlanItem[] | null;
  /** Diff in production items. Entries match by steel_grade_name. */
  production_items?: DiffNameBasedSteelGradePlanItem[] | null;
  period_params?: DiffNameBasedSearchPeriodParams | null;
};
export type DiffMiscParams = {
  /** Locally unique identifier for the changed property.In a list of diffs, this should be unique. */
  key: string;
  previous?: MiscParams | null;
  updated: MiscParams | null;
};
export type DiffPhysicalParameters = {
  /** Locally unique identifier for the changed property.In a list of diffs, this should be unique. */
  key: string;
  previous?: PhysicalParameters | null;
  updated: PhysicalParameters | null;
};
export type DiffNameBasedMaterialChemistry = {
  /** Locally unique identifier for the changed property.In a list of diffs, this should be unique. */
  key: string;
  previous?: NameBasedMaterialChemistry | null;
  updated: NameBasedMaterialChemistry | null;
};
export type DiffNameBasedMaterialLimit = {
  /** Locally unique identifier for the changed property.In a list of diffs, this should be unique. */
  key: string;
  previous?: NameBasedMaterialLimit | null;
  updated: NameBasedMaterialLimit | null;
};
export type NameBasedSearchDiff = {
  /** Diff in inventory. Entries match by material_name. */
  inventory?: DiffNameBasedInventoryItem[] | null;
  /** Diff in search periods. Periods match by name. */
  periods?: NameBasedSearchPeriodDiff[] | null;
  misc_params?: DiffMiscParams | null;
  physical_parameters?: DiffPhysicalParameters | null;
  /** Diff in material chemistry overrides. Entries match by "chemical_element_name-material_name". */
  material_chemistry_overrides?: DiffNameBasedMaterialChemistry[] | null;
  /** Diff in fixed mix overrides. Entries match by steel_grade_name. */
  fixed_mix_overrides?: DiffFixedMixOverride[] | null;
  /** Diff in material limit overrides. Entries match by "chef_group_name :: name", or chef_group_name alone when the limit is unnamed. */
  material_limit_overrides?: DiffNameBasedMaterialLimit[] | null;
};
export type NameBasedSearchDiffRequest = {
  /** The target search to compare (actual/child) */
  target: NameBasedSearch;
  /** The source search to compare (expected/parent) */
  source: NameBasedSearch;
};
export type DeployedPlanRead = {
  session_id: number;
  search_id: number;
  plan_id: number;
  session_name: string;
  deployed_at: string;
  deployed_by_email: string;
  deployed_by: UserRead;
  start_at: string;
  end_at: string;
  deployment_type: DeploymentType;
  first_period_summary: PeriodSummary;
  parent_id: number | null;
  recipe_codes: string[];
};
export type DeployedPlansRead = {
  items: DeployedPlanRead[];
  limit: number;
  offset: number;
  total: number;
};
export type DeployedPlanDayRead = {
  deployed_on: string;
  plan_count: number;
  plans: DeployedPlanRead[];
};
export type DeployedPlanDaysRead = {
  items: DeployedPlanDayRead[];
  limit: number;
  offset: number;
  total: number;
  plan_total: number;
};
export type ProductionMixResultCreate = {
  name: string;
  description?: string | null;
  production: NameBasedSteelGradePlanItem[];
  mix?: MixCreate | null;
  mix_id?: number | null;
};
export type LayerSource = "per_basket_totals" | "manual";
export type ChildMixUpdate = {
  parent_mix_ids: number[];
  new_mix_production: ProductionMixResultCreate;
  layer_source?: LayerSource | null;
};
export type PlanMixPeriodUpdates = {
  period: number;
  /** Mapping from existing mix IDs to ones to replace them with */
  replacements: {
    [key: string]: number;
  };
  /** List of specifications for how to update mixes. Each entry is a list of `mix_id`s to be mapped to the specified production items and target mix. If multiple `mix_id`s are specified, the entry represents a merge; if the same `mix_id` appears multiple times, it represents a split into multiple mixes. */
  updates?: ChildMixUpdate[];
};
export type PlanMixUpdates = {
  period_updates: PlanMixPeriodUpdates[];
  comment?: string | null;
  layer_source?: LayerSource;
};
export type DeployedPlanMixUpdates = {
  period_updates: PlanMixPeriodUpdates[];
  comment?: string | null;
  layer_source?: LayerSource;
  start_at: string;
  end_at: string;
  deployment_type: DeploymentType;
};
export type PublishPreflightVerdict = "unchanged" | "moved" | "new";
export type PublishPreflightMaterialPresence = "in_both" | "added" | "removed";
export type PublishPreflightMaterialDelta = {
  material_name: string;
  /** Whether the material is in both mixes, or in only one. */
  presence: PublishPreflightMaterialPresence;
  /** Mass of the material per heat in the baseline mix. Zero when the material is absent from that mix. */
  baseline_mass_per_heat: number;
  /** Mass of the material per heat in the candidate mix. Zero when the material is absent from that mix. */
  candidate_mass_per_heat: number;
  /** Candidate mass minus baseline mass, per heat. A positive value means the mix charges more of the material. */
  change_mass_per_heat: number;
};
export type PlanComparisonSavingClass = "reportable" | "within_noise" | "none";
export type ChefGroupPlanComparison = {
  chef_group_id: number;
  chef_group_name: string;
  /** NEW means the baseline period holds no mix for this chef group. */
  verdict: PublishPreflightVerdict;
  /** Basket materials whose mass per heat moves. Empty when the verdict is not MOVED. */
  material_deltas: PublishPreflightMaterialDelta[];
  /** Null when the verdict is NEW, and when a material either mix charges has no current price. */
  baseline_material_cost_per_tonne_at_current_prices: number | null;
  /** Null when the verdict is NEW, and when a material either mix charges has no current price. */
  candidate_material_cost_per_tonne_at_current_prices: number | null;
  /** Baseline material cost per tonne minus the candidate. A positive value means the candidate mix is cheaper. Null when either cost is null. */
  saving_per_tonne: number | null;
  /** REPORTABLE when the cost gap exceeds the noise floor in either direction, WITHIN_NOISE when rounding the recipe could account for all of it, NONE when there is no cost to compare. */
  saving_class: PlanComparisonSavingClass;
  /** Material cost gap per tonne that rounding the recipe to the plant's units can produce on its own. Null when either cost is null. */
  noise_floor_per_tonne: number | null;
};
export type PlanPeriodComparison = {
  plan_id: number;
  period: number;
  baseline_plan_id: number;
  baseline_period: number;
  /** When the comparison read the latest material prices. */
  priced_at: string;
  items: ChefGroupPlanComparison[];
};
export type MixDifference = {
  source_mix_id: number;
  target_mix_id: number;
  basket_number: number;
  material_name: string;
  material_id: number;
  addition_location: string;
  source_value: number;
  target_value: number;
  value_difference: number;
  unit: MaterialQuantityUnit;
};
export type MixDifferenceRead = {
  source_mix_id: number;
  target_mix_id: number;
  basket_number: number;
  material_name: string;
  material_id: number;
  addition_location: string;
  source_value: number;
  target_value: number;
  value_difference: number;
  unit: MaterialQuantityUnit;
  source_mass: number;
  target_mass: number;
  mass_difference: number;
};
export type LayerDeleted = {
  kind: "delete";
  basket_number: number;
  /** Position of the deleted layer in the source mix. */
  layer_number: number;
  material_name: string;
  value: number;
  unit: MaterialQuantityUnit;
};
export type LayerInserted = {
  kind: "insert";
  basket_number: number;
  /** Position of the inserted layer in the target mix. */
  layer_number: number;
  material_name: string;
  value: number;
  unit: MaterialQuantityUnit;
};
export type LayerUpdated = {
  kind: "update";
  basket_number: number;
  source_layer_number: number;
  target_layer_number: number;
  source_material_name: string;
  source_value: number;
  source_unit: MaterialQuantityUnit;
  target_material_name: string;
  target_value: number;
  target_unit: MaterialQuantityUnit;
};
export type MixDifferences = {
  source_mix_id: number;
  target_mix_id: number;
  target_steel_grade_names: string[];
  differences: MixDifference[];
  layer_differences: (
    | ({
        kind: "delete";
      } & LayerDeleted)
    | ({
        kind: "insert";
      } & LayerInserted)
    | ({
        kind: "update";
      } & LayerUpdated)
  )[];
};
export type MixDifferencesRead = {
  source_mix_id: number;
  target_mix_id: number;
  target_steel_grade_names: string[];
  differences: MixDifferenceRead[];
  layer_differences: (
    | ({
        kind: "delete";
      } & LayerDeleted)
    | ({
        kind: "insert";
      } & LayerInserted)
    | ({
        kind: "update";
      } & LayerUpdated)
  )[];
};
export type PlanDifferenceSummary = {
  source_display_cost_per_tonne: number;
  target_display_cost_per_tonne: number;
};
export type PlanDifferences = {
  source_plan_id: number;
  target_plan_id: number;
  differences: MixDifferences[];
  target_created_by_name: string;
  target_created_at: string;
  target_comment: string | null;
  target_deployments: Deployment[];
  summary: PlanDifferenceSummary;
};
export type PlanDifferencesRead = {
  source_plan_id: number;
  target_plan_id: number;
  differences: MixDifferencesRead[];
  target_created_by_name: string;
  target_created_at: string;
  target_comment: string | null;
  target_deployments: Deployment[];
  summary: PlanDifferenceSummary;
};
export type PlanAncestorDiffs = {
  plan_id: number;
  ancestors: PlanDifferences[];
};
export type PlanAncestorDiffsRead = {
  plan_id: number;
  ancestors: PlanDifferencesRead[];
};
export type PlanBackupSummary = {
  session_id: number;
  session_name: string;
  display_name: string;
  search_id: number;
  plan_id: number | null;
  status: OptimisationStatus;
  display_cost_per_tonne: number | null;
};
export type PlanBackupSummaries = {
  backups: PlanBackupSummary[];
};
export type CopiedPlanSteelGrades = {
  new_plan_id: number | null;
  target_plan_id: number;
  source_search_id: number | null;
  source_plan_id: number | null;
  copied_mix_steel_grade_names: {
    [key: string]: string[];
  };
};
export type DeploymentHistory = {
  session_id: number;
  search_id: number;
  username: string;
  email: string;
  deployed_at: string;
  plan_id: number;
};
export type SessionSummary = {
  session_id: number;
  name: string;
  created_by_current_user: boolean;
  user_email: string;
  user: UserRead;
  created_at: string;
  search_count: number;
  searches_not_started: number;
  searches_running: number;
  searches_failed: number;
  searches_succeeded: number;
  deployment_history: DeploymentHistory[];
  last_search_id: number;
};
export type SessionCreate = {
  name: string;
  search_type: SearchType;
  deleted?: boolean;
};
export type SessionMajorVersion = {
  search_id: number;
  version_number: number;
  status: SearchStatus;
  user: UserRead;
  created_at: string;
};
export type SessionMajorVersions = {
  session_id: number;
  versions: SessionMajorVersion[];
};
export type RenameSession = {
  name: string;
};
export type CopySearch = {
  name: string | null;
};
export type ResultsRead = {
  plan_id: number;
  optimisation_status: OptimisationStatus;
  periods: {
    [key: string]: ResultsPeriodRead;
  };
  slack_variable_usage: OptimisationSlackVariableUsage[];
  summary: NameBasedSummary;
};
export type UploadedFileState = "new" | "parsed";
export type FileMeta = {
  name: string;
  updated_at: string | null;
};
export type UploadedFileMeta = {
  id: number;
  uploaded_at: string;
  uploaded_by_id: string;
  type: string;
  deleted: boolean;
  state: UploadedFileState;
  file: FileMeta;
};
export type File = {
  name?: string;
  updated_at?: string | null;
  content: string;
};
export type UploadedFileCreate = {
  type: string;
  file: File;
};
export type UploadedFileRead = {
  type: string;
  file: File;
  id: number;
  uploaded_at: string;
  uploaded_by_id: string;
  deleted: boolean;
  state: UploadedFileState;
};
export type UploadedFileTypeList = {
  items: string[];
};
export type UploadedFileOutputType =
  | "steel_grade_plan"
  | "product_group_plan"
  | "purchasing_plan"
  | "material_inputs";
export type UploadedFileOutputTypeList = {
  items: UploadedFileOutputType[] | null;
};
export type MaterialAvailability = {
  material_id: number;
  inventory: number | null;
  obtainable_min: number | null;
  obtainable_max: number | null;
  inventory_target_min: number | null;
  inventory_target_max: number | null;
  price: number | null;
};
export type UploadedSearchParameters = {
  unrecognised_names: string[] | null;
  steel_grade_plan: SteelGradePlanItem[] | null;
  availabilities: MaterialAvailability[] | null;
};
export type PublishedChargeScheduleLayeringItem = {
  ChargeNum: number;
  LayerNum: number;
  Weight: number;
  ScrapID: number;
  Description: string;
};
export type PublishedChargeScheduleLayering = {
  plan_id: number;
  period: number;
  chef_group_id: number;
  mix_number: number;
  layering: PublishedChargeScheduleLayeringItem[];
};
export type PublishedChargeScheduleType = string;
export type PublishedChargeScheduleSteelGrade = {
  BilletSize: string;
  MeltGrade: string;
  FinishGoodCode: string;
};
export type PlanPublishedChargeScheduleRead = {
  /** Internal ID used by FDM for a charge schedule */
  fdm_charge_schedule_id: number;
  /** Charge schedule type code used by the plant */
  cmc_charge_schedule_type: PublishedChargeScheduleType;
  steel_grades: PublishedChargeScheduleSteelGrade[];
  layering: PublishedChargeScheduleLayeringItem[];
  /** UTC timestamp of the start of the period for which the charge schedule is valid */
  start_timestamp: string;
  /** UTC timestamp of the end of the period for which the charge schedule is valid */
  end_timestamp: string;
  period: number;
  plan_id: number;
};
export type ChefGroupChargeScheduleOverride = {
  chef_group_id: number;
  manual_heat_override: string;
};
export type PublishPlanCreate = {
  plan_id: number;
  period: number;
  /** Chef groups to publish. Omit to publish every deployable chef group in the period. */
  chef_group_ids?: number[] | null;
  chef_group_overrides?: ChefGroupChargeScheduleOverride[];
};
export type PublishPlans = {
  plans: PublishPlanCreate[];
  manual_heat_override?: string | null;
};
export type PublishedChargeScheduleRead = {
  /** Internal ID used by FDM for a charge schedule */
  fdm_charge_schedule_id: number;
  /** Charge schedule type code used by the plant */
  cmc_charge_schedule_type: PublishedChargeScheduleType;
  steel_grades: PublishedChargeScheduleSteelGrade[];
  layering: PublishedChargeScheduleLayeringItem[];
  /** UTC timestamp of the start of the period for which the charge schedule is valid */
  start_timestamp: string;
  /** UTC timestamp of the end of the period for which the charge schedule is valid */
  end_timestamp: string;
};
export type ChargeScheduleConfirm = {
  /** Internal ID used by FDM for a charge schedule */
  fdm_charge_schedule_id: number;
  /** Charge schedule ID in the plant Level 2 database */
  cmc_charge_schedule_id: string;
};
export type ConfirmedChargeScheduleMeta = {
  fdm_charge_schedule_id: number;
  cmc_charge_schedule_id: string;
  plan_id: number;
  period: number;
  chef_group_id: number;
  mix_number: number;
};
export type PublishPreflightBaselineState =
  "confirmed" | "awaiting_confirmation" | "absent" | "unreadable";
export type PublishPreflightBaseline = {
  /** Internal ID used by FDM for a charge schedule */
  published_charge_schedule_id: number;
  /** Charge schedule ID in the plant Level 2 database */
  cmc_charge_schedule_id: string;
  /** Plan that the acknowledged charge schedule comes from. */
  plan_id: number;
  /** Period of that plan that the charge schedule covers. */
  period: number;
  /** Chef group the charge schedule was published under. A chef group id belongs to one grouping version, so this differs from the id the report is keyed by when the plant was re-grouped after this send. */
  chef_group_id: number;
  /** When the charge schedule went to Level 2. */
  published_at: string;
};
export type PublishPreflightUnconfirmedSchedule = {
  /** Internal ID used by FDM for a charge schedule */
  published_charge_schedule_id: number;
  /** Plan that the unconfirmed charge schedule comes from. */
  plan_id: number;
  /** Period of that plan that the charge schedule covers. */
  period: number;
  /** When the charge schedule went to Level 2. */
  published_at: string;
};
export type PublishPreflightConsumptionRole =
  "selected" | "held" | "uncounted" | "unreadable";
export type ChefGroupPublishPreflight = {
  chef_group_id: number;
  chef_group_name: string;
  /** How the mix waiting to be published compares with the mix Level 2 holds now. */
  verdict: PublishPreflightVerdict;
  /** Whether Level 2 acknowledged the last charge schedule sent for this chef group. */
  baseline_state: PublishPreflightBaselineState;
  /** The acknowledged charge schedule the comparison uses. Null when Level 2 holds none for this chef group. */
  baseline: PublishPreflightBaseline | null;
  /** The newest charge schedule sent for this chef group, while Level 2 has not confirmed it. A publish of the same plan and period is refused until Level 2 confirms it. Null when the newest charge schedule is confirmed, or when Level 2 holds none. */
  unconfirmed_schedule: PublishPreflightUnconfirmedSchedule | null;
  /** Materials whose charged mass per heat moves. Empty when the verdict is not MOVED. */
  material_deltas: PublishPreflightMaterialDelta[];
  /** Material cost per tonne of the mix Level 2 holds now, priced with the latest material prices. Null when Level 2 holds no mix for this chef group. */
  baseline_material_cost_per_tonne_at_current_prices: number | null;
  /** Material cost per tonne of the mix waiting to be published, priced with the latest material prices. Null when Level 2 holds no mix to compare with. */
  candidate_material_cost_per_tonne_at_current_prices: number | null;
  /** How the joint closing balances count this chef group. SELECTED charges the candidate mix. HELD is not selected and keeps charging the mix Level 2 holds. UNCOUNTED is not selected and Level 2 holds no mix for it, so it charges nothing. UNREADABLE is not selected and the mix Level 2 holds cannot be read, so its draw is unknown. */
  consumption_role: PublishPreflightConsumptionRole;
};
export type MaterialClosingBalanceState =
  "covered" | "short" | "within_noise" | "inventory_unknown";
export type MaterialClosingBalance = {
  material_name: string;
  /** Mass on hand at the start of the period, as the candidate plan projects it. Null when the inventory snapshot carries no quantity for the material. */
  initial_inventory: number | null;
  /** Mass the selected chef groups charge over the period: the candidate mixes as the plant charges them, at the candidate heat counts. */
  selected_consumption: number;
  /** Mass the held chef groups charge over the period: the mixes Level 2 holds as the plant charges them, at the candidate heat counts. */
  held_consumption: number;
  /** Initial inventory minus both consumptions, without material obtained during the period. Null when the initial inventory is unknown. */
  closing_balance: number | null;
  /** COVERED when the initial inventory covers both consumptions. WITHIN_NOISE when the shortfall is at most one rounding unit for each heat that charges the material. SHORT when it is larger. INVENTORY_UNKNOWN when the inventory snapshot carries no quantity for the material. */
  state: MaterialClosingBalanceState;
};
export type PublishPreflight = {
  plan_id: number;
  period: number;
  items: ChefGroupPublishPreflight[];
  /** One entry for each material a selected or held chef group charges over the period. Empty when any chef group is UNREADABLE, because the total draw is then unknown. */
  joint_closing_balances: MaterialClosingBalance[];
};
export type ChargeScheduleMessage = {
  text: string;
  plan_id: number;
  period: number;
};
export type ChargeScheduleMessages = {
  charge_schedule_messages: ChargeScheduleMessage[];
};
export type ActiveChargeScheduleMaterials = {
  area: string;
  charge_schedule_id: string | null;
  bucket_number: number | null;
  planned_material_names: string[] | null;
  active_from: string;
};
export type ActiveChargeSchedules = {
  charge_schedules: ActiveChargeScheduleMaterials[];
};
export type Message = {
  id: number;
  message: string;
  sent: boolean;
  created_by_id: string;
  created_at: string;
};
export type MessageFilter = "sent" | "queued" | "all";
export type AddSentMessageRequest = {
  text: string;
  created_at?: string | null;
};
export type InventoryMeasurementItem = {
  material_name: string;
  quantity: number;
  quantity_scrap_bay: number;
  quantity_yard: number;
  quantity_rail_car: number;
  quantity_scrap_bay_estimate: number;
};
export type DeliveryMeasurementItem = {
  material_name: string;
  quantity: number;
  source: string;
};
export type InventoryMeasurementSetCreate = {
  items: InventoryMeasurementItem[];
  delivery_items?: DeliveryMeasurementItem[];
};
export type InventoryEstimateItem = {
  material_id: number;
  quantity: number | null;
  specific_price: number | null;
  previous_quantity: number | null;
  deliveries_since_previous: number | null;
  consumption_since_previous: number | null;
  projected_deliveries_since_previous: number | null;
  projected_consumption_since_previous: number | null;
  material_name: string;
};
export type InventoryEstimate = {
  latest_delivery_data_timestamp: UtcTimestamp | null;
  last_inventory_report_timestamp: UtcTimestamp;
  items: InventoryEstimateItem[];
};
export type InventoryBreakdownItem = {
  date: UtcTimestamp;
  material_name: string;
  quantity: number;
  location: string;
  source: string;
  specific_price: number;
};
export type InventoryBreakdown = {
  items: InventoryBreakdownItem[];
};
export type LatestInventoryMeasurementTimestamp = {
  created_at: string | null;
};
export type InventoryMeasurementComplianceItem = {
  material_name: string;
  quantity_scrap_bay_estimate: number;
  quantity_scrap_bay: number;
  diff_mass: number;
  diff_mass_fraction: number;
};
export type InventoryMeasurementCompliance = {
  measurement_set_id: number;
  created_at: UtcTimestamp;
  items: InventoryMeasurementComplianceItem[];
  total_diff_mass_fraction: number;
  compliance_score: number;
};
export type TargetBasketSetRead = {
  items: TargetBasketItem[];
  id: number;
  default: boolean;
  source: EntitySource;
  created_at: string;
};
export type TargetBasketSetCreate = {
  items: TargetBasketItem[];
};
export type UpdateDefaultTargetBasketSetRequest = {
  source_target_basket_set_id: number;
  items: TargetBasketItem[];
};
export type FeasibilityBound = {
  basket_id?: number | null;
  min_mass?: number | null;
  max_mass?: number | null;
  soft_min_mass?: number | null;
  soft_max_mass?: number | null;
};
export type FeasibilityMaterialLimit = {
  chef_group_id: number;
  coefficients: MaterialLimitCoefficientCreate[];
  bounds: FeasibilityBound[];
};
export type CheckParameterFeasibilityRequest = {
  material_physics_overrides?: MaterialPhysicsOverride[] | null;
  /** Measurements to replace or add by material and element. Omitted measurements retain their default values. */
  material_chemistry_overrides?: MaterialChemistry[] | null;
  material_limits?: FeasibilityMaterialLimit[] | null;
  /** Basket-count overrides by chef group. Omitted groups use their default counts. */
  target_baskets?: TargetBasketItem[] | null;
};
export type Permission =
  | "review"
  | "publish"
  | "edit"
  | "read"
  | "review_mix"
  | "video_labelling"
  | "video_label_reviewing"
  | "loading_edit_proposing"
  | "manage_labellers"
  | "crane_driver"
  | "delivery_form"
  | "crane_supervisor"
  | "crane_supervisor_viewer"
  | "manage_overrides_catalog"
  | "view_override_history"
  | "edit_override_history"
  | "scrap_tracking_dashboard_viewer"
  | "scrap_eye_ingest"
  | "scrap_eye_manager"
  | "upload_file_write"
  | "purchasing_admin"
  | "scenario_planning"
  | "analytics_admin"
  | "strategy_dashboard_admin"
  | "strategy_dashboard_inventory"
  | "strategy_dashboard_consumption"
  | "strategy_dashboard_production"
  | "strategy_dashboard_quality"
  | "strategy_dashboard_cost"
  | "strategy_dashboard_prices"
  | "strategy_dashboard_heats"
  | "strategy_dashboard_scrap_chef_usage"
  | "strategy_dashboard_deliveries"
  | "strategy_dashboard_compliance"
  | "strategy_dashboard_consumption_projection"
  | "strategy_dashboard_editing"
  | "strategy_dashboard_crew_comparison"
  | "strategy_dashboard_schedule"
  | "strategy_dashboard_savings"
  | "manage_target_baskets"
  | "plan_recipient"
  | "render_artefact"
  | "clark_user"
  | "read_clark_directory";
export type AddUsersRequest = {
  emails: string[];
  permissions: Permission[];
  send_email?: boolean;
};
export type GenerateSignInLinkResponse = {
  sign_in_link: string;
};
export type GenerateSignInLinkRequest = {
  email: string;
};
export type SendInviteEmailRequest = {
  email: string;
};
export type InvitedUser = {
  email: string;
  permissions: Permission[];
  is_active: boolean;
  invited_at: string;
  accepted_at: string | null;
};
export type LabelCoveragePriority =
  | "breadth"
  | "depth"
  | "last_calendar_day_then_breadth"
  | "last_calendar_day_then_depth"
  | "recent_breadth"
  | "recent_depth";
export type NoReservationBehaviour = "no_reservation" | "fallback";
export type LabelReservationSettingsRead = {
  id: number;
  name: string;
  label_coverage_priority: LabelCoveragePriority;
  reserve_from: string | null;
  reserve_until: string | null;
  recent_window_buffer_hours: number;
  max_duration_seconds: number | null;
  allowed_coverage_gap_seconds: number | null;
  required_angles: string | null;
  maximum_number_of_labellers: number | null;
  target_number_of_labellers: number | null;
  location: string | null;
  ignore_coverage: boolean;
  no_reservation_behaviour: NoReservationBehaviour;
  fallback_priority: number | null;
  default: boolean;
  created_at: string;
  created_by_id: string;
};
export type LabelReservationSettingsList = {
  items: LabelReservationSettingsRead[];
};
export type LabelReservationSettingsCreate = {
  name: string;
  label_coverage_priority: LabelCoveragePriority;
  reserve_from?: string | null;
  reserve_until?: string | null;
  recent_window_buffer_hours?: number;
  max_duration_seconds?: number | null;
  allowed_coverage_gap_seconds?: number | null;
  required_angles?: string | null;
  maximum_number_of_labellers?: number | null;
  target_number_of_labellers?: number | null;
  location?: string | null;
  ignore_coverage?: boolean;
  no_reservation_behaviour?: NoReservationBehaviour;
  fallback_priority?: number | null;
};
export type LabelReservationSettingsUpdate = {
  name?: string | null;
  label_coverage_priority?: LabelCoveragePriority | null;
  reserve_from?: string | null;
  reserve_until?: string | null;
  recent_window_buffer_hours?: number | null;
  max_duration_seconds?: number | null;
  allowed_coverage_gap_seconds?: number | null;
  required_angles?: string | null;
  maximum_number_of_labellers?: number | null;
  target_number_of_labellers?: number | null;
  location?: string | null;
  ignore_coverage?: boolean | null;
  no_reservation_behaviour?: NoReservationBehaviour | null;
  fallback_priority?: number | null;
};
export type UserSettingsAssignmentRead = {
  id: number;
  user_id: string;
  settings_id: number;
  assigned_at: string;
  user_name: string | null;
  user_email: string | null;
  settings_name: string | null;
};
export type UserSettingsAssignmentList = {
  items: UserSettingsAssignmentRead[];
};
export type UserSettingsAssignment = {
  user_id: string;
  settings_id: number;
};
export type ShiftInfo = {
  day: number;
  time: "day" | "night";
  crew: string;
};
export type ChargeSummary = {
  planned: {
    [key: string]: number;
  };
  loaded: {
    [key: string]: number;
  };
  predicted_load: {
    [key: string]: number;
  };
  labelled_load: {
    [key: string]: number;
  };
  prices: {
    [key: string]: number;
  };
  start: string;
  end: string | null;
  labelled_coverage: {
    [key: string]: number;
  };
  labelled_periods: {
    [key: string]: [string, string][];
  };
};
export type HeatSummary = {
  heat_id: string;
  start: string;
  end: string;
  shift: ShiftInfo;
  charges: ChargeSummary[] | null;
  /** Distinct materials in the heat's planned recipe. */
  planned_material_names: string[] | null;
};
export type ReviewPeriodData = {
  id: number;
  location_id: number;
  start: string;
  end: string;
  verified_by_id: string | null;
  verified_by_name: string | null;
  verified_at: string | null;
  assigned_to_id: string | null;
  assigned_to_name: string | null;
  assigned_at: string | null;
  created_at: string;
  tool_session_id: number | null;
};
export type EventType = "lift" | "drop" | "flag";
export type ReviewTimelineTickFlag =
  "consumption" | "railcar_arrival" | "railcar_departure";
export type ReviewReason =
  | "too_few_examples"
  | "missing_labels"
  | "incompatible_labels"
  | "incompatible_timing"
  | "ambiguous_matching"
  | "invalid_sequence"
  | "comment"
  | "false_positive"
  | "false_negative"
  | "low_confidence_event"
  | "low_confidence_material"
  | "low_confidence_area"
  | "likely_error"
  | "confusable_material"
  | "unplanned_material"
  | "railcar_disagreement"
  | "mass_outlier"
  | "duplicate_mass";
export type ReviewTimelineTick = {
  id: number;
  start: UtcTimestamp;
  event_type: EventType | null;
  material: string | null;
  area: string | null;
  comment: string | null;
  flags: ReviewTimelineTickFlag[];
  verified: boolean;
  targeted_review_reasons: ReviewReason[];
};
export type LoadingWindowAssignment = {
  bucket_id: string;
  start: string;
  end: string;
  heat_id: string;
  basket_number: number | null;
  load_id: number | null;
  raw_segment_start: string | null;
};
export type ReviewDayOverview = {
  heats: HeatSummary[];
  review_periods: ReviewPeriodData[];
  ticks: ReviewTimelineTick[];
  /** Per-basket loading windows, for associating a time with a heat. */
  loading_windows: LoadingWindowAssignment[] | null;
};
export type LocationReviewPeriods = {
  location_name: string;
  review_periods: ReviewPeriodData[];
};
export type SiteReviewPeriods = {
  locations: LocationReviewPeriods[];
};
export type ReviewPeriodStatusCounts = {
  verified: number;
  assigned_to_me: number;
  assigned_to_other: number;
  unassigned: number;
};
export type ReviewDaySummary = {
  date: string;
  review_period_counts: ReviewPeriodStatusCounts;
  commented_verified_events: number;
  consumption_events: number | null;
  filtered_event_count: number | null;
  likely_error_count: number | null;
  random_check_count: number | null;
};
export type ReviewMonthProjection = "full" | "targeted_summary";
export type ReviewMonthSummary = {
  days: ReviewDaySummary[];
  projection_applied: ReviewMonthProjection | null;
};
export type ReviewCountCategory = "commented" | "consumption";
export type ReviewEventLimit = "verified" | "model";
export type FilterDimension = "material" | "area" | "event_type";
export type MaterialAreaFilter = {
  material: string | null;
  area: string | null;
  event_type: EventType | null;
  limit_to: ReviewEventLimit | null;
  negated?: FilterDimension[];
};
export type MaterialAreaFilterList = {
  items: MaterialAreaFilter[];
};
export type EventData = {
  event_type: EventType;
  start: UtcTimestamp;
  end: UtcTimestamp;
};
export type LabelType =
  | "material"
  | "co_material"
  | "crane"
  | "scrap_car"
  | "mass"
  | "heat_id"
  | "comment"
  | "area"
  | "event_confidence"
  | "material_confidence"
  | "area_confidence"
  | "mass_confidence"
  | "initial_mass"
  | "final_mass";
export type LabelData = {
  label_type: LabelType;
  label: string;
};
export type Label = {
  id: number;
  created_at: UtcTimestamp;
  data: LabelData;
};
export type EventReservation = {
  reserved_by_id: string;
  reserved_until: UtcTimestamp;
  label_type: LabelType;
};
export type LabellerType = "human" | "model";
export type EventLabellingModelStatus = "unused" | "passive" | "active";
export type LabellerDetails = {
  id: string;
  name: string | null;
  email: string | null;
  labeller_type: LabellerType;
  model_status: EventLabellingModelStatus | null;
};
export type Event = {
  id: number;
  created_at: UtcTimestamp;
  data: EventData;
  labels: Label[];
  reservations: EventReservation[];
  labelled_by: LabellerDetails;
  labelling_period_id: number | null;
  label_review_period_id: number | null;
};
export type CommentedEvent = {
  event: Event;
  comment: string;
  commenter: LabellerDetails;
  location_name: string;
  verified_at: string;
  last_edited_at: string | null;
  last_edited_by: LabellerDetails | null;
  reviewed_at: string | null;
  reviewed_by: LabellerDetails | null;
};
export type CommentedEventsList = {
  commented_events: CommentedEvent[];
};
export type ReviewSlotRevision = {
  start: string;
  end: string;
  revision_id: number | null;
};
export type EventCreate = {
  event: EventData;
  labels: LabelData[];
};
export type MassOutlierBand = {
  material: string;
  low: number;
  high: number;
  n_events: number;
};
export type ReviewEvent = {
  merged: EventCreate;
  mass_event: EventCreate | null;
  original_events: Event[];
  review_reasons: ReviewReason[];
  /** The band a model's mass for this event falls outside. */
  mass_outlier_band: MassOutlierBand | null;
};
export type LabellerPeriod = {
  period_id: number;
  start: string;
  end: string;
  events: Event[];
};
export type LabellerTimeline = {
  labeller: LabellerDetails;
  periods: LabellerPeriod[];
};
export type TimelineFeature = "material" | "timing" | "all";
export type DefaultTimelineExclusion = {
  labeller_type: LabellerType;
  feature: TimelineFeature;
  model_status: EventLabellingModelStatus | null;
};
export type TimelineExclusionMode = "explicit" | "server_defaults";
export type TimelineExclusionPeriodIds = {
  all: number[];
  material: number[];
  timing: number[];
};
export type RandomReview = "selected" | "not_selected";
export type TargetedReviewPeriod = {
  period_id: number | null;
  start: string;
  end: string;
  flagged_count: number;
  random_review: RandomReview;
};
export type RailcarSlotMaterialSpan = {
  area: string;
  material: string;
  start: UtcTimestamp;
  end: UtcTimestamp;
};
export type EventsForReview = {
  review_slot_revisions: ReviewSlotRevision[];
  review_events: ReviewEvent[];
  labeller_timelines: LabellerTimeline[];
  exclude_material_from_labellers_by_default: string[];
  default_timeline_exclusions: DefaultTimelineExclusion[];
  exclusion_mode_applied: TimelineExclusionMode | null;
  applied_exclusions: TimelineExclusionPeriodIds | null;
  targeted_review_periods: TargetedReviewPeriod[];
  railcar_slot_materials: RailcarSlotMaterialSpan[];
  mass_outlier_bands: MassOutlierBand[];
};
export type ClientIdentifiedEvent = {
  client_id: string;
  event: EventData;
  labels: LabelData[];
};
export type CorrectedEventsForPeriods = {
  expected_slot_revisions?: ReviewSlotRevision[] | null;
  period_ids: number[];
  original_events: ClientIdentifiedEvent[];
  corrected_events: ClientIdentifiedEvent[];
  active_review_seconds?: number | null;
  session_started_at?: string | null;
  location?: string | null;
  verify_period_starts?: string[];
};
export type UnverifiedReviewPeriodData = {
  review_periods: ReviewPeriodData[];
};
export type AssignedReviewPeriod = {
  start: string;
  end: string;
  assigned_at: string | null;
};
export type AssignedReviewPeriodsResponse = {
  periods: AssignedReviewPeriod[];
};
export type LabellerTimelinesReport = {
  labeller_timelines: LabellerTimeline[];
  default_timeline_exclusions: DefaultTimelineExclusion[];
};
export type EventsList = {
  events: Event[];
};
export type LabellingReservation = {
  labelling_period_id: number;
  start: UtcTimestamp;
  end: UtcTimestamp;
  reserved_until: UtcTimestamp;
  location: string;
};
export type EventsCreate = {
  events: EventCreate[];
  completed_labelling_reservations: LabellingReservation[];
  active_labelling_seconds?: number | null;
};
export type LabellingReservations = {
  reservations: LabellingReservation[];
  candidate_events: EventCreate[];
  railcar_slot_materials: RailcarSlotMaterialSpan[];
};
export type MaterialEventPair = {
  pair_id: string;
  lift: Event;
  drop: Event;
};
export type MaterialExamplesList = {
  material: string;
  location: string;
  pairs: MaterialEventPair[];
};
export type VerifiedEventComparison = {
  verified_event: Event | null;
  comparison_event: Event | null;
  conflict_reasons: ReviewReason[];
};
export type LabellerVerifiedEventsComparison = {
  labeller: LabellerDetails;
  comparisons: VerifiedEventComparison[];
  all_labeller_events: Event[];
  all_verified_events: Event[];
};
export type TimeRangeFilterMode = "real_time" | "label_time";
export type ToolSessionType = "labelling" | "reviewing";
export type DailySessionDetail = {
  session_id: string;
  session_type: ToolSessionType;
  location_name: string;
  footage_start_at: string;
  footage_end_at: string;
};
export type DailyLabellerStatsEntry = {
  date: string;
  time_labelled_seconds: number;
  time_spent_labelling_seconds: number;
  submissions: number;
  sessions: DailySessionDetail[];
};
export type DailyLabellerStatsResponse = {
  daily_stats: DailyLabellerStatsEntry[];
};
export type ConfusionMatrixEntry = {
  predicted: string;
  actual: string;
  count: number;
};
export type LabellerAccuracyStats = {
  matched_events: number;
  total_verified_events: number;
  total_labeller_events: number;
  match_accuracy: number | null;
  area_accuracy: number | null;
  material_accuracy: number | null;
  average_timing_iou: number | null;
  material_confusion_matrix: ConfusionMatrixEntry[];
  area_confusion_matrix: ConfusionMatrixEntry[];
  location_names: string[];
};
export type LabellerStatsEntry = {
  labeller: LabellerDetails;
  total_time_labelled_seconds: number;
  total_time_spent_labelling_seconds: number | null;
  total_submissions: number;
  total_periods: number;
  events_created: number;
  accuracy: LabellerAccuracyStats | null;
};
export type ReviewerStatsEntry = {
  reviewer: LabellerDetails;
  total_time_reviewed_seconds: number;
  total_time_spent_reviewing_seconds: number | null;
  total_submissions: number;
  periods_reviewed: number;
};
export type LabellerCostStatsResponse = {
  labeller_stats: LabellerStatsEntry[];
  reviewer_stats: ReviewerStatsEntry[];
};
export type MatchedEventRow = {
  labeller_event_id: number;
  verified_event_id: number;
  labeller_start: string;
  labeller_end: string;
  predicted_material: string;
  actual_material: string;
  predicted_area: string;
  actual_area: string;
  timing_iou: number;
};
export type MatchedEventsResponse = {
  rows: MatchedEventRow[];
};
export type AccuracyMetric = "material" | "area" | "timing";
export type LabellingCoverageBucket = {
  start: string;
  end: string;
  labellable_fraction: number;
  labelled_by_passes: {
    [key: string]: number;
  };
  verified_fraction: number;
};
export type LocationLabellingCoverage = {
  location_name: string;
  buckets: LabellingCoverageBucket[];
  summary: LabellingCoverageBucket;
};
export type TenantLabellingCoverage = {
  tenant_name: string;
  coverage_by_location: {
    [key: string]: LocationLabellingCoverage;
  };
  buckets: LabellingCoverageBucket[];
  summary: LabellingCoverageBucket;
};
export type LabellingCoverageGranularity =
  "period" | "hourly" | "daily" | "weekly" | "monthly";
export type LocationsLoadingBucket = {
  start: string;
  end: string;
  loading_location_names: string[];
};
export type LocationsLoadingTimeline = {
  locations: string[];
  buckets: LocationsLoadingBucket[];
};
export type PlanChangeStatus = "pending" | "acknowledged";
export type PlanChangeAcknowledgmentRead = {
  plan_id: number;
  notes: string | null;
  id: number;
  acknowledged_by_uid: string;
  acknowledged_at: string;
  acknowledged_by_name: string;
};
export type PlanChangeData = {
  plan_differences: PlanDifferences;
  original_plan_results: ProductionMixResultRead[];
  new_plan_results: ProductionMixResultRead[];
};
export type PlanChangeDataRead = {
  plan_differences: PlanDifferencesRead;
  original_plan_results: ProductionMixResultRead[];
  new_plan_results: ProductionMixResultRead[];
};
export type PlanChangeRead = {
  plan_id: number;
  changed_by_id: string;
  changed_at: string;
  changed_by_name: string;
  status: PlanChangeStatus;
  acknowledgments: PlanChangeAcknowledgmentRead[];
  plan_change_data: PlanChangeData;
};
export type PlanChangeReadRead = {
  plan_id: number;
  changed_by_id: string;
  changed_at: string;
  changed_by_name: string;
  status: PlanChangeStatus;
  acknowledgments: PlanChangeAcknowledgmentRead[];
  plan_change_data: PlanChangeDataRead;
};
export type PlanChangesResponse = {
  changes: PlanChangeRead[];
  count: number;
};
export type PlanChangesResponseRead = {
  changes: PlanChangeReadRead[];
  count: number;
};
export type PlanChangeDetailsResponse = {
  change: PlanChangeRead | null;
  acknowledgments: PlanChangeAcknowledgmentRead[];
};
export type PlanChangeDetailsResponseRead = {
  change: PlanChangeReadRead | null;
  acknowledgments: PlanChangeAcknowledgmentRead[];
};
export type PhysicalParametersSetRead = {
  parameters: PhysicalParameters;
  id: number;
  created_at: string;
  created_by_id: string;
};
export type SimulatorDataLoadersSpecs = {
  deliveries_loaders: ParameterisedStrategySpec[];
};
export type SimulatorRunStatus =
  "not_started" | "running" | "success" | "failure";
export type SimulatorFailureReason =
  | "no_deployable_periods"
  | "search_error"
  | "search_timeout"
  | "optimisation_infeasible"
  | "optimisation_timeout"
  | "optimisation_error"
  | "optimisation_unacceptable_slack_variable_usage";
export type SimulatorDataLoadersSpec = {
  deliveries_loader: ParameterisedStrategySpec;
};
export type SimulatorRunMetadata = {
  id: number;
  created_by_id: string;
  status: SimulatorRunStatus;
  failure_reason: SimulatorFailureReason | null;
  start_timestamp: UtcTimestamp;
  end_timestamp: UtcTimestamp;
  auto_recipe_strategy: AutoRecipeStrategySpec;
  auto_recipe_estimators: AutoRecipeEstimatorsSpec;
  simulator_data_loaders: SimulatorDataLoadersSpec;
  search_timeout_seconds: number;
};
export type SimulatorRunList = {
  runs: SimulatorRunMetadata[];
};
export type SimulatorStepResult = {
  session_id: number;
  search_id: number;
  plan_id: number;
  start_timestamp: UtcTimestamp;
  end_timestamp: UtcTimestamp;
};
export type DatedInventory = {
  on_timestamp: UtcTimestamp;
  material_name: string;
  inventory: number;
};
export type SimulatorRunRead = {
  id: number;
  created_by_id: string;
  status: SimulatorRunStatus;
  failure_reason: SimulatorFailureReason | null;
  start_timestamp: UtcTimestamp;
  end_timestamp: UtcTimestamp;
  auto_recipe_strategy: AutoRecipeStrategySpec;
  auto_recipe_estimators: AutoRecipeEstimatorsSpec;
  simulator_data_loaders: SimulatorDataLoadersSpec;
  search_timeout_seconds: number;
  results: SimulatorStepResult[];
  inventory: DatedInventory[];
};
export type SummarisedMixRead = {
  baskets: MixBasket[];
  furnace: MixMaterial[];
  thresholds: MixMaterialThreshold[] | null;
  id: number;
  summary: SingleMixSummary;
};
export type SummarisedProductionMixResultRead = {
  original_mix_id: number;
  name: string;
  description: string | null;
  production: NameBasedSteelGradePlanItem[];
  mix: SummarisedMixRead;
};
export type SummarisedPlanResults = {
  plan_id: number;
  period: number;
  mixes: SummarisedProductionMixResultRead[];
};
export type UnsummarisedProductionMixResult = {
  name: string;
  description?: string | null;
  production: NameBasedSteelGradePlanItem[];
  mix?: MixCreate | null;
  mix_id?: number | null;
  original_mix_id: number;
  layer_source?: LayerSource | null;
};
export type PriceBasis = "plan" | "current";
export type UnsummarisedPlanResults = {
  plan_id: number;
  period: number;
  mixes: UnsummarisedProductionMixResult[];
  /** PLAN (the default) costs the mixes with the plan's frozen prices; CURRENT with the tenant's latest material prices. */
  price_basis?: PriceBasis | null;
};
export type StrategyDashboardNotification = {
  tab: string;
  replay_id: string | null;
};
export type ProductGroupName = string;
export type EditingSeries = {
  heat_date: string;
  product_group_name: ProductGroupName;
  heats_edited: number;
  total_mass_changed: number;
  avg_tons_changed_per_heat: number | null;
  avg_num_edits_per_heat: number | null;
  avg_num_materials_edited_per_heat: number | null;
  avg_num_basket_additions_per_heat: number | null;
  avg_num_recipe_additions_per_heat: number | null;
  avg_num_basket_removals_per_heat: number | null;
  avg_num_recipe_removals_per_heat: number | null;
  avg_num_materials_only_moved_per_heat: number | null;
};
export type StrategyDashboardEditingData = {
  series: EditingSeries[];
  available_product_groups: ProductGroupName[];
};
export type EditingRecipeBreakdown = {
  recipe_code: string;
  num_heats_edited: number;
  recipe_mass_changed_tons: number;
};
export type StrategyDashboardEditingRecipesByDate = {
  recipes: EditingRecipeBreakdown[];
};
export type RecipeEditDetail = {
  material_name: string;
  suggested_basket: number | null;
  deployed_basket: number | null;
  mass_difference: number;
  edit_type: string;
  heat_level_edit_type: string;
};
export type StrategyDashboardRecipeEditsVisualizationData = {
  recipe_code: string;
  edits: RecipeEditDetail[];
};
export type MaterialGroupingName = string;
export type MaterialGroupName = string;
export type InventoryMassSeries = {
  material_grouping_name: MaterialGroupingName;
  material_group_name: MaterialGroupName;
  inventory_date: string;
  inventory_mass: number;
  /** Fraction of total inventory. */
  inventory_fraction: number;
  specific_price: number | null;
};
export type StrategyDashboardInventoryData = {
  series: InventoryMassSeries[];
  material_groupings: {
    [key: string]: MaterialGroupName[];
  };
};
export type TimeAggregation = "daily" | "monthly";
export type ConsumptionSourceName = string;
export type ProductGrouping = string;
export type ConsumptionSeries = {
  time_aggregation: TimeAggregation;
  consumption_source: ConsumptionSourceName;
  material_grouping_name: MaterialGroupingName;
  material_group_name: MaterialGroupName;
  product_grouping: ProductGrouping;
  product_group_name: ProductGroupName;
  consumption_date: string;
  /** Mass consumed. Note this can be negative. */
  consumed_mass: number;
  /** Fraction of material consumed. Note this can be negative or greater than 1. */
  consumed_fraction: number;
};
export type StrategyDashboardConsumptionData = {
  series: ConsumptionSeries[];
  consumption_sources: ConsumptionSourceName[];
  material_groupings: {
    [key: string]: MaterialGroupName[];
  };
  product_groupings: {
    [key: string]: ProductGroupName[];
  };
};
export type ConsumptionProjectionsQuantity = {
  unit: UnitType;
  value: number;
};
export type PriceSourceName = string;
export type ConsumptionProjectionPrice = {
  price_source: PriceSourceName;
  specific_price: number;
};
export type ConsumptionProjectionsValue = {
  source: ConsumptionSourceName;
  material_name: string;
  quantities: ConsumptionProjectionsQuantity[];
  prices: ConsumptionProjectionPrice[];
};
export type StrategyDashboardConsumptionProjectionsData = {
  values: ConsumptionProjectionsValue[];
};
export type ProductionSourceName = string;
export type ProductionType = "tapped" | "billets";
export type ProductionSeries = {
  time_aggregation: TimeAggregation;
  production_source: ProductionSourceName;
  production_type: ProductionType;
  product_group_name: ProductGroupName;
  production_date: string;
  produced_mass: number;
  heat_count: number | null;
};
export type StrategyDashboardProductionData = {
  series: ProductionSeries[];
  production_sources: ProductionSourceName[];
  production_types: ProductionType[];
  product_groups: ProductGroupName[];
};
export type ProductionPaceSeries = {
  production_source: ProductionSourceName;
  production_type: ProductionType;
  product_group_name: ProductGroupName;
  production_date: string;
  produced_mass_mtd: number;
  expected_monthly_production: number;
};
export type StrategyDashboardProductionPaceData = {
  series: ProductionPaceSeries[];
  production_sources: ProductionSourceName[];
  production_types: ProductionType[];
  product_groups: ProductGroupName[];
};
export type ChemicalSampleLocation = "eaf" | "lf" | "caster" | "str" | "met";
export type ChemicalSamplePositionType = "first" | "last";
export type ChemicalElementSymbol =
  | "H"
  | "He"
  | "Li"
  | "Be"
  | "B"
  | "C"
  | "N"
  | "O"
  | "F"
  | "Ne"
  | "Na"
  | "Mg"
  | "Al"
  | "Si"
  | "P"
  | "S"
  | "Cl"
  | "Ar"
  | "K"
  | "Ca"
  | "Sc"
  | "Ti"
  | "V"
  | "Cr"
  | "Mn"
  | "Fe"
  | "Co"
  | "Ni"
  | "Cu"
  | "Zn"
  | "Ga"
  | "Ge"
  | "As"
  | "Se"
  | "Br"
  | "Kr"
  | "Rb"
  | "Sr"
  | "Y"
  | "Zr"
  | "Nb"
  | "Mo"
  | "Tc"
  | "Ru"
  | "Rh"
  | "Pd"
  | "Ag"
  | "Cd"
  | "In"
  | "Sn"
  | "Sb"
  | "Te"
  | "I"
  | "Xe"
  | "Cs"
  | "Ba"
  | "La"
  | "Ce"
  | "Pr"
  | "Nd"
  | "Pm"
  | "Sm"
  | "Eu"
  | "Gd"
  | "Tb"
  | "Dy"
  | "Ho"
  | "Er"
  | "Tm"
  | "Yb"
  | "Lu"
  | "Hf"
  | "Ta"
  | "W"
  | "Re"
  | "Os"
  | "Ir"
  | "Pt"
  | "Au"
  | "Hg"
  | "Tl"
  | "Pb"
  | "Bi"
  | "Po"
  | "At"
  | "Rn"
  | "Fr"
  | "Ra"
  | "Ac"
  | "Th"
  | "Pa"
  | "U"
  | "Np"
  | "Pu";
export type NonElementQuantity = "ECH";
export type FailureMetadata = {
  heat_id: string;
  sample_timestamp: UtcTimestamp;
  steel_grade_name: string;
  product_group_name: string;
  weight_percent: number;
  weight_percent_max: number;
  violation_fraction: number;
  expected_weight_percent: number;
  expected_weight_percent_violation: number;
  expected_failure_rate: number;
};
export type FailureRateSeries = {
  time_aggregation: TimeAggregation;
  sample_location: ChemicalSampleLocation;
  sample_position_type: ChemicalSamplePositionType;
  chemical_element_symbol: ChemicalElementSymbol | NonElementQuantity;
  product_group_name: ProductGroupName;
  sample_date: string;
  num_failures: number;
  failure_rate: number | null;
  expected_num_failures: number;
  expected_failure_rate: number | null;
  failures_metadata: FailureMetadata[];
};
export type StrategyDashboardFailureRateData = {
  series: FailureRateSeries[];
};
export type PriceSeries = {
  price_source: PriceSourceName;
  material_name: string;
  price_valid_from: UtcTimestamp;
  specific_price: number;
};
export type StrategyDashboardPriceData = {
  series: PriceSeries[];
  price_sources: PriceSourceName[];
  materials: string[];
};
export type ScrapChefUsageSeries = {
  heat_start_date: string;
  usage_percentage: number;
  current_usage_percentage: number;
  trend_percentage: number;
  scrapchef_recipe_edited_outside_percentage: number | null;
};
export type StrategyDashboardScrapChefUsageData = {
  series: ScrapChefUsageSeries[];
  current_usage_percentage: number;
  trend_percentage: number;
  /** The date significant development started on deploying ScrapChef. Can be null if development has not yet started, or the date is not known. */
  development_start_date: string | null;
  /** The date the rolling average usage percentage first exceeded 85%. */
  high_usage_start_date: string | null;
  /** The time in days between the development start date and the high usage start date. */
  ramp_up_time: number | null;
};
export type ScrapChefUsageDetailedPoint = {
  /** Start of the ISO week (Monday) */
  period_start: string;
  /** Steel standard name, or 'all' for tenant aggregate */
  standard: string;
  /** Total heats in the week */
  total_heats: number;
  /** Heats that ran a ScrapChef recipe */
  scrap_chef_heats: number;
  /** scrap_chef_heats / total_heats as a percentage */
  scrap_chef_percentage: number | null;
};
export type ScrapChefUsageDetailedData = {
  /** Weekly per-standard ScrapChef usage breakdown */
  weekly: ScrapChefUsageDetailedPoint[];
};
export type MassDenominator = "tapped" | "billets" | "charged";
export type CostTimeseriesKey = {
  source: string;
  mass_denominator: MassDenominator;
  date: string;
  cost: number;
  time_aggregation: TimeAggregation;
};
export type CostTableSource =
  "charged_cost_timeseries" | "charged_cost_diff_timeseries";
export type RangeMode = "normal" | "tozero" | "nonnegative";
export type CostTimeseriesData = {
  series: CostTimeseriesKey[];
  table_source: CostTableSource;
  range_mode: RangeMode;
  sources: string[];
};
export type StrategyDashboardCostData = {
  series_collection: {
    [key: string]: CostTimeseriesData;
  };
};
export type CrewName = string;
export type SummaryData = {
  /** The name of this summary data (should be a translation key) */
  name: string;
  value: number | null;
  unit_type: UnitType | null;
  /** Number of decimal places to display this value to */
  decimal_places: number | null;
  diff: number | null;
};
export type ChemicalSampleValue = {
  constraint_name: string;
  ordering: number;
  weight_percent_min: number;
  weight_percent_max: number;
  weight_percent: number;
  violation_fraction: number;
};
export type ChemicalSample = {
  sample_timestamp: UtcTimestamp;
  sample_location: ChemicalSampleLocation;
  sample_number: number;
  sample_position_type: ChemicalSamplePositionType[];
  values: ChemicalSampleValue[];
};
export type MixLiftCount = {
  material_name: string;
  lifts: number;
  strike_if_above: number | null;
  strike_if_below: number | null;
  normalised_lifts: number | null;
};
export type TotalledMix = {
  baskets: MixBasket[];
  furnace: MixMaterial[];
  thresholds: MixMaterialThreshold[] | null;
  totals: MixMassTotal[];
  diffs: MixMassTotal[];
  lifts: MixLiftCount[];
  lift_diffs: MixLiftCount[];
};
export type MixCost = {
  price_source: PriceSourceName;
  cost: number;
};
export type HeatMix = {
  /** Where this mix was specified. E.g., was it the one suggested by ScrapChef, the one deployed, the one recorded in level 2 etc. */
  source: ConsumptionSourceName;
  /** The order of this source, i.e., when was it recorded relative to other sources. */
  ordering: number;
  ignored_materials: string[];
  mix: TotalledMix;
  /** Database ID of the relevant ScrapChef plan, if it exists. */
  plan_id: number | null;
  /** Database ID of the relevant ScrapChef mix, if it exists. */
  mix_id: number | null;
  total_material_cost: MixCost[];
  summary_data: SummaryData[];
  user: UserRead | null;
  /** Whether the mix is identical to the one with the previous ordering value */
  is_equivalent_to_previous: boolean;
};
export type HeatDrop = {
  material_name: string;
  drop_timestamp: UtcTimestamp;
  basket_number: number | null;
  mass: number;
  consumption_area: string | null;
  from_area: string;
  to_area: string;
  location_name: string | null;
  drop_event_id: number | null;
  material_slot: number | null;
};
export type MixedMaterialPair = {
  material_a: string;
  material_b: string;
  num_lifts: number;
};
export type EstimatedMaterialAvailability = {
  material_name: string;
  estimated_available_area_count: number;
};
export type EstimatedLoadingZonePosition = {
  area: string;
  material_name: string;
};
export type BasketLayeringCompliance = {
  basket_number: number;
  /** Layer-order agreement: 1 minus the normalised Damerau-Levenshtein distance over the layer material sequence. */
  sequence_score: number;
  /** Layer-size agreement: 1 minus the normalised per-material mass mismatch. */
  mass_score: number;
  /** Weighted combination of sequence_score and mass_score. */
  compliance: number;
};
export type HeatLayeringCompliance = {
  /** Mass-weighted mean of the per-basket compliance scores. */
  overall: number;
  baskets: BasketLayeringCompliance[];
};
export type LayeringCompliancePair = {
  /** The reference mix source, e.g. 'plannedSource'. */
  target_mix_source: string;
  /** The mix source scored against the target, e.g. 'ScrapEye'. */
  comparison_mix_source: string;
  compliance: HeatLayeringCompliance;
};
export type HeatSeries = {
  heat_id: string;
  crew_id: CrewName;
  steel_grade: string;
  original_steel_grade: string | null;
  recipe_name: string | null;
  sequence_number: number | null;
  start_timestamp: UtcTimestamp;
  tap_timestamp: UtcTimestamp | null;
  eaf: string | null;
  loading_start_timestamp: UtcTimestamp | null;
  loading_end_timestamp: UtcTimestamp | null;
  summary_data: SummaryData[];
  samples: ChemicalSample[];
  mixes: HeatMix[];
  drops: HeatDrop[];
  /** Unordered material pairs dropped together in mixed lifts on this heat, with per-pair lift counts. Empty when the heat has no mixed lifts. */
  mixed_material_pairs: MixedMaterialPair[];
  estimated_loading_zone_availability: EstimatedMaterialAvailability[];
  estimated_loading_zone_positions: EstimatedLoadingZonePosition[];
  /** Materials that triggered a min-lift strike on this heat and were not available in the loading zone during the heat. None when the feature is not enabled for this tenant; empty list when enabled but no such materials exist for this heat. */
  unavailable_required_materials: string[] | null;
  /** Layering compliance per configured mix-source pair (e.g. plannedSource vs ScrapEye). Empty when the tenant has no configured pairs or no scored heats. The compared layerings come through the `mixes` array as ordinary mix sources. */
  layering_compliance: LayeringCompliancePair[];
  /** Share of drops on this heat treated as errors by the operator selection signal (0..1). Null when the tenant does not track it. */
  operator_error_rate: number | null;
};
export type SummaryType = "stat" | "recipe";
export type RatioRecipeAggregate = {
  material: string;
  value: number;
  is_strike: boolean;
};
export type HeatsSummaryItem = {
  /** Name/identifier for this summary (e.g., 'totalCost', '1008') */
  summary_name: string;
  summary_type: SummaryType;
  /** Unit type (e.g., 'cost', 'percentage') */
  unit_type: UnitType | null;
  /** Number of decimal places for display */
  decimal_places: number;
  value: number | RatioRecipeAggregate[];
  ignored_materials: string[];
};
export type HeatsSummary = {
  items: HeatsSummaryItem[];
};
export type StrikeRule = {
  material_name: string;
  /** Strike if lifts exceed this threshold */
  strike_if_above: number | null;
  /** Strike if lifts are below this threshold */
  strike_if_below: number | null;
  /** Strike if the lift ratio to the normalisation material deviates from the recipe's planned ratio by more than this */
  ratio_tolerance: number | null;
  /** Denominator material of the lift ratio */
  normalisation_material_name: string | null;
};
export type LoadingZoneColumn = {
  label: string;
  areas: string[];
};
export type StrategyDashboardHeatData = {
  series: HeatSeries[];
  available_mix_sources: ConsumptionSourceName[];
  available_price_sources: PriceSourceName[];
  available_summaries: {
    [key: string]: UnitType | null;
  };
  available_mix_summaries: {
    [key: string]: UnitType | null;
  };
  available_sample_constraints: (ChemicalElementSymbol | NonElementQuantity)[];
  available_ignored_material_sets: string[][];
  /** Total rows available for pagination. */
  total: number;
  /** Daily aggregate summary for cost, specific cost and yield */
  heats_summary: HeatsSummary;
  strike_rules: StrikeRule[];
  /** Loading zone layout defining how to group areas into columns */
  loading_zone_layout: LoadingZoneColumn[];
  resolved_day: string | null;
  latest_heat_timestamp: string | null;
};
export type CraneShift = {
  date: string;
  shift_number: number;
  crew_id: string | null;
  shift_start_time: UtcTimestamp;
  shift_end_time: UtcTimestamp;
};
export type StrategyDashboardShiftsData = {
  shifts: CraneShift[];
};
export type DeliverySeries = {
  material_name: string;
  delivered_date: string;
  delivered_mass: number;
  delivered_mass_mtd: number;
  month_purchased_mass: number;
  month_expected_mass: number;
  delivered_fraction: number;
  expected_fraction: number;
  expected_mass_mtd: number;
};
export type StrategyDashboardDeliveryData = {
  delivery_series: DeliverySeries[];
  materials: string[];
};
export type RecipeComplianceDiffSourceName = string;
export type ComplianceQuantity = {
  unit: UnitType;
  value: number;
};
export type ComplianceConsumptionValue = {
  material_name: string;
  quantities: ComplianceQuantity[];
  outlier_heat_ids: string[];
};
export type ComplianceValue = {
  crew_id: CrewName;
  product_group_name: ProductGroupName;
  source: ConsumptionSourceName;
  recipe_compliance_diff_source: RecipeComplianceDiffSourceName;
  source_a: ConsumptionSourceName;
  source_b: ConsumptionSourceName;
  consumption: ComplianceConsumptionValue[];
  totals: ComplianceQuantity[];
  max_values: ComplianceQuantity[];
  specific_cost: number | null;
};
export type StrategyDashboardComplianceData = {
  available_product_groups: ProductGroupName[];
  available_crews: CrewName[];
  available_recipe_compliance_diff_sources: RecipeComplianceDiffSourceName[];
  available_units: UnitType[];
  values: ComplianceValue[];
};
export type MaterialPercentage = {
  material_name: string;
  planned_percentage: number | null;
  actual_percentage: number | null;
};
export type CrewProductGroupCompliance = {
  /** Product group: 'Dual Grade' or 'Sixty Grade' */
  product_group: string;
  /** Ordered list of materials with their planned/actual percentages */
  materials: MaterialPercentage[];
  /** Planned cost per tonne, or None if no data */
  planned_specific_price: number | null;
  /** Actual cost per tonne, or None if no data */
  actual_specific_price: number | null;
  /** Price difference per tonne, or None if no data */
  specific_price_diff: number | null;
  planned_mix: MixLiftCount[];
  actual_mix: MixLiftCount[];
  actual_total_heats: number;
  actual_total_mass: number;
  actual_total_cost: number;
  planned_total_mass: number;
  planned_total_cost: number;
};
export type CrewAggregatedComplianceRow = {
  /** Crew identifier: 'A', 'B', 'C', or 'D' */
  crew_id: string;
  product_groups: CrewProductGroupCompliance[];
};
export type CrewAggregatedComplianceData = {
  crews: CrewAggregatedComplianceRow[];
  date_range_start: string;
  date_range_end: string;
};
export type CrewComparisonMaterial = {
  material_name: string;
  fraction: number;
  count: number;
};
export type CrewComparisonStrikeStatus = {
  status: "red" | "amber" | "green";
  fraction: number;
  count: number;
};
export type CrewComparisonCrew = {
  /** Crew identifier: 'A', 'B', 'C', 'D' or 'All' */
  crew_id: string;
  materials: CrewComparisonMaterial[];
  planned_materials: CrewComparisonMaterial[];
  strike_statuses: CrewComparisonStrikeStatus[];
  mean_strikes_per_heat: number;
};
export type CrewComparisonData = {
  crews: CrewComparisonCrew[];
  /** List of materials excluded */
  ignored_materials: string[];
  date_range_start: string;
  date_range_end: string;
};
export type CrewComparisonResponse = {
  crew_data: CrewComparisonData[];
  strike_rules: StrikeRule[];
};
export type MonthlySavings = {
  /** First day of the month (YYYY-MM-DD format) */
  month: string;
  /** Savings per tonne in $/t */
  specific_savings: number;
  /** Total savings in dollars */
  total_savings: number;
};
export type TenantSavingsData = {
  savings: MonthlySavings[];
};
export type SavingsTimeseriesPoint = {
  /** Start of the period */
  period_start: string;
  /** Steel standard name, or 'all' for aggregate */
  standard: string;
  /** Number of heats in this period */
  heat_count: number;
  /** Total charged mass in tonnes */
  total_charged_mass: number;
  /** Actual cost in local currency */
  actual_cost: number;
  /** Baseline counterfactual cost in local currency */
  baseline_cost: number;
  /** Total savings in local currency */
  total_savings: number;
  /** Running sum of total_savings over period_start, within (time_aggregation, standard) */
  cumulative_savings: number;
  /** Savings per tonne in local currency */
  specific_savings: number | null;
  /** Alloy (metallic-addition) savings in local currency for the period, merged from the alloy track; non-zero on 'all' rows only */
  alloy_savings: number;
  /** Alloy heats' charged mass in tonnes for the period (alloy basis), for blending alloy into per-tonne savings; non-zero on 'all' rows only */
  alloy_charged_mass: number;
  /** Running sum of alloy_savings over period_start, within (time_aggregation, standard) */
  alloy_cumulative_savings: number;
};
export type AlloySavingsPoint = {
  /** Start of the period */
  period_start: string;
  /** Alloyed grade name, or 'all' for aggregate */
  standard: string;
  /** Number of alloyed heats in this period */
  heat_count: number;
  /** Total alloy savings in local currency */
  total_savings: number;
  /** Alloy savings per tonne in local currency */
  specific_savings: number | null;
};
export type SavingsTimeseriesData = {
  weekly: SavingsTimeseriesPoint[];
  monthly: SavingsTimeseriesPoint[];
  /** Total cumulative savings in local currency since deployment */
  cumulative_savings: number;
  alloy_weekly: AlloySavingsPoint[];
  alloy_monthly: AlloySavingsPoint[];
  /** Total cumulative alloy savings in local currency since deployment */
  cumulative_alloy_savings: number;
};
export type SiopSchedulePoint = {
  /** First day of the month */
  month_start: string;
  /** Total scheduled billet mass in tonnes for the month */
  scheduled_tons: number;
};
export type SiopScheduleMixGroupPoint = {
  /** First day of the month */
  month_start: string;
  /** Mix group name: REBAR, MBQ, or SBQ */
  mix_group_name: string;
  /** Scheduled billet mass in tonnes for this mix group */
  scheduled_tons: number;
};
export type TenantSiopScheduleData = {
  /** Grand total scheduled tonnes across the period */
  total_scheduled_tons: number;
  /** Monthly breakdown of scheduled production */
  series: SiopSchedulePoint[];
  /** Ordered mix group names present for this tenant */
  mix_group_names: string[];
  /** Monthly breakdown by mix group */
  mix_group_series: SiopScheduleMixGroupPoint[];
  daily_series: SiopSchedulePoint[] | null;
  daily_mix_group_series: SiopScheduleMixGroupPoint[] | null;
};
export type MonthlyPlannedShredFraction = {
  /** First day of the month */
  month: string;
  /** Planned shred fraction (0.0-1.0) */
  shred_fraction: number;
};
export type PlannedShredProductGroup = {
  /** Product group name (e.g. REBAR, MBQ, SBQ) */
  product_group_name: string;
  /** Monthly planned shred fraction timeseries */
  monthly_series: MonthlyPlannedShredFraction[];
};
export type TenantPlannedShredData = {
  /** Planned shred consumption data by product group */
  product_groups: PlannedShredProductGroup[];
};
export type DeliveryFormRead = {
  id: number;
  created_at: UtcTimestamp;
  updated_at: UtcTimestamp;
  name: string | null;
  bay: string | null;
  commodity: string | null;
  notes: string | null;
  mass_lbs: number | null;
  deviations: string | null;
  truck_number: string | null;
};
export type DeliveryFormSave = {
  id?: number | null;
  name?: string | null;
  bay?: string | null;
  commodity?: string | null;
  notes?: string | null;
  mass_lbs?: number | null;
  deviations?: string | null;
  truck_number?: string | null;
};
export type GeminiDeliveryFormTool =
  | "update_bay_number"
  | "update_commodity"
  | "update_weight"
  | "update_deviations"
  | "update_notes"
  | "update_truck_number"
  | "update_name"
  | "save_and_new_delivery"
  | "open_delivery_form"
  | "go_to_completed_deliveries";
export type ProcessAudioWithGeminiRequest = {
  audio_data: string;
  available_tools: GeminiDeliveryFormTool[];
  current_form_data: DeliveryFormSave;
};
export type CacheLine = {
  key: string;
  tenant: string | null;
  type_name: string | null;
  category: string | null;
  id: string | null;
  ttl_seconds: number | null;
  expires_at: string | null;
  size_in_bytes: number | null;
  redis_type: string | null;
  encoding: string | null;
};
export type CacheLines = {
  lines: CacheLine[];
};
export type CacheLineKeys = {
  keys: string[];
};
export type ConsumptionProjectionMaterialItemRead = {
  material_name: string;
  quantity: number;
  fraction: number;
};
export type ConsumptionProjectionRead = {
  id: number;
  created_at: string;
  month: string;
  items: ConsumptionProjectionMaterialItemRead[];
};
export type ConsumptionProjectionMaterialItem = {
  material_name: string;
  quantity: number;
};
export type ConsumptionProjectionCreate = {
  month: string;
  items: ConsumptionProjectionMaterialItem[];
};
export type DeliveryAdjustmentMaterialItem = {
  material_name: string;
  quantity: number;
};
export type DeliveryAdjustmentRead = {
  id: number;
  created_at: string;
  month: string;
  items: DeliveryAdjustmentMaterialItem[];
};
export type DeliveryAdjustmentCreate = {
  month: string;
  items: DeliveryAdjustmentMaterialItem[];
};
export type PeakShavingOutputs = {
  production_cost_savings_per_tonne_from_basket_removal: number;
  production_cost_savings_per_tonne_from_peak_shaving: number;
  production_expected_variable_profit: number;
  should_peak_shave_and_run_faster: boolean;
  should_peak_shave_and_produce_less: boolean;
  should_use_extra_basket_and_produce_less: boolean;
};
export type PeakShavingInputs = {
  mean_electricity_cost_mwh: number;
  peak_electricity_cost_mwh: number;
  basket_per_tonne_material_cost_diff: number;
  energy_usage_per_tonne_mwh: number;
  basket_heat_loss_per_tonne_mwh: number;
  increased_production_percent_per_basket_removed: number;
  expected_variable_profit: number;
};
export type RailcarPosition = {
  area: string;
  track: string;
  position: number;
  outline: [number, number][];
  centre: [number, number];
};
export type RailcarTrackingConfig = {
  location: string;
  angle: string;
  track_outlines: {
    [key: string]: [number, number][];
  };
  car_positions: RailcarPosition[];
  mask_confidence_threshold: number;
  minimum_car_position_coverage: number;
  minimum_mask_fraction_in_track: number;
  minimum_track_overlap_difference: number;
  consecutive_frames_to_confirm: number;
};
export type RailcarTrackingSpec = {
  configuration: RailcarTrackingConfig;
  first_window_start: string;
  run_until: string | null;
};
export type DefaultAreas = {
  lift: string | null;
  drop: string | null;
  flag: string | null;
};
export type ScaleWeightSource = "bucket" | "crane";
export type ReservationConfig = {
  /** Length in seconds of every labelling period and review period. Do not change it after the tenant has periods, because queries use it to bound period starts. */
  chunk_seconds: number;
  grid_start: string;
  default_reserve_from: string | null;
  default_label_coverage_priority: LabelCoveragePriority;
  recent_window_buffer_hours?: number;
};
export type ScrapEyeExtraData =
  "mass_data" | "bucket_loading_windows" | "railcar_slot_materials";
export type DropDetector =
  "raw_cumulative" | "clean_cumulative" | "plateau_steps";
export type RawCumulativeDetectionConfig = {
  /** How long a pause may last before it ends the drop it sits in. */
  max_drop_wait_seconds?: number;
  /** The largest rise one second of feed can be. */
  max_physical_drop_tons?: number;
  /** The largest fall one second of feed can be. */
  max_physical_decrease_tons?: number;
};
export type CleanCumulativeDetectionConfig = {
  /** Steps larger than this are more than one drop, and are excluded rather than measured. */
  max_step_tons?: number;
  /** Widen each measured step by this much at its start. */
  pre_step_padding_seconds?: number;
  /** Widen each measured step by this much at its end. */
  post_step_padding_seconds?: number;
};
export type PlateauDetectionConfig = {
  /** Readings outside this range are not real weights. Set the floor above the scale's empty reading, so a lifted bucket is not read as a loaded one. */
  plausible_reading_range_tons: [number, number];
  /** Length of the window the scale is judged steady over. */
  settle_window_seconds: number;
  /** How far the scale may wander and still count as steady. This also sets the slowest loading that can be measured: material arriving more slowly than this per settle_window_seconds reads as drift. */
  settle_tolerance_tons: number;
  /** How long the scale must stay steady before its level counts, on top of settle_window_seconds. The window is centred, so two drops either side of a shorter pause are measured as one. */
  settle_min_run_seconds: number;
  /** Two steady levels this close apart are one level split by a jolt, not two separated by a drop. Keep it at or below the settle tolerance, so only jolts are merged. */
  plateau_merge_tons: number;
  /** Steps larger than this are more than one drop, and are excluded rather than measured. */
  max_step_tons: number;
  /** Widen each measured step by this much at both ends, so a drop labelled just before or after the scale moved still lines up with the step. */
  step_edge_tolerance_seconds: number;
  /** Extra signal read either side of a request, so a drop near its edge still has a settled reading on both sides. */
  context_widening_minutes: number;
  /** Longest silence in the feed held at its last reading; longer silences count as missing signal. */
  max_ffill_seconds: number;
};
export type DropDetectionConfig = {
  /** How candidate masses are measured from the scale. */
  detector: DropDetector;
  /** Extra signal read either side of every request, whichever detector measures it. */
  smoothing_horizon_seconds?: number;
  raw_cumulative?: RawCumulativeDetectionConfig | null;
  clean_cumulative?: CleanCumulativeDetectionConfig | null;
  plateau?: PlateauDetectionConfig | null;
};
export type BucketCycleConfig = {
  empty_status_min_steps?: number;
  empty_status_with_load_min_steps?: number;
  empty_status_weight_threshold_tons?: number;
  zero_mass_ready_min_steps?: number;
  loading_detection_window_steps?: number;
  heat_start_first_bucket_grace_minutes?: number;
  long_heat_first_charge_to_tap_min_minutes?: number;
  max_cycle_merge_gap_seconds?: number;
  max_buckets?: number;
};
export type ConfidenceThresholds = {
  event?: number;
  material?: number;
  area?: number;
};
export type FlagRules = {
  /** Targeted-review reasons that can flag the model's events. */
  reasons: ReviewReason[];
  event_confidence_threshold: number | null;
  material_confidence_threshold: number | null;
  area_confidence_threshold: number | null;
  mass_outlier_quantile: number | null;
  /** Material names that are rare and easily confused with one another. */
  confusable_materials: string[];
  /** Material names that never appear in a planned recipe. */
  never_planned_materials: string[];
};
export type ReviewWarningConfig = {
  mass_event_types?: EventType[];
  confidence_thresholds: ConfidenceThresholds;
  /** The site's default targeted-review flag rules. */
  default_flag_rules: FlagRules;
};
export type MassCandidateSharing = "exclusive" | "shared";
export type LabelReviewConfig = {
  warnings: ReviewWarningConfig;
  /** What happens when one measured mass covers several drops. EXCLUSIVE gives it all to the first drop and leaves the rest with no mass; SHARED splits it between them. */
  mass_candidate_sharing?: MassCandidateSharing;
  mass_event_fallback_padding_seconds?: number;
  /** The heaviest total one event may be given from the scale, however many measured steps it is built from. */
  max_assigned_mass_tons: number | null;
  merge_events_separated_by_gap_seconds?: number;
  minimum_intersection_over_union?: number;
  assignment_expiry_seconds?: number;
  default_timeline_exclusions?: DefaultTimelineExclusion[];
  /** Fraction of review periods the site intends to review. Below 1, the incomplete-periods alerts count only flagged periods. */
  target_review_period_fraction: number;
  /** Random review fractions keyed by labelling installation location name. Periods are sampled independently of the flagging rules. Locations without an entry send no periods for random review. */
  random_review_period_fraction_by_location: {
    [key: string]: number;
  };
  /** Dataset in `scrapeye.dataset` whose test split expected model performance is measured on. The split has to be verified through regardless of which periods the targeted-review rule flagged, and held out from the training data of every model reported for the site. Null leaves the site without an expected-performance estimate. Naming a dataset also schedules every model reported for the site over that dataset's test split. */
  evaluation_dataset_id: string | null;
  /** Sets of locations whose model performance is reported together, for locations interchangeable enough that one figure describes them all. A location named in no set is reported on its own. A set is reported as one model whichever version each of its locations is running. */
  pooled_location_groups: string[][];
};
export type MassEventMatching = "on_drop" | "on_lift";
export type ScaleReadingLookup = "nearest" | "at_or_before";
export type LayeringComparisonPair = {
  /** The reference mix source (e.g. 'plannedSource'). */
  target_mix_source: string;
  /** The mix source scored against the target (e.g. 'ScrapEye'). */
  comparison_mix_source: string;
};
export type UnknownLayerHandling = "distinct_material" | "wildcard";
export type LayeringComplianceSettings = {
  /** Weight in [0, 1] traded between the layer-order penalty and the layer-mass penalty when scoring layering compliance. 0.5 is balanced. */
  order_weight?: number;
  /** Mix-source pairs to score against each other. Empty means layering compliance is not computed for the tenant. */
  pairs?: LayeringComparisonPair[];
  /** How the ScrapEye 'unknown' layer is scored. WILDCARD aligns it to any material with no order penalty and may merge it into an adjacent layer for free; DISTINCT_MATERIAL scores it as ordinary. */
  unknown_layer_handling?: UnknownLayerHandling;
};
export type ScrapEyeMetadata = {
  railcar_tracking_specs?: RailcarTrackingSpec[];
  available_areas: string[];
  default_areas: DefaultAreas;
  drop_areas: string[];
  scale_weight_areas: string[];
  scale_weight_source: ScaleWeightSource | null;
  required_angles: string[];
  /** Footage dropouts up to this long still count as covered. */
  gap_tolerance_seconds: number;
  reservation: ReservationConfig;
  extra_data: ScrapEyeExtraData[];
  area_hotkeys: {
    [key: string]: string;
  };
  default_area_materials: {
    [key: string]: string;
  };
  max_consecutive_drops: number;
  max_consecutive_lifts: number;
  target_num_labellers: number;
  maximum_num_labellers: number;
  drop_detection_config: DropDetectionConfig;
  bucket_cycle_config: BucketCycleConfig;
  label_review_config: LabelReviewConfig;
  mass_area_matching: boolean;
  mass_event_matching: MassEventMatching;
  scale_reading_lookup: ScaleReadingLookup;
  label_recording_playback_rate: number;
  layering_compliance_config: LayeringComplianceSettings;
};
export type SegmentKind =
  "video" | "metrics" | "logs" | "radio" | "prediction" | "embedding" | "label";
export type VideoSegmentStatus = "ok" | "gap" | "unknown";
export type SegmentSource = "live" | "backfill";
export type ScrapEyeRecordingPosition = {
  name: string;
  location_name: string;
  id: number;
  priority: number | null;
};
export type SegmentRecord = {
  id: number;
  segment_start: string;
  segment_length_sec: number;
  kind: SegmentKind;
  status: VideoSegmentStatus;
  source: SegmentSource;
  duration_ms: number | null;
  size_bytes: number | null;
  mp4_path: string | null;
  ts_path: string | null;
  thumbnail_path: string | null;
  frame_timestamps_ms: number[] | null;
  camera_angle: ScrapEyeRecordingPosition | null;
  video_fps: number | null;
  radio_path: string | null;
  sample_rate: number | null;
  channels: number | null;
  codec: string | null;
  bit_depth: number | null;
};
export type ListSegmentsByDevicesResponse = {
  items: {
    [key: string]: SegmentRecord[];
  };
};
export type ListCameraAnglesResponse = {
  items: ScrapEyeRecordingPosition[];
};
export type RenameScrapEyeDeviceRequest = {
  name: string;
};
export type TrainableAngleConfig = {
  location: string;
  angle: string;
  enabled?: boolean;
  training_required?: boolean;
};
export type TrainablePeriodsConfig = {
  target_location: string;
  available_locations: string[];
  angles: TrainableAngleConfig[];
  embedding_json: string;
};
export type TrainableAngleCoverage = {
  location: string;
  angle: string;
  coverage_ratio: number;
  transform_coverage_ratio: number;
  video_coverage_ratio: number;
};
export type TrainableWindow = {
  window_start: string;
  window_end: string;
  review_coverage_ratio: number;
  labelling_coverage_ratio: number;
  embedding_coverage_by_angle: TrainableAngleCoverage[];
  min_embedding_coverage_ratio: number;
  min_transform_coverage_ratio: number;
  min_video_coverage_ratio: number;
};
export type TrainablePeriodsResponse = {
  windows: TrainableWindow[];
  period_duration_seconds: number;
  config: TrainablePeriodsConfig;
};
export type ModelCoverageModelInfo = {
  mlflow_run_id: string;
  labelling_name: string;
};
export type ModelCoverageConfig = {
  target_location: string;
  available_locations: string[];
  available_models: {
    [key: string]: ModelCoverageModelInfo[];
  };
};
export type ModelCoverageDataKind =
  "video" | "transformed" | "embedded" | "predictions" | "model_labels";
export type ModelCoverageWindow = {
  window_start: string;
  window_end: string;
  video_coverage_ratio: number;
  transform_coverage_ratio: number;
  embedding_coverage_ratio: number;
  prediction_coverage_ratio: number;
  label_coverage_ratio: number;
  available_data: ModelCoverageDataKind[];
};
export type ModelCoverageResponse = {
  windows: ModelCoverageWindow[];
  period_duration_seconds: number;
};
export type JobFailureWindow = {
  window_start: string;
  window_end: string;
  terminal_failure_ratio: number;
  retriable_failure_ratio: number;
  terminal_failure_count: number;
  retriable_failure_count: number;
  total_batches: number;
};
export type JobFailuresResponse = {
  windows: JobFailureWindow[];
};
export type TerminalFailuresByModel = {
  labelling_name: string;
  job_type: string;
  count: number;
};
export type TerminalFailuresPreview = {
  total_count: number;
  by_model: TerminalFailuresByModel[];
};
export type ResetTerminalFailuresResponse = {
  batches_reset: number;
};
export type PerformanceTimeseriesBucket = {
  bucket_start: string;
  bucket_end: string;
  total_verified_events: number;
  matched_events: number;
  total_labeller_events: number;
  fn_rate: number | null;
  fp_rate: number | null;
  jaccard_accuracy: number | null;
  total_event_duration_seconds: number | null;
  event_duration_count: number;
  missing_data_kind: ModelCoverageDataKind | null;
};
export type PerformanceTimeseriesResponseEntry = {
  labelling_name: string;
  target_location: string;
  buckets: PerformanceTimeseriesBucket[];
  dataset_id: string | null;
};
export type DatasetSplitPeriod = {
  start: string;
  end: string;
  split: "train" | "val" | "test";
};
export type PerformanceTimeseriesResponse = {
  results: PerformanceTimeseriesResponseEntry[];
  bucket_size_seconds: number;
  split_periods: DatasetSplitPeriod[];
};
export type DatasetSizeWindow = {
  date: string;
  location: string;
  angle: string;
  segment_count: number;
  total_duration_sec: number;
  estimated_size_bytes: number;
};
export type DatasetSizeResponse = {
  windows: DatasetSizeWindow[];
  cumulative_size_bytes: number;
  ram_threshold_bytes: number;
};
export type LabellingCostDailyEntry = {
  date: string;
  labelling_active_seconds: number;
  labelling_footage_seconds: number;
  labelling_session_count: number;
  labeller_count: number;
  review_active_seconds: number;
  review_footage_seconds: number;
  review_session_count: number;
  reviewer_count: number;
  total_active_seconds: number;
  labelling_cost_ratio: number | null;
  review_cost_ratio: number | null;
  labelling_cost_gbp: number;
  review_cost_gbp: number;
  total_cost_gbp: number;
};
export type LabellingCostDailyResponse = {
  entries: LabellingCostDailyEntry[];
  flat_rate_cost_gbp: number;
};
export type LabellingCostScope = "per_tenant" | "all_tenants";
export type LabellingCostDailyByLocationEntry = {
  date: string;
  location_name: string;
  labelling_active_seconds: number;
  labelling_footage_seconds: number;
  labelling_session_count: number;
  labeller_count: number;
  review_active_seconds: number;
  review_footage_seconds: number;
  review_session_count: number;
  reviewer_count: number;
  total_active_seconds: number;
  labelling_cost_ratio: number | null;
  review_cost_ratio: number | null;
  labelling_cost_gbp: number;
  review_cost_gbp: number;
  total_cost_gbp: number;
};
export type LabellingCostDailyByLocationResponse = {
  entries: LabellingCostDailyByLocationEntry[];
  flat_rate_cost_gbp: number;
};
export type LabellingCostByLabellerEntry = {
  labeller_user_id: string;
  labeller_name: string;
  total_active_seconds: number;
  total_footage_seconds: number;
  cost_ratio: number | null;
  cost_gbp: number;
  session_count: number;
  first_session_date: string;
  last_session_date: string;
};
export type LabellingCostByLabellerResponse = {
  entries: LabellingCostByLabellerEntry[];
};
export type LabellingRedundancyDailyEntry = {
  footage_date: string;
  labeller_count: number;
  period_count: number;
  footage_seconds: number;
};
export type LabellingRedundancyDailyResponse = {
  entries: LabellingRedundancyDailyEntry[];
};
export type ReviewerTrackingDailyEntry = {
  footage_date: string;
  location_name: string;
  events_created: number;
  events_deleted: number;
  events_modified: number;
  consumption_events_created: number;
  consumption_events_deleted: number;
  consumption_events_introduced: number;
  consumption_events_removed: number;
  session_count: number;
};
export type ReviewerTrackingDailyResponse = {
  entries: ReviewerTrackingDailyEntry[];
};
export type ProvisionNewManualDeviceResponse = {
  name: string;
  device_id: number;
  created_at: string;
};
export type VideoVariant = "original" | "low";
export type GcsTokenResponse = {
  access_token: string;
  token_type: "Bearer";
  expires_at: string | null;
  prefix: string;
};
export type RadioTranscriptWord = {
  text: string;
  /** Word start offset from the segment start, in ms. */
  start_ms: number;
  /** Word end offset from the segment start, in ms. */
  end_ms: number;
  /** DMR address of the handset that transmitted this word. Null where no single handset spoke it. */
  source_id: number | null;
  /** How many transmissions were live over this word's audio. */
  concurrent_transmissions: number;
};
export type RadioTranscriptSegment = {
  segment_start: string;
  segment_length_sec: number;
  /** Channel identifier for this segment; null for recordings without channel metadata. */
  receiver_id: number | null;
  text: string;
  words: RadioTranscriptWord[];
  /** Language Scribe detected for this segment (ISO code), or null when unknown. */
  language: string | null;
};
export type RadioTranscriptResponse = {
  /** Transcribed radio segments in the window, oldest first. Only segments containing speech are included; silent stretches are omitted. */
  segments: RadioTranscriptSegment[];
};
export type RadioSegmentInfo = {
  /** Segment length of this device's stored radio segments, in seconds; null when no radio segments have been recorded yet. */
  segment_length_sec: number | null;
  /** Start time of this device's most recent radio segment (any transcode status); null when no radio segments have been recorded yet. */
  last_received_at: string | null;
};
export type RadioReceiver = {
  id: number;
  /** Identifier the device records this channel's segments under */
  receiver_key: string;
  /** Human-readable name of the channel, e.g. its frequency */
  label: string | null;
  /** Centre frequency the channel is tuned to, in Hz */
  frequency_hz: number | null;
  /** Identifier of the physical receiver this channel is captured through, as the installation records name it. Null until the device reports one. */
  receiver_hardware_id: string | null;
  /** Start time of this channel's most recent segment; null when it has produced none. */
  last_received_at: string | null;
};
export type ListRadioReceiversResponse = {
  items: RadioReceiver[];
};
export type MassCandidateEvents = {
  candidate_events: EventCreate[];
};
export type MassDataPoint = {
  area: string;
  timestamp: string;
  value: number;
  loading_status: string;
  basket_number: number | null;
};
export type MassTimeSeries = {
  start: string;
  end: string;
  series: MassDataPoint[];
  candidate_events: EventCreate[];
};
export type MassTimeSeriesExtra = "candidate_events";
export type PostprocessedProbabilityFlag = "argmax";
export type PeakData = {
  prominence: number;
};
export type PredictionRowOrigin =
  "model_output" | "pooled_material" | "pooled_material_component";
export type ModelPredictionDataPoint = {
  frame_ts: string;
  label: string;
  probability: number;
  postprocessed_probability: number | null;
  postprocessed_flags: PostprocessedProbabilityFlag[];
  peak: PeakData | null;
  origin: PredictionRowOrigin;
};
export type ModelPredictionTimeSeries = {
  start: string;
  end: string;
  mlflow_run_id: string;
  series: ModelPredictionDataPoint[];
};
export type InferenceInputSegment = {
  segment_start: string;
  device_name: string;
  physical_id: string;
  angle: string;
  embedding_job_spec: string;
  embedding_model_name: string | null;
};
export type InferenceInputTimeSeries = {
  start: string;
  end: string;
  mlflow_run_id: string;
  segment_duration_seconds: number;
  segments: InferenceInputSegment[];
};
export type HeatQualityFlag =
  | "basket_count_out_of_range"
  | "basket_numbers_not_contiguous"
  | "multiple_basket_numbers_per_bucket"
  | "duplicate_basket_number_across_buckets"
  | "multiple_loads_per_heat_bucket"
  | "bucket_loading_window_too_long"
  | "charged_mass_deviation"
  | "bucket_mass_out_of_range"
  | "loads_disagree_with_charged_buckets"
  | "missed_consumption_drops"
  | "missing_charge_data";
export type HeatQualityFlagDetail = {
  code: HeatQualityFlag;
  details: {
    [key: string]: any;
  } | null;
};
export type HeatQualityIssue = {
  heat_id: string;
  tap_timestamp: string | null;
  loading_start_time: string | null;
  flags: HeatQualityFlagDetail[];
};
export type HeatQualityIssues = {
  issues: HeatQualityIssue[];
};
export type HeatPlannedMix = {
  heat_id: string;
  mix: MixCreate;
};
export type LoadingWindowPlannedConsumptionResponse = {
  heats: HeatPlannedMix[];
};
export type BucketDrop = {
  drop_timestamp: string;
  net_drop_mass_to_heat: number | null;
  material: string | null;
  from_area: string | null;
  to_area: string | null;
};
export type HeatBucketDrops = {
  consumption_area: string;
  heat_id: string;
  drops: BucketDrop[];
};
export type UnassignedConsumptionDrop = {
  drop_event_id: number;
  drop_timestamp: string;
  from_area: string | null;
  to_area: string | null;
  material: string | null;
  drop_mass: number | null;
  attributed_heat_id: string | null;
};
export type LoadingWindowDropsResponse = {
  labelled_heat_drops: HeatBucketDrops[];
  unassigned_drops: UnassignedConsumptionDrop[];
};
export type HeatMetadataRead = {
  heat_id: string;
  crew_id: string | null;
  steel_grade: string | null;
  recipe_name: string | null;
  sequence_number: number | null;
  start_timestamp: string;
  tap_timestamp: string | null;
  eaf: string | null;
  /** Whether ScrapEye covers the heat; null when coverage is unknown. */
  is_covered: boolean | null;
  is_verified: boolean | null;
};
export type LoadingWindowHeatMetadataResponse = {
  heats: HeatMetadataRead[];
};
export type ChargeEvent = {
  consumption_area: string;
  charge_sequence: number;
  charged_at: string;
};
export type HeatChargeEvents = {
  heat_id: string;
  charges: ChargeEvent[];
};
export type LoadingWindowChargeEventsResponse = {
  heats: HeatChargeEvents[];
};
export type LoadingCellStatus = "loading" | "idle";
export type LoadingEditSource = "human" | "agent" | "seed";
export type LoadingReviewDecision = "approved" | "declined" | "revoked";
export type LoadingEditRead = {
  id: number;
  area_name: string;
  start_time: string;
  end_time: string;
  target_status: LoadingCellStatus;
  target_heat_id: string | null;
  target_basket_number: number | null;
  source: LoadingEditSource;
  rationale: string | null;
  revises_edit_id: number | null;
  created_at: string;
  created_by: UserRead | null;
  /** Latest review decision; null means pending (no review yet). */
  latest_decision: LoadingReviewDecision | null;
  reviewed_at: string | null;
  reviewed_by: UserRead | null;
};
export type ListLoadingEditsResponse = {
  edits: LoadingEditRead[];
};
export type ProposeLoadingEditRequest = {
  area_name: string;
  start_time: string;
  end_time: string;
  target_status: LoadingCellStatus;
  target_heat_id?: string | null;
  target_basket_number?: number | null;
  rationale?: string | null;
};
export type SubmitLoadingEditsRequest = {
  edits: ProposeLoadingEditRequest[];
};
export type ReviewResultStatus =
  "recorded" | "unchanged" | "not_found" | "conflict";
export type ReviewResult = {
  edit_id: number;
  /** recorded: the decision was appended; unchanged: the edit was already in that state; not_found: no such edit; conflict: the decision is not valid from the edit's current state. */
  status: ReviewResultStatus;
  /** The updated edit for recorded/unchanged; null otherwise. */
  edit: LoadingEditRead | null;
};
export type ListReviewResultsResponse = {
  results: ReviewResult[];
};
export type LoadingReviewRequest = {
  edit_id: number;
  decision: LoadingReviewDecision;
  rationale?: string | null;
};
export type SubmitLoadingReviewsRequest = {
  reviews: LoadingReviewRequest[];
};
export type ReviseLoadingEditItem = {
  start_time: string;
  end_time: string;
  target_status: LoadingCellStatus;
  target_heat_id?: string | null;
  target_basket_number?: number | null;
  rationale?: string | null;
  edit_id: number;
};
export type ReviseAndApplyLoadingEditsRequest = {
  revisions: ReviseLoadingEditItem[];
};
export type LoadingWindowRead = {
  area_name: string;
  start_time: string;
  end_time: string;
  heat_id: string;
  basket_number: number;
};
export type ListLoadingWindowsResponse = {
  windows: LoadingWindowRead[];
};
export type ConsumptionAreaRead = {
  area_name: string;
};
export type ListConsumptionAreasResponse = {
  areas: ConsumptionAreaRead[];
};
export type ReseedResult = {
  /** Distinct consumption areas covered by the seed. */
  areas: number;
  /** Seed edits inserted (one per window). */
  edits_written: number;
  /** Prior applied seed edits soft-deleted (revoked) in the window. */
  superseded: number;
  /** Overhang edits re-inserted for seeds straddling the window edge. */
  overhang: number;
};
export type SeedLoadingWindow = {
  area_name: string;
  /** Window start; snapped down to the 10s grid when stored. */
  start_time: string;
  /** Window end; snapped up to the 10s grid when stored. */
  end_time: string;
  heat_id: string;
  basket_number: number;
};
export type ReseedLoadingWindowsRequest = {
  start_time: string;
  end_time: string;
  /** The complete seed windows within [start_time, end_time); empty means the range has no loading and its seed layer is cleared. */
  windows: SeedLoadingWindow[];
};
export type ScrapEyeInstallationLocationCreate = {
  name: string;
};
export type LocationType = "labelling" | "supporting";
export type ScrapEyeInstallationLocation = {
  name: string;
  location_type: LocationType;
  furnaces: string[];
};
export type ScrapEyeInstallationLocationWithBacklog = {
  name: string;
  location_type: LocationType;
  backlog_seconds: number;
  backlog_by_label_count: {
    [key: string]: number;
  };
};
export type ScrapEyeRecordingPositionCreate = {
  name: string;
  location_name: string;
};
export type ListRecordingPositionsResponse = {
  items: ScrapEyeRecordingPosition[];
};
export type ScrapEyeInstallationEventCreate = {
  device_name: string;
  camera_physical_id: string;
  location_name: string;
  camera_angle_name: string;
  priority: number;
  installed_at: string;
};
export type ScrapEyeUninstallation = {
  device_name: string;
  camera_physical_id: string;
  removed_at: string;
};
export type ScrapEyeInstallationEventRead = {
  device_name: string;
  camera_physical_id: string;
  location_name: string;
  camera_angle_name: string;
  priority: number;
  installed_at: string;
  removed_at: string | null;
};
export type ScrapEyeInstallationListOption = "all" | "current";
export type ScrapEyeInstallationVideoPlayerGroupRead = {
  name: string;
  location_name: string;
  ordering: number;
  id: number;
};
export type ScrapEyeInstallationVideoPlayerGroupCreate = {
  name: string;
  location_name: string;
  ordering: number;
};
export type ScrapEyeInstallationVideoPlayerGroupWithAngles = {
  name: string;
  location_name: string;
  ordering: number;
  id: number;
  angles: ScrapEyeRecordingPosition[];
};
export type ScrapEyeInstallationVideoPlayerGroupUpdate = {
  name?: string | null;
  ordering?: number | null;
};
export type ScrapEyeInstallationVideoPlayerGroupMembershipCreate = {
  camera_angle_id: number;
  priority: number;
};
export type ScrapEyeLocationSupportAssociationRead = {
  id: number;
  labelling_location_name: string;
  supporting_location_name: string;
};
export type ScrapEyeLocationSupportAssociationCreate = {
  labelling_location_name: string;
  supporting_location_name: string;
};
export type ScrapEyeSensorPlacementCreate = {
  sensor_id: number;
  recording_position_id: number;
  priority: number;
  installed_at: string;
  removed_at: string | null;
};
export type SensorType = "camera" | "position_tracker" | "radio_receiver";
export type ScrapEyeSensorPlacementRead = {
  sensor_id: number;
  recording_position_id: number;
  priority: number;
  installed_at: string;
  removed_at: string | null;
  id: number;
  deduplication_key: string;
  recorded_at: string;
  recorded_by_id: string | null;
  sensor_name: string;
  sensor_type: SensorType;
  serial_number: string | null;
  location_name: string;
  recording_position_name: string;
};
export type ListScrapEyeSensorPlacementsResponse = {
  items: ScrapEyeSensorPlacementRead[];
};
export type ScrapEyeSensorConnectionCreate = {
  sensor_id: number;
  device_id: number;
  device_sensor_id: string | null;
  camera_id: number | null;
  connected_at: string;
  disconnected_at: string | null;
};
export type ScrapEyeSensorConnectionRead = {
  sensor_id: number;
  device_id: number;
  device_sensor_id: string | null;
  camera_id: number | null;
  connected_at: string;
  disconnected_at: string | null;
  id: number;
  deduplication_key: string;
  recorded_at: string;
  recorded_by_id: string | null;
  sensor_name: string;
  sensor_type: SensorType;
  device_name: string;
};
export type ListScrapEyeSensorConnectionsResponse = {
  items: ScrapEyeSensorConnectionRead[];
};
export type ScrapEyeSensorConnectionCorrection = {
  sensor_id: number;
  device_id: number;
  device_sensor_id: string | null;
  camera_id: number | null;
  connected_at: string;
  disconnected_at: string | null;
};
export type ScrapEyeCameraRecordingRead = {
  id: number;
  device_id: number;
  physical_id: string;
  created_at: string;
  removed_at: string | null;
};
export type ListScrapEyeCameraRecordingsResponse = {
  items: ScrapEyeCameraRecordingRead[];
};
export type ScrapEyeSensorRead = {
  id: number;
  metadata_version_id: number;
  sensor_type: SensorType;
  name: string;
  serial_number: string | null;
  created_at: string;
  properties: {
    [key: string]: any;
  };
};
export type ScrapEyeSensorCreate = {
  sensor_type: SensorType;
  name: string;
  serial_number: string | null;
};
export type ListScrapEyeSensorsResponse = {
  items: ScrapEyeSensorRead[];
};
export type ScrapEyeSensorMetadataUpdate = {
  expected_version_id: number;
  name: string;
  properties?: {
    [key: string]: any;
  } | null;
};
export type RedactFootagePreviewItem = {
  device_id: number;
  device_name: string;
  camera_physical_id: string;
  segment_count: number;
};
export type RedactFootagePreviewResponse = {
  items: RedactFootagePreviewItem[];
  total_segments: number;
};
export type RedactFootageRequest = {
  location_name: string;
  angle_name: string;
  start: string;
  end: string;
};
export type RedactFootageJobResponse = {
  job_id: string;
};
export type RedactFootageStatusResponse = {
  status: string;
  progress: number;
  total: number;
  errors: string[];
};
export type LocationExceptionalStatusType =
  "missing" | "ignorable" | "bad_labels" | "broken_scale_weights";
export type LocationExceptionalStatusRead = {
  id: number;
  location_name: string | null;
  area: string | null;
  status: LocationExceptionalStatusType;
  started_at: string;
  ended_at: string;
  note: string | null;
  created_at: string;
  created_by: UserRead;
};
export type LocationExceptionalStatusCreate = {
  location_name?: string | null;
  area?: string | null;
  status: LocationExceptionalStatusType;
  started_at: string;
  ended_at: string;
  note?: string | null;
};
export type ListLocationExceptionalStatusResponse = {
  items: LocationExceptionalStatusRead[];
};
export type LocationExceptionalStatusUpdate = {
  started_at: string;
  ended_at: string;
  status: LocationExceptionalStatusType;
  note?: string | null;
};
export type DailyVideoData = {
  date: string;
  per_camera_expected_seconds: {
    [key: string]: number;
  };
  per_camera_live_seconds: {
    [key: string]: number;
  };
  per_camera_backfilled_seconds: {
    [key: string]: number;
  };
};
export type DeviceMetricUnit =
  "seconds" | "milliseconds" | "bytes" | "celsius" | "percent";
export type DeviceMetric = {
  key: string;
  translation_key: string;
  tooltip_key: string | null;
  tooltip_params: {
    [key: string]: number;
  } | null;
  icon: string;
  value: number | null;
  unit: DeviceMetricUnit;
  status: "ok" | "warning" | "critical" | "missing";
};
export type AdditionalDeviceInfo = {
  last_video_segment_received_at: string | null;
  daily_video_data: DailyVideoData[];
  storage_space_used_gb: number | null;
  storage_space_total_gb: number | null;
  last_video_segment_thumbnail_path: string | null;
  last_video_segment_mp4_path: string | null;
  metrics: DeviceMetric[];
};
export type DeviceCapability = "radio";
export type StandbyState = "standing_by" | "covering";
export type ScrapEyeDevice = {
  name: string;
  id: number;
  user_uid: string | null;
  created_at: string;
  additional_info: AdditionalDeviceInfo | null;
  installation_location: string | null;
  capabilities: DeviceCapability[];
  standby_state: StandbyState | null;
};
export type ListScrapEyeDevicesResponse = {
  items: ScrapEyeDevice[];
};
export type CameraResolution = {
  width: number;
  height: number;
  /** Frames per second */
  fps?: number | null;
};
export type CameraCapability = {
  /** Physical camera ID (e.g., 'usb_port0', 'usb_port1', 'usb_port2') */
  physical_id: string;
  video_resolutions: CameraResolution[];
  /** Primary focal length in mm */
  focal_length_mm?: number | null;
  /** Minimum zoom ratio */
  min_zoom_ratio?: number | null;
  /** Maximum zoom ratio */
  max_zoom_ratio?: number | null;
  /** Sensor orientation in degrees */
  sensor_orientation?: number | null;
  /** Optical image stabilization */
  supports_ois?: boolean | null;
  /** Electronic image stabilization */
  supports_eis?: boolean | null;
};
export type ListScrapEyeCamerasResponse = {
  cameras: CameraCapability[];
};
export type SensorTopologyDevice = {
  id: number;
  name: string;
  created_at: string;
};
export type SensorTopologyEventKind =
  "connected" | "disconnected" | "installed" | "removed";
export type SensorTopologyEvent = {
  at: string;
  kind: SensorTopologyEventKind;
  sensor_id: number;
  version_id: number;
  label: string;
};
export type SensorTopology = {
  at: string;
  devices: SensorTopologyDevice[];
  sensors: ScrapEyeSensorRead[];
  connections: ScrapEyeSensorConnectionRead[];
  installations: ScrapEyeSensorPlacementRead[];
  active_connection_ids: number[];
  active_installation_ids: number[];
  events: SensorTopologyEvent[];
};
export type SensorTopologyConnectionChange = {
  expected_version_id: number | null;
  connection: ScrapEyeSensorConnectionCorrection;
};
export type SensorTopologyInstallationChange = {
  expected_version_id: number | null;
  installation: ScrapEyeSensorPlacementCreate;
};
export type SensorTopologyChanges = {
  connections: SensorTopologyConnectionChange[];
  installations: SensorTopologyInstallationChange[];
};
export type DeviceMetadata = {
  cameras: CameraCapability[];
};
export type RegisterCapabilitiesRequest = {
  device_metadata: DeviceMetadata;
};
export type AnnounceCamerasResponse = {
  /** Announced camera IDs that had no active registration before this call */
  created_physical_ids: string[];
};
export type AnnounceCamerasRequest = {
  /** Physical camera IDs the device is recording from, as they appear on its uploaded segments */
  physical_ids: string[];
};
export type VideoCreate = {
  source: SegmentSource;
  uploaded_uri: string;
  /** MD5 hash as 32-character hex string */
  uploaded_md5: string;
  segment_start: string;
  segment_length_sec: number;
  duration_ms: number;
  content_type: string;
  frame_timestamps_ms: number[];
  /** Physical camera ID (e.g., 'usb_port0') */
  camera_physical_id: string;
  /** Video width in pixels */
  width?: number | null;
  /** Video height in pixels */
  height?: number | null;
  /** Camera frames per second */
  camera_fps?: number | null;
  /** Video frames per second */
  video_fps?: number | null;
};
export type RadioCallHeader = {
  /** Start of the transmission as an offset from the segment start, in ms. Negative where the transmission began in the previous segment. */
  offset_ms: number;
  /** End of the transmission as an offset from the segment start, in ms. Null where the call is known from its header only. */
  end_offset_ms?: number | null;
  /** DMR source address: the radio that transmitted. Null when the header decoded without one. */
  source_id: number | null;
  /** DMR target address: the talkgroup addressed. Null when the header decoded without one. */
  talkgroup: number | null;
  /** TDMA slot the call was carried on. Null when the header decoded without one. */
  slot: number | null;
};
export type RadioCreate = {
  source: SegmentSource;
  uploaded_uri: string;
  /** MD5 hash as 32-character hex string */
  uploaded_md5: string;
  segment_start: string;
  segment_length_sec: number;
  duration_ms: number;
  content_type: string;
  /** Audio sample rate in Hz */
  sample_rate?: number | null;
  /** Number of audio channels */
  channels?: number | null;
  /** Audio codec (e.g. 'pcm_s16le', 'aac') */
  codec?: string | null;
  /** Bits per sample */
  bit_depth?: number | null;
  /** Which of the device's radio channels this segment came from. A device that records several channels sends one segment per channel for the same time slot, and this is what separates them; null from devices that predate multi-channel recording. */
  receiver_id?: string | null;
  /** Human-readable name of the channel, e.g. its frequency */
  receiver_label?: string | null;
  /** Center frequency the channel was tuned to, in Hz */
  receiver_frequency_hz?: number | null;
  /** Identifier of the physical receiver that captured this segment, as the installation records name it. Null from devices whose receiver has not been catalogued. */
  receiver_hardware_id?: string | null;
  /** DMR call headers heard in this segment's window, in the order they were heard. Null from devices that do not decode call headers; empty when the segment carried none that were readable. */
  calls?: RadioCallHeader[] | null;
};
export type SegmentStatusListItem = {
  status: VideoSegmentStatus;
  epoch_sec: number;
  ok_camera_count: number | null;
  total_camera_count: number | null;
};
export type SegmentStatusListResponse = {
  items: SegmentStatusListItem[];
};
export type EdgeWindowFlag = "complete" | "partial" | "no_output";
export type EdgePredictionWindowCreate = {
  source: SegmentSource;
  uploaded_uri: string;
  uploaded_md5: string;
  /** The shorthand of the model's `InferenceJobSpec`. */
  job_spec: string;
  /** Identifies one edge output. A retry sends the same `run_id` and `run_started_at`. */
  run_id: string;
  run_started_at: string;
  window_start: string;
  window_seconds: number;
  row_count: number;
  flag: EdgeWindowFlag;
};
export type EdgeEmbeddingCreate = {
  source: SegmentSource;
  uploaded_uri: string;
  uploaded_md5: string;
  /** The shorthand of the camera's `EmbeddingJobSpec`. */
  job_spec: string;
  /** Identifies one edge output. A retry sends the same `run_id` and `run_started_at`. */
  run_id: string;
  run_started_at: string;
  segment_start: string;
  segment_length_sec: number;
  video_fps: number;
};
export type BayLayoutData = {
  columns: (string | null)[][];
  description: string;
};
export type BayLayoutRead = {
  layout_type: "bay";
  data: BayLayoutData;
};
export type RailCarShape = "railcar" | "square" | "circle" | "landmark";
export type RailCarLayoutArea = {
  area_id: string;
  display_name: string;
  shape: RailCarShape;
  width: number | null;
  height: number | null;
  label: string | null;
  short_label: string | null;
};
export type RailCarLayoutTrack = {
  name: string;
  areas: RailCarLayoutArea[];
};
export type RailCarLayoutData = {
  tracks: RailCarLayoutTrack[];
  description: string;
  orientation: "row" | "column";
  name: string | null;
  camera_direction_label: string | null;
};
export type RailCarLayoutRead = {
  layout_type: "railcar";
  data: RailCarLayoutData;
};
export type GridCell = {
  row: number;
  col: number;
};
export type GridLayoutArea = {
  area_id: string;
  display_name: string;
  cells: GridCell[];
  label: string | null;
};
export type GridLayoutData = {
  rows: number;
  cols: number;
  areas: GridLayoutArea[];
  description: string;
};
export type GridLayoutRead = {
  layout_type: "grid";
  data: GridLayoutData;
};
export type ScrapLoadingLayoutResponse = {
  layout: BayLayoutRead | RailCarLayoutRead | GridLayoutRead;
};
export type RailcarMovement = {
  tag_id: string;
  tag_id_display: string | null;
  material: MaterialRead;
  inbound_time: string;
  outbound_time: string | null;
  inbound_weight: number;
  outbound_weight: number | null;
  consumed_weight: number | null;
  bay_number: string | null;
};
export type RailcarMovements = {
  railcar_movements: RailcarMovement[];
};
export type ReportedRailcarSlots = {
  layout: RailCarLayoutRead;
  spans: RailcarSlotMaterialSpan[];
};
export type LayoutNumbering = "crane" | "plant";
export type RailcarDepotCars = {
  material: string;
  cars: number;
};
export type RailcarConsumptionSource = "actual" | "planned";
export type RailcarSupplyPosition = {
  material_family: string;
  yard_tons: number;
  daily_consumption_tons: number;
  /** Null when the consumption rate is zero. */
  days_of_supply: number | null;
  consumption_source: RailcarConsumptionSource;
};
export type RailcarOrderRequestRead = {
  uploaded_file_id: number;
  plant_date: string;
  /** 1 for the first depot list of the plant date. */
  revision: number;
  revision_note: string | null;
  depot_cars: RailcarDepotCars[];
  supply_positions: RailcarSupplyPosition[];
  id: number;
  created_at: string;
};
export type RailcarOrderRequestCreate = {
  uploaded_file_id: number;
  plant_date: string;
  /** 1 for the first depot list of the plant date. */
  revision: number;
  revision_note: string | null;
  depot_cars: RailcarDepotCars[];
  supply_positions: RailcarSupplyPosition[];
};
export type RailcarOrderProposalOutcome = "accepted" | "refused";
export type RailcarOrderLineCreate = {
  material: string;
  cars: number;
  reason: string;
};
export type RailcarOrderProposalRead = {
  id: number;
  request_id: number;
  summary: string;
  lines: RailcarOrderLineCreate[];
  clark_session_id: string | null;
  created_by_id: string;
  created_at: string;
};
export type RailcarOrderRefusalReason =
  | "material_not_at_depot"
  | "more_cars_than_at_depot"
  | "material_repeated"
  | "too_many_cars"
  | "no_cars_before_weekend"
  | "superseded_by_newer_list"
  | "already_proposed";
export type RailcarOrderRefusal = {
  reason: RailcarOrderRefusalReason;
  material: string | null;
  detail: string;
};
export type RailcarOrderProposalResult = {
  outcome: RailcarOrderProposalOutcome;
  proposal: RailcarOrderProposalRead | null;
  refusals: RailcarOrderRefusal[];
};
export type RailcarOrderProposalCreate = {
  request_id: number;
  summary: string;
  lines: RailcarOrderLineCreate[];
  clark_session_id: string | null;
};
export type DiffMode = "mass" | "fraction";
export type RecipeComplianceOverall = {
  /** Total actual minus planned mass across all crews. */
  net_diff_mass: number;
  verified_heats: number;
  total_heats: number;
  /** Mass-weighted plan-vs-actual across crews. Null when any crew is null. */
  planned_vs_actual: number | null;
  /** Verified-heat-weighted on-recipe score across crews (0..1). */
  on_recipe_score: number;
};
export type CrewCompliance = {
  crew_id: string;
  /** Shift period for daily reports (e.g. "Wednesday Night"); empty on monthly reports. */
  shift_label: string;
  /** Crew total actual minus planned mass. */
  total_mass_diff: number;
  num_heats: number;
  num_heats_verified: number;
  /** Crew plan-vs-actual specific charged cost. Null (not zero) when any material in the window is unpriced. */
  planned_vs_actual: number | null;
  /** Crew on-recipe score (0..1). */
  compliance_score: number;
};
export type CrewMaterialCompliance = {
  crew_id: string;
  /** Actual minus planned mass for this material. */
  mass_diff: number;
  /** Actual minus planned charge fraction for this material (0..1). */
  frac_diff: number;
  /** This material's contribution to the crew's plan-vs-actual specific charged cost. */
  impact: number;
};
export type MaterialCompliance = {
  material_name: string;
  /** This material's specific price over the window, weighted by the mass charged at each shift's price. Null for materials that are never priced (e.g. 'unknown'). */
  specific_price: number | null;
  /** One entry per crew, in the same order as `crews`. */
  by_crew: CrewMaterialCompliance[];
};
export type TargetKind = "required_lift" | "layering_compliance";
export type CrewTargetValue = {
  crew_id: string;
  /** This crew's progress toward the target (0..1); null when it can't be computed (e.g. no verified heats, or no scored heats). */
  fraction: number | null;
};
export type Target = {
  kind: TargetKind;
  /** Display name for config-driven targets (required-lift trackers); null for built-in metrics, which the client labels from `kind`. */
  name: string | null;
  /** One entry per crew, in the same order as `crews`. */
  by_crew: CrewTargetValue[];
};
export type CrewOverrideCount = {
  crew_id: string;
  count: number;
  stable_heat_ids: string[] | null;
};
export type OverrideReasonCount = {
  reason: string | null;
  subreason: string | null;
  /** One entry per crew, in the same order as `crews`. */
  by_crew: CrewOverrideCount[];
};
export type OverrideCounts = {
  by_reason: OverrideReasonCount[];
  /** One entry per crew, in the same order as `crews`. */
  total_by_crew: CrewOverrideCount[];
};
export type ListedChargeChange = {
  basket_number: number;
  /** Each changed material, as signed mass and name, e.g. "+2.00 t HMS1". */
  material_changes: string[];
};
export type ListedOverride = {
  override_id: number;
  /** Start time of the override's first heat, on the tenant's clock. */
  first_heat_start_time: string;
  created_by: string;
  /** Each heat the override covers, as "<heat ID> (<grade>)". */
  heats: string[];
  reason: string | null;
  charge_changes: ListedChargeChange[];
  comment: string | null;
};
export type CrewOverrideList = {
  /** Null for overrides whose first heat started outside every crew shift. */
  crew_id: string | null;
  overrides: ListedOverride[];
};
export type RecipeComplianceBreakdown = {
  title: string;
  overall: RecipeComplianceOverall;
  crews: CrewCompliance[];
  materials: MaterialCompliance[];
  /** Rows for the report's targets section — required-lift trackers and built-in metrics like layering compliance — each carrying a per-crew fraction. Empty when the tenant tracks none. */
  targets: Target[];
  /** Null when heat overrides are disabled. */
  overrides: OverrideCounts | null;
  /** Uncancelled overrides whose first heat started in the window, grouped by crew in order of each crew's first override. Null unless the tenant's compliance report overrides section is override_list_by_crew, and null on monthly reports. */
  override_list: CrewOverrideList[] | null;
};
export type RecipeComplianceReport = {
  window_start: string;
  window_end: string;
  title: string;
  /** Number of distinct crews represented in the report. */
  crew_count: number;
  /** The tenant's preferred diff mode. */
  default_diff_mode: DiffMode;
  /** Deprecated; render from `breakdown`. HTML body in the requested (or default) diff mode. Null when the window had no verified heats. */
  html: string | null;
  /** Deprecated; render from `breakdown`. Rendered HTML keyed by diff mode, with both modes populated on every request. */
  html_by_diff_mode: {
    [key: string]: string | null;
  };
  /** Numeric report breakdown the client formats, colours, and toggles diff modes from. Null when the window had no verified heats. */
  breakdown: RecipeComplianceBreakdown | null;
};
export type RecipeComplianceReportShiftAnchor = "first" | "last";
export type RecipeComplianceReportLabel = "daily_shift" | "morning_meeting";
export type TenantEmail = {
  user_uid: string;
  name: string;
  email: string;
};
export type TenantEmails = {
  tenant_name: string;
  emails: TenantEmail[];
};
export type TenantNames = {
  tenant_names: string[];
};
export type TenantGroupNames = {
  tenant_group_names: string[];
  tenant_group_long_names: {
    [key: string]: string;
  };
};
export type AccountType = "user" | "service_account";
export type UserPermission = {
  user_uid: string;
  permission: Permission;
};
export type UserReadAll = {
  uid: string;
  name: string;
  email: string;
  created_at: string;
  updated_at: string;
  is_enabled: boolean;
  is_admin: boolean;
  account_type: AccountType;
  permissions: UserPermission[];
};
export type CustomTokenResponse = {
  custom_token: string;
  firebase_api_key: string;
};
export type UserUpdate = {
  uid: string;
  is_admin?: boolean | null;
  is_enabled?: boolean | null;
  permissions?: {
    [key: string]: Permission[];
  } | null;
};
export type AdminMode = "active" | "paused";
export type AdminModeUpdate = {
  mode: AdminMode;
};
export type RequestSignInLinkRequest = {
  email: string;
};
export type ClarkHandleChannel = "imessage";
export type ClarkHandle = {
  channel: ClarkHandleChannel;
  identifier: string;
};
export type ClarkProfileRead = {
  user: UserRead | null;
  description: string | null;
  handles: ClarkHandle[];
};
export type ClarkProfileUpdate = {
  email: string;
  name: string;
  description: string;
  handles: ClarkHandle[];
};
export type MissionControlTenant = {
  tenant_name: string;
  long_name: string;
  short_name: string;
  latitude: number;
  longitude: number;
  tenant_names: string[];
  feature_flags: FeatureFlag[];
  open_status: "enabled" | "disabled";
};
export type MissionControlTenantsResponse = {
  tenants: MissionControlTenant[];
  savings_target: number | null;
};
export type MissionControlUploadResult = {
  filename: string;
  tenant: string | null;
  success: boolean;
};
export type MissionControlUploadResponse = {
  results: MissionControlUploadResult[];
};
export type MissionControlUploadRequest = {
  files: File[];
};
export type TotalInventoryPoint = {
  /** Date of the inventory measurement */
  inventory_date: string;
  /** Total inventory mass in tonnes */
  total_inventory_mass: number;
};
export type TenantTotalInventoryData = {
  series: TotalInventoryPoint[];
};
export type ProductMixGroup = {
  /** Mix group name: MBQ, REBAR, or SBQ */
  mix_group_name: string;
  /** Produced billet mass in tonnes */
  produced_mass_tonnes: number;
  /** Fraction of total production (0.0-1.0) */
  mix_percentage: number;
};
export type ProductMixMonth = {
  /** First day of the month */
  month_start: string;
  /** Production breakdown by mix group */
  groups: ProductMixGroup[];
};
export type TenantProductMixData = {
  /** Ordered mix group names present for this tenant */
  mix_group_names: string[];
  /** Monthly product mix data, newest first */
  months: ProductMixMonth[];
};
export type MonthlyShredUsage = {
  /** First day of the month */
  month: string;
  /** Shred mix percentage */
  mix_percentage: number;
};
export type TenantShredUsageData = {
  /** Monthly shred usage records */
  shred_usage: MonthlyShredUsage[];
};
export type ScrapReportMaterial = {
  material_name: string;
  inventory_tons: number | null;
  price_per_ton: number | null;
  open_purchase_order_tons: number | null;
};
export type ScrapReportResponse = {
  tenant_name: string;
  materials: ScrapReportMaterial[];
};
export type OrganisationPermission =
  "mission_control_viewer" | "mission_control_upload";
export type OrganisationUserRead = {
  uid: string;
  email: string;
  name: string;
  disabled_at: string | null;
  created_at: string;
  permissions: OrganisationPermission[];
};
export type OrganisationUsersResponse = {
  users: OrganisationUserRead[];
};
export type AddOrganisationUserRequest = {
  email: string;
  permissions: OrganisationPermission[];
};
export type UpdateOrganisationUserRequest = {
  permissions: OrganisationPermission[];
};
export type ClarkDirectoryStatus = "active" | "inactive";
export type ClarkRole = "user" | "developer";
export type ClarkDirectoryPerson = {
  id: string;
  user_uid: string | null;
  name: string;
  description: string;
  status: ClarkDirectoryStatus;
  role: ClarkRole;
  tenant_names: string[];
  email: string | null;
  handles: ClarkHandle[];
};
export type ClarkDirectory = {
  people: ClarkDirectoryPerson[];
};
export type MatchMethod = "new_node" | "auto_matched" | "manual_matched";
export type NodeObservationRead = {
  id: number;
  node_id: number;
  data_source_id: number;
  observed_at: string;
  recorded_at: string;
  reported_name: string;
  reported_latitude: number | null;
  reported_longitude: number | null;
  reported_address: string | null;
  reported_node_type: string | null;
  match_method: MatchMethod;
  match_score: number | null;
  notes: string | null;
};
export type DataSourceName = "manual_entry" | "scrapyard_scraper";
export type NodeType =
  "scrapyard" | "aggregator" | "steel_mill" | "broker" | "processor";
export type NodeObservationCreate = {
  data_source: DataSourceName;
  observed_at: string;
  reported_name: string;
  reported_latitude: number | null;
  reported_longitude: number | null;
  reported_address: string | null;
  reported_node_type: NodeType | null;
  notes: string | null;
};
export type NodeAttributeType =
  "buy_price" | "sell_price" | "available_mass" | "has_barge" | "has_rail_spur";
export type NodeAttributeObservationRead = {
  id: number;
  node_id: number;
  data_source_id: number;
  observed_at: string;
  recorded_at: string;
  material_id: number | null;
  material_name: string | null;
  attribute_type: NodeAttributeType;
  notes: string | null;
};
export type MassUnit = "g" | "gt" | "oz" | "mt" | "ton" | "kg" | "lb";
export type BuyPriceCreate = {
  price: number | string;
  currency: string;
  unit?: MassUnit;
};
export type SellPriceCreate = {
  price: number | string;
  currency: string;
  unit?: MassUnit;
};
export type AvailableMassCreate = {
  mass: number | string;
  unit?: MassUnit;
};
export type HasTransportCapability = "yes" | "no" | "unknown";
export type HasBargeCreate = {
  value: HasTransportCapability;
};
export type HasRailSpurCreate = {
  value: HasTransportCapability;
};
export type NodeAttributeObservationCreate = {
  node_id: number;
  data_source: DataSourceName;
  observed_at: string;
  material_name: string | null;
  attribute_type: NodeAttributeType;
  attribute:
    | BuyPriceCreate
    | SellPriceCreate
    | AvailableMassCreate
    | HasBargeCreate
    | HasRailSpurCreate;
  notes: string | null;
};
export type RouteAttributeType = "transport_cost" | "transport_time";
export type RouteAttributeObservationRead = {
  id: number;
  route_id: number;
  data_source_id: number;
  observed_at: string;
  recorded_at: string;
  attribute_type: RouteAttributeType;
  notes: string | null;
};
export type TransportMode = "truck" | "rail" | "barge";
export type TransportCostCreate = {
  cost_per_ton: number | string;
  currency: string;
  minimum_tons: number | string | null;
};
export type TransportTimeCreate = {
  duration: string;
};
export type RouteAttributeObservationCreate = {
  origin_node_id: number;
  destination_node_id: number;
  transport_mode: TransportMode;
  data_source: DataSourceName;
  observed_at: string;
  attribute_type: RouteAttributeType;
  attribute: TransportCostCreate | TransportTimeCreate;
  notes: string | null;
};
export type NodeStatus =
  "unverified" | "verified_active" | "verified_inactive" | "verified_false";
export type NodeStateRead = {
  node_id: number;
  name: string;
  node_type: NodeType;
  latitude: number | null;
  longitude: number | null;
  address: string | null;
  city: string | null;
  state: string | null;
  country: string | null;
  status: NodeStatus;
  valid_from: string;
};
export type PurchasingMaterialRead = {
  material_id: number;
  code: string;
  name: string;
  created_at: string;
};
export type SourceType = "scraper" | "manual";
export type DataSourceRead = {
  data_source_id: number;
  name: string;
  source_type: SourceType;
  created_at: string;
  valid_from: string;
};
export type UsState =
  | "AL"
  | "AK"
  | "AZ"
  | "AR"
  | "CA"
  | "CO"
  | "CT"
  | "DE"
  | "FL"
  | "GA"
  | "HI"
  | "ID"
  | "IL"
  | "IN"
  | "IA"
  | "KS"
  | "KY"
  | "LA"
  | "ME"
  | "MD"
  | "MA"
  | "MI"
  | "MN"
  | "MS"
  | "MO"
  | "MT"
  | "NE"
  | "NV"
  | "NH"
  | "NJ"
  | "NM"
  | "NY"
  | "NC"
  | "ND"
  | "OH"
  | "OK"
  | "OR"
  | "PA"
  | "RI"
  | "SC"
  | "SD"
  | "TN"
  | "TX"
  | "UT"
  | "VT"
  | "VA"
  | "WA"
  | "WV"
  | "WI"
  | "WY";
export type RailStation = {
  station_name: string;
  station_state: UsState;
};
export type Coordinates = {
  latitude: number;
  longitude: number;
};
export type MillInfo = {
  tenant_name: string;
  name: string;
  display_name: string;
  color: string;
  location: Coordinates;
};
export type StationsListResponse = {
  stations: RailStation[];
  mills: MillInfo[];
};
export type RateToMill = {
  tenant_name: string;
  destination_name: string;
  destination_group: string;
  origin_group: string;
  rate_per_ton_private_car_usd: number | null;
  rate_per_ton_railroad_car_usd: number | null;
  rate_per_ton_all_car_usd: number | null;
};
export type RatesToMillsResponse = {
  origin_station: string;
  origin_state: UsState;
  rates: RateToMill[];
  mills: MillInfo[];
};
export type TruckRoute = {
  coordinates: Coordinates[];
  distance_miles: number;
  cost_per_ton_usd: number;
  origin: Coordinates;
  destination: Coordinates;
};
export type TruckCostFormula = {
  base_cost_usd: number;
  cost_per_mile_usd: number;
};
export type RailRouteResponse = {
  coordinates: Coordinates[];
  total_miles: number;
  origin: Coordinates;
  destination: Coordinates;
};
export type GeocodedLocation = {
  station_name: string;
  station_state: string;
  location: Coordinates;
};
export type InferenceEnvironment = "pipeline" | "cloud" | "edge";
export type ModelRequiredAngle = {
  location: string;
  angle: string;
  must_be_present: boolean;
};
export type EventLabellingModelRead = {
  id: number;
  mlflow_run_id: string;
  created_at: string;
  status: EventLabellingModelStatus;
  labelling_name: string;
  target_location: string | null;
  dataset_id: string | null;
  inference_environment: InferenceEnvironment;
  authority: number | null;
  flag_rules: FlagRules | null;
  required_angles: ModelRequiredAngle[];
};
export type ModelRequiredAngleCreate = {
  location: string;
  angle: string;
  must_be_present?: boolean;
};
export type EventLabellingModelCreate = {
  mlflow_run_id: string;
  status: EventLabellingModelStatus;
  labelling_name: string;
  target_location?: string | null;
  dataset_id?: string | null;
  inference_environment: InferenceEnvironment;
  required_angles?: ModelRequiredAngleCreate[];
};
export type EventLabellingModels = {
  models: EventLabellingModelRead[];
};
export type TargetedReviewReasonsInUse = {
  reasons_in_use: ReviewReason[];
};
export type ModelState = {
  id: number;
  authority: number | null;
  inference_environment: InferenceEnvironment;
  status: EventLabellingModelStatus;
  flag_rules: FlagRules | null;
  effective_from: string | null;
  effective_to: string | null;
};
export type ModelStateHistory = {
  model_id: number;
  states: ModelState[];
};
export type ModelStateHistories = {
  histories: ModelStateHistory[];
};
export type EventLabellingModelUpdate = {
  status?: EventLabellingModelStatus | null;
  authority?: number | null;
  inference_environment?: InferenceEnvironment | null;
  /** The instant the changes start to apply. Omit it to start from now. Send null to apply from the beginning of time. */
  effective_from?: string | null;
  /** The instant the changes stop applying. It must be later than the start. After it, the state is as it was before this update. Send null to leave it open-ended. */
  effective_to?: string | null;
  /** The flag rules to apply over the state's range. Send null for no rules. */
  flag_rules?: FlagRules | null;
};
export type ConfidenceRecallAtThresholds = {
  recall: number | null;
  event_budget: number | null;
  window_budget: number | null;
  total_periods: number;
  total_errors: number;
  caught_false_positive: number;
  caught_wrong_material: number;
  caught_wrong_area: number;
  total_false_positive: number;
  total_wrong_material: number;
  total_wrong_area: number;
};
export type PerformanceRates = {
  jaccard: number | null;
  fn_rate: number | null;
  fp_rate: number | null;
  material_accuracy: number | null;
  area_accuracy: number | null;
};
export type EvaluationDataset = {
  dataset_id: string;
  created_at: string;
  data_start: string;
  data_end: string;
  test_fraction: number;
  minimum_continuous_split_seconds: number;
  /** Start of this model's own reach into the test split */
  reference_start: string | null;
  /** End of this model's own reach into the test split */
  reference_end: string | null;
  /** Share of the whole test split a reviewer has verified */
  verified_share: number | null;
};
export type ExpectedPerformanceAtThresholds = {
  flagged_periods: number;
  total_periods: number;
  /** Rates over the periods these thresholds select */
  flagged: PerformanceRates | null;
  /** Rates over every period in the test split */
  all_periods: PerformanceRates | null;
  dataset: EvaluationDataset | null;
};
export type WindowedConfidenceRecallAtThresholds = {
  residual_review_error_score: number | null;
  base_review_error_score: number | null;
  pure_miss_contribution_to_review_error_score: number | null;
  flagged_periods: number;
  total_periods: number;
  window_budget: number | null;
  total_fn: number;
  missing_data_tagged_fn: number;
  window_days: number;
};
export type ReviewReasonContribution = {
  reason: ReviewReason;
  n_periods: number;
  n_events: number;
};
export type AlwaysOnReviewFlags = {
  reasons: ReviewReasonContribution[];
  n_periods: number;
  n_events: number;
};
export type WindowedAlwaysOnReviewFlags = {
  reasons: ReviewReasonContribution[];
  n_periods: number;
  window_days: number;
};
export type RecallAtThresholds = {
  recall: number | null;
  event_budget: number | null;
  window_budget: number | null;
  total_periods: number;
  total_errors: number;
  caught_false_positive: number;
  caught_wrong_material: number;
  caught_wrong_area: number;
  total_false_positive: number;
  total_wrong_material: number;
  total_wrong_area: number;
  always_on_reasons: ReviewReasonContribution[];
  always_on_periods: number;
  always_on_events: number;
};
export const {
  useGetTenantMetadataQuery,
  useTriggerAutoRecipesFromFilesMutation,
  useTriggerAutoRecipesFromTypesMutation,
  useListAutoRecipeStrategiesQuery,
  useListAutoRecipeEstimatorsQuery,
  useGetDefaultAutoRecipeEstimatorsQuery,
  useGetDefaultAutoRecipeStrategyQuery,
  useCreateAutoRecipeMutation,
  useCreateAndRunAutoRecipeMutation,
  useListChefGroupsQuery,
  useCreateChefGroupingMutation,
  useUpdateDefaultTargetBasketsMutation,
  useGetChefGroupingQuery,
  useUpdateDefaultMaterialLimitsMutation,
  useGetMaterialLimitSetQuery,
  useListSteelGradesQuery,
  useCreateSteelGradeSetMutation,
  useGetSteelGradeSetQuery,
  useListSteelGradePlansQuery,
  useCreateSteelGradePlanMutation,
  useGetSteelGradePlanQuery,
  useGetTypicalSteelGradePlanQuery,
  useGetSteelGradePlanItemsFromProductGroupPlanItemsMutation,
  useGetFormattedBasketConstraintsQuery,
  useListChemicalElementsQuery,
  useGetCraneAssignedBasketQuery,
  useGetMaterialMetadataSetQuery,
  useListMaterialConstraintClassesQuery,
  useCreateMaterialChemistrySetMutation,
  useListMaterialChemistrySetsQuery,
  useUpdateDefaultMaterialChemistryMutation,
  useGetMaterialChemistrySetQuery,
  useGetMaterialPricesQuery,
  useUpdateDefaultMaterialPhysicsMutation,
  useGetMaterialPhysicsSetQuery,
  useGetFixedMixDefaultsQuery,
  useUpdateFixedMixDefaultsMutation,
  usePreviewFixedMixDefaultsMutation,
  useGetAutoRecipeDefaultsQuery,
  useValidateAutoRecipeDefaultsMutation,
  useUpdateAutoRecipeDefaultsMutation,
  useRevertAutoRecipeDefaultsMutation,
  usePreviewAutoRecipeSupplyMutation,
  useNotifyDefaultParameterVisitMutation,
  useListLoadsQuery,
  useCreateLoadMutation,
  useListCranesQuery,
  useGetLoadQuery,
  useDeleteLoadMutation,
  useUpdateLoadBasketAssignmentMutation,
  useUpdateLoadBasketAdditionsMutation,
  useCompleteLoadBasketMutation,
  useGetPlanResultsQuery,
  useGetPlanResultsBatchMutation,
  useGetDeployedPlansQuery,
  useGetDeployedPlanResultsQuery,
  useGetDeployedPlanMetadataQuery,
  useGetPlanResultsExcelQuery,
  useDeployPlanMutation,
  useCreateHeatOverrideMutation,
  useListCompletedHeatsQuery,
  useCreateCompletedHeatsOverrideMutation,
  useListHeatOverrideHistoryQuery,
  useEditHeatOverrideHistoryMutation,
  useListHeatOverrideRecipesQuery,
  useReviseHeatOverrideRecipeMutation,
  useListHeatOverrideReasonsQuery,
  useCancelHeatOverrideMutation,
  useCancelHistoricalHeatOverrideMutation,
  useGetLiveRecipeQuery,
  useGetHeatQueueQuery,
  useGetObtainableBundleItemSetQuery,
  useCreateObtainableBundleItemSetMutation,
  useListProductGroupingsQuery,
  useCreateProductGroupingMutation,
  useGetProductGroupingQuery,
  useListProductGroupPlansQuery,
  useCreateProductGroupPlanMutation,
  useGetProductGroupPlanQuery,
  useGetTypicalProductGroupPlanQuery,
  useGetProductGroupPlanItemsFromSteelGradePlanItemsMutation,
  useListSearchesQuery,
  useSendSearchNotificationMutation,
  useCreateSearchFromContextMutation,
  useRunSearchMutation,
  useGetSearchQuery,
  useCreateSearchMutation,
  useGetSearchContextQuery,
  useGetNameBasedSearchQuery,
  useOverwriteFromNameBasedSearchMutation,
  useApplyNameBasedSearchDiffMutation,
  useGetNameBasedSearchDiffQuery,
  useGetNameBasedSearchObjectDiffMutation,
  useListDeployedPlansQuery,
  useListDeployedPlanDaysQuery,
  useSendPlanNotificationMutation,
  useCreatePlanFromStandingRecipeMutation,
  usePreviewLayeringMutation,
  useUpdatePlanResultsMutation,
  useUpdateAndDeployPlanResultsMutation,
  useComparePlanPeriodsQuery,
  useCompareMixesQuery,
  useGetPlanAncestorsQuery,
  useGetBackupsQuery,
  useGetPlanQuery,
  useCopyDeployedPlanMixesMutation,
  useListSessionsQuery,
  useCreateSessionMutation,
  useListSessionVersionsQuery,
  useRenameSessionMutation,
  useDeleteSessionMutation,
  useCopySearchMutation,
  useGetResultQuery,
  useGetNameBasedResultsQuery,
  useGetNameBasedResultQuery,
  useSaveUploadedFileMutation,
  useListUploadedFilesQuery,
  useSaveAndParseFileMutation,
  useUploadAdhocFileMutation,
  useGetUploadedFileQuery,
  useListUploadedFileTypesQuery,
  useGetParsedSearchParametersQuery,
  useGetLayeringMutation,
  usePublishPlanChargeScheduleMutation,
  useListNewPublishedChargeSchedulesQuery,
  useListAllPublishedChargeSchedulesQuery,
  useConfirmPublishedChargeSchedulesMutation,
  useListConfirmedChargeScheduleMetaMutation,
  useGetPublishPreflightQuery,
  useGetChargeScheduleMessageTemplateQuery,
  useSendChargeScheduleMessageListMutation,
  useSendPlanDeployedMessageMutation,
  useGetActiveChargeSchedulesQuery,
  useListMessagesQuery,
  useAddSentMessageMutation,
  useConfirmMessageSentMutation,
  useCreateInventoryMeasurementSetMutation,
  useGetInventoryEstimateAtTimestampQuery,
  useGetInventoryEstimateAtTimestampForMeasurementQuery,
  useGetInventoryBreakdownAtTimestampQuery,
  useGetLatestInventoryMeasurementCreatedAtQuery,
  useGetInventoryMeasurementComplianceQuery,
  useGetRecipesImpuritiesStatsQuery,
  useCreateTargetBasketSetMutation,
  useUpdateDefaultTargetBasketsSetMutation,
  useGetTargetBasketSetQuery,
  useCheckParameterFeasibilityMutation,
  useAddUsersMutation,
  useGenerateSignInLinkMutation,
  useSendInviteEmailMutation,
  useGetPendingInvitesQuery,
  useDeleteUserInviteMutation,
  useListLabelReservationSettingsQuery,
  useCreateLabelReservationSettingsMutation,
  useUpdateLabelReservationSettingsMutation,
  useDeleteLabelReservationSettingsMutation,
  useSetDefaultLabelReservationSettingsMutation,
  useListLabelReservationSettingsAssignmentsQuery,
  useAssignUserLabelReservationSettingsMutation,
  useUnassignUserLabelReservationSettingsMutation,
  useGetResolvedLabelReservationSettingsQuery,
  useGetReviewDayOverviewQuery,
  useGetSiteReviewPeriodsQuery,
  useGetReviewMonthSummaryQuery,
  useGetCommentedEventsQuery,
  useGetEventsForReviewQuery,
  useUnverifyPeriodMutation,
  useUploadCorrectedEventsAndVerifyMutation,
  useMarkCommentEventReviewedMutation,
  useAssignPeriodsMutation,
  useUnassignPeriodsMutation,
  useGetUnverifiedPeriodsQuery,
  useGetUnverifiedDatesQuery,
  useGetAssignedReviewPeriodsQuery,
  useGetLabellerTimelinesReportQuery,
  useCreateEventMutation,
  useCreateEventsForReservationsMutation,
  useListEventsQuery,
  useGetReservedPeriodsQuery,
  useReserveLabellingPeriodsMutation,
  useReserveLabellingPeriodsForModelMutation,
  useDeletePeriodReservationMutation,
  useInvalidatePeriodsMutation,
  useGetLatestEventExamplesQuery,
  useGetMaterialExamplesQuery,
  useGetLabellerVerifiedEventsComparisonQuery,
  useGetLabellersQuery,
  useGetCostLabellersQuery,
  useGetDailyLabellerStatsQuery,
  useGetLabellerCostStatsQuery,
  useGetLabellerAccuracyStatsQuery,
  useGetLabellerMatchedEventsQuery,
  useGetTenantLabellingCoverageQuery,
  useGetLocationsLoadingTimelineQuery,
  useListPendingPlanChangesQuery,
  useListPlanChangesQuery,
  useGetPlanChangeDetailsQuery,
  useGetPhysicalParametersSetQuery,
  useListSimulatorDataLoadersQuery,
  useListSimulatorRunsQuery,
  useGetSimulatorRunQuery,
  useSummarisePlanResultsMutation,
  useSendStrategyDashboardNotificationMutation,
  useGetStrategyDashboardEditingQuery,
  useGetStrategyDashboardEditingRecipesByDateQuery,
  useGetRecipeEditsVisualizationQuery,
  useGetStrategyDashboardInventoryQuery,
  useGetStrategyDashboardConsumptionQuery,
  useGetStrategyDashboardConsumptionProjectionQuery,
  useGetStrategyDashboardProductionQuery,
  useGetStrategyDashboardProductionPaceQuery,
  useGetStrategyDashboardFailureRateQuery,
  useGetStrategyDashboardPricesQuery,
  useGetStrategyDashboardScrapChefUsageQuery,
  useGetStrategyDashboardScrapChefUsageDetailedQuery,
  useGetStrategyDashboardCostQuery,
  useGetStrategyDashboardHeatsQuery,
  useGetStrategyDashboardHeatsByIdsMutation,
  useGetStrategyDashboardShiftsQuery,
  useGetStrategyDashboardDeliveriesAndPurchasesQuery,
  useGetStrategyDashboardDeliveriesOverviewQuery,
  useGetStrategyDashboardComplianceQuery,
  useGetCrewAggregatedComplianceQuery,
  useGetStrategyDashboardCrewComparisonQuery,
  useGetTenantSavingsQuery,
  useGetStrategyDashboardSavingsTimeseriesQuery,
  useGetTenantSiopScheduleQuery,
  useGetTenantPlannedShredQuery,
  useUploadDeliveryFormPhotoMutation,
  useSaveDeliveryFormMutation,
  useListDeliveryFormsQuery,
  useGetDeliveryFormQuery,
  useGetUploadedPhotoQuery,
  useProcessAudioWithGeminiMutation,
  useGenerateDeliveryFormNameMutation,
  useGetCacheLinesQuery,
  useInvalidateCacheLinesMutation,
  useGetLatestConsumptionProjectionQuery,
  useListConsumptionProjectionsQuery,
  useCreateConsumptionProjectionMutation,
  useGetLatestDeliveryAdjustmentQuery,
  useListDeliveryAdjustmentsQuery,
  useCreateDeliveryAdjustmentMutation,
  useRunPeakShavingScenariosMutation,
  useGetScrapEyeMetadataQuery,
  useListScrapEyeSegmentsByDevicesQuery,
  useListAvailableCameraAnglesQuery,
  useRenameScrapEyeDeviceMutation,
  useGetTrainableConfigQuery,
  useGetTrainablePeriodsQuery,
  useGetModelCoverageConfigQuery,
  useGetModelCoverageQuery,
  useGetJobFailuresQuery,
  usePreviewTerminalFailuresQuery,
  useResetTerminalFailuresMutation,
  useGetPerformanceTimeseriesQuery,
  useGetDatasetSizeQuery,
  useGetLabellingCostDailyQuery,
  useGetLabellingCostDailyByLocationQuery,
  useGetLabellingCostByLabellerQuery,
  useGetLabellingRedundancyDailyQuery,
  useGetReviewerTrackingDailyQuery,
  useProvisionNewManualDeviceMutation,
  useGetLiveCameraVideoPlaylistQuery,
  useGetCameraVideoPlaylistQuery,
  useGetLiveAngleVideoPlaylistQuery,
  useGetAngleVideoPlaylistQuery,
  useGetGcsReadTokenQuery,
  useGetLiveRadioPlaylistQuery,
  useGetRadioPlaylistQuery,
  useGetRadioTranscriptQuery,
  useGetRadioSegmentInfoQuery,
  useListRadioReceiversQuery,
  useGetRadioGcsReadTokenQuery,
  useGetMassCandidateEventsQuery,
  useGetMassTimeseriesQuery,
  useGetModelPredictionTimeseriesQuery,
  useGetInferenceInputTimeseriesQuery,
  useGetHeatQualityIssuesQuery,
  useGetLoadingWindowPlannedConsumptionQuery,
  useGetLoadingWindowDropsQuery,
  useGetLoadingWindowHeatMetadataQuery,
  useGetLoadingWindowChargeEventsQuery,
  useSubmitAndApplyLoadingEditsMutation,
  useSubmitLoadingReviewsMutation,
  useReviseAndApplyLoadingEditsMutation,
  useGetLoadingWindowsQuery,
  useListConsumptionAreasQuery,
  useListLoadingEditsQuery,
  useSubmitLoadingEditsForReviewMutation,
  useReseedLoadingWindowsMutation,
  useCreateInstallationLocationMutation,
  useListInstallationLocationsQuery,
  useListInstallationLocationsWithBacklogQuery,
  useCreateRecordingPositionMutation,
  useListRecordingPositionsQuery,
  useListAvailableRecordingPositionsForLocationQuery,
  useCreateCameraAngleMutation,
  useListCameraAnglesQuery,
  useListAvailableCameraAnglesForLocationQuery,
  useInstallCameraMutation,
  useUninstallCameraMutation,
  useListInstallationsQuery,
  useCreateVideoPlayerGroupMutation,
  useListVideoPlayerGroupsQuery,
  useGetVideoPlayerGroupQuery,
  useUpdateVideoPlayerGroupMutation,
  useDeleteVideoPlayerGroupMutation,
  useAddAngleToGroupMutation,
  useUpdateAnglePriorityMutation,
  useRemoveAngleFromGroupMutation,
  useCreateLocationSupportAssociationMutation,
  useListLocationSupportAssociationsQuery,
  useDeleteLocationSupportAssociationMutation,
  useInstallSensorMutation,
  useListSensorInstallationsQuery,
  useCorrectSensorInstallationMutation,
  useConnectSensorMutation,
  useListSensorConnectionsQuery,
  useCorrectSensorConnectionMutation,
  useListSensorCameraRecordingsQuery,
  useReconcileSensorMetricsMutation,
  useCreateSensorMutation,
  useListSensorsQuery,
  useUpdateSensorMetadataMutation,
  useRedactFootagePreviewMutation,
  useRedactFootageMutation,
  useGetRedactionStatusQuery,
  useCreateLocationExceptionalStatusMutation,
  useListLocationExceptionalStatusesQuery,
  useUpdateLocationExceptionalStatusMutation,
  useDeleteLocationExceptionalStatusMutation,
  useListScrapEyeDevicesQuery,
  useListScrapEyeCamerasQuery,
  useGetSensorTopologyQuery,
  useApplySensorTopologyChangesMutation,
  useRegisterCapabilitiesMutation,
  useAnnounceCamerasMutation,
  useUploadVideoFromUriMutation,
  useUploadRadioFromUriMutation,
  useGetGcsUploadTokenQuery,
  useGetSegmentStatusListQuery,
  useUploadEdgePredictionsFromUriMutation,
  useUploadEdgeEmbeddingFromUriMutation,
  useGetScrapLoadingLayoutQuery,
  useGetRailcarMovementsQuery,
  useGetReportedRailcarSlotsQuery,
  useCreateRailcarOrderRequestMutation,
  useProposeRailcarOrderMutation,
  useGetRecipeComplianceReportDailyQuery,
  useGetRecipeComplianceReportMonthlyQuery,
  useGetRecipeComplianceReportDailyHtmlQuery,
  useGetRecipeComplianceReportMonthlyHtmlQuery,
  useListTenantEmailsQuery,
  useListTenantNamesQuery,
  useListTenantGroupsQuery,
  useGetMeQuery,
  useGetAuthCustomTokenMutation,
  useGetUsersQuery,
  useGetUserByEmailQuery,
  useUpdateUserMutation,
  useSyncWithFirebaseMutation,
  useLogoutMutation,
  useSetAdminModeMutation,
  useRequestSignInLinkMutation,
  useGetClarkProfileQuery,
  useUpdateClarkProfileMutation,
  useSendMissionControlNotificationMutation,
  useListMissionControlTenantsQuery,
  useUploadMissionControlFilesMutation,
  useGetMissionControlTenantSavingsQuery,
  useGetMissionControlTenantTotalInventoryQuery,
  useGetMissionControlTenantSiopScheduleQuery,
  useGetMissionControlTenantProductMixQuery,
  useGetMissionControlTenantShredUsageQuery,
  useGetMissionControlScrapReportQuery,
  useListOrganisationUsersQuery,
  useAddOrganisationUserMutation,
  useUpdateOrganisationUserPermissionsMutation,
  useRemoveOrganisationUserMutation,
  useGetClarkDirectoryQuery,
  useAddNodeObservationMutation,
  useAddNodeAttributeObservationMutation,
  useAddRouteAttributeObservationMutation,
  useListNodesQuery,
  useListMaterialsQuery,
  useListDataSourcesQuery,
  useSendLogisticsRoutingNotificationMutation,
  useGetRailStationsQuery,
  useGetRatesToMillsQuery,
  useFindTruckRouteQuery,
  useGetTruckCostFormulaQuery,
  useFindRailRouteQuery,
  useGeocodeStationQuery,
  useHealthCheckQuery,
  useRegisterEventLabellingModelMutation,
  useListEventLabellingModelsQuery,
  useGetEventLabellingModelQuery,
  useGetTargetedReviewReasonsInUseQuery,
  useGetEventLabellingModelStateHistoriesQuery,
  useUpdateEventLabellingModelMutation,
  useGetEventLabellingModelConfidenceRecallAtThresholdsQuery,
  useGetEventLabellingModelExpectedPerformanceAtThresholdsQuery,
  useGetEventLabellingModelWindowedConfidenceRecallAtThresholdsQuery,
  useGetEventLabellingModelAlwaysOnFlagsQuery,
  useGetEventLabellingModelWindowedAlwaysOnFlagsQuery,
  useGetEventLabellingModelRecallAtThresholdsQuery,
} = injectedRtkApi;
